function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRequire.register("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRequire.register("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRequire.register("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRequire.register("fjRTt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2726f8b35d70887$export$2e2bcd8739ae039; });

var $a5q8p = parcelRequire("a5q8p");
var $b2726f8b35d70887$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $b2726f8b35d70887$var$index = (0, $a5q8p.default)(function(prop) {
    return $b2726f8b35d70887$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $b2726f8b35d70887$export$2e2bcd8739ae039 = $b2726f8b35d70887$var$index;

});
parcelRequire.register("a5q8p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $757ea4c9ef9a7a6c$export$2e2bcd8739ae039; });
function $757ea4c9ef9a7a6c$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $757ea4c9ef9a7a6c$export$2e2bcd8739ae039 = $757ea4c9ef9a7a6c$var$memoize;

});


parcelRequire.register("7ORd6", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.36
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.36", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRequire.register("g4WQO", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $bb4aab9d21a68c2e$export$2b8d127b894957b9; }, function (v) { return $bb4aab9d21a68c2e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $bb4aab9d21a68c2e$export$cea3a54a6425200c; }, function (v) { return $bb4aab9d21a68c2e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae; }, function (v) { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d; }, function (v) { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac; }, function (v) { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35; }, function (v) { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bb4aab9d21a68c2e$export$ffb0004e005737fa; }, function (v) { return $bb4aab9d21a68c2e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bb4aab9d21a68c2e$export$b624eff549462981; }, function (v) { return $bb4aab9d21a68c2e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bb4aab9d21a68c2e$export$7897aa7841a5380c; }, function (v) { return $bb4aab9d21a68c2e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bb4aab9d21a68c2e$export$602eac185826482c; }, function (v) { return $bb4aab9d21a68c2e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bb4aab9d21a68c2e$export$e2c29f18771995cb; }, function (v) { return $bb4aab9d21a68c2e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bb4aab9d21a68c2e$export$5f8d39834fd61797; }, function (v) { return $bb4aab9d21a68c2e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5; }, function (v) { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bb4aab9d21a68c2e$export$92387174baf9b227; }, function (v) { return $bb4aab9d21a68c2e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6; }, function (v) { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bb4aab9d21a68c2e$export$b706b080d889d2c9; }, function (v) { return $bb4aab9d21a68c2e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc; }, function (v) { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d; }, function (v) { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bb4aab9d21a68c2e$export$455c2e768291efa6; }, function (v) { return $bb4aab9d21a68c2e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bb4aab9d21a68c2e$export$9522e17588c12572; }, function (v) { return $bb4aab9d21a68c2e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bb4aab9d21a68c2e$export$2110ac352bb060b9; }, function (v) { return $bb4aab9d21a68c2e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab; }, function (v) { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de; }, function (v) { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bb4aab9d21a68c2e$export$b82d16f27459e05a; }, function (v) { return $bb4aab9d21a68c2e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8; }, function (v) { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6; }, function (v) { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bb4aab9d21a68c2e$export$9b621391a187a31a; }, function (v) { return $bb4aab9d21a68c2e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f; }, function (v) { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb4aab9d21a68c2e$export$2b8d127b894957b9;
var $bb4aab9d21a68c2e$export$cea3a54a6425200c;
var $bb4aab9d21a68c2e$export$a7c73072b1a182ae;
var $bb4aab9d21a68c2e$export$9f27bc3417b4524d;
var $bb4aab9d21a68c2e$export$db77ccec0bb4ccac;
var $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35;
var $bb4aab9d21a68c2e$export$ffb0004e005737fa;
var $bb4aab9d21a68c2e$export$b624eff549462981;
var $bb4aab9d21a68c2e$export$7897aa7841a5380c;
var $bb4aab9d21a68c2e$export$602eac185826482c;
var $bb4aab9d21a68c2e$export$e2c29f18771995cb;
var $bb4aab9d21a68c2e$export$5f8d39834fd61797;
var $bb4aab9d21a68c2e$export$74bf444e3cd11ea5;
var $bb4aab9d21a68c2e$export$92387174baf9b227;
var $bb4aab9d21a68c2e$export$ec112efeb987d9c6;
var $bb4aab9d21a68c2e$export$b706b080d889d2c9;
var $bb4aab9d21a68c2e$export$5be5a87408f70ddc;
var $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d;
var $bb4aab9d21a68c2e$export$455c2e768291efa6;
var $bb4aab9d21a68c2e$export$9522e17588c12572;
var $bb4aab9d21a68c2e$export$2110ac352bb060b9;
var $bb4aab9d21a68c2e$export$56885ab8b9c456ab;
var $bb4aab9d21a68c2e$export$d927fcb6adf8f9de;
var $bb4aab9d21a68c2e$export$b82d16f27459e05a;
var $bb4aab9d21a68c2e$export$522c17b4f5e123e8;
var $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6;
var $bb4aab9d21a68c2e$export$9b621391a187a31a;
var $bb4aab9d21a68c2e$export$f5bbd400c2f4426f;
"use strict";
var $bb4aab9d21a68c2e$var$b = "function" === typeof Symbol && Symbol.for, $bb4aab9d21a68c2e$var$c = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.element") : 60103, $bb4aab9d21a68c2e$var$d = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.portal") : 60106, $bb4aab9d21a68c2e$var$e = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fragment") : 60107, $bb4aab9d21a68c2e$var$f = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.strict_mode") : 60108, $bb4aab9d21a68c2e$var$g = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.profiler") : 60114, $bb4aab9d21a68c2e$var$h = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.provider") : 60109, $bb4aab9d21a68c2e$var$k = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.context") : 60110, $bb4aab9d21a68c2e$var$l = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.async_mode") : 60111, $bb4aab9d21a68c2e$var$m = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bb4aab9d21a68c2e$var$n = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.forward_ref") : 60112, $bb4aab9d21a68c2e$var$p = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense") : 60113, $bb4aab9d21a68c2e$var$q = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense_list") : 60120, $bb4aab9d21a68c2e$var$r = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.memo") : 60115, $bb4aab9d21a68c2e$var$t = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.lazy") : 60116, $bb4aab9d21a68c2e$var$v = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.block") : 60121, $bb4aab9d21a68c2e$var$w = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fundamental") : 60117, $bb4aab9d21a68c2e$var$x = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.responder") : 60118, $bb4aab9d21a68c2e$var$y = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.scope") : 60119;
function $bb4aab9d21a68c2e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bb4aab9d21a68c2e$var$c:
                switch(a = a.type, a){
                    case $bb4aab9d21a68c2e$var$l:
                    case $bb4aab9d21a68c2e$var$m:
                    case $bb4aab9d21a68c2e$var$e:
                    case $bb4aab9d21a68c2e$var$g:
                    case $bb4aab9d21a68c2e$var$f:
                    case $bb4aab9d21a68c2e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bb4aab9d21a68c2e$var$k:
                            case $bb4aab9d21a68c2e$var$n:
                            case $bb4aab9d21a68c2e$var$t:
                            case $bb4aab9d21a68c2e$var$r:
                            case $bb4aab9d21a68c2e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bb4aab9d21a68c2e$var$d:
                return u;
        }
    }
}
function $bb4aab9d21a68c2e$var$A(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$m;
}
$bb4aab9d21a68c2e$export$2b8d127b894957b9 = $bb4aab9d21a68c2e$var$l;
$bb4aab9d21a68c2e$export$cea3a54a6425200c = $bb4aab9d21a68c2e$var$m;
$bb4aab9d21a68c2e$export$a7c73072b1a182ae = $bb4aab9d21a68c2e$var$k;
$bb4aab9d21a68c2e$export$9f27bc3417b4524d = $bb4aab9d21a68c2e$var$h;
$bb4aab9d21a68c2e$export$db77ccec0bb4ccac = $bb4aab9d21a68c2e$var$c;
$bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = $bb4aab9d21a68c2e$var$n;
$bb4aab9d21a68c2e$export$ffb0004e005737fa = $bb4aab9d21a68c2e$var$e;
$bb4aab9d21a68c2e$export$b624eff549462981 = $bb4aab9d21a68c2e$var$t;
$bb4aab9d21a68c2e$export$7897aa7841a5380c = $bb4aab9d21a68c2e$var$r;
$bb4aab9d21a68c2e$export$602eac185826482c = $bb4aab9d21a68c2e$var$d;
$bb4aab9d21a68c2e$export$e2c29f18771995cb = $bb4aab9d21a68c2e$var$g;
$bb4aab9d21a68c2e$export$5f8d39834fd61797 = $bb4aab9d21a68c2e$var$f;
$bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = $bb4aab9d21a68c2e$var$p;
$bb4aab9d21a68c2e$export$92387174baf9b227 = function(a) {
    return $bb4aab9d21a68c2e$var$A(a) || $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$l;
};
$bb4aab9d21a68c2e$export$ec112efeb987d9c6 = $bb4aab9d21a68c2e$var$A;
$bb4aab9d21a68c2e$export$b706b080d889d2c9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$k;
};
$bb4aab9d21a68c2e$export$5be5a87408f70ddc = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$h;
};
$bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb4aab9d21a68c2e$var$c;
};
$bb4aab9d21a68c2e$export$455c2e768291efa6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$n;
};
$bb4aab9d21a68c2e$export$9522e17588c12572 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$e;
};
$bb4aab9d21a68c2e$export$2110ac352bb060b9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$t;
};
$bb4aab9d21a68c2e$export$56885ab8b9c456ab = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$r;
};
$bb4aab9d21a68c2e$export$d927fcb6adf8f9de = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$d;
};
$bb4aab9d21a68c2e$export$b82d16f27459e05a = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$g;
};
$bb4aab9d21a68c2e$export$522c17b4f5e123e8 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$f;
};
$bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$p;
};
$bb4aab9d21a68c2e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bb4aab9d21a68c2e$var$e || a === $bb4aab9d21a68c2e$var$m || a === $bb4aab9d21a68c2e$var$g || a === $bb4aab9d21a68c2e$var$f || a === $bb4aab9d21a68c2e$var$p || a === $bb4aab9d21a68c2e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bb4aab9d21a68c2e$var$t || a.$$typeof === $bb4aab9d21a68c2e$var$r || a.$$typeof === $bb4aab9d21a68c2e$var$h || a.$$typeof === $bb4aab9d21a68c2e$var$k || a.$$typeof === $bb4aab9d21a68c2e$var$n || a.$$typeof === $bb4aab9d21a68c2e$var$w || a.$$typeof === $bb4aab9d21a68c2e$var$x || a.$$typeof === $bb4aab9d21a68c2e$var$y || a.$$typeof === $bb4aab9d21a68c2e$var$v);
};
$bb4aab9d21a68c2e$export$f5bbd400c2f4426f = $bb4aab9d21a68c2e$var$z;

});

parcelRequire.register("frWs0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f6b7b651414f31$export$2e2bcd8739ae039; });
/* global window */ 
var $2o9g9 = parcelRequire("2o9g9");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $2o9g9.default)(root);
var $b3f6b7b651414f31$export$2e2bcd8739ae039 = result;

});
parcelRequire.register("2o9g9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bd5016cb15f1cd5$export$2e2bcd8739ae039; });
function $1bd5016cb15f1cd5$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}

});


parcelRequire.register("8TKuU", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");

var $lAPp0 = parcelRequire("lAPp0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dnnhb.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $lAPp0;
module.exports = isBuffer;

});
parcelRequire.register("dnnhb", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `self`. */ var $9bcf7a804d00ded1$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9bcf7a804d00ded1$var$root = $8vz42 || $9bcf7a804d00ded1$var$freeSelf || Function("return this")();
module.exports = $9bcf7a804d00ded1$var$root;

});
parcelRequire.register("8vz42", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $631c6b00c6701f20$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $631c6b00c6701f20$var$freeGlobal;

});


parcelRequire.register("lAPp0", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $fb84d52c0f9b5c17$var$stubFalse() {
    return false;
}
module.exports = $fb84d52c0f9b5c17$var$stubFalse;

});


parcelRequire.register("1mm29", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8vz42.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;



parcelRequire("bh6RR");

parcelRequire("bh6RR");

parcelRequire("bh6RR");
const $5763721b9fa71fc2$export$3f68a6c8e931da17 = "Wedding Connections";
const $5763721b9fa71fc2$export$7ea57ed97bda1046 = 4;


/**
 * lucide-react v0.288.0 - ISC
 */ /**
 * lucide-react v0.288.0 - ISC
 */ 
var $bh6RR = parcelRequire("bh6RR");
/**
 * lucide-react v0.288.0 - ISC
 */ var $ec254981854797b3$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


const $dc38aceacd32c739$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $dc38aceacd32c739$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $bh6RR.forwardRef)(({ color: color = "currentColor" , size: size = 24 , strokeWidth: strokeWidth = 2 , absoluteStrokeWidth: absoluteStrokeWidth , children: children , ...rest }, ref)=>(0, $bh6RR.createElement)("svg", {
            ref: ref,
            ...(0, $ec254981854797b3$export$2e2bcd8739ae039),
            width: size,
            height: size,
            stroke: color,
            strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
            className: `lucide lucide-${$dc38aceacd32c739$export$73bda83cddbc7187(iconName)}`,
            ...rest
        }, [
            ...iconNode.map(([tag, attrs])=>(0, $bh6RR.createElement)(tag, attrs)),
            ...(Array.isArray(children) ? children : [
                children
            ]) || []
        ]));
    Component.displayName = `${iconName}`;
    return Component;
};


const $c2b396b5ac29bd02$export$2e2bcd8739ae039 = (0, $dc38aceacd32c739$export$2e2bcd8739ae039)("Info", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
]);


// Google Analytics 4 helper functions
const $61b270a9c2ec9ef5$export$73d0a139caca1fee = (eventName, eventParams = {})=>{
    if (typeof window !== "undefined" && window.gtag) window.gtag("event", eventName, eventParams);
};
const $61b270a9c2ec9ef5$export$74ddb128c139d5ca = (isCorrect, isOneAway, numGuesses)=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("guess_submitted", {
        correct: isCorrect,
        one_away: isOneAway,
        guess_number: numGuesses
    });
};
const $61b270a9c2ec9ef5$export$9d170c11c6dddd1b = ()=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("repeated_guess");
};
const $61b270a9c2ec9ef5$export$5d5a7387b247147e = (numGuesses, numMistakes)=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("game_won", {
        num_guesses: numGuesses,
        num_mistakes: numMistakes,
        success: true
    });
};
const $61b270a9c2ec9ef5$export$74b3310c834b946e = (numGuesses, numMistakes)=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("game_lost", {
        num_guesses: numGuesses,
        num_mistakes: numMistakes,
        success: false
    });
};
const $61b270a9c2ec9ef5$export$25376a6166516c67 = ()=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("shuffle_clicked");
};
const $61b270a9c2ec9ef5$export$64c83896ccb893ac = ()=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("deselect_clicked");
};
const $61b270a9c2ec9ef5$export$691802c93373a60f = (numGuesses, won)=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("share_score", {
        num_guesses: numGuesses,
        won: won
    });
};
const $61b270a9c2ec9ef5$export$a2e3c44b967be155 = (word, isSelecting)=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("word_clicked", {
        word: word,
        action: isSelecting ? "select" : "deselect"
    });
};
const $61b270a9c2ec9ef5$export$69daaca24e7d39b8 = ()=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("play_again_clicked");
};
const $61b270a9c2ec9ef5$export$ffae68720d19fc39 = ()=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("view_results_clicked");
};
const $61b270a9c2ec9ef5$export$312fb35742390537 = ()=>{
    $61b270a9c2ec9ef5$export$73d0a139caca1fee("info_modal_opened");
};




var $bh6RR = parcelRequire("bh6RR");
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39ab41060f0dd572$export$2e2bcd8739ae039.apply(this, arguments);
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
function $1cecd1d75f085228$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $1cecd1d75f085228$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $1cecd1d75f085228$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $1cecd1d75f085228$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $e52f713866128e60$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $e52f713866128e60$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$e52f713866128e60$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $e52f713866128e60$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($e52f713866128e60$export$43e446d32b3d21af(...refs), refs);
}




var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($18fd289ffa468154$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$18fd289ffa468154$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$18fd289ffa468154$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $e52f713866128e60$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $18fd289ffa468154$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $18fd289ffa468154$export$d9f1ccf0bdb05d45;
}
function $18fd289ffa468154$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $18fd289ffa468154$export$be92b6f5f03c0fe9 = $18fd289ffa468154$export$8c6ed5c666ac1360;


// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $c43a6ccc42422c95$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}



function $93dfa6b8fe6a3629$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $c901973c35f9b07b$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $bh6RR.useRef)(callback);
    (0, $bh6RR.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $bh6RR.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $dfcfc7aa8980054c$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $dfcfc7aa8980054c$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $bh6RR.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $dfcfc7aa8980054c$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0, $bh6RR.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $bh6RR.useRef)(value);
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    (0, $bh6RR.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $bh6RR = parcelRequire("bh6RR");


const $793b1a0f4d9647b1$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $793b1a0f4d9647b1$export$250ffa63cdc0d034 = $793b1a0f4d9647b1$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $18fd289ffa468154$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $793b1a0f4d9647b1$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $793b1a0f4d9647b1$export$be92b6f5f03c0fe9 = $793b1a0f4d9647b1$export$250ffa63cdc0d034;




var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $8b7ab17803b8e6f8$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};





var $bh6RR = parcelRequire("bh6RR");



function $e651d1dc516f7371$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $bh6RR.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $e651d1dc516f7371$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $e651d1dc516f7371$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $bh6RR.Children).only(children);
    const ref = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(child, {
        ref: ref
    }) : null;
};
$e651d1dc516f7371$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $e651d1dc516f7371$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $bh6RR.useState)();
    const stylesRef = (0, $bh6RR.useRef)({});
    const prevPresentRef = (0, $bh6RR.useRef)(present);
    const prevAnimationNameRef = (0, $bh6RR.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e651d1dc516f7371$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $47cfd4084854a574$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $bh6RR.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}



var $bh6RR = parcelRequire("bh6RR");

const $d172fcbd2da23bac$var$$1746a345f3d73bb7$var$useReactId = $bh6RR["useId".toString()] || (()=>undefined);
let $d172fcbd2da23bac$var$$1746a345f3d73bb7$var$count = 0;
function $d172fcbd2da23bac$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($d172fcbd2da23bac$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($d172fcbd2da23bac$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


/* -------------------------------------------------------------------------------------------------
 * Collapsible
 * -----------------------------------------------------------------------------------------------*/ const $eabe53cc1d2d97a4$var$$409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible";
const [$eabe53cc1d2d97a4$var$$409067139f391064$var$createCollapsibleContext, $eabe53cc1d2d97a4$export$952b32dcbe73087a] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($eabe53cc1d2d97a4$var$$409067139f391064$var$COLLAPSIBLE_NAME);
const [$eabe53cc1d2d97a4$var$$409067139f391064$var$CollapsibleProvider, $eabe53cc1d2d97a4$var$$409067139f391064$var$useCollapsibleContext] = $eabe53cc1d2d97a4$var$$409067139f391064$var$createCollapsibleContext($eabe53cc1d2d97a4$var$$409067139f391064$var$COLLAPSIBLE_NAME);
const $eabe53cc1d2d97a4$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , open: openProp , defaultOpen: defaultOpen , disabled: disabled , onOpenChange: onOpenChange , ...collapsibleProps } = props;
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($eabe53cc1d2d97a4$var$$409067139f391064$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        open: open,
        onOpenToggle: (0, $bh6RR.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $eabe53cc1d2d97a4$var$$409067139f391064$var$getState(open),
        "data-disabled": disabled ? "" : undefined
    }, collapsibleProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($eabe53cc1d2d97a4$export$6eb0f7ddcda6131f, {
    displayName: $eabe53cc1d2d97a4$var$$409067139f391064$var$COLLAPSIBLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleTrigger
 * -----------------------------------------------------------------------------------------------*/ const $eabe53cc1d2d97a4$var$$409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger";
const $eabe53cc1d2d97a4$export$c135dce7b15bbbdc = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , ...triggerProps } = props;
    const context = $eabe53cc1d2d97a4$var$$409067139f391064$var$useCollapsibleContext($eabe53cc1d2d97a4$var$$409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $eabe53cc1d2d97a4$var$$409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? "" : undefined,
        disabled: context.disabled
    }, triggerProps, {
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($eabe53cc1d2d97a4$export$c135dce7b15bbbdc, {
    displayName: $eabe53cc1d2d97a4$var$$409067139f391064$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleContent
 * -----------------------------------------------------------------------------------------------*/ const $eabe53cc1d2d97a4$var$$409067139f391064$var$CONTENT_NAME = "CollapsibleContent";
const $eabe53cc1d2d97a4$export$aadde00976f34151 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...contentProps } = props;
    const context = $eabe53cc1d2d97a4$var$$409067139f391064$var$useCollapsibleContext($eabe53cc1d2d97a4$var$$409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, ({ present: present  })=>/*#__PURE__*/ (0, $bh6RR.createElement)($eabe53cc1d2d97a4$var$$409067139f391064$var$CollapsibleContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
            ref: forwardedRef,
            present: present
        })));
});
/*#__PURE__*/ Object.assign($eabe53cc1d2d97a4$export$aadde00976f34151, {
    displayName: $eabe53cc1d2d97a4$var$$409067139f391064$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $eabe53cc1d2d97a4$var$$409067139f391064$var$CollapsibleContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , present: present , children: children , ...contentProps } = props;
    const context = $eabe53cc1d2d97a4$var$$409067139f391064$var$useCollapsibleContext($eabe53cc1d2d97a4$var$$409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = (0, $bh6RR.useState)(present);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const heightRef = (0, $bh6RR.useRef)(0);
    const height = heightRef.current;
    const widthRef = (0, $bh6RR.useRef)(0);
    const width = widthRef.current; // when opening we want it to immediately open to retrieve dimensions
    // when closing we delay `present` to retrieve dimensions before closing
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = (0, $bh6RR.useRef)(isOpen);
    const originalStylesRef = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            }; // block any animations/transitions so the element renders at its full dimensions
            node.style.transitionDuration = "0s";
            node.style.animationName = "none"; // get width and height from full dimensions
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width; // kick off any animations/transitions that were originally set up if it isn't the initial mount
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    /**
     * depends on `context.open` because it will change to `false`
     * when a close is triggered but `present` will be `false` on
     * animation end (so when close finishes). This allows us to
     * retrieve the dimensions *before* closing.
     */ }, [
        context.open,
        present
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $eabe53cc1d2d97a4$var$$409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? "" : undefined,
        id: context.contentId,
        hidden: !isOpen
    }, contentProps, {
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : undefined,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : undefined,
            ...props.style
        }
    }), isOpen && children);
});
/* -----------------------------------------------------------------------------------------------*/ function $eabe53cc1d2d97a4$var$$409067139f391064$var$getState(open) {
    return open ? "open" : "closed";
}
const $eabe53cc1d2d97a4$export$be92b6f5f03c0fe9 = $eabe53cc1d2d97a4$export$6eb0f7ddcda6131f;
const $eabe53cc1d2d97a4$export$41fb9f06171c75f4 = $eabe53cc1d2d97a4$export$c135dce7b15bbbdc;
const $eabe53cc1d2d97a4$export$7c6e2c02157bb7d2 = $eabe53cc1d2d97a4$export$aadde00976f34151;




var $bh6RR = parcelRequire("bh6RR");
const $4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $4ac4e2f5e0780c9a$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $4ac4e2f5e0780c9a$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $bh6RR.useContext)($4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $4ac4e2f5e0780c9a$export$2881499e37b75b9a = $4ac4e2f5e0780c9a$export$c760c09fdd558351;


/* -------------------------------------------------------------------------------------------------
 * Accordion
 * -----------------------------------------------------------------------------------------------*/ const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME = "Accordion";
const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_KEYS = [
    "Home",
    "End",
    "ArrowDown",
    "ArrowUp",
    "ArrowLeft",
    "ArrowRight"
];
const [$e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$Collection, $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useCollection, $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$createCollectionScope] = (0, $c43a6ccc42422c95$export$c74125a8e3af6bb2)($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$createAccordionContext, $e694e3ad1f3a30c7$export$9748edc328a73be1] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, [
    $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$createCollectionScope,
    (0, $eabe53cc1d2d97a4$export$952b32dcbe73087a)
]);
const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useCollapsibleScope = (0, $eabe53cc1d2d97a4$export$952b32dcbe73087a)();
const $e694e3ad1f3a30c7$export$a766cd26d0d69044 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
    const { type: type , ...accordionProps } = props;
    const singleProps = accordionProps;
    const multipleProps = accordionProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$Collection.Provider, {
        scope: props.__scopeAccordion
    }, type === "multiple" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImplMultiple, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, multipleProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImplSingle, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, singleProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($e694e3ad1f3a30c7$export$a766cd26d0d69044, {
    displayName: $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME
});
$e694e3ad1f3a30c7$export$a766cd26d0d69044.propTypes = {
    type (props) {
        const value = props.value || props.defaultValue;
        if (props.type && ![
            "single",
            "multiple"
        ].includes(props.type)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.");
        if (props.type === "multiple" && typeof value === "string") return new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.");
        if (props.type === "single" && Array.isArray(value)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.");
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const [$e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionValueProvider, $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionValueContext] = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$createAccordionContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionCollapsibleContext] = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$createAccordionContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, {
    collapsible: false
});
const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImplSingle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , collapsible: collapsible = false , ...accordionSingleProps } = props;
    const [value, setValue] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value ? [
            value
        ] : [],
        onItemOpen: setValue,
        onItemClose: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>collapsible && setValue(""), [
            collapsible,
            setValue
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
        scope: props.__scopeAccordion,
        collapsible: collapsible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, accordionSingleProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImplMultiple = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , ...accordionMultipleProps } = props;
    const [value1 = [], setValue] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const handleItemOpen = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleItemClose = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value)=>value !== itemValue)), [
        setValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value1,
        onItemOpen: handleItemOpen,
        onItemClose: handleItemClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
        scope: props.__scopeAccordion,
        collapsible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, accordionMultipleProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const [$e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImplProvider, $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionContext] = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$createAccordionContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME);
const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImpl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , disabled: disabled , dir: dir , orientation: orientation = "vertical" , ...accordionProps } = props;
    const accordionRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(accordionRef, forwardedRef);
    const getItems = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useCollection(__scopeAccordion);
    const direction = (0, $4ac4e2f5e0780c9a$export$b39126d51d94e6f3)(dir);
    const isDirectionLTR = direction === "ltr";
    const handleKeyDown = (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
        var _triggerCollection$cl;
        if (!$e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_KEYS.includes(event.key)) return;
        const target = event.target;
        const triggerCollection = getItems().filter((item)=>{
            var _item$ref$current;
            return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
        });
        const triggerIndex = triggerCollection.findIndex((item)=>item.ref.current === target);
        const triggerCount = triggerCollection.length;
        if (triggerIndex === -1) return; // Prevents page scroll while user is navigating
        event.preventDefault();
        let nextIndex = triggerIndex;
        const homeIndex = 0;
        const endIndex = triggerCount - 1;
        const moveNext = ()=>{
            nextIndex = triggerIndex + 1;
            if (nextIndex > endIndex) nextIndex = homeIndex;
        };
        const movePrev = ()=>{
            nextIndex = triggerIndex - 1;
            if (nextIndex < homeIndex) nextIndex = endIndex;
        };
        switch(event.key){
            case "Home":
                nextIndex = homeIndex;
                break;
            case "End":
                nextIndex = endIndex;
                break;
            case "ArrowRight":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) moveNext();
                    else movePrev();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") moveNext();
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) movePrev();
                    else moveNext();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") movePrev();
                break;
        }
        const clampedIndex = nextIndex % triggerCount;
        (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionImplProvider, {
        scope: __scopeAccordion,
        disabled: disabled,
        direction: dir,
        orientation: orientation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$Collection.Slot, {
        scope: __scopeAccordion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, accordionProps, {
        "data-orientation": orientation,
        ref: composedRefs,
        onKeyDown: disabled ? undefined : handleKeyDown
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionItem
 * -----------------------------------------------------------------------------------------------*/ const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ITEM_NAME = "AccordionItem";
const [$e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionItemProvider, $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionItemContext] = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$createAccordionContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ITEM_NAME);
/**
 * `AccordionItem` contains all of the parts of a collapsible section inside of an `Accordion`.
 */ const $e694e3ad1f3a30c7$export$d99097c13d4dac9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , value: value , ...accordionItemProps } = props;
    const accordionContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
    const valueContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionValueContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
    const collapsibleScope = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    const triggerId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const open1 = value && valueContext.value.includes(value) || false;
    const disabled = accordionContext.disabled || props.disabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$AccordionItemProvider, {
        scope: __scopeAccordion,
        open: open1,
        disabled: disabled,
        triggerId: triggerId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eabe53cc1d2d97a4$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-orientation": accordionContext.orientation,
        "data-state": $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$getState(open1)
    }, collapsibleScope, accordionItemProps, {
        ref: forwardedRef,
        disabled: disabled,
        open: open1,
        onOpenChange: (open)=>{
            if (open) valueContext.onItemOpen(value);
            else valueContext.onItemClose(value);
        }
    })));
});
/*#__PURE__*/ Object.assign($e694e3ad1f3a30c7$export$d99097c13d4dac9f, {
    displayName: $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AccordionHeader
 * -----------------------------------------------------------------------------------------------*/ const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$HEADER_NAME = "AccordionHeader";
/**
 * `AccordionHeader` contains the content for the parts of an `AccordionItem` that will be visible
 * whether or not its content is collapsed.
 */ const $e694e3ad1f3a30c7$export$5e3e5deaaf81ee41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...headerProps } = props;
    const accordionContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionItemContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$HEADER_NAME, __scopeAccordion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).h3, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-orientation": accordionContext.orientation,
        "data-state": $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$getState(itemContext.open),
        "data-disabled": itemContext.disabled ? "" : undefined
    }, headerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e694e3ad1f3a30c7$export$5e3e5deaaf81ee41, {
    displayName: $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$HEADER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AccordionTrigger
 * -----------------------------------------------------------------------------------------------*/ const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$TRIGGER_NAME = "AccordionTrigger";
/**
 * `AccordionTrigger` is the trigger that toggles the collapsed state of an `AccordionItem`. It
 * should always be nested inside of an `AccordionHeader`.
 */ const $e694e3ad1f3a30c7$export$94e939b1f85bdd73 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...triggerProps } = props;
    const accordionContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionItemContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionCollapsibleContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleScope = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$Collection.ItemSlot, {
        scope: __scopeAccordion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eabe53cc1d2d97a4$export$41fb9f06171c75f4), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-disabled": itemContext.open && !collapsibleContext.collapsible || undefined,
        "data-orientation": accordionContext.orientation,
        id: itemContext.triggerId
    }, collapsibleScope, triggerProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($e694e3ad1f3a30c7$export$94e939b1f85bdd73, {
    displayName: $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AccordionContent
 * -----------------------------------------------------------------------------------------------*/ const $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$CONTENT_NAME = "AccordionContent";
/**
 * `AccordionContent` contains the collapsible content for an `AccordionItem`.
 */ const $e694e3ad1f3a30c7$export$985b9a77379b54a0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...contentProps } = props;
    const accordionContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useAccordionItemContext($e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$CONTENT_NAME, __scopeAccordion);
    const collapsibleScope = $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eabe53cc1d2d97a4$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "region",
        "aria-labelledby": itemContext.triggerId,
        "data-orientation": accordionContext.orientation
    }, collapsibleScope, contentProps, {
        ref: forwardedRef,
        style: {
            ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
            ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($e694e3ad1f3a30c7$export$985b9a77379b54a0, {
    displayName: $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $e694e3ad1f3a30c7$var$$1bf158f521e1b1b4$var$getState(open) {
    return open ? "open" : "closed";
}
const $e694e3ad1f3a30c7$export$be92b6f5f03c0fe9 = $e694e3ad1f3a30c7$export$a766cd26d0d69044;
const $e694e3ad1f3a30c7$export$6d08773d2e66f8f2 = $e694e3ad1f3a30c7$export$d99097c13d4dac9f;
const $e694e3ad1f3a30c7$export$8b251419efc915eb = $e694e3ad1f3a30c7$export$5e3e5deaaf81ee41;
const $e694e3ad1f3a30c7$export$41fb9f06171c75f4 = $e694e3ad1f3a30c7$export$94e939b1f85bdd73;
const $e694e3ad1f3a30c7$export$7c6e2c02157bb7d2 = $e694e3ad1f3a30c7$export$985b9a77379b54a0;


/**
 * lucide-react v0.288.0 - ISC
 */ 
const $2148299efdb5c48a$export$2e2bcd8739ae039 = (0, $dc38aceacd32c739$export$2e2bcd8739ae039)("ChevronDown", [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
]);


function $fa1a2e608fb826ea$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $fa1a2e608fb826ea$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $fa1a2e608fb826ea$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $fa1a2e608fb826ea$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fa1a2e608fb826ea$export$2e2bcd8739ae039 = $fa1a2e608fb826ea$export$4f5d2d50c9deca37;


var $28daedd7a8cf13b2$var$CLASS_PART_SEPARATOR = "-";
function $28daedd7a8cf13b2$export$e3a687438e51f555(config) {
    var classMap = $28daedd7a8cf13b2$export$936eaf1f027937d7(config);
    var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
    function getClassGroupId(className) {
        var classParts = className.split($28daedd7a8cf13b2$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $28daedd7a8cf13b2$var$getGroupRecursive(classParts, classMap) || $28daedd7a8cf13b2$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        var conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $28daedd7a8cf13b2$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[0];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    var classGroupFromNextClassPart = nextClassPartObject ? $28daedd7a8cf13b2$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    var classRest = classParts.join($28daedd7a8cf13b2$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(function(_ref) {
        var validator = _ref.validator;
        return validator(classRest);
    })?.classGroupId;
}
var $28daedd7a8cf13b2$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $28daedd7a8cf13b2$var$getGroupIdForArbitraryProperty(className) {
    if ($28daedd7a8cf13b2$var$arbitraryPropertyRegex.test(className)) {
        var arbitraryPropertyClassName = $28daedd7a8cf13b2$var$arbitraryPropertyRegex.exec(className)[1];
        var property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $28daedd7a8cf13b2$export$936eaf1f027937d7(config) {
    var theme = config.theme, prefix = config.prefix;
    var classMap = {
        nextPart: new Map(),
        validators: []
    };
    var prefixedClassGroupEntries = $28daedd7a8cf13b2$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(function(_ref2) {
        var classGroupId = _ref2[0], classGroup = _ref2[1];
        $28daedd7a8cf13b2$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $28daedd7a8cf13b2$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach(function(classDefinition) {
        if (typeof classDefinition === "string") {
            var classPartObjectToEdit = classDefinition === "" ? classPartObject : $28daedd7a8cf13b2$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($28daedd7a8cf13b2$var$isThemeGetter(classDefinition)) {
                $28daedd7a8cf13b2$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(function(_ref3) {
            var key = _ref3[0], classGroup = _ref3[1];
            $28daedd7a8cf13b2$var$processClassesRecursively(classGroup, $28daedd7a8cf13b2$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $28daedd7a8cf13b2$var$getPart(classPartObject, path) {
    var currentClassPartObject = classPartObject;
    path.split($28daedd7a8cf13b2$var$CLASS_PART_SEPARATOR).forEach(function(pathPart) {
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $28daedd7a8cf13b2$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $28daedd7a8cf13b2$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(function(_ref4) {
        var classGroupId = _ref4[0], classGroup = _ref4[1];
        var prefixedClassGroup = classGroup.map(function(classDefinition) {
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
                var key = _ref5[0], value = _ref5[1];
                return [
                    prefix + key,
                    value
                ];
            }));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}


// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $4707b55ae288e7f8$export$cf6a7cbaa5f64437(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function get() {
            return undefined;
        },
        set: function set() {}
    };
    var cacheSize = 0;
    var cache = new Map();
    var previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get: function get(key) {
            var value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}


var $9270754a4f9f3614$export$61823b46426d06fa = "!";
function $9270754a4f9f3614$export$b5f40ac45a8dd583(config) {
    var separator = config.separator || ":";
    var isSeparatorSingleCharacter = separator.length === 1;
    var firstSeparatorCharacter = separator[0];
    var separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        for(var index = 0; index < className.length; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        var hasImportantModifier = baseClassNameWithImportantModifier.startsWith($9270754a4f9f3614$export$61823b46426d06fa);
        var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $9270754a4f9f3614$export$4f247a60f8a83b3a(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    var sortedModifiers = [];
    var unsortedModifiers = [];
    modifiers.forEach(function(modifier) {
        var isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([
                modifier
            ]));
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
    return sortedModifiers;
}


function $4e8b98b622c8eddd$export$56ab4ba5b0b25eb0(config) {
    return {
        cache: (0, $4707b55ae288e7f8$export$cf6a7cbaa5f64437)(config.cacheSize),
        splitModifiers: (0, $9270754a4f9f3614$export$b5f40ac45a8dd583)(config),
        ...(0, $28daedd7a8cf13b2$export$e3a687438e51f555)(config)
    };
}



var $b349a8363cf7ab57$var$SPLIT_CLASSES_REGEX = /\s+/;
function $b349a8363cf7ab57$export$b41084d9255a3248(classList, configUtils) {
    var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = new Set();
    return classList.trim().split($b349a8363cf7ab57$var$SPLIT_CLASSES_REGEX).map(function(originalClassName) {
        var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
        var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        var variantModifier = (0, $9270754a4f9f3614$export$4f247a60f8a83b3a)(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + (0, $9270754a4f9f3614$export$61823b46426d06fa) : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter(function(parsed) {
        if (!parsed.isTailwindClass) return true;
        var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
            return classGroupsInConflict.add(modifierId + group);
        });
        return true;
    }).reverse().map(function(parsed) {
        return parsed.originalClassName;
    }).join(" ");
}


/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $049d6204c3fd8b94$export$a8bbfb445e1f163f() {
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $049d6204c3fd8b94$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $049d6204c3fd8b94$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $049d6204c3fd8b94$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}


function $02b505b6857dfcd4$export$ea2d4fba4d1bd27f() {
    for(var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++)createConfig[_key] = arguments[_key];
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
        var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, firstCreateConfig());
        configUtils = (0, $4e8b98b622c8eddd$export$56ab4ba5b0b25eb0)(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = (0, $b349a8363cf7ab57$export$b41084d9255a3248)(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall((0, $049d6204c3fd8b94$export$a8bbfb445e1f163f).apply(null, arguments));
    };
}


function $7ee5b424ab0fa1bb$export$e176af7b8eefe933(key) {
    var themeGetter = function themeGetter(theme) {
        return theme[key] || [];
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
}


var $72990d7fd9846713$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var $72990d7fd9846713$var$fractionRegex = /^\d+\/\d+$/;
var $72990d7fd9846713$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
var $72990d7fd9846713$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $72990d7fd9846713$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
var $72990d7fd9846713$var$shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $72990d7fd9846713$export$38db3d147cb3433(value) {
    return $72990d7fd9846713$export$7e4aa119212bc614(value) || $72990d7fd9846713$var$stringLengths.has(value) || $72990d7fd9846713$var$fractionRegex.test(value) || $72990d7fd9846713$export$f5e3af6d4c0fbe38(value);
}
function $72990d7fd9846713$export$f5e3af6d4c0fbe38(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "length", $72990d7fd9846713$var$isLengthOnly);
}
function $72990d7fd9846713$export$92dbd3a305a7cb8b(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "size", $72990d7fd9846713$var$isNever);
}
function $72990d7fd9846713$export$57d00f225f425549(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "position", $72990d7fd9846713$var$isNever);
}
function $72990d7fd9846713$export$478a5386e985802b(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "url", $72990d7fd9846713$var$isUrl);
}
function $72990d7fd9846713$export$ea45ce4f1b2d6088(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "number", $72990d7fd9846713$export$7e4aa119212bc614);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */ var $72990d7fd9846713$export$cd3ce15f42623f06 = $72990d7fd9846713$export$ea45ce4f1b2d6088;
function $72990d7fd9846713$export$7e4aa119212bc614(value) {
    return !Number.isNaN(Number(value));
}
function $72990d7fd9846713$export$e50269385c77c348(value) {
    return value.endsWith("%") && $72990d7fd9846713$export$7e4aa119212bc614(value.slice(0, -1));
}
function $72990d7fd9846713$export$a287f47fed4544b8(value) {
    return $72990d7fd9846713$var$isIntegerOnly(value) || $72990d7fd9846713$var$getIsArbitraryValue(value, "number", $72990d7fd9846713$var$isIntegerOnly);
}
function $72990d7fd9846713$export$5534a8576501817d(value) {
    return $72990d7fd9846713$var$arbitraryValueRegex.test(value);
}
function $72990d7fd9846713$export$ebb65efc98a3b5f7() {
    return true;
}
function $72990d7fd9846713$export$a40791c6b7db5bcc(value) {
    return $72990d7fd9846713$var$tshirtUnitRegex.test(value);
}
function $72990d7fd9846713$export$d01106465b385604(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "", $72990d7fd9846713$var$isShadow);
}
function $72990d7fd9846713$var$getIsArbitraryValue(value, label, testValue) {
    var result = $72990d7fd9846713$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return result[1] === label;
        return testValue(result[2]);
    }
    return false;
}
function $72990d7fd9846713$var$isLengthOnly(value) {
    return $72990d7fd9846713$var$lengthUnitRegex.test(value);
}
function $72990d7fd9846713$var$isNever() {
    return false;
}
function $72990d7fd9846713$var$isUrl(value) {
    return value.startsWith("url(");
}
function $72990d7fd9846713$var$isIntegerOnly(value) {
    return Number.isInteger(Number(value));
}
function $72990d7fd9846713$var$isShadow(value) {
    return $72990d7fd9846713$var$shadowRegex.test(value);
}


function $891902bcdecedc9f$export$ed30944e0fe6ae5c() {
    var colors = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("colors");
    var spacing = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("spacing");
    var blur = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("blur");
    var brightness = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("brightness");
    var borderColor = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("borderColor");
    var borderRadius = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("borderRadius");
    var borderSpacing = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("borderSpacing");
    var borderWidth = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("borderWidth");
    var contrast = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("contrast");
    var grayscale = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("grayscale");
    var hueRotate = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("hueRotate");
    var invert = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("invert");
    var gap = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("gap");
    var gradientColorStops = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("gradientColorStops");
    var gradientColorStopPositions = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("gradientColorStopPositions");
    var inset = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("inset");
    var margin = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("margin");
    var opacity = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("opacity");
    var padding = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("padding");
    var saturate = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("saturate");
    var scale = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("scale");
    var sepia = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("sepia");
    var skew = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("skew");
    var space = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("space");
    var translate = (0, $7ee5b424ab0fa1bb$export$e176af7b8eefe933)("translate");
    var getOverscroll = function getOverscroll() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var getOverflow = function getOverflow() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $72990d7fd9846713$export$5534a8576501817d),
            spacing
        ];
    };
    var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
        return [
            (0, $72990d7fd9846713$export$5534a8576501817d),
            spacing
        ];
    };
    var getLengthWithEmpty = function getLengthWithEmpty() {
        return [
            "",
            (0, $72990d7fd9846713$export$38db3d147cb3433)
        ];
    };
    var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $72990d7fd9846713$export$7e4aa119212bc614),
            (0, $72990d7fd9846713$export$5534a8576501817d)
        ];
    };
    var getPositions = function getPositions() {
        return [
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    };
    var getLineStyles = function getLineStyles() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    };
    var getBlendModes = function getBlendModes() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    };
    var getAlign = function getAlign() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    };
    var getZeroAndEmpty = function getZeroAndEmpty() {
        return [
            "",
            "0",
            (0, $72990d7fd9846713$export$5534a8576501817d)
        ];
    };
    var getBreaks = function getBreaks() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var getNumber = function getNumber() {
        return [
            (0, $72990d7fd9846713$export$7e4aa119212bc614),
            (0, $72990d7fd9846713$export$ea45ce4f1b2d6088)
        ];
    };
    var getNumberAndArbitrary = function getNumberAndArbitrary() {
        return [
            (0, $72990d7fd9846713$export$7e4aa119212bc614),
            (0, $72990d7fd9846713$export$5534a8576501817d)
        ];
    };
    return {
        cacheSize: 500,
        theme: {
            colors: [
                (0, $72990d7fd9846713$export$ebb65efc98a3b5f7)
            ],
            spacing: [
                (0, $72990d7fd9846713$export$38db3d147cb3433)
            ],
            blur: [
                "none",
                "",
                (0, $72990d7fd9846713$export$a40791c6b7db5bcc),
                (0, $72990d7fd9846713$export$5534a8576501817d)
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                (0, $72990d7fd9846713$export$a40791c6b7db5bcc),
                (0, $72990d7fd9846713$export$5534a8576501817d)
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmpty(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                (0, $72990d7fd9846713$export$e50269385c77c348),
                (0, $72990d7fd9846713$export$f5e3af6d4c0fbe38)
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        (0, $72990d7fd9846713$export$a40791c6b7db5bcc)
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ "float": [
                {
                    "float": [
                        "right",
                        "left",
                        "none"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [].concat(getPositions(), [
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ])
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        (0, $72990d7fd9846713$export$a287f47fed4544b8)
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        (0, $72990d7fd9846713$export$a287f47fed4544b8)
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        (0, $72990d7fd9846713$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                (0, $72990d7fd9846713$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        (0, $72990d7fd9846713$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                (0, $72990d7fd9846713$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal"
                    ].concat(getAlign())
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        (0, $72990d7fd9846713$export$5534a8576501817d),
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        "min",
                        "max",
                        "fit",
                        (0, $72990d7fd9846713$export$5534a8576501817d),
                        (0, $72990d7fd9846713$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        "0",
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                (0, $72990d7fd9846713$export$a40791c6b7db5bcc)
                            ]
                        },
                        (0, $72990d7fd9846713$export$a40791c6b7db5bcc),
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        (0, $72990d7fd9846713$export$5534a8576501817d),
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        "min",
                        "max",
                        "fit",
                        (0, $72990d7fd9846713$export$5534a8576501817d),
                        (0, $72990d7fd9846713$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        (0, $72990d7fd9846713$export$5534a8576501817d),
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        (0, $72990d7fd9846713$export$a40791c6b7db5bcc),
                        (0, $72990d7fd9846713$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        (0, $72990d7fd9846713$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        (0, $72990d7fd9846713$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        (0, $72990d7fd9846713$export$7e4aa119212bc614),
                        (0, $72990d7fd9846713$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        (0, $72990d7fd9846713$export$5534a8576501817d),
                        (0, $72990d7fd9846713$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [].concat(getLineStyles(), [
                        "wavy"
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        (0, $72990d7fd9846713$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        (0, $72990d7fd9846713$export$5534a8576501817d),
                        (0, $72990d7fd9846713$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ "break": [
                {
                    "break": [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [].concat(getPositions(), [
                        (0, $72990d7fd9846713$export$57d00f225f425549)
                    ])
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        (0, $72990d7fd9846713$export$92dbd3a305a7cb8b)
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        (0, $72990d7fd9846713$export$478a5386e985802b)
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [].concat(getLineStyles(), [
                        "hidden"
                    ])
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        ""
                    ].concat(getLineStyles())
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        (0, $72990d7fd9846713$export$5534a8576501817d),
                        (0, $72990d7fd9846713$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        (0, $72990d7fd9846713$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmpty()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        (0, $72990d7fd9846713$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        (0, $72990d7fd9846713$export$a40791c6b7db5bcc),
                        (0, $72990d7fd9846713$export$d01106465b385604)
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        (0, $72990d7fd9846713$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        (0, $72990d7fd9846713$export$a40791c6b7db5bcc),
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        (0, $72990d7fd9846713$export$a287f47fed4544b8),
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                "appearance-none"
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "pinch-zoom",
                        "manipulation",
                        {
                            pan: [
                                "x",
                                "left",
                                "right",
                                "y",
                                "up",
                                "down"
                            ]
                        }
                    ]
                }
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        (0, $72990d7fd9846713$export$5534a8576501817d)
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        (0, $72990d7fd9846713$export$38db3d147cb3433),
                        (0, $72990d7fd9846713$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}


var $3b83a0ac4514ea3d$export$b4660bb6000dfbc9 = /*#__PURE__*/ (0, $02b505b6857dfcd4$export$ea2d4fba4d1bd27f)((0, $891902bcdecedc9f$export$ed30944e0fe6ae5c));


function $92dc8dbec6af1b1e$export$1343a74baacb0543(...inputs) {
    return (0, $3b83a0ac4514ea3d$export$b4660bb6000dfbc9)((0, $fa1a2e608fb826ea$export$4f5d2d50c9deca37)(inputs));
}
function $92dc8dbec6af1b1e$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
const $92dc8dbec6af1b1e$export$4385e60b38654f68 = (min, max)=>Math.floor(Math.random() * (max - min)) + min;
const $92dc8dbec6af1b1e$export$d02631cccf789723 = (start, end, step = 1)=>{
    let output = [];
    if (typeof end === "undefined") {
        end = start;
        start = 0;
    }
    for(let i = start; i < end; i += step)output.push(i);
    return output;
};
const $92dc8dbec6af1b1e$export$4812e460280c6ef2 = (arr)=>{
    return arr[Math.floor(Math.random() * arr.length)];
};
const $92dc8dbec6af1b1e$export$448332262467e042 = (array)=>{
    let currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle.
    while(currentIndex > 0){
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
};
const $92dc8dbec6af1b1e$export$5f7ec48d69707ddd = (chunkSize, array)=>{
    const chunkedArray = [];
    for(let i = 0; i < array.length; i += chunkSize){
        const sub = array.slice(i, i + chunkSize);
        chunkedArray.push(sub);
    }
    return chunkedArray;
};
const $92dc8dbec6af1b1e$export$4c3569103e7f2532 = (arr1, arr2)=>{
    return [
        ...arr1
    ].filter((x)=>!arr2.includes(x));
};
const $92dc8dbec6af1b1e$export$76a46922e320ce3b = (arr1, arr2)=>{
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
    const difference = $92dc8dbec6af1b1e$export$4c3569103e7f2532(arr1, arr2);
    return difference.length === 0 && arr1.length === arr2.length;
};


const $742edf3294a6f836$export$a766cd26d0d69044 = $e694e3ad1f3a30c7$export$be92b6f5f03c0fe9;
const $742edf3294a6f836$export$d99097c13d4dac9f = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e694e3ad1f3a30c7$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("border-b", className),
        ...props
    }));
$742edf3294a6f836$export$d99097c13d4dac9f.displayName = "AccordionItem";
const $742edf3294a6f836$export$94e939b1f85bdd73 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , children: children , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e694e3ad1f3a30c7$export$8b251419efc915eb, {
        className: "flex",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($e694e3ad1f3a30c7$export$41fb9f06171c75f4, {
            ref: ref,
            className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180", className),
            ...props,
            children: [
                children,
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2148299efdb5c48a$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 shrink-0 transition-transform duration-200"
                })
            ]
        })
    }));
$742edf3294a6f836$export$94e939b1f85bdd73.displayName = $e694e3ad1f3a30c7$export$41fb9f06171c75f4.displayName;
const $742edf3294a6f836$export$985b9a77379b54a0 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , children: children , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e694e3ad1f3a30c7$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down", className),
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "pb-4 pt-0",
            children: children
        })
    }));
$742edf3294a6f836$export$985b9a77379b54a0.displayName = $e694e3ad1f3a30c7$export$7c6e2c02157bb7d2.displayName;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");

/**
 * Listens for when the escape key is down
 */ function $879e0a3f7f60ef06$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $bh6RR.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $8473b83e333b07d4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $bh6RR.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $8473b83e333b07d4$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0, $bh6RR.useContext)($8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $bh6RR.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $bh6RR.useState)({});
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $8473b83e333b07d4$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $8473b83e333b07d4$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $879e0a3f7f60ef06$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $bh6RR.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($8473b83e333b07d4$export$177fb62ff3ec1f22, {
    displayName: $8473b83e333b07d4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $8473b83e333b07d4$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $8473b83e333b07d4$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = (0, $bh6RR.useContext)($8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($8473b83e333b07d4$export$4d5eb2109db14228, {
    displayName: $8473b83e333b07d4$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $8473b83e333b07d4$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    const handleClickRef = (0, $bh6RR.useRef)(()=>{});
    (0, $bh6RR.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $8473b83e333b07d4$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $793b1a0f4d9647b1$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $8473b83e333b07d4$export$be92b6f5f03c0fe9 = $8473b83e333b07d4$export$177fb62ff3ec1f22;
const $8473b83e333b07d4$export$aecb2ddcb55c95be = $8473b83e333b07d4$export$4d5eb2109db14228;




var $bh6RR = parcelRequire("bh6RR");



const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $0757534448b5e4bf$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = (0, $bh6RR.useState)(null);
    const onMountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $bh6RR.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $bh6RR.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (container1) {
            $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusFirst($0757534448b5e4bf$var$$d3863c46a17e8a28$var$removeLinks($0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $bh6RR.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($0757534448b5e4bf$export$20e40289641fbbb6, {
    displayName: $0757534448b5e4bf$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$0757534448b5e4bf$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $0757534448b5e4bf$export$be92b6f5f03c0fe9 = $0757534448b5e4bf$export$20e40289641fbbb6;




var $bh6RR = parcelRequire("bh6RR");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $252b3d40eb00b07a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $252b3d40eb00b07a$export$602eac185826482c = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).createPortal(/*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($252b3d40eb00b07a$export$602eac185826482c, {
    displayName: $252b3d40eb00b07a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $252b3d40eb00b07a$export$be92b6f5f03c0fe9 = $252b3d40eb00b07a$export$602eac185826482c;





var $bh6RR = parcelRequire("bh6RR");
/** Number of components which have requested interest to have focus guards */ let $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count = 0;
function $39ae7ab2790868b6$export$ac5b58043b79449b(props) {
    $39ae7ab2790868b6$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $39ae7ab2790868b6$export$b7ece24a22aeda8c() {
    (0, $bh6RR.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $39ae7ab2790868b6$export$be92b6f5f03c0fe9 = $39ae7ab2790868b6$export$ac5b58043b79449b;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
var $dbb3c33b31cdcfb1$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $dbb3c33b31cdcfb1$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $dbb3c33b31cdcfb1$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $83a050b8f7e61fc1$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $bh6RR = parcelRequire("bh6RR");
function $bcea459d6fe13dac$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $bh6RR.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $59e9bf7262dc1a6d$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $bcea459d6fe13dac$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



function $0647093a1b1c5afc$var$ItoI(a) {
    return a;
}
function $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $0647093a1b1c5afc$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    return $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware);
}
function $0647093a1b1c5afc$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $0647093a1b1c5afc$var$innerCreateMedium(null);
    medium.options = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $1e32631777ba14da$export$e27363444bedfeac = (0, $0647093a1b1c5afc$export$e13ec7dd7a14088d)();


var $1c1f9cd94bee4822$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $1c1f9cd94bee4822$export$22940b497e769dee = $bh6RR.forwardRef(function(props, parentRef) {
    var ref = $bh6RR.useRef(null);
    var _a = $bh6RR.useState({
        onScrollCapture: $1c1f9cd94bee4822$var$nothing,
        onWheelCapture: $1c1f9cd94bee4822$var$nothing,
        onTouchMoveCapture: $1c1f9cd94bee4822$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $59e9bf7262dc1a6d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest), callbacks);
    return $bh6RR.createElement($bh6RR.Fragment, null, enabled && $bh6RR.createElement(SideCar, {
        sideCar: (0, $1e32631777ba14da$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $bh6RR.cloneElement($bh6RR.Children.only(children), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $bh6RR.createElement(Container, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$1c1f9cd94bee4822$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$1c1f9cd94bee4822$export$22940b497e769dee.classNames = {
    fullWidth: (0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e),
    zeroRight: (0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3)
};




var $bh6RR = parcelRequire("bh6RR");
var $db1654befbc8d676$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $bh6RR.createElement(Target, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest));
};
$db1654befbc8d676$var$SideCar.isSideCarExport = true;
function $db1654befbc8d676$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $db1654befbc8d676$var$SideCar;
}




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
var $c1a97cf4bee7a747$var$currentNonce;
var $c1a97cf4bee7a747$export$c5f670b24c0ae95a = function(nonce) {
    $c1a97cf4bee7a747$var$currentNonce = nonce;
};
var $c1a97cf4bee7a747$export$2b85b721e524d74b = function() {
    if ($c1a97cf4bee7a747$var$currentNonce) return $c1a97cf4bee7a747$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $ec0bd1fbc8093bb3$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c1a97cf4bee7a747$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $ec0bd1fbc8093bb3$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ec0bd1fbc8093bb3$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $ec0bd1fbc8093bb3$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $ec0bd1fbc8093bb3$var$makeStyleTag()) {
                    $ec0bd1fbc8093bb3$var$injectStyles(stylesheet, style);
                    $ec0bd1fbc8093bb3$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $388d9750a20580a4$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $ec0bd1fbc8093bb3$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $bh6RR.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $8f0cc34b8d78d287$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $388d9750a20580a4$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $c24b64e0e48f5c2b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $c24b64e0e48f5c2b$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $c24b64e0e48f5c2b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $c24b64e0e48f5c2b$var$parse(left),
        $c24b64e0e48f5c2b$var$parse(top),
        $c24b64e0e48f5c2b$var$parse(right)
    ];
};
var $c24b64e0e48f5c2b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $c24b64e0e48f5c2b$export$efed13b5d0ca3386;
    var offsets = $c24b64e0e48f5c2b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $a1bca04d3c994e31$var$Style = (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $a1bca04d3c994e31$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $dbb3c33b31cdcfb1$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $dbb3c33b31cdcfb1$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $a1bca04d3c994e31$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $bh6RR.useMemo(function() {
        return (0, $c24b64e0e48f5c2b$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $bh6RR.createElement($a1bca04d3c994e31$var$Style, {
        styles: $a1bca04d3c994e31$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $c3d5eca92c5827bc$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $c3d5eca92c5827bc$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $c3d5eca92c5827bc$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
    // @ts-ignore
    window.removeEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
} catch (err) {
    $c3d5eca92c5827bc$var$passiveSupported = false;
}
var $c3d5eca92c5827bc$export$10a6e88623fa9454 = $c3d5eca92c5827bc$var$passiveSupported ? {
    passive: false
} : false;


var $b2f037382e9b8811$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $b2f037382e9b8811$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$b2f037382e9b8811$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $b2f037382e9b8811$var$elementCouldBeVScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowY");
};
var $b2f037382e9b8811$var$elementCouldBeHScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowX");
};
var $b2f037382e9b8811$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $b2f037382e9b8811$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $b2f037382e9b8811$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $b2f037382e9b8811$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $b2f037382e9b8811$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $b2f037382e9b8811$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$elementCouldBeVScrolled(node) : $b2f037382e9b8811$var$elementCouldBeHScrolled(node);
};
var $b2f037382e9b8811$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$getVScrollVariables(node) : $b2f037382e9b8811$var$getHScrollVariables(node);
};
var $b2f037382e9b8811$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $b2f037382e9b8811$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $b2f037382e9b8811$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $b2f037382e9b8811$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($b2f037382e9b8811$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $0012650a668228df$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $0012650a668228df$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $0012650a668228df$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $0012650a668228df$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $0012650a668228df$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $0012650a668228df$var$idCounter = 0;
var $0012650a668228df$var$lockStack = [];
function $0012650a668228df$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $bh6RR.useRef([]);
    var touchStartRef = $bh6RR.useRef([
        0,
        0
    ]);
    var activeAxis = $bh6RR.useRef();
    var id = $bh6RR.useState($0012650a668228df$var$idCounter++)[0];
    var Style = $bh6RR.useState(function() {
        return (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $bh6RR.useRef(props);
    $bh6RR.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $bh6RR.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($0012650a668228df$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $bh6RR.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $0012650a668228df$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $b2f037382e9b8811$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $bh6RR.useCallback(function(_event) {
        var event = _event;
        if (!$0012650a668228df$var$lockStack.length || $0012650a668228df$var$lockStack[$0012650a668228df$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $0012650a668228df$export$39efaa2ca254a28d(event) : $0012650a668228df$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $0012650a668228df$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($0012650a668228df$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $bh6RR.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $bh6RR.useCallback(function(event) {
        touchStartRef.current = $0012650a668228df$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $bh6RR.useEffect(function() {
        $0012650a668228df$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        return function() {
            $0012650a668228df$var$lockStack = $0012650a668228df$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $bh6RR.createElement($bh6RR.Fragment, null, inert ? $bh6RR.createElement(Style, {
        styles: $0012650a668228df$var$generateStyle(id)
    }) : null, removeScrollBar ? $bh6RR.createElement((0, $a1bca04d3c994e31$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $32fbe4a10a756a07$export$2e2bcd8739ae039 = (0, $db1654befbc8d676$export$6cacc8fb0a9b94ce)((0, $1e32631777ba14da$export$e27363444bedfeac), (0, $0012650a668228df$export$a09dbff87b5da2d));


var $2a904e957609af53$var$ReactRemoveScroll = $bh6RR.forwardRef(function(props, ref) {
    return $bh6RR.createElement((0, $1c1f9cd94bee4822$export$22940b497e769dee), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $32fbe4a10a756a07$export$2e2bcd8739ae039)
    }));
});
$2a904e957609af53$var$ReactRemoveScroll.classNames = (0, $1c1f9cd94bee4822$export$22940b497e769dee).classNames;
var $2a904e957609af53$export$2e2bcd8739ae039 = $2a904e957609af53$var$ReactRemoveScroll;


var $43e375177e5001c1$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $43e375177e5001c1$var$counterMap = new WeakMap();
var $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
var $43e375177e5001c1$var$markerMap = {};
var $43e375177e5001c1$var$lockCount = 0;
var $43e375177e5001c1$var$unwrapHost = function(node) {
    return node && (node.host || $43e375177e5001c1$var$unwrapHost(node.parentNode));
};
var $43e375177e5001c1$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $43e375177e5001c1$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $43e375177e5001c1$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $43e375177e5001c1$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$43e375177e5001c1$var$markerMap[markerName]) $43e375177e5001c1$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $43e375177e5001c1$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($43e375177e5001c1$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $43e375177e5001c1$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $43e375177e5001c1$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $43e375177e5001c1$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $43e375177e5001c1$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $43e375177e5001c1$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$43e375177e5001c1$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $43e375177e5001c1$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $43e375177e5001c1$var$lockCount--;
        if (!$43e375177e5001c1$var$lockCount) {
            // clear
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
            $43e375177e5001c1$var$markerMap = {};
        }
    };
};
var $43e375177e5001c1$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $43e375177e5001c1$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $43e375177e5001c1$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $43e375177e5001c1$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $43e375177e5001c1$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $43e375177e5001c1$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($43e375177e5001c1$export$cc95fea82d705fca() ? $43e375177e5001c1$export$59151cc8db999a24 : $43e375177e5001c1$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$createDialogContext, $919b3aedf69a16e5$export$cc702773b8ea3e41] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogProvider, $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$createDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $919b3aedf69a16e5$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = (0, $bh6RR.useRef)(null);
    const contentRef = (0, $bh6RR.useRef)(null);
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        titleId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        descriptionId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $bh6RR.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$3ddf2d174ce01153, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $919b3aedf69a16e5$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$2e1e1122cf0cba88, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PortalProvider, $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$createDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $919b3aedf69a16e5$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $bh6RR.Children).map(children, (child)=>/*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$dad7c95542bacce0, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $919b3aedf69a16e5$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$usePortalContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$bd1d06c79be19e17, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $bh6RR.createElement)((0, $2a904e957609af53$export$2e2bcd8739ae039), {
        as: (0, $18fd289ffa468154$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $919b3aedf69a16e5$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$usePortalContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$b6d9565de1e068cf, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $bh6RR.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $bh6RR.useRef)(false);
    const hasPointerDownOutsideRef = (0, $bh6RR.useRef)(false);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $39ae7ab2790868b6$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0757534448b5e4bf$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $919b3aedf69a16e5$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).h2, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$16f7638e4a34b909, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $919b3aedf69a16e5$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).p, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$94e94c2ec2c954d5, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $919b3aedf69a16e5$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$fba2fb7cd781b7ac, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$919b3aedf69a16e5$export$69b62a49393917d6, $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $1cecd1d75f085228$export$fd42f52fd3ae1109)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useWarningContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $bh6RR.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useWarningContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $bh6RR.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $919b3aedf69a16e5$export$be92b6f5f03c0fe9 = $919b3aedf69a16e5$export$3ddf2d174ce01153;
const $919b3aedf69a16e5$export$41fb9f06171c75f4 = $919b3aedf69a16e5$export$2e1e1122cf0cba88;
const $919b3aedf69a16e5$export$602eac185826482c = $919b3aedf69a16e5$export$dad7c95542bacce0;
const $919b3aedf69a16e5$export$c6fdb837b070b4ff = $919b3aedf69a16e5$export$bd1d06c79be19e17;
const $919b3aedf69a16e5$export$7c6e2c02157bb7d2 = $919b3aedf69a16e5$export$b6d9565de1e068cf;
const $919b3aedf69a16e5$export$f99233281efd08a0 = $919b3aedf69a16e5$export$16f7638e4a34b909;
const $919b3aedf69a16e5$export$393edc798c47379d = $919b3aedf69a16e5$export$94e94c2ec2c954d5;
const $919b3aedf69a16e5$export$f39c2d165cd861fe = $919b3aedf69a16e5$export$fba2fb7cd781b7ac;




/* -------------------------------------------------------------------------------------------------
 * AlertDialog
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$ROOT_NAME = "AlertDialog";
const [$217e1b2155a036b0$var$$905f4ae918aab1aa$var$createAlertDialogContext, $217e1b2155a036b0$export$b8891880751c2c5b] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($217e1b2155a036b0$var$$905f4ae918aab1aa$var$ROOT_NAME, [
    (0, $919b3aedf69a16e5$export$cc702773b8ea3e41)
]);
const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope = (0, $919b3aedf69a16e5$export$cc702773b8ea3e41)();
const $217e1b2155a036b0$export$de466dd8317b0b75 = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...alertDialogProps } = props;
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, dialogScope, alertDialogProps, {
        modal: true
    }));
};
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$de466dd8317b0b75, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$ROOT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$TRIGGER_NAME = "AlertDialogTrigger";
const $217e1b2155a036b0$export$6edd7a623ef0f40b = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...triggerProps } = props;
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$41fb9f06171c75f4), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, dialogScope, triggerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$6edd7a623ef0f40b, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$PORTAL_NAME = "AlertDialogPortal";
const $217e1b2155a036b0$export$660f2bfdb986706c = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...portalProps } = props;
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$602eac185826482c), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, dialogScope, portalProps));
};
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$660f2bfdb986706c, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$OVERLAY_NAME = "AlertDialogOverlay";
const $217e1b2155a036b0$export$a707a4895ce23256 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...overlayProps } = props;
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$c6fdb837b070b4ff), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, dialogScope, overlayProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$a707a4895ce23256, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$OVERLAY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogContent
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$CONTENT_NAME = "AlertDialogContent";
const [$217e1b2155a036b0$var$$905f4ae918aab1aa$var$AlertDialogContentProvider, $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useAlertDialogContentContext] = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$createAlertDialogContext($217e1b2155a036b0$var$$905f4ae918aab1aa$var$CONTENT_NAME);
const $217e1b2155a036b0$export$94e6af45f0af4efd = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , children: children , ...contentProps } = props;
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    const contentRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const cancelRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$69b62a49393917d6), {
        contentName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$CONTENT_NAME,
        titleName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$TITLE_NAME,
        docsSlug: "alert-dialog"
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($217e1b2155a036b0$var$$905f4ae918aab1aa$var$AlertDialogContentProvider, {
        scope: __scopeAlertDialog,
        cancelRef: cancelRef
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "alertdialog"
    }, dialogScope, contentProps, {
        ref: composedRefs,
        onOpenAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(contentProps.onOpenAutoFocus, (event)=>{
            var _cancelRef$current;
            event.preventDefault();
            (_cancelRef$current = cancelRef.current) === null || _cancelRef$current === void 0 || _cancelRef$current.focus({
                preventScroll: true
            });
        }),
        onPointerDownOutside: (event)=>event.preventDefault(),
        onInteractOutside: (event)=>event.preventDefault()
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $18fd289ffa468154$export$d9f1ccf0bdb05d45), null, children), false)));
});
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$94e6af45f0af4efd, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$TITLE_NAME = "AlertDialogTitle";
const $217e1b2155a036b0$export$225e0da62d314b7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...titleProps } = props;
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$f99233281efd08a0), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, dialogScope, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$225e0da62d314b7, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$DESCRIPTION_NAME = "AlertDialogDescription";
const $217e1b2155a036b0$export$a23b55cde55ad9a5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...descriptionProps } = props;
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$393edc798c47379d), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, dialogScope, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$a23b55cde55ad9a5, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogAction
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$ACTION_NAME = "AlertDialogAction";
const $217e1b2155a036b0$export$b454f818c58ee85d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...actionProps } = props;
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$f39c2d165cd861fe), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, dialogScope, actionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$b454f818c58ee85d, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogCancel
 * -----------------------------------------------------------------------------------------------*/ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$CANCEL_NAME = "AlertDialogCancel";
const $217e1b2155a036b0$export$2f67a923571aaea0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...cancelProps } = props;
    const { cancelRef: cancelRef  } = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useAlertDialogContentContext($217e1b2155a036b0$var$$905f4ae918aab1aa$var$CANCEL_NAME, __scopeAlertDialog);
    const dialogScope = $217e1b2155a036b0$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    const ref = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, cancelRef);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $919b3aedf69a16e5$export$f39c2d165cd861fe), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, dialogScope, cancelProps, {
        ref: ref
    }));
});
/*#__PURE__*/ Object.assign($217e1b2155a036b0$export$2f67a923571aaea0, {
    displayName: $217e1b2155a036b0$var$$905f4ae918aab1aa$var$CANCEL_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $217e1b2155a036b0$var$$905f4ae918aab1aa$var$DescriptionWarning = ({ contentRef: contentRef  })=>{
    const MESSAGE = `\`${$217e1b2155a036b0$var$$905f4ae918aab1aa$var$CONTENT_NAME}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${$217e1b2155a036b0$var$$905f4ae918aab1aa$var$CONTENT_NAME}\` by passing a \`${$217e1b2155a036b0$var$$905f4ae918aab1aa$var$DESCRIPTION_NAME}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${$217e1b2155a036b0$var$$905f4ae918aab1aa$var$CONTENT_NAME}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
    (0, $bh6RR.useEffect)(()=>{
        var _contentRef$current;
        const hasDescription = document.getElementById((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"));
        if (!hasDescription) console.warn(MESSAGE);
    }, [
        MESSAGE,
        contentRef
    ]);
    return null;
};
const $217e1b2155a036b0$export$be92b6f5f03c0fe9 = $217e1b2155a036b0$export$de466dd8317b0b75;
const $217e1b2155a036b0$export$41fb9f06171c75f4 = $217e1b2155a036b0$export$6edd7a623ef0f40b;
const $217e1b2155a036b0$export$602eac185826482c = $217e1b2155a036b0$export$660f2bfdb986706c;
const $217e1b2155a036b0$export$c6fdb837b070b4ff = $217e1b2155a036b0$export$a707a4895ce23256;
const $217e1b2155a036b0$export$7c6e2c02157bb7d2 = $217e1b2155a036b0$export$94e6af45f0af4efd;
const $217e1b2155a036b0$export$e19cd5f9376f8cee = $217e1b2155a036b0$export$b454f818c58ee85d;
const $217e1b2155a036b0$export$848c9b7ead0df967 = $217e1b2155a036b0$export$2f67a923571aaea0;
const $217e1b2155a036b0$export$f99233281efd08a0 = $217e1b2155a036b0$export$225e0da62d314b7;
const $217e1b2155a036b0$export$393edc798c47379d = $217e1b2155a036b0$export$a23b55cde55ad9a5;





var $bh6RR = parcelRequire("bh6RR");


const $3e91b320546fc9fb$var$falsyToString = (value)=>typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
const $3e91b320546fc9fb$export$a274e22fb40f762e = (0, $fa1a2e608fb826ea$export$4f5d2d50c9deca37);
const $3e91b320546fc9fb$export$87dc52566e90b739 = (base, config)=>{
    return (props)=>{
        var ref;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $3e91b320546fc9fb$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants , defaultVariants: defaultVariants  } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $3e91b320546fc9fb$var$falsyToString(variantProp) || $3e91b320546fc9fb$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1)=>{
            let { class: cvClass , className: cvClassName , ...compoundVariantOptions } = param1;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $3e91b320546fc9fb$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};



const $96fae3fa1f07fd29$export$dca1ee5a936bb312 = (0, $3e91b320546fc9fb$export$87dc52566e90b739)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all cursor-pointer disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 shrink-0 outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px]", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            submit: "bg-gradient-to-br from-[#6B7F5E] to-[#4A5D3F] hover:from-[#4A5D3F] hover:to-[#2C3A28] text-white shadow-lg hover:shadow-xl",
            outline: "border bg-background text-foreground hover:bg-accent hover:text-accent-foreground",
            secondary: "border border-[#B8A17F]/40 text-[#4A5D3F] hover:bg-[#B8A17F]/10 hover:border-[#B8A17F] backdrop-blur-sm bg-white/20",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
            share: "border-solid bg-fuchsia-400	basis-1/2 hover:bg-fuchsia-400/80"
        },
        size: {
            default: "h-9 px-4 py-2 has-[>svg]:px-3",
            sm: "h-8 rounded-md px-3 has-[>svg]:px-2.5",
            lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
            deselectallsize: "h-9 py-2",
            icon: "h-9 w-9"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $96fae3fa1f07fd29$export$353f5b6fc5456de1 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , variant: variant , size: size , asChild: asChild = false , ...props }, ref)=>{
    const Comp = asChild ? (0, $18fd289ffa468154$export$8c6ed5c666ac1360) : "button";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Comp, {
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)($96fae3fa1f07fd29$export$dca1ee5a936bb312({
            variant: variant,
            size: size,
            className: className
        })),
        ref: ref,
        ...props
    });
});
$96fae3fa1f07fd29$export$353f5b6fc5456de1.displayName = "Button";


const $463538fa8a5d53d8$export$de466dd8317b0b75 = $217e1b2155a036b0$export$be92b6f5f03c0fe9;
const $463538fa8a5d53d8$export$6edd7a623ef0f40b = $217e1b2155a036b0$export$41fb9f06171c75f4;
const $463538fa8a5d53d8$export$660f2bfdb986706c = $217e1b2155a036b0$export$602eac185826482c;
const $463538fa8a5d53d8$export$a707a4895ce23256 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , children: children , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($217e1b2155a036b0$export$c6fdb837b070b4ff, {
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props,
        ref: ref
    }));
$463538fa8a5d53d8$export$a707a4895ce23256.displayName = $217e1b2155a036b0$export$c6fdb837b070b4ff.displayName;
const $463538fa8a5d53d8$export$94e6af45f0af4efd = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , handleMouseDownOnOverlay: handleMouseDownOnOverlay , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($463538fa8a5d53d8$export$660f2bfdb986706c, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($463538fa8a5d53d8$export$a707a4895ce23256, {
                onMouseDown: handleMouseDownOnOverlay
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($217e1b2155a036b0$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full", className),
                ...props
            })
        ]
    }));
$463538fa8a5d53d8$export$94e6af45f0af4efd.displayName = $217e1b2155a036b0$export$7c6e2c02157bb7d2.displayName;
const $463538fa8a5d53d8$export$c9359e10414c2de7 = ({ className: className , ...props })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
$463538fa8a5d53d8$export$c9359e10414c2de7.displayName = "AlertDialogHeader";
const $463538fa8a5d53d8$export$691560c8793e1baf = ({ className: className , ...props })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("flex flex-row gap-x-4 justify-center", className),
        ...props
    });
$463538fa8a5d53d8$export$691560c8793e1baf.displayName = "AlertDialogFooter";
const $463538fa8a5d53d8$export$225e0da62d314b7 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($217e1b2155a036b0$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("text-lg font-semibold", className),
        ...props
    }));
$463538fa8a5d53d8$export$225e0da62d314b7.displayName = $217e1b2155a036b0$export$f99233281efd08a0.displayName;
const $463538fa8a5d53d8$export$a23b55cde55ad9a5 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($217e1b2155a036b0$export$393edc798c47379d, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("text-sm text-muted-foreground", className),
        ...props
    }));
$463538fa8a5d53d8$export$a23b55cde55ad9a5.displayName = $217e1b2155a036b0$export$393edc798c47379d.displayName;
const $463538fa8a5d53d8$export$b454f818c58ee85d = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($217e1b2155a036b0$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)((0, $96fae3fa1f07fd29$export$dca1ee5a936bb312)(), className),
        ...props
    }));
$463538fa8a5d53d8$export$b454f818c58ee85d.displayName = $217e1b2155a036b0$export$e19cd5f9376f8cee.displayName;
const $463538fa8a5d53d8$export$2f67a923571aaea0 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($217e1b2155a036b0$export$848c9b7ead0df967, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)((0, $96fae3fa1f07fd29$export$dca1ee5a936bb312)({
            variant: "outline"
        }), "mt-2 sm:mt-0", className),
        ...props
    }));
$463538fa8a5d53d8$export$2f67a923571aaea0.displayName = $217e1b2155a036b0$export$848c9b7ead0df967.displayName;


function $1afdc1be3ae11346$var$BaseModal({ title: title = "title" , trigger: trigger , initiallyOpen: initiallyOpen = true , footerElements: footerElements , children: children , actionButtonText: actionButtonText = "Continue" , showActionButton: showActionButton = true  }) {
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(initiallyOpen);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setIsOpen(initiallyOpen);
    }, [
        initiallyOpen
    ]);
    function handleCloseEvent() {
        setIsOpen(false);
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $463538fa8a5d53d8$export$de466dd8317b0b75), {
        open: isOpen,
        onOpenChange: setIsOpen,
        children: [
            !!trigger && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $463538fa8a5d53d8$export$6edd7a623ef0f40b), {
                children: trigger
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $463538fa8a5d53d8$export$94e6af45f0af4efd), {
                handleMouseDownOnOverlay: handleCloseEvent,
                onEscapeKeyDown: handleCloseEvent,
                onCloseAutoFocus: (e)=>{
                    e.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $463538fa8a5d53d8$export$c9359e10414c2de7), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $463538fa8a5d53d8$export$225e0da62d314b7), {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $463538fa8a5d53d8$export$a23b55cde55ad9a5), {
                                children: children
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $463538fa8a5d53d8$export$691560c8793e1baf), {
                        children: [
                            footerElements,
                            showActionButton && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $463538fa8a5d53d8$export$b454f818c58ee85d), {
                                onClick: ()=>setIsOpen(false),
                                children: actionButtonText
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $1afdc1be3ae11346$export$2e2bcd8739ae039 = $1afdc1be3ae11346$var$BaseModal;




function $18f3b5e47ff54378$var$InfoModal() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1afdc1be3ae11346$export$2e2bcd8739ae039), {
        title: "",
        trigger: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c2b396b5ac29bd02$export$2e2bcd8739ae039), {
            className: "mr-4",
            onClick: ()=>(0, $61b270a9c2ec9ef5$export$312fb35742390537)()
        }),
        initiallyOpen: false,
        actionButtonText: "Got It!",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $742edf3294a6f836$export$a766cd26d0d69044), {
            type: "single",
            collapsible: true,
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $742edf3294a6f836$export$d99097c13d4dac9f), {
                    value: "item-1",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $742edf3294a6f836$export$94e939b1f85bdd73), {
                            children: "What's The Goal?"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $742edf3294a6f836$export$985b9a77379b54a0), {
                            children: "Find groups of items or names that share something in common."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $742edf3294a6f836$export$d99097c13d4dac9f), {
                    value: "item-2",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $742edf3294a6f836$export$94e939b1f85bdd73), {
                            children: "How Do I Play?"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $742edf3294a6f836$export$985b9a77379b54a0), {
                            children: "Select the items and tap 'Submit' to check if your guess matches one of the answer categories."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $742edf3294a6f836$export$d99097c13d4dac9f), {
                    value: "item-3",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $742edf3294a6f836$export$94e939b1f85bdd73), {
                            children: "How Many Tries Do I Get?"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $742edf3294a6f836$export$985b9a77379b54a0), {
                            children: `You can make ${(0, $5763721b9fa71fc2$export$7ea57ed97bda1046)} mistakes before the game ends.`
                        })
                    ]
                })
            ]
        })
    });
}
var $18f3b5e47ff54378$export$2e2bcd8739ae039 = $18f3b5e47ff54378$var$InfoModal;




function $02ce57c81a0104d3$var$Header() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("header", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "header-content",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "title-section",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                            children: "Connections"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            className: "byline",
                            children: "BY X&J"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "info-icon",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $18f3b5e47ff54378$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $02ce57c81a0104d3$export$2e2bcd8739ae039 = $02ce57c81a0104d3$var$Header;






var $bh6RR = parcelRequire("bh6RR");

function $b9fa76065069edb9$var$getAllWordsOfGameData({ gameData: gameData  }) {
    const numCategories = gameData.length;
    let allWords = [];
    for(let i = 0; i < numCategories; i++)if (gameData[i]?.words) allWords.push(gameData[i].words);
    else allWords.push(gameData[i]);
    return allWords.flat();
}
function $b9fa76065069edb9$export$d1246a55b993f861({ gameData: gameData  }) {
    let categorySize;
    if (gameData[0]?.words) categorySize = gameData[0].words.length;
    else categorySize = gameData[0].length;
    const allWordsFlattened = $b9fa76065069edb9$var$getAllWordsOfGameData({
        gameData: gameData
    });
    return (0, $92dc8dbec6af1b1e$export$5f7ec48d69707ddd)(categorySize, (0, $92dc8dbec6af1b1e$export$448332262467e042)(allWordsFlattened));
}
function $b9fa76065069edb9$export$872584ef35ecfeaa({ gameData: gameData , guessCandidate: guessCandidate  }) {
    let isCorrect = false;
    let correctWords = "";
    let correctCategory = "";
    let correctImageSrc = null;
    let isGuessOneAway = false;
    let correctDifficulty = null;
    const differencesOfArrays = [];
    for(let i = 0; i < gameData.length; i++){
        correctWords = gameData[i].words;
        correctCategory = gameData[i].category;
        correctDifficulty = gameData[i].difficulty;
        correctImageSrc = gameData[i].imageSrc;
        if ((0, $92dc8dbec6af1b1e$export$76a46922e320ce3b)(guessCandidate, correctWords)) {
            isCorrect = true;
            return {
                isCorrect: isCorrect,
                correctWords: correctWords,
                correctCategory: correctCategory,
                isGuessOneAway: isGuessOneAway,
                correctDifficulty: correctDifficulty,
                correctImageSrc: correctImageSrc
            };
        } else {
            // check size of difference, were doing this twice, but no need to optimize for tiny arrays
            const differenceLength = (0, $92dc8dbec6af1b1e$export$4c3569103e7f2532)(guessCandidate, correctWords).length;
            // store how far off their guess was from category
            differencesOfArrays.push(differenceLength);
        }
    }
    isGuessOneAway = Math.min(...differencesOfArrays) === 1;
    return {
        isCorrect: isCorrect,
        correctWords: correctWords,
        correctCategory: correctCategory,
        isGuessOneAway: isGuessOneAway,
        correctImageSrc: correctImageSrc
    };
}
function $b9fa76065069edb9$export$a7c89472cbd6a2db({ submittedGuesses: submittedGuesses , guessCandidate: guessCandidate  }) {
    for(let i = 0; i < submittedGuesses.length; i++){
        const prevGuess = submittedGuesses[i];
        if ((0, $92dc8dbec6af1b1e$export$76a46922e320ce3b)(guessCandidate, prevGuess)) return true;
    }
    return false;
}
function $b9fa76065069edb9$export$5bf48084bac4ea00({ gd1: gd1 , gd2: gd2  }) {
    if (gd1 == null || gd2 == null) return false;
    if (gd1.length !== gd2.length) return false;
    for(let i = 0; i < gd1.lengthl; i++){
        if (!(0, $92dc8dbec6af1b1e$export$76a46922e320ce3b)(gd1.words[i], gd2.words[i])) return false;
    }
    return true;
}
function $b9fa76065069edb9$export$81af505f04eac98f({ gameData: gameData , submittedGuesses: submittedGuesses  }) {
    const allGameWordsFlattened = $b9fa76065069edb9$var$getAllWordsOfGameData({
        gameData: gameData
    });
    const allGuessesFlattened = $b9fa76065069edb9$var$getAllWordsOfGameData({
        gameData: submittedGuesses
    });
    if (submittedGuesses.length === 0) return false;
    const isSubset = allGuessesFlattened.every((val)=>allGameWordsFlattened.includes(val));
    return isSubset;
}
const $b9fa76065069edb9$export$a63577e223e2a6c9 = (gameData, submittedGuesses)=>{
    const wordToDifficultyMap = {};
    const tiles = $b9fa76065069edb9$export$dbae3455ab69bd40();
    const numCategories = gameData.length;
    const allWords = [];
    for(let i = 0; i < numCategories; i++){
        allWords.push(gameData[i].words);
        let difficulty = gameData[i].difficulty;
        gameData[i].words.map((word)=>wordToDifficultyMap[word] = difficulty);
    }
    const allEmojiRowsArray = [];
    for(let i = 0; i < submittedGuesses.length; i++){
        const submittedGuess = submittedGuesses[i];
        let wordDifficultiesArray = submittedGuess.map((word)=>wordToDifficultyMap[word]);
        const emojiRowForGuess = wordDifficultiesArray.map((wordDifficulty)=>{
            switch(wordDifficulty){
                case 1:
                    return tiles[0];
                case 2:
                    return tiles[1];
                case 3:
                    return tiles[2];
                case 4:
                    return tiles[3];
            }
        }).join("");
        allEmojiRowsArray.push(emojiRowForGuess);
    }
    return `${allEmojiRowsArray.join("\n")}`;
};
function $b9fa76065069edb9$export$dbae3455ab69bd40() {
    let tiles = [];
    tiles.push("\uD83D\uDFE9");
    tiles.push("\uD83D\uDFE8");
    tiles.push("\uD83D\uDFEA");
    tiles.push("\uD83D\uDFE6");
    return tiles;
}




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
var $d7526ef66699a419$export$3677029976656ab8;
var $d7526ef66699a419$export$27bef6389954e24d;
var $d7526ef66699a419$export$f2a5e34fc82c172f;
var $d7526ef66699a419$export$8584e71b330397e1;
var $d7526ef66699a419$export$d90250155de6d7e7;
$d7526ef66699a419$export$3677029976656ab8 = `_7_rvlW_growShrink`;
$d7526ef66699a419$export$27bef6389954e24d = `_7_rvlW_hideText`;
$d7526ef66699a419$export$27bef6389954e24d;
$d7526ef66699a419$export$f2a5e34fc82c172f = `_7_rvlW_mergeToBar`;
$d7526ef66699a419$export$f2a5e34fc82c172f;
$d7526ef66699a419$export$8584e71b330397e1 = `_7_rvlW_merging`;
$d7526ef66699a419$export$d90250155de6d7e7 = `_7_rvlW_selected`;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



/* -------------------------------------------------------------------------------------------------
 * Toggle
 * -----------------------------------------------------------------------------------------------*/ const $956254bff89036f3$var$$b3bbe2732c13b576$var$NAME = "Toggle";
const $956254bff89036f3$export$bea8ebba691c5813 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { pressed: pressedProp , defaultPressed: defaultPressed = false , onPressedChange: onPressedChange , ...buttonProps } = props;
    const [pressed = false, setPressed] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : undefined
    }, buttonProps, {
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    }));
});
/*#__PURE__*/ Object.assign($956254bff89036f3$export$bea8ebba691c5813, {
    displayName: $956254bff89036f3$var$$b3bbe2732c13b576$var$NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $956254bff89036f3$export$be92b6f5f03c0fe9 = $956254bff89036f3$export$bea8ebba691c5813;




const $66130c78b3447be5$export$559a8be544a0b762 = (0, $3e91b320546fc9fb$export$87dc52566e90b739)("inline-flex items-center justify-center rounded-xl md:rounded-2xl text-sm font-medium transition-all duration-300 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        variant: {
            default: "bg-transparent",
            outline: "bg-white/20 backdrop-blur-md text-[#233020] border border-white/40 hover:bg-white/30 data-[state=on]:bg-gradient-to-br data-[state=on]:from-[#6B7F5E] data-[state=on]:to-[#4A5D3F] data-[state=on]:text-white data-[state=on]:shadow-2xl data-[state=on]:shadow-[#6B7F5E]/30 data-[state=on]:border-transparent"
        },
        size: {
            default: "h-10 px-3",
            sm: "h-9 px-2.5",
            lg: "h-11 px-5"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $66130c78b3447be5$export$bea8ebba691c5813 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , variant: variant , size: size , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($956254bff89036f3$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)($66130c78b3447be5$export$559a8be544a0b762({
            variant: variant,
            size: size,
            className: className
        })),
        ...props
    }));
$66130c78b3447be5$export$bea8ebba691c5813.displayName = $956254bff89036f3$export$be92b6f5f03c0fe9.displayName;





var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
function $5fa2427dbbbb369e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}


function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}


function $4ff366e58c33ccee$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $f741f874145d0154$export$2e2bcd8739ae039(argument) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $d4cc3831797a4057$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $63dba254cf419de0$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $c7a5375f03b0a15d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $b50469c0909a5344$var$MILLISECONDS_IN_DAY = 86400000;
function $b50469c0909a5344$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $63dba254cf419de0$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $63dba254cf419de0$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $b50469c0909a5344$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $69bbef5abecd6c1f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $b50469c0909a5344$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


function $e6c856ebc9ae82ee$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



function $1ff38398f48a5451$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var originalDate = (0, $f741f874145d0154$export$2e2bcd8739ae039)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError("Invalid time value");
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
    if (format !== "extended" && format !== "basic") throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== "date" && representation !== "time" && representation !== "complete") throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
        var month = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
        var year = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
        var minute = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
        var second = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4fd2c93311e78e29$export$dfd9b671c89acc8e = 7;
var $4fd2c93311e78e29$export$3913210603d8e9ae = 365.2425;
var $4fd2c93311e78e29$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4fd2c93311e78e29$export$91246f0b9bd9beff = 60000;
var $4fd2c93311e78e29$export$7f72910d6dfd237a = 3600000;
var $4fd2c93311e78e29$export$397c2d5776aa9055 = 1000;
var $4fd2c93311e78e29$export$4dec998e48f9c246 = -$4fd2c93311e78e29$export$81caae6e1cc7a622;
var $4fd2c93311e78e29$export$f2f5ae5a8e2d8f9f = 60;
var $4fd2c93311e78e29$export$3c58128db900d44e = 3;
var $4fd2c93311e78e29$export$80d7e435f744f319 = 12;
var $4fd2c93311e78e29$export$4db7641526e3241f = 4;
var $4fd2c93311e78e29$export$698aec755e92c695 = 3600;
var $4fd2c93311e78e29$export$a77c1a7ebebe2a5a = 60;
var $4fd2c93311e78e29$export$815a9362476d2fe3 = $4fd2c93311e78e29$export$698aec755e92c695 * 24;
var $4fd2c93311e78e29$export$34804a017b31e2fe = $4fd2c93311e78e29$export$815a9362476d2fe3 * 7;
var $4fd2c93311e78e29$export$7271e9e3478110d1 = $4fd2c93311e78e29$export$815a9362476d2fe3 * $4fd2c93311e78e29$export$3913210603d8e9ae;
var $4fd2c93311e78e29$export$8e6600bbdee7dabb = $4fd2c93311e78e29$export$7271e9e3478110d1 / 12;
var $4fd2c93311e78e29$export$be1dccf2de902d31 = $4fd2c93311e78e29$export$8e6600bbdee7dabb * 3;




function $1869277eefbd126c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $1869277eefbd126c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $1869277eefbd126c$var$parseYear(dateStrings.date, additionalDigits);
        date = $1869277eefbd126c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $1869277eefbd126c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $1869277eefbd126c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $1869277eefbd126c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $1869277eefbd126c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $1869277eefbd126c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $1869277eefbd126c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $1869277eefbd126c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($1869277eefbd126c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($1869277eefbd126c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($1869277eefbd126c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $1869277eefbd126c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1869277eefbd126c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $1869277eefbd126c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($1869277eefbd126c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $1869277eefbd126c$var$parseDateUnit(captures[1]);
    var month = $1869277eefbd126c$var$parseDateUnit(captures[2]) - 1;
    var day = $1869277eefbd126c$var$parseDateUnit(captures[3]);
    var week = $1869277eefbd126c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $1869277eefbd126c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$1869277eefbd126c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1869277eefbd126c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$1869277eefbd126c$var$validateDate(year, month, day) || !$1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $1869277eefbd126c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $1869277eefbd126c$var$parseTime(timeString) {
    var captures = timeString.match($1869277eefbd126c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $1869277eefbd126c$var$parseTimeUnit(captures[1]);
    var minutes = $1869277eefbd126c$var$parseTimeUnit(captures[2]);
    var seconds = $1869277eefbd126c$var$parseTimeUnit(captures[3]);
    if (!$1869277eefbd126c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $4fd2c93311e78e29$export$7f72910d6dfd237a) + minutes * (0, $4fd2c93311e78e29$export$91246f0b9bd9beff) + seconds * 1000;
}
function $1869277eefbd126c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $1869277eefbd126c$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($1869277eefbd126c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$1869277eefbd126c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $4fd2c93311e78e29$export$7f72910d6dfd237a) + minutes * (0, $4fd2c93311e78e29$export$91246f0b9bd9beff));
}
function $1869277eefbd126c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $1869277eefbd126c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1869277eefbd126c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1869277eefbd126c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($1869277eefbd126c$var$daysInMonths[month] || ($1869277eefbd126c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($1869277eefbd126c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $1869277eefbd126c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $1869277eefbd126c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $1869277eefbd126c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


function $2b69b9dda3b0dc41$export$2e2bcd8739ae039() {
    return (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(Date.now());
}

/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ function $48c056419c65b8b4$export$2e2bcd8739ae039() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $f1f439cb1f906708$exports = {};

$parcel$export($f1f439cb1f906708$exports, "extract", function () { return $f1f439cb1f906708$export$f9380c9a627682d3; });
$parcel$export($f1f439cb1f906708$exports, "parse", function () { return $f1f439cb1f906708$export$98e6a39c04603d36; });
$parcel$export($f1f439cb1f906708$exports, "stringify", function () { return $f1f439cb1f906708$export$fac44ee5b035f737; });
$parcel$export($f1f439cb1f906708$exports, "parseUrl", function () { return $f1f439cb1f906708$export$7a5253c0f62e0150; });
$parcel$export($f1f439cb1f906708$exports, "stringifyUrl", function () { return $f1f439cb1f906708$export$a8c1621ea79325d3; });
$parcel$export($f1f439cb1f906708$exports, "pick", function () { return $f1f439cb1f906708$export$357523c63a2253b9; });
$parcel$export($f1f439cb1f906708$exports, "exclude", function () { return $f1f439cb1f906708$export$44c361b8ec72ef7f; });
const $e1c58bf2e246f16d$var$token = "%[a-f0-9]{2}";
const $e1c58bf2e246f16d$var$singleMatcher = new RegExp("(" + $e1c58bf2e246f16d$var$token + ")|([^%]+?)", "gi");
const $e1c58bf2e246f16d$var$multiMatcher = new RegExp("(" + $e1c58bf2e246f16d$var$token + ")+", "gi");
function $e1c58bf2e246f16d$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $e1c58bf2e246f16d$var$decodeComponents(left), $e1c58bf2e246f16d$var$decodeComponents(right));
}
function $e1c58bf2e246f16d$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($e1c58bf2e246f16d$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $e1c58bf2e246f16d$var$decodeComponents(tokens, i).join("");
            tokens = input.match($e1c58bf2e246f16d$var$singleMatcher) || [];
        }
        return input;
    }
}
function $e1c58bf2e246f16d$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    let match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $e1c58bf2e246f16d$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function $e1c58bf2e246f16d$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $e1c58bf2e246f16d$var$customDecodeURIComponent(encodedURI);
    }
}


function $731a0efefa6baa63$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}


function $f2797a3f33da989b$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $f2797a3f33da989b$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $f2797a3f33da989b$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $f2797a3f33da989b$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}


const $f1f439cb1f906708$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $f1f439cb1f906708$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $f1f439cb1f906708$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $f1f439cb1f906708$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "[",
                            $f1f439cb1f906708$var$encode(index, options),
                            "]=",
                            $f1f439cb1f906708$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "[]=",
                            $f1f439cb1f906708$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            ":list=",
                            $f1f439cb1f906708$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $f1f439cb1f906708$var$encode(key, options),
                                keyValueSep,
                                $f1f439cb1f906708$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $f1f439cb1f906708$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $f1f439cb1f906708$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "=",
                            $f1f439cb1f906708$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $f1f439cb1f906708$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $f1f439cb1f906708$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $f1f439cb1f906708$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$f1f439cb1f906708$var$decode(item, options)) : value === null ? value : $f1f439cb1f906708$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $f1f439cb1f906708$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$f1f439cb1f906708$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $f1f439cb1f906708$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $f1f439cb1f906708$var$encode(value, options) {
    if (options.encode) return options.strict ? $f1f439cb1f906708$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $f1f439cb1f906708$var$decode(value, options) {
    if (options.decode) return (0, $e1c58bf2e246f16d$export$2e2bcd8739ae039)(value);
    return value;
}
function $f1f439cb1f906708$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $f1f439cb1f906708$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $f1f439cb1f906708$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $f1f439cb1f906708$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $f1f439cb1f906708$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $f1f439cb1f906708$export$f9380c9a627682d3(input) {
    input = $f1f439cb1f906708$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $f1f439cb1f906708$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $f1f439cb1f906708$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $f1f439cb1f906708$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, $731a0efefa6baa63$export$2e2bcd8739ae039)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $f1f439cb1f906708$var$decode(value, options);
        formatter($f1f439cb1f906708$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $f1f439cb1f906708$var$parseValue(value2, options);
        else returnValue[key] = $f1f439cb1f906708$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $f1f439cb1f906708$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
function $f1f439cb1f906708$export$fac44ee5b035f737(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    $f1f439cb1f906708$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $f1f439cb1f906708$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $f1f439cb1f906708$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $f1f439cb1f906708$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $f1f439cb1f906708$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $f1f439cb1f906708$var$encode(key, options) + "=" + $f1f439cb1f906708$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function $f1f439cb1f906708$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $731a0efefa6baa63$export$2e2bcd8739ae039)(url, "#");
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split("?")?.[0] ?? "",
        query: $f1f439cb1f906708$export$98e6a39c04603d36($f1f439cb1f906708$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $f1f439cb1f906708$var$decode(hash, options)
        } : {}
    };
}
function $f1f439cb1f906708$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$f1f439cb1f906708$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $f1f439cb1f906708$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $f1f439cb1f906708$export$f9380c9a627682d3(object.url);
    const query = {
        ...$f1f439cb1f906708$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $f1f439cb1f906708$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $f1f439cb1f906708$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$f1f439cb1f906708$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $f1f439cb1f906708$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$f1f439cb1f906708$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url , query: query , fragmentIdentifier: fragmentIdentifier  } = $f1f439cb1f906708$export$7a5253c0f62e0150(input, options);
    return $f1f439cb1f906708$export$a8c1621ea79325d3({
        url: url,
        query: (0, $f2797a3f33da989b$export$ff05df6c2df24b52)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $f1f439cb1f906708$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $f1f439cb1f906708$export$357523c63a2253b9(input, exclusionFilter, options);
}


var $d1ffd40e86b7fa1f$export$2e2bcd8739ae039 = $f1f439cb1f906708$exports;


const $4bdd1c705d14b0c9$export$f22a6422853df92a = [
    [
        {
            category: "To Tie Together",
            words: [
                "Knot",
                "Link",
                "Fuse",
                "Unite"
            ],
            difficulty: 1
        },
        {
            category: "Ends in Jack",
            words: [
                "Car",
                "Flap",
                "Hi",
                "Black"
            ],
            difficulty: 2
        },
        {
            category: "All are Cooks",
            words: [
                "Ratatouille",
                "Captain",
                "Tim",
                "Nigella"
            ],
            difficulty: 3
        },
        {
            category: "Famous Swiss Things",
            words: [
                "Knives",
                "Watches",
                "Chocolate",
                "Banks"
            ],
            difficulty: 4
        }
    ]
];


const $b50a230eab57da32$export$883228a582a7567d = ()=>(0, $2b69b9dda3b0dc41$export$2e2bcd8739ae039)();
const $b50a230eab57da32$export$e7b72760378c0d3b = ()=>(0, $48c056419c65b8b4$export$2e2bcd8739ae039)();
const $b50a230eab57da32$export$6caa362aa47de0a9 = new Date(2023, 9, 23);
const $b50a230eab57da32$export$f962b3e391165a04 = 7;
const $b50a230eab57da32$export$4bd620cea39ca6a8 = (today)=>{
    const t = (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(today);
    let daysSinceLastGame = (0, $69bbef5abecd6c1f$export$2e2bcd8739ae039)(t, $b50a230eab57da32$export$6caa362aa47de0a9) % $b50a230eab57da32$export$f962b3e391165a04;
    return (0, $d4cc3831797a4057$export$2e2bcd8739ae039)(t, -daysSinceLastGame);
};
const $b50a230eab57da32$export$b4d1281d281145f7 = (today)=>{
    return (0, $d4cc3831797a4057$export$2e2bcd8739ae039)($b50a230eab57da32$export$4bd620cea39ca6a8(today), $b50a230eab57da32$export$f962b3e391165a04);
};
const $b50a230eab57da32$export$f5550a7c9e870a10 = (date)=>{
    if (date < $b50a230eab57da32$export$6caa362aa47de0a9 || date > $b50a230eab57da32$export$883228a582a7567d()) return false;
    return (0, $69bbef5abecd6c1f$export$2e2bcd8739ae039)($b50a230eab57da32$export$6caa362aa47de0a9, date) % $b50a230eab57da32$export$f962b3e391165a04 === 0;
};
const $b50a230eab57da32$export$ddfa24987dade61b = (gameDate)=>{
    let start = $b50a230eab57da32$export$6caa362aa47de0a9;
    let index = -1;
    console.log($b50a230eab57da32$export$6caa362aa47de0a9);
    do {
        index++;
        start = (0, $d4cc3831797a4057$export$2e2bcd8739ae039)(start, $b50a230eab57da32$export$f962b3e391165a04);
    }while (start <= gameDate);
    return index;
};
const $b50a230eab57da32$export$7d6469d31f34c305 = (index)=>{
    if (index < 0) throw new Error("Invalid index");
    return (0, $4bdd1c705d14b0c9$export$f22a6422853df92a)[index % (0, $4bdd1c705d14b0c9$export$f22a6422853df92a).length];
};
const $b50a230eab57da32$export$aa83c3a07763586 = (gameDate)=>{
    const nextGameDate = $b50a230eab57da32$export$b4d1281d281145f7(gameDate);
    const index = $b50a230eab57da32$export$ddfa24987dade61b(gameDate);
    const puzzleOfTheDay = $b50a230eab57da32$export$7d6469d31f34c305(index);
    console.log("index for today: ", index);
    return {
        puzzleAnswers: puzzleOfTheDay,
        puzzleGameDate: gameDate,
        puzzleIndex: index,
        dateOfNextPuzzle: nextGameDate.valueOf()
    };
};
const $b50a230eab57da32$export$9a080392f5112997 = ()=>{
    if ($b50a230eab57da32$export$3a4dea89a5aa7ed5()) return $b50a230eab57da32$export$883228a582a7567d();
    const parsed = (0, $d1ffd40e86b7fa1f$export$2e2bcd8739ae039).parse(window.location.search);
    try {
        const d = (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)((0, $1869277eefbd126c$export$2e2bcd8739ae039)(parsed.d?.toString()));
        if (d >= $b50a230eab57da32$export$883228a582a7567d() || d < $b50a230eab57da32$export$6caa362aa47de0a9) $b50a230eab57da32$export$762c0c2e53901f0e($b50a230eab57da32$export$883228a582a7567d());
        return d;
    } catch (e) {
        console.log(e);
        return $b50a230eab57da32$export$883228a582a7567d();
    }
};
const $b50a230eab57da32$export$762c0c2e53901f0e = (d)=>{
    try {
        if (d < $b50a230eab57da32$export$883228a582a7567d()) {
            window.location.href = "/?d=" + (0, $1ff38398f48a5451$export$2e2bcd8739ae039)(d, {
                representation: "date"
            });
            return;
        }
    } catch (e) {
        console.log(e);
    }
    window.location.href = "/";
};
const $b50a230eab57da32$export$3a4dea89a5aa7ed5 = ()=>{
    // https://github.com/cwackerfuss/react-wordle/pull/505
    const parsed = (0, $d1ffd40e86b7fa1f$export$2e2bcd8739ae039).parse(window.location.search);
    return parsed === null || !("d" in parsed);
};
const { puzzleAnswers: $b50a230eab57da32$export$943619dc4de0e8da , puzzleGameDate: $b50a230eab57da32$export$fedf7004e34a72fc , puzzleIndex: $b50a230eab57da32$export$3014f1d0d6bd394f , dateOfNextPuzzle: $b50a230eab57da32$export$a20d366458c50e4a  } = $b50a230eab57da32$export$aa83c3a07763586($b50a230eab57da32$export$9a080392f5112997());


const $ae43375334d8e130$export$e8331451049320c2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
function $ae43375334d8e130$var$PuzzleDataProvider({ children: children  }) {
    const [gameData, setGameData] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState((0, $b50a230eab57da32$export$943619dc4de0e8da));
    const categorySize = gameData[0].words.length;
    const numCategories = gameData.length;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ae43375334d8e130$export$e8331451049320c2.Provider, {
        value: {
            gameData: gameData,
            numCategories: numCategories,
            categorySize: categorySize
        },
        children: children
    });
}
var $ae43375334d8e130$export$2e2bcd8739ae039 = $ae43375334d8e130$var$PuzzleDataProvider;




const $a5d221f393d22414$var$gameStateKey = "gameState";
const $a5d221f393d22414$export$56041581280517cc = (gameState)=>{
    localStorage.setItem($a5d221f393d22414$var$gameStateKey, JSON.stringify(gameState));
};
const $a5d221f393d22414$export$9c74827dbe230598 = ()=>{
    const state = localStorage.getItem($a5d221f393d22414$var$gameStateKey);
    return state ? JSON.parse(state) : null;
};
const $a5d221f393d22414$var$gameStatKey = "gameStats";
const $a5d221f393d22414$export$bceb2c2841615d22 = (gameStats)=>{
    localStorage.setItem($a5d221f393d22414$var$gameStatKey, JSON.stringify(gameStats));
};
const $a5d221f393d22414$export$f2b270f795666cba = ()=>{
    const stats = localStorage.getItem($a5d221f393d22414$var$gameStatKey);
    return stats ? JSON.parse(stats) : null;
};



const $005b445a28133b13$export$3f49015a6304186f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
function $005b445a28133b13$var$GameStatusProvider({ children: children  }) {
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ae43375334d8e130$export$e8331451049320c2));
    const [submittedGuesses, setSubmittedGuesses] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [solvedGameData, setSolvedGameData] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(()=>{
        const loadedState = (0, $a5d221f393d22414$export$9c74827dbe230598)();
        console.log("checking game state!", {
            loadedState: loadedState,
            gd1: gameData,
            gd2: loadedState?.gameData
        });
        if (!(0, $b9fa76065069edb9$export$5bf48084bac4ea00)({
            gd1: gameData,
            gd2: loadedState?.gameData
        })) return [];
        if (!(0, $b9fa76065069edb9$export$81af505f04eac98f)({
            gameData: gameData,
            submittedGuesses: loadedState?.submittedGuesses
        })) return [];
        if (Array.isArray(loadedState?.submittedGuesses)) setSubmittedGuesses(loadedState.submittedGuesses);
        if (Array.isArray(loadedState?.solvedGameData)) return loadedState.solvedGameData;
        return [];
    });
    const [isGameOver, setIsGameOver] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [isGameWon, setIsGameWon] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [guessCandidate, setGuessCandidate] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const numMistakesUsed = submittedGuesses.length - solvedGameData.length;
    // use effect to check if game is won
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (solvedGameData.length === gameData.length) {
            setIsGameOver(true);
            setIsGameWon(true);
        }
        const gameState = {
            submittedGuesses: submittedGuesses,
            solvedGameData: solvedGameData,
            gameData: gameData
        };
        (0, $a5d221f393d22414$export$56041581280517cc)(gameState);
    }, [
        solvedGameData
    ]);
    // use effect to check if all mistakes have been used and end the game accordingly
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (numMistakesUsed >= (0, $5763721b9fa71fc2$export$7ea57ed97bda1046)) {
            setIsGameOver(true);
            setIsGameWon(false);
        }
        const gameState = {
            submittedGuesses: submittedGuesses,
            solvedGameData: solvedGameData,
            gameData: gameData
        };
        (0, $a5d221f393d22414$export$56041581280517cc)(gameState);
    }, [
        submittedGuesses
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($005b445a28133b13$export$3f49015a6304186f.Provider, {
        value: {
            isGameOver: isGameOver,
            isGameWon: isGameWon,
            numMistakesUsed: numMistakesUsed,
            solvedGameData: solvedGameData,
            setSolvedGameData: setSolvedGameData,
            submittedGuesses: submittedGuesses,
            setSubmittedGuesses: setSubmittedGuesses,
            guessCandidate: guessCandidate,
            setGuessCandidate: setGuessCandidate,
            setIsGameOver: setIsGameOver,
            setIsGameWon: setIsGameWon
        },
        children: children
    });
}
var $005b445a28133b13$export$2e2bcd8739ae039 = $005b445a28133b13$var$GameStatusProvider;




function $a8473a6fb8133656$var$WordButton({ word: word , fullCandidateSize: fullCandidateSize , isAnimating: isAnimating = false , isMerging: isMerging = false  }) {
    const { guessCandidate: guessCandidate , setGuessCandidate: setGuessCandidate  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $005b445a28133b13$export$3f49015a6304186f));
    const [isSelected, setIsSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(!!guessCandidate.includes(word));
    const isCandidateListFull = guessCandidate.length == fullCandidateSize;
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setIsSelected(!!guessCandidate.includes(word));
    }, [
        guessCandidate
    ]);
    function flipSelection() {
        if (isSelected) {
            (0, $61b270a9c2ec9ef5$export$a2e3c44b967be155)(word, false);
            // remove from candidateGuess
            const updatedGuessCandidate = guessCandidate.filter((w)=>{
                return w !== word;
            });
            setGuessCandidate(updatedGuessCandidate);
            // set state to *not* selected
            setIsSelected(false);
        } else // check if the candidate array is full
        if (!isCandidateListFull) {
            (0, $61b270a9c2ec9ef5$export$a2e3c44b967be155)(word, true);
            // add to candidateGuess array
            setGuessCandidate([
                ...guessCandidate,
                word
            ]);
            // set state to *selected*
            setIsSelected(true);
        }
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $66130c78b3447be5$export$bea8ebba691c5813), {
        className: `${$d7526ef66699a419$export$3677029976656ab8} ${isMerging ? $d7526ef66699a419$export$8584e71b330397e1 : ""} select-none w-full h-full`,
        variant: "outline",
        pressed: isSelected,
        onClick: flipSelection,
        disabled: isAnimating || isMerging,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "uppercase tracking-[0.05em] md:tracking-[0.15em] text-center block text-xs md:text-base px-1",
            children: word
        })
    });
}
var $a8473a6fb8133656$export$2e2bcd8739ae039 = $a8473a6fb8133656$var$WordButton;




var $715d2096b51a0c15$export$267b06a7460aa7d3;
var $715d2096b51a0c15$export$434a04ccf8ef5c9a;
var $715d2096b51a0c15$export$422dc104ec2e5f12;
$715d2096b51a0c15$export$267b06a7460aa7d3 = `J8PHqW_shake`;
$715d2096b51a0c15$export$434a04ccf8ef5c9a = `J8PHqW_shake-horizontal`;
$715d2096b51a0c15$export$422dc104ec2e5f12 = `J8PHqW_tilt-shaking`;
$715d2096b51a0c15$export$422dc104ec2e5f12;


// src/index.ts
// src/index.ts
// src/hooks/useChain.ts

var $bh6RR = parcelRequire("bh6RR");
var $67a01f8f769a9ff0$var$__defProp = Object.defineProperty;
var $67a01f8f769a9ff0$var$__export = (target, all)=>{
    for(var name in all)$67a01f8f769a9ff0$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $67a01f8f769a9ff0$export$cceeabf822b64fc0 = {};
$67a01f8f769a9ff0$var$__export($67a01f8f769a9ff0$export$cceeabf822b64fc0, {
    assign: ()=>$67a01f8f769a9ff0$var$assign,
    colors: ()=>$67a01f8f769a9ff0$var$colors,
    createStringInterpolator: ()=>$67a01f8f769a9ff0$var$createStringInterpolator,
    skipAnimation: ()=>$67a01f8f769a9ff0$var$skipAnimation,
    to: ()=>$67a01f8f769a9ff0$var$to,
    willAdvance: ()=>$67a01f8f769a9ff0$var$willAdvance
});
// ../rafz/dist/react-spring_rafz.modern.mjs
var $67a01f8f769a9ff0$var$updateQueue = $67a01f8f769a9ff0$var$makeQueue();
var $67a01f8f769a9ff0$export$27f233d61a9e2fa4 = (fn)=>$67a01f8f769a9ff0$var$schedule(fn, $67a01f8f769a9ff0$var$updateQueue);
var $67a01f8f769a9ff0$var$writeQueue = $67a01f8f769a9ff0$var$makeQueue();
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.write = (fn)=>$67a01f8f769a9ff0$var$schedule(fn, $67a01f8f769a9ff0$var$writeQueue);
var $67a01f8f769a9ff0$var$onStartQueue = $67a01f8f769a9ff0$var$makeQueue();
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.onStart = (fn)=>$67a01f8f769a9ff0$var$schedule(fn, $67a01f8f769a9ff0$var$onStartQueue);
var $67a01f8f769a9ff0$var$onFrameQueue = $67a01f8f769a9ff0$var$makeQueue();
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.onFrame = (fn)=>$67a01f8f769a9ff0$var$schedule(fn, $67a01f8f769a9ff0$var$onFrameQueue);
var $67a01f8f769a9ff0$var$onFinishQueue = $67a01f8f769a9ff0$var$makeQueue();
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.onFinish = (fn)=>$67a01f8f769a9ff0$var$schedule(fn, $67a01f8f769a9ff0$var$onFinishQueue);
var $67a01f8f769a9ff0$var$timeouts = [];
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $67a01f8f769a9ff0$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $67a01f8f769a9ff0$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $67a01f8f769a9ff0$var$timeouts.splice(i, 1);
        $67a01f8f769a9ff0$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $67a01f8f769a9ff0$var$timeouts.splice($67a01f8f769a9ff0$var$findTimeout(time), 0, timeout);
    $67a01f8f769a9ff0$var$pendingCount += 1;
    $67a01f8f769a9ff0$var$start();
    return timeout;
};
var $67a01f8f769a9ff0$var$findTimeout = (time)=>~(~$67a01f8f769a9ff0$var$timeouts.findIndex((t)=>t.time > time) || ~$67a01f8f769a9ff0$var$timeouts.length);
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $67a01f8f769a9ff0$var$onStartQueue.delete(fn);
    $67a01f8f769a9ff0$var$onFrameQueue.delete(fn);
    $67a01f8f769a9ff0$var$onFinishQueue.delete(fn);
    $67a01f8f769a9ff0$var$updateQueue.delete(fn);
    $67a01f8f769a9ff0$var$writeQueue.delete(fn);
};
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.sync = (fn)=>{
    $67a01f8f769a9ff0$var$sync = true;
    $67a01f8f769a9ff0$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $67a01f8f769a9ff0$var$sync = false;
};
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $67a01f8f769a9ff0$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $67a01f8f769a9ff0$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $67a01f8f769a9ff0$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.use = (impl)=>$67a01f8f769a9ff0$var$nativeRaf = impl;
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.catch = console.error;
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.frameLoop = "always";
$67a01f8f769a9ff0$export$27f233d61a9e2fa4.advance = ()=>{
    if ($67a01f8f769a9ff0$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $67a01f8f769a9ff0$var$update();
};
var $67a01f8f769a9ff0$var$ts = -1;
var $67a01f8f769a9ff0$var$pendingCount = 0;
var $67a01f8f769a9ff0$var$sync = false;
function $67a01f8f769a9ff0$var$schedule(fn, queue) {
    if ($67a01f8f769a9ff0$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $67a01f8f769a9ff0$var$start();
    }
}
function $67a01f8f769a9ff0$var$start() {
    if ($67a01f8f769a9ff0$var$ts < 0) {
        $67a01f8f769a9ff0$var$ts = 0;
        if ($67a01f8f769a9ff0$export$27f233d61a9e2fa4.frameLoop !== "demand") $67a01f8f769a9ff0$var$nativeRaf($67a01f8f769a9ff0$var$loop);
    }
}
function $67a01f8f769a9ff0$var$stop() {
    $67a01f8f769a9ff0$var$ts = -1;
}
function $67a01f8f769a9ff0$var$loop() {
    if (~$67a01f8f769a9ff0$var$ts) {
        $67a01f8f769a9ff0$var$nativeRaf($67a01f8f769a9ff0$var$loop);
        $67a01f8f769a9ff0$export$27f233d61a9e2fa4.batchedUpdates($67a01f8f769a9ff0$var$update);
    }
}
function $67a01f8f769a9ff0$var$update() {
    const prevTs = $67a01f8f769a9ff0$var$ts;
    $67a01f8f769a9ff0$var$ts = $67a01f8f769a9ff0$export$27f233d61a9e2fa4.now();
    const count = $67a01f8f769a9ff0$var$findTimeout($67a01f8f769a9ff0$var$ts);
    if (count) {
        $67a01f8f769a9ff0$var$eachSafely($67a01f8f769a9ff0$var$timeouts.splice(0, count), (t)=>t.handler());
        $67a01f8f769a9ff0$var$pendingCount -= count;
    }
    if (!$67a01f8f769a9ff0$var$pendingCount) {
        $67a01f8f769a9ff0$var$stop();
        return;
    }
    $67a01f8f769a9ff0$var$onStartQueue.flush();
    $67a01f8f769a9ff0$var$updateQueue.flush(prevTs ? Math.min(64, $67a01f8f769a9ff0$var$ts - prevTs) : 16.667);
    $67a01f8f769a9ff0$var$onFrameQueue.flush();
    $67a01f8f769a9ff0$var$writeQueue.flush();
    $67a01f8f769a9ff0$var$onFinishQueue.flush();
}
function $67a01f8f769a9ff0$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $67a01f8f769a9ff0$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $67a01f8f769a9ff0$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $67a01f8f769a9ff0$var$pendingCount -= current.size;
                $67a01f8f769a9ff0$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $67a01f8f769a9ff0$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $67a01f8f769a9ff0$var$eachSafely(values, each2) {
    values.forEach((value)=>{
        try {
            each2(value);
        } catch (e) {
            $67a01f8f769a9ff0$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
// src/helpers.ts
function $67a01f8f769a9ff0$export$8793edee2d425525() {}
var $67a01f8f769a9ff0$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $67a01f8f769a9ff0$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $67a01f8f769a9ff0$export$248d38f6296296c5(a, b) {
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(a)) {
        if (!$67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $67a01f8f769a9ff0$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $67a01f8f769a9ff0$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $67a01f8f769a9ff0$export$45b10814cc054894 = (a)=>$67a01f8f769a9ff0$export$226b3eccf92c9ed9.und(a) ? [] : $67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $67a01f8f769a9ff0$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $67a01f8f769a9ff0$export$79b2f7037acddd43(items, iterator);
    }
}
var $67a01f8f769a9ff0$export$7ba486852759e806 = (queue, ...args)=>$67a01f8f769a9ff0$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $67a01f8f769a9ff0$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $67a01f8f769a9ff0$var$createStringInterpolator;
var $67a01f8f769a9ff0$var$to;
var $67a01f8f769a9ff0$var$colors = null;
var $67a01f8f769a9ff0$var$skipAnimation = false;
var $67a01f8f769a9ff0$var$willAdvance = $67a01f8f769a9ff0$export$8793edee2d425525;
var $67a01f8f769a9ff0$var$assign = (globals)=>{
    if (globals.to) $67a01f8f769a9ff0$var$to = globals.to;
    if (globals.now) $67a01f8f769a9ff0$export$27f233d61a9e2fa4.now = globals.now;
    if (globals.colors !== void 0) $67a01f8f769a9ff0$var$colors = globals.colors;
    if (globals.skipAnimation != null) $67a01f8f769a9ff0$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $67a01f8f769a9ff0$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) $67a01f8f769a9ff0$export$27f233d61a9e2fa4.use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) $67a01f8f769a9ff0$export$27f233d61a9e2fa4.batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $67a01f8f769a9ff0$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) $67a01f8f769a9ff0$export$27f233d61a9e2fa4.frameLoop = globals.frameLoop;
};
// src/FrameLoop.ts
var $67a01f8f769a9ff0$var$startQueue = /* @__PURE__ */ new Set();
var $67a01f8f769a9ff0$var$currentFrame = [];
var $67a01f8f769a9ff0$var$prevFrame = [];
var $67a01f8f769a9ff0$var$priority = 0;
var $67a01f8f769a9ff0$export$a57f5080a3bcc90a = {
    get idle () {
        return !$67a01f8f769a9ff0$var$startQueue.size && !$67a01f8f769a9ff0$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($67a01f8f769a9ff0$var$priority > animation.priority) {
            $67a01f8f769a9ff0$var$startQueue.add(animation);
            $67a01f8f769a9ff0$export$27f233d61a9e2fa4.onStart($67a01f8f769a9ff0$var$flushStartQueue);
        } else {
            $67a01f8f769a9ff0$var$startSafely(animation);
            $67a01f8f769a9ff0$export$27f233d61a9e2fa4($67a01f8f769a9ff0$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $67a01f8f769a9ff0$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($67a01f8f769a9ff0$var$priority) $67a01f8f769a9ff0$export$27f233d61a9e2fa4.onFrame(()=>$67a01f8f769a9ff0$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $67a01f8f769a9ff0$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $67a01f8f769a9ff0$var$currentFrame.splice(prevIndex, 1);
                $67a01f8f769a9ff0$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $67a01f8f769a9ff0$var$currentFrame = [];
        $67a01f8f769a9ff0$var$startQueue.clear();
    }
};
function $67a01f8f769a9ff0$var$flushStartQueue() {
    $67a01f8f769a9ff0$var$startQueue.forEach($67a01f8f769a9ff0$var$startSafely);
    $67a01f8f769a9ff0$var$startQueue.clear();
    $67a01f8f769a9ff0$export$27f233d61a9e2fa4($67a01f8f769a9ff0$var$advance);
}
function $67a01f8f769a9ff0$var$startSafely(animation) {
    if (!$67a01f8f769a9ff0$var$currentFrame.includes(animation)) $67a01f8f769a9ff0$var$startUnsafely(animation);
}
function $67a01f8f769a9ff0$var$startUnsafely(animation) {
    $67a01f8f769a9ff0$var$currentFrame.splice($67a01f8f769a9ff0$var$findIndex($67a01f8f769a9ff0$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $67a01f8f769a9ff0$var$advance(dt) {
    const nextFrame = $67a01f8f769a9ff0$var$prevFrame;
    for(let i = 0; i < $67a01f8f769a9ff0$var$currentFrame.length; i++){
        const animation = $67a01f8f769a9ff0$var$currentFrame[i];
        $67a01f8f769a9ff0$var$priority = animation.priority;
        if (!animation.idle) {
            $67a01f8f769a9ff0$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $67a01f8f769a9ff0$var$priority = 0;
    $67a01f8f769a9ff0$var$prevFrame = $67a01f8f769a9ff0$var$currentFrame;
    $67a01f8f769a9ff0$var$prevFrame.length = 0;
    $67a01f8f769a9ff0$var$currentFrame = nextFrame;
    return $67a01f8f769a9ff0$var$currentFrame.length > 0;
}
function $67a01f8f769a9ff0$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $67a01f8f769a9ff0$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $67a01f8f769a9ff0$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $67a01f8f769a9ff0$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $67a01f8f769a9ff0$var$PERCENTAGE = $67a01f8f769a9ff0$var$NUMBER + "%";
function $67a01f8f769a9ff0$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $67a01f8f769a9ff0$export$8972dc0e6ad9238f = new RegExp("rgb" + $67a01f8f769a9ff0$var$call($67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER));
var $67a01f8f769a9ff0$export$4e46ac54fc82cf3b = new RegExp("rgba" + $67a01f8f769a9ff0$var$call($67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER));
var $67a01f8f769a9ff0$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $67a01f8f769a9ff0$var$call($67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$PERCENTAGE, $67a01f8f769a9ff0$var$PERCENTAGE));
var $67a01f8f769a9ff0$export$810b04175080204c = new RegExp("hsla" + $67a01f8f769a9ff0$var$call($67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$PERCENTAGE, $67a01f8f769a9ff0$var$PERCENTAGE, $67a01f8f769a9ff0$var$NUMBER));
var $67a01f8f769a9ff0$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $67a01f8f769a9ff0$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $67a01f8f769a9ff0$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $67a01f8f769a9ff0$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $67a01f8f769a9ff0$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $67a01f8f769a9ff0$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($67a01f8f769a9ff0$var$colors && $67a01f8f769a9ff0$var$colors[color] !== void 0) return $67a01f8f769a9ff0$var$colors[color];
    if (match = $67a01f8f769a9ff0$export$8972dc0e6ad9238f.exec(color)) return ($67a01f8f769a9ff0$var$parse255(match[1]) << 24 | // r
    $67a01f8f769a9ff0$var$parse255(match[2]) << 16 | // g
    $67a01f8f769a9ff0$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $67a01f8f769a9ff0$export$4e46ac54fc82cf3b.exec(color)) return ($67a01f8f769a9ff0$var$parse255(match[1]) << 24 | // r
    $67a01f8f769a9ff0$var$parse255(match[2]) << 16 | // g
    $67a01f8f769a9ff0$var$parse255(match[3]) << 8 | // b
    $67a01f8f769a9ff0$var$parse1(match[4])) >>> // a
    0;
    if (match = $67a01f8f769a9ff0$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $67a01f8f769a9ff0$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $67a01f8f769a9ff0$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $67a01f8f769a9ff0$export$8f4a7c0bb78e6ea8.exec(color)) return ($67a01f8f769a9ff0$var$hslToRgb($67a01f8f769a9ff0$var$parse360(match[1]), // h
    $67a01f8f769a9ff0$var$parsePercentage(match[2]), // s
    $67a01f8f769a9ff0$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $67a01f8f769a9ff0$export$810b04175080204c.exec(color)) return ($67a01f8f769a9ff0$var$hslToRgb($67a01f8f769a9ff0$var$parse360(match[1]), // h
    $67a01f8f769a9ff0$var$parsePercentage(match[2]), // s
    $67a01f8f769a9ff0$var$parsePercentage(match[3])) | $67a01f8f769a9ff0$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $67a01f8f769a9ff0$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $67a01f8f769a9ff0$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $67a01f8f769a9ff0$var$hue2rgb(p, q, h + 1 / 3);
    const g = $67a01f8f769a9ff0$var$hue2rgb(p, q, h);
    const b = $67a01f8f769a9ff0$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $67a01f8f769a9ff0$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $67a01f8f769a9ff0$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $67a01f8f769a9ff0$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $67a01f8f769a9ff0$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $67a01f8f769a9ff0$export$61db176b839af1f(input) {
    let int32Color = $67a01f8f769a9ff0$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $67a01f8f769a9ff0$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(range)) return $67a01f8f769a9ff0$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.str(range.output[0])) return $67a01f8f769a9ff0$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $67a01f8f769a9ff0$var$findRange(input, inputRange);
        return $67a01f8f769a9ff0$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $67a01f8f769a9ff0$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $67a01f8f769a9ff0$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $67a01f8f769a9ff0$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $67a01f8f769a9ff0$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $67a01f8f769a9ff0$var$c1 = 1.70158;
var $67a01f8f769a9ff0$var$c2 = $67a01f8f769a9ff0$var$c1 * 1.525;
var $67a01f8f769a9ff0$var$c3 = $67a01f8f769a9ff0$var$c1 + 1;
var $67a01f8f769a9ff0$var$c4 = 2 * Math.PI / 3;
var $67a01f8f769a9ff0$var$c5 = 2 * Math.PI / 4.5;
var $67a01f8f769a9ff0$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $67a01f8f769a9ff0$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$67a01f8f769a9ff0$var$c3 * x * x * x - $67a01f8f769a9ff0$var$c1 * x * x,
    easeOutBack: (x)=>1 + $67a01f8f769a9ff0$var$c3 * Math.pow(x - 1, 3) + $67a01f8f769a9ff0$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($67a01f8f769a9ff0$var$c2 + 1) * 2 * x - $67a01f8f769a9ff0$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($67a01f8f769a9ff0$var$c2 + 1) * (x * 2 - 2) + $67a01f8f769a9ff0$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $67a01f8f769a9ff0$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $67a01f8f769a9ff0$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $67a01f8f769a9ff0$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $67a01f8f769a9ff0$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $67a01f8f769a9ff0$var$bounceOut(1 - x),
    easeOutBounce: $67a01f8f769a9ff0$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $67a01f8f769a9ff0$var$bounceOut(1 - 2 * x)) / 2 : (1 + $67a01f8f769a9ff0$var$bounceOut(2 * x - 1)) / 2,
    steps: $67a01f8f769a9ff0$var$steps
};
// src/fluids.ts
var $67a01f8f769a9ff0$var$$get = Symbol.for("FluidValue.get");
var $67a01f8f769a9ff0$var$$observers = Symbol.for("FluidValue.observers");
var $67a01f8f769a9ff0$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$67a01f8f769a9ff0$var$$get]);
var $67a01f8f769a9ff0$export$e37b7520edd66839 = (arg)=>arg && arg[$67a01f8f769a9ff0$var$$get] ? arg[$67a01f8f769a9ff0$var$$get]() : arg;
var $67a01f8f769a9ff0$export$133f54e9f7cf1796 = (target)=>target[$67a01f8f769a9ff0$var$$observers] || null;
function $67a01f8f769a9ff0$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $67a01f8f769a9ff0$export$31752c40a5fab62a(target, event) {
    const observers = target[$67a01f8f769a9ff0$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $67a01f8f769a9ff0$export$8cbca1207adce0c0(observer2, event);
    });
}
var $67a01f8f769a9ff0$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $67a01f8f769a9ff0$export$a3b4618659637aa3(this, get);
    }
};
$67a01f8f769a9ff0$var$$get, $67a01f8f769a9ff0$var$$observers;
var $67a01f8f769a9ff0$export$a3b4618659637aa3 = (target, get)=>$67a01f8f769a9ff0$var$setHidden(target, $67a01f8f769a9ff0$var$$get, get);
function $67a01f8f769a9ff0$export$72d604e3f8d000a5(target, observer2) {
    if (target[$67a01f8f769a9ff0$var$$get]) {
        let observers = target[$67a01f8f769a9ff0$var$$observers];
        if (!observers) $67a01f8f769a9ff0$var$setHidden(target, $67a01f8f769a9ff0$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $67a01f8f769a9ff0$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$67a01f8f769a9ff0$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$67a01f8f769a9ff0$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $67a01f8f769a9ff0$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $67a01f8f769a9ff0$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $67a01f8f769a9ff0$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $67a01f8f769a9ff0$var$unitRegex = new RegExp(`(${$67a01f8f769a9ff0$var$numberRegex.source})(%|[a-z]+)`, "i");
var $67a01f8f769a9ff0$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $67a01f8f769a9ff0$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $67a01f8f769a9ff0$var$variableToRgba = (input)=>{
    const [token, fallback] = $67a01f8f769a9ff0$var$parseCSSVariable(input);
    if (!token || $67a01f8f769a9ff0$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $67a01f8f769a9ff0$var$cssVariableRegex.test(fallback)) return $67a01f8f769a9ff0$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $67a01f8f769a9ff0$var$parseCSSVariable = (current)=>{
    const match = $67a01f8f769a9ff0$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $67a01f8f769a9ff0$var$namedColorRegex;
var $67a01f8f769a9ff0$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $67a01f8f769a9ff0$export$4759a013d387347a = (config)=>{
    if (!$67a01f8f769a9ff0$var$namedColorRegex) $67a01f8f769a9ff0$var$namedColorRegex = $67a01f8f769a9ff0$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($67a01f8f769a9ff0$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $67a01f8f769a9ff0$export$e37b7520edd66839(value).replace($67a01f8f769a9ff0$var$cssVariableRegex, $67a01f8f769a9ff0$var$variableToRgba).replace($67a01f8f769a9ff0$var$colorRegex, $67a01f8f769a9ff0$export$61db176b839af1f).replace($67a01f8f769a9ff0$var$namedColorRegex, $67a01f8f769a9ff0$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($67a01f8f769a9ff0$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$67a01f8f769a9ff0$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$67a01f8f769a9ff0$var$unitRegex.test(output[0]) && output.find((value)=>$67a01f8f769a9ff0$var$unitRegex.test(value))?.replace($67a01f8f769a9ff0$var$numberRegex, "");
        let i = 0;
        return output[0].replace($67a01f8f769a9ff0$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($67a01f8f769a9ff0$var$rgbaRegex, $67a01f8f769a9ff0$var$rgbaRound);
    };
};
// src/deprecations.ts
var $67a01f8f769a9ff0$export$82e9f45cca5ba907 = "react-spring: ";
var $67a01f8f769a9ff0$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$67a01f8f769a9ff0$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $67a01f8f769a9ff0$var$warnInterpolate = $67a01f8f769a9ff0$export$d2de3aaeafa91619(console.warn);
function $67a01f8f769a9ff0$export$2abfcde8ae218ba8() {
    $67a01f8f769a9ff0$var$warnInterpolate(`${$67a01f8f769a9ff0$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $67a01f8f769a9ff0$var$warnDirectCall = $67a01f8f769a9ff0$export$d2de3aaeafa91619(console.warn);
function $67a01f8f769a9ff0$export$d99d974913ad3b12() {
    $67a01f8f769a9ff0$var$warnDirectCall(`${$67a01f8f769a9ff0$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $67a01f8f769a9ff0$export$75bed621f62abfa9(value) {
    return $67a01f8f769a9ff0$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$67a01f8f769a9ff0$export$48d7c418edadb60c() && $67a01f8f769a9ff0$var$cssVariableRegex.test(value) || value in ($67a01f8f769a9ff0$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $67a01f8f769a9ff0$var$observer;
var $67a01f8f769a9ff0$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $67a01f8f769a9ff0$var$handleObservation = (entries)=>entries.forEach(({ target: target , contentRect: contentRect  })=>{
        return $67a01f8f769a9ff0$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $67a01f8f769a9ff0$var$resizeElement(handler, target) {
    if (!$67a01f8f769a9ff0$var$observer) {
        if (typeof ResizeObserver !== "undefined") $67a01f8f769a9ff0$var$observer = new ResizeObserver($67a01f8f769a9ff0$var$handleObservation);
    }
    let elementHandlers = $67a01f8f769a9ff0$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $67a01f8f769a9ff0$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($67a01f8f769a9ff0$var$observer) $67a01f8f769a9ff0$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $67a01f8f769a9ff0$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $67a01f8f769a9ff0$var$observer) $67a01f8f769a9ff0$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $67a01f8f769a9ff0$var$listeners = /* @__PURE__ */ new Set();
var $67a01f8f769a9ff0$var$cleanupWindowResizeHandler;
var $67a01f8f769a9ff0$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $67a01f8f769a9ff0$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $67a01f8f769a9ff0$var$resizeWindow = (callback)=>{
    $67a01f8f769a9ff0$var$listeners.add(callback);
    if (!$67a01f8f769a9ff0$var$cleanupWindowResizeHandler) $67a01f8f769a9ff0$var$cleanupWindowResizeHandler = $67a01f8f769a9ff0$var$createResizeHandler();
    return ()=>{
        $67a01f8f769a9ff0$var$listeners.delete(callback);
        if (!$67a01f8f769a9ff0$var$listeners.size && $67a01f8f769a9ff0$var$cleanupWindowResizeHandler) {
            $67a01f8f769a9ff0$var$cleanupWindowResizeHandler();
            $67a01f8f769a9ff0$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $67a01f8f769a9ff0$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement  } = {})=>{
    if (container === document.documentElement) return $67a01f8f769a9ff0$var$resizeWindow(callback);
    else return $67a01f8f769a9ff0$var$resizeElement(callback, container);
};
// src/progress.ts
var $67a01f8f769a9ff0$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $67a01f8f769a9ff0$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $67a01f8f769a9ff0$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length , position: position  } = $67a01f8f769a9ff0$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
            axis.progress = $67a01f8f769a9ff0$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $67a01f8f769a9ff0$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $67a01f8f769a9ff0$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $67a01f8f769a9ff0$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $67a01f8f769a9ff0$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $67a01f8f769a9ff0$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement  } = {})=>{
    let containerHandlers = $67a01f8f769a9ff0$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $67a01f8f769a9ff0$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $67a01f8f769a9ff0$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$67a01f8f769a9ff0$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $67a01f8f769a9ff0$var$scrollListeners.set(container, listener);
        const target = $67a01f8f769a9ff0$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $67a01f8f769a9ff0$var$resizeListeners.set(container, $67a01f8f769a9ff0$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $67a01f8f769a9ff0$var$scrollListeners.get(container);
    $67a01f8f769a9ff0$export$27f233d61a9e2fa4(animateScroll);
    return ()=>{
        $67a01f8f769a9ff0$export$27f233d61a9e2fa4.cancel(animateScroll);
        const containerHandlers2 = $67a01f8f769a9ff0$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $67a01f8f769a9ff0$var$scrollListeners.get(container);
        $67a01f8f769a9ff0$var$scrollListeners.delete(container);
        if (listener) {
            $67a01f8f769a9ff0$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $67a01f8f769a9ff0$var$resizeListeners.get(container)?.();
        }
    };
};
function $67a01f8f769a9ff0$export$fe4300aa8eebea86(init) {
    const ref = (0, $bh6RR.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $67a01f8f769a9ff0$export$700979bc83e7db82 = $67a01f8f769a9ff0$export$48d7c418edadb60c() ? (0, $bh6RR.useEffect) : (0, $bh6RR.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $67a01f8f769a9ff0$var$useIsMounted = ()=>{
    const isMounted = (0, $bh6RR.useRef)(false);
    $67a01f8f769a9ff0$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $67a01f8f769a9ff0$export$91db9bc4f8ac944a() {
    const update2 = (0, $bh6RR.useState)()[1];
    const isMounted = $67a01f8f769a9ff0$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update2(Math.random());
    };
}
function $67a01f8f769a9ff0$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $bh6RR.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $bh6RR.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $67a01f8f769a9ff0$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $bh6RR.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $67a01f8f769a9ff0$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $67a01f8f769a9ff0$export$392544347a18b6ea = (effect)=>(0, $bh6RR.useEffect)(effect, $67a01f8f769a9ff0$var$emptyDeps);
var $67a01f8f769a9ff0$var$emptyDeps = [];
function $67a01f8f769a9ff0$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $67a01f8f769a9ff0$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $bh6RR.useState)(null);
    $67a01f8f769a9ff0$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $67a01f8f769a9ff0$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $bh6RR = parcelRequire("bh6RR");
// src/Animated.ts


var $bh6RR = parcelRequire("bh6RR");
var $17cf8f29d99824c1$var$$node = Symbol.for("Animated:node");
var $17cf8f29d99824c1$export$3df5e165e801a70f = (value)=>!!value && value[$17cf8f29d99824c1$var$$node] === value;
var $17cf8f29d99824c1$export$6b63995194a3a9e4 = (owner)=>owner && owner[$17cf8f29d99824c1$var$$node];
var $17cf8f29d99824c1$export$b553cb5b22b81b04 = (owner, node)=>(0, $67a01f8f769a9ff0$export$5c74248ea0e35446)(owner, $17cf8f29d99824c1$var$$node, node);
var $17cf8f29d99824c1$export$ccab2b64c5d440 = (owner)=>owner && owner[$17cf8f29d99824c1$var$$node] && owner[$17cf8f29d99824c1$var$$node].getPayload();
var $17cf8f29d99824c1$export$31627395a3b18e54 = class {
    constructor(){
        $17cf8f29d99824c1$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $17cf8f29d99824c1$export$cb1e8f3c05d37ad5 = class extends $17cf8f29d99824c1$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $17cf8f29d99824c1$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done  } = this;
        this.done = false;
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93 = class extends $17cf8f29d99824c1$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $67a01f8f769a9ff0$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $67a01f8f769a9ff0$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $17cf8f29d99824c1$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $17cf8f29d99824c1$export$f1b0b9e366a6e2d4 = class extends $17cf8f29d99824c1$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($17cf8f29d99824c1$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $67a01f8f769a9ff0$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($17cf8f29d99824c1$var$TreeContext.dependencies && (0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(source)) $17cf8f29d99824c1$var$TreeContext.dependencies.add(source);
        const payload = $17cf8f29d99824c1$export$ccab2b64c5d440(source);
        if (payload) (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $17cf8f29d99824c1$export$ede394683406942d = class extends $17cf8f29d99824c1$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $17cf8f29d99824c1$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($17cf8f29d99824c1$var$makeAnimated));
        return true;
    }
};
function $17cf8f29d99824c1$var$makeAnimated(value) {
    const nodeType = (0, $67a01f8f769a9ff0$export$75bed621f62abfa9)(value) ? $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93 : $17cf8f29d99824c1$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $17cf8f29d99824c1$export$e6b77ddbe47b132e(value) {
    const parentNode = $17cf8f29d99824c1$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(value) ? $17cf8f29d99824c1$export$ede394683406942d : (0, $67a01f8f769a9ff0$export$75bed621f62abfa9)(value) ? $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93 : $17cf8f29d99824c1$export$cb1e8f3c05d37ad5;
}
var $17cf8f29d99824c1$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $bh6RR.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $bh6RR.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $bh6RR.useCallback)((value)=>{
            instanceRef.current = $17cf8f29d99824c1$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $17cf8f29d99824c1$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $67a01f8f769a9ff0$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $17cf8f29d99824c1$var$PropsObserver(callback, deps);
        const observerRef = (0, $bh6RR.useRef)();
        (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(deps, (dep)=>(0, $67a01f8f769a9ff0$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $67a01f8f769a9ff0$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $bh6RR.useEffect)(callback, []);
        (0, $67a01f8f769a9ff0$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $67a01f8f769a9ff0$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $bh6RR.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $17cf8f29d99824c1$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $17cf8f29d99824c1$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $17cf8f29d99824c1$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $17cf8f29d99824c1$export$f1b0b9e366a6e2d4(props);
    $17cf8f29d99824c1$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $17cf8f29d99824c1$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $17cf8f29d99824c1$var$cacheKey = Symbol.for("AnimatedComponent");
var $17cf8f29d99824c1$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false , createAnimatedStyle: createAnimatedStyle = (style)=>new $17cf8f29d99824c1$export$f1b0b9e366a6e2d4(style) , getComponentProps: getComponentProps = (props)=>props  } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $17cf8f29d99824c1$var$getDisplayName(Component) || "Anonymous";
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $17cf8f29d99824c1$var$withAnimated(Component, hostConfig));
        else Component = Component[$17cf8f29d99824c1$var$cacheKey] || (Component[$17cf8f29d99824c1$var$cacheKey] = $17cf8f29d99824c1$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(components)) key = $17cf8f29d99824c1$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $17cf8f29d99824c1$var$getDisplayName = (arg)=>(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $e7c9bb2cfef2c846$export$b24b633b1364b94b = class {
};


function $41b3099c4ff7ef63$var$callProp(value, ...args) {
    return (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $41b3099c4ff7ef63$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $67a01f8f769a9ff0$export$45b10814cc054894)(value).includes(key)));
var $41b3099c4ff7ef63$var$resolveProp = (prop, key)=>(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $41b3099c4ff7ef63$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $41b3099c4ff7ef63$var$noopTransform = (value)=>value;
var $41b3099c4ff7ef63$var$getDefaultProps = (props, transform = $41b3099c4ff7ef63$var$noopTransform)=>{
    let keys = $41b3099c4ff7ef63$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $41b3099c4ff7ef63$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $41b3099c4ff7ef63$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $41b3099c4ff7ef63$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$41b3099c4ff7ef63$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $41b3099c4ff7ef63$export$b971039a739bf227(props) {
    const to2 = $41b3099c4ff7ef63$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $41b3099c4ff7ef63$var$computeGoal(value) {
    value = (0, $67a01f8f769a9ff0$export$e37b7520edd66839)(value);
    return (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(value) ? value.map($41b3099c4ff7ef63$var$computeGoal) : (0, $67a01f8f769a9ff0$export$75bed621f62abfa9)(value) ? (0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $41b3099c4ff7ef63$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $41b3099c4ff7ef63$var$isAsyncTo(to2) {
    return (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(to2) || (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(to2) && (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $41b3099c4ff7ef63$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $41b3099c4ff7ef63$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $41b3099c4ff7ef63$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $41b3099c4ff7ef63$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $41b3099c4ff7ef63$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $41b3099c4ff7ef63$var$defaults = {
    ...$41b3099c4ff7ef63$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $67a01f8f769a9ff0$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $41b3099c4ff7ef63$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $41b3099c4ff7ef63$var$defaults);
    }
};
function $41b3099c4ff7ef63$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $41b3099c4ff7ef63$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $41b3099c4ff7ef63$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $41b3099c4ff7ef63$var$defaults)if (config2[key] == null) config2[key] = $41b3099c4ff7ef63$var$defaults[key];
    let { frequency: frequency , damping: damping  } = config2;
    const { mass: mass  } = config2;
    if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $41b3099c4ff7ef63$var$sanitizeConfig(config2, props) {
    if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.tension) || !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.damping) || !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $41b3099c4ff7ef63$var$emptyArray = [];
var $41b3099c4ff7ef63$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $41b3099c4ff7ef63$var$emptyArray;
        this.toValues = null;
        this.fromValues = $41b3099c4ff7ef63$var$emptyArray;
        this.config = new $41b3099c4ff7ef63$var$AnimationConfig();
        this.immediate = false;
    }
};
function $41b3099c4ff7ef63$var$scheduleProps(callId, { key: key , props: props , defaultProps: defaultProps , state: state , actions: actions  }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $41b3099c4ff7ef63$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $41b3099c4ff7ef63$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $41b3099c4ff7ef63$var$matchProp(pause, key);
            delay = $41b3099c4ff7ef63$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $41b3099c4ff7ef63$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $41b3099c4ff7ef63$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $41b3099c4ff7ef63$var$getNoopResult(target.get()) : $41b3099c4ff7ef63$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $41b3099c4ff7ef63$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $41b3099c4ff7ef63$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $41b3099c4ff7ef63$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $41b3099c4ff7ef63$var$runAsync(to2, props, state, target) {
    const { callId: callId , parentId: parentId , onRest: onRest  } = props;
    const { asyncTo: prevTo , promise: prevPromise  } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $41b3099c4ff7ef63$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $41b3099c4ff7ef63$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $41b3099c4ff7ef63$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $41b3099c4ff7ef63$export$d362d093fa99dc7();
            const skipAnimationSignal = new $41b3099c4ff7ef63$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).skipAnimation) {
                    $41b3099c4ff7ef63$var$stopAsync(state);
                    skipAnimationSignal.result = $41b3099c4ff7ef63$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).skipAnimation) {
            $41b3099c4ff7ef63$var$stopAsync(state);
            return $41b3099c4ff7ef63$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $41b3099c4ff7ef63$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $41b3099c4ff7ef63$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $41b3099c4ff7ef63$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(onRest)) (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $41b3099c4ff7ef63$var$stopAsync(state, cancelId) {
    (0, $67a01f8f769a9ff0$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $41b3099c4ff7ef63$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $41b3099c4ff7ef63$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $41b3099c4ff7ef63$var$isFrameValue = (value)=>value instanceof $41b3099c4ff7ef63$export$8229896f80e2495e;
var $41b3099c4ff7ef63$var$nextId = 1;
var $41b3099c4ff7ef63$export$8229896f80e2495e = class extends (0, $67a01f8f769a9ff0$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $41b3099c4ff7ef63$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $67a01f8f769a9ff0$export$2abfcde8ae218ba8)();
        return (0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $67a01f8f769a9ff0$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $67a01f8f769a9ff0$export$a57f5080a3bcc90a).sort(this);
        (0, $67a01f8f769a9ff0$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $41b3099c4ff7ef63$var$$P = Symbol.for("SpringPhase");
var $41b3099c4ff7ef63$var$HAS_ANIMATED = 1;
var $41b3099c4ff7ef63$var$IS_ANIMATING = 2;
var $41b3099c4ff7ef63$var$IS_PAUSED = 4;
var $41b3099c4ff7ef63$var$hasAnimated = (target)=>(target[$41b3099c4ff7ef63$var$$P] & $41b3099c4ff7ef63$var$HAS_ANIMATED) > 0;
var $41b3099c4ff7ef63$var$isAnimating = (target)=>(target[$41b3099c4ff7ef63$var$$P] & $41b3099c4ff7ef63$var$IS_ANIMATING) > 0;
var $41b3099c4ff7ef63$var$isPaused = (target)=>(target[$41b3099c4ff7ef63$var$$P] & $41b3099c4ff7ef63$var$IS_PAUSED) > 0;
var $41b3099c4ff7ef63$var$setActiveBit = (target, active)=>active ? target[$41b3099c4ff7ef63$var$$P] |= $41b3099c4ff7ef63$var$IS_ANIMATING | $41b3099c4ff7ef63$var$HAS_ANIMATED : target[$41b3099c4ff7ef63$var$$P] &= ~$41b3099c4ff7ef63$var$IS_ANIMATING;
var $41b3099c4ff7ef63$var$setPausedBit = (target, paused)=>paused ? target[$41b3099c4ff7ef63$var$$P] |= $41b3099c4ff7ef63$var$IS_PAUSED : target[$41b3099c4ff7ef63$var$$P] &= ~$41b3099c4ff7ef63$var$IS_PAUSED;
// src/SpringValue.ts
var $41b3099c4ff7ef63$export$5854d13427d5a954 = class extends $41b3099c4ff7ef63$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $41b3099c4ff7ef63$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(arg1) || !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($41b3099c4ff7ef63$var$isAnimating(this) || this._state.asyncTo) || $41b3099c4ff7ef63$var$isPaused(this);
    }
    get goal() {
        return (0, $67a01f8f769a9ff0$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $17cf8f29d99824c1$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $41b3099c4ff7ef63$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $41b3099c4ff7ef63$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $41b3099c4ff7ef63$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues  } = anim;
        const { config: config2  } = anim;
        const payload = (0, $17cf8f29d99824c1$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $67a01f8f769a9ff0$export$45b10814cc054894)((0, $67a01f8f769a9ff0$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $67a01f8f769a9ff0$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($41b3099c4ff7ef63$var$isAnimating(this)) {
            const { to: to2 , config: config2  } = this.animation;
            (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$41b3099c4ff7ef63$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2  } = this.animation;
        this._focus(this.get());
        $41b3099c4ff7ef63$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2 , from: from  } = props;
        to2 = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $41b3099c4ff7ef63$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$41b3099c4ff7ef63$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $67a01f8f769a9ff0$export$e37b7520edd66839)(from);
            if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key , defaultProps: defaultProps  } = this;
        if (props.default) Object.assign(defaultProps, $41b3099c4ff7ef63$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $41b3099c4ff7ef63$var$resolveProp(value, key) : value));
        $41b3099c4ff7ef63$var$mergeActiveFn(this, props, "onProps");
        $41b3099c4ff7ef63$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $41b3099c4ff7ef63$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$41b3099c4ff7ef63$var$isPaused(this)) {
                        $41b3099c4ff7ef63$var$setPausedBit(this, true);
                        (0, $67a01f8f769a9ff0$export$7ba486852759e806)(state.pauseQueue);
                        $41b3099c4ff7ef63$var$sendEvent(this, "onPause", $41b3099c4ff7ef63$var$getFinishedResult(this, $41b3099c4ff7ef63$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($41b3099c4ff7ef63$var$isPaused(this)) {
                        $41b3099c4ff7ef63$var$setPausedBit(this, false);
                        if ($41b3099c4ff7ef63$var$isAnimating(this)) this._resume();
                        (0, $67a01f8f769a9ff0$export$7ba486852759e806)(state.resumeQueue);
                        $41b3099c4ff7ef63$var$sendEvent(this, "onResume", $41b3099c4ff7ef63$var$getFinishedResult(this, $41b3099c4ff7ef63$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $41b3099c4ff7ef63$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($41b3099c4ff7ef63$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($41b3099c4ff7ef63$var$getCancelledResult(this));
        }
        const { key: key , defaultProps: defaultProps , animation: anim  } = this;
        const { to: prevTo , from: prevFrom  } = anim;
        let { to: to2 = prevTo , from: from = prevFrom  } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $67a01f8f769a9ff0$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $67a01f8f769a9ff0$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $67a01f8f769a9ff0$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $41b3099c4ff7ef63$var$isAsyncTo(props.to);
        const { config: config2  } = anim;
        const { decay: decay , velocity: velocity  } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $41b3099c4ff7ef63$var$mergeConfig(config2, $41b3099c4ff7ef63$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $41b3099c4ff7ef63$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this);
        if (!node || (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(to2)) return resolve($41b3099c4ff7ef63$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(from) && $41b3099c4ff7ef63$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $41b3099c4ff7ef63$var$computeGoal(to2);
        const isAnimatable = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).num(goal) || (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(goal) || (0, $67a01f8f769a9ff0$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $41b3099c4ff7ef63$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $17cf8f29d99824c1$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$41b3099c4ff7ef63$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $67a01f8f769a9ff0$export$248d38f6296296c5)($41b3099c4ff7ef63$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $67a01f8f769a9ff0$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $67a01f8f769a9ff0$export$248d38f6296296c5)(config2.decay, decay) || !(0, $67a01f8f769a9ff0$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $41b3099c4ff7ef63$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $67a01f8f769a9ff0$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest  } = anim;
                (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)($41b3099c4ff7ef63$var$ACTIVE_EVENTS, (type)=>$41b3099c4ff7ef63$var$mergeActiveFn(this, props, type));
                const result = $41b3099c4ff7ef63$var$getFinishedResult(this, $41b3099c4ff7ef63$var$checkFinished(this, prevTo));
                (0, $67a01f8f769a9ff0$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $41b3099c4ff7ef63$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($41b3099c4ff7ef63$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($41b3099c4ff7ef63$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($41b3099c4ff7ef63$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $67a01f8f769a9ff0$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $67a01f8f769a9ff0$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2  } = this.animation;
        if ((0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(to2)) {
            (0, $67a01f8f769a9ff0$export$72d604e3f8d000a5)(to2, this);
            if ($41b3099c4ff7ef63$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2  } = this.animation;
        if ((0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(to2)) (0, $67a01f8f769a9ff0$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $67a01f8f769a9ff0$export$e37b7520edd66839)(arg);
        if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $67a01f8f769a9ff0$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $17cf8f29d99824c1$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $17cf8f29d99824c1$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $41b3099c4ff7ef63$var$sendEvent(this, "onStart", $41b3099c4ff7ef63$var$getFinishedResult(this, $41b3099c4ff7ef63$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $41b3099c4ff7ef63$var$callProp(this.animation.onChange, value, this);
        }
        $41b3099c4ff7ef63$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this).reset((0, $67a01f8f769a9ff0$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$41b3099c4ff7ef63$var$isAnimating(this)) {
            $41b3099c4ff7ef63$var$setActiveBit(this, true);
            if (!$41b3099c4ff7ef63$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $67a01f8f769a9ff0$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($41b3099c4ff7ef63$var$isAnimating(this)) {
            $41b3099c4ff7ef63$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $67a01f8f769a9ff0$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $41b3099c4ff7ef63$var$getCancelledResult(this.get()) : $41b3099c4ff7ef63$var$getFinishedResult(this.get(), $41b3099c4ff7ef63$var$checkFinished(this, goal ?? anim.to));
            (0, $67a01f8f769a9ff0$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $41b3099c4ff7ef63$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $41b3099c4ff7ef63$var$checkFinished(target, to2) {
    const goal = $41b3099c4ff7ef63$var$computeGoal(to2);
    const value = $41b3099c4ff7ef63$var$computeGoal(target.get());
    return (0, $67a01f8f769a9ff0$export$248d38f6296296c5)(value, goal);
}
function $41b3099c4ff7ef63$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $41b3099c4ff7ef63$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $41b3099c4ff7ef63$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $41b3099c4ff7ef63$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $41b3099c4ff7ef63$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $41b3099c4ff7ef63$var$createUpdate(props) {
    const { to: to2 , from: from  } = props = $41b3099c4ff7ef63$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(to2)) $41b3099c4ff7ef63$var$findDefined(to2, keys);
    if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(from)) $41b3099c4ff7ef63$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $41b3099c4ff7ef63$var$declareUpdate(props) {
    const update2 = $41b3099c4ff7ef63$var$createUpdate(props);
    if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $41b3099c4ff7ef63$var$getDefaultProps(update2);
    return update2;
}
function $41b3099c4ff7ef63$var$findDefined(values, keys) {
    (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $41b3099c4ff7ef63$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $41b3099c4ff7ef63$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $41b3099c4ff7ef63$var$getDefaultProp(props, type) ? $41b3099c4ff7ef63$var$resolveProp(props[type], target.key) : void 0;
}
function $41b3099c4ff7ef63$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $41b3099c4ff7ef63$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $41b3099c4ff7ef63$var$nextId2 = 1;
var $41b3099c4ff7ef63$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $41b3099c4ff7ef63$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($41b3099c4ff7ef63$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue  } = this;
        if (props) queue = (0, $67a01f8f769a9ff0$export$45b10814cc054894)(props).map($41b3099c4ff7ef63$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $41b3099c4ff7ef63$var$prepareKeys(this, queue);
        return $41b3099c4ff7ef63$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)((0, $67a01f8f769a9ff0$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $41b3099c4ff7ef63$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)((0, $67a01f8f769a9ff0$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)((0, $67a01f8f769a9ff0$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart , onChange: onChange , onRest: onRest  } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $67a01f8f769a9ff0$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $67a01f8f769a9ff0$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $67a01f8f769a9ff0$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $41b3099c4ff7ef63$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$41b3099c4ff7ef63$var$flushUpdate(ctrl, props))).then((results)=>$41b3099c4ff7ef63$var$getCombinedResult(ctrl, results));
}
async function $41b3099c4ff7ef63$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys , to: to2 , from: from , loop: loop , onRest: onRest , onResolve: onResolve  } = props;
    const defaults2 = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(to2) || (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)($41b3099c4ff7ef63$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished , cancelled: cancelled  })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $67a01f8f769a9ff0$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $41b3099c4ff7ef63$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($41b3099c4ff7ef63$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $67a01f8f769a9ff0$export$8793edee2d425525),
            resume: (0, $67a01f8f769a9ff0$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $41b3099c4ff7ef63$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($41b3099c4ff7ef63$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($41b3099c4ff7ef63$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $41b3099c4ff7ef63$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $41b3099c4ff7ef63$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $41b3099c4ff7ef63$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $41b3099c4ff7ef63$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $41b3099c4ff7ef63$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)((0, $67a01f8f769a9ff0$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $41b3099c4ff7ef63$var$createUpdate(props2);
        if (!(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $41b3099c4ff7ef63$var$prepareSprings(springs, props2, (key)=>{
            return $41b3099c4ff7ef63$var$createSpring(key);
        });
    });
    $41b3099c4ff7ef63$var$setSprings(ctrl, springs);
    return springs;
}
function $41b3099c4ff7ef63$var$setSprings(ctrl, springs) {
    (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $67a01f8f769a9ff0$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $41b3099c4ff7ef63$var$createSpring(key, observer) {
    const spring = new $41b3099c4ff7ef63$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $67a01f8f769a9ff0$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $41b3099c4ff7ef63$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $41b3099c4ff7ef63$var$prepareKeys(ctrl, queue) {
    (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(queue, (props)=>{
        $41b3099c4ff7ef63$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $41b3099c4ff7ef63$var$createSpring(key, ctrl);
        });
    });
}
var $41b3099c4ff7ef63$export$f12a216ec50d2cf1 = ({ children: children , ...props })=>{
    const inherited = (0, $bh6RR.useContext)($41b3099c4ff7ef63$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $67a01f8f769a9ff0$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider  } = $41b3099c4ff7ef63$var$ctx;
    return /* @__PURE__ */ $bh6RR.createElement(Provider, {
        value: props
    }, children);
};
var $41b3099c4ff7ef63$var$ctx = $41b3099c4ff7ef63$var$makeContext($41b3099c4ff7ef63$export$f12a216ec50d2cf1, {});
$41b3099c4ff7ef63$export$f12a216ec50d2cf1.Provider = $41b3099c4ff7ef63$var$ctx.Provider;
$41b3099c4ff7ef63$export$f12a216ec50d2cf1.Consumer = $41b3099c4ff7ef63$var$ctx.Consumer;
function $41b3099c4ff7ef63$var$makeContext(target, init) {
    Object.assign(target, $bh6RR.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $41b3099c4ff7ef63$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $67a01f8f769a9ff0$export$d99d974913ad3b12)();
        const results = [];
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $41b3099c4ff7ef63$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $bh6RR.useMemo)(()=>propsFn || arguments.length == 3 ? $41b3099c4ff7ef63$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $bh6RR.useRef)(0);
    const forceUpdate = (0, $67a01f8f769a9ff0$export$91db9bc4f8ac944a)();
    const state = (0, $bh6RR.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $41b3099c4ff7ef63$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $41b3099c4ff7ef63$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $41b3099c4ff7ef63$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($41b3099c4ff7ef63$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $bh6RR.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $67a01f8f769a9ff0$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $bh6RR.useMemo)(()=>{
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $41b3099c4ff7ef63$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $bh6RR.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $41b3099c4ff7ef63$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $41b3099c4ff7ef63$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$41b3099c4ff7ef63$var$getSprings(ctrl, updates[i]));
    const context = (0, $bh6RR.useContext)($41b3099c4ff7ef63$export$f12a216ec50d2cf1);
    const prevContext = (0, $67a01f8f769a9ff0$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $41b3099c4ff7ef63$var$hasProps(context);
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue  } = state;
        if (queue.length) {
            state.queue = [];
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $41b3099c4ff7ef63$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $67a01f8f769a9ff0$export$392544347a18b6ea)(()=>()=>{
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $41b3099c4ff7ef63$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $41b3099c4ff7ef63$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $41b3099c4ff7ef63$var$initSpringRef = ()=>$41b3099c4ff7ef63$export$2471ae76e2946684();
var $41b3099c4ff7ef63$export$564bff9c23cad2ca = ()=>(0, $bh6RR.useState)($41b3099c4ff7ef63$var$initSpringRef)[0];
var $41b3099c4ff7ef63$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $67a01f8f769a9ff0$export$fe4300aa8eebea86)(()=>new $41b3099c4ff7ef63$export$5854d13427d5a954(initial, props));
    (0, $67a01f8f769a9ff0$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $41b3099c4ff7ef63$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $41b3099c4ff7ef63$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $41b3099c4ff7ef63$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $41b3099c4ff7ef63$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset , sort: sort , trail: trail = 0 , expires: expires = true , exitBeforeEnter: exitBeforeEnter = false , onDestroyed: onDestroyed , ref: propsRef , config: propsConfig  } = propsFn ? propsFn() : props;
    const ref = (0, $bh6RR.useMemo)(()=>propsFn || arguments.length == 3 ? $41b3099c4ff7ef63$export$2471ae76e2946684() : void 0, []);
    const items = (0, $67a01f8f769a9ff0$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $bh6RR.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $67a01f8f769a9ff0$export$392544347a18b6ea)(()=>{
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $41b3099c4ff7ef63$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $41b3099c4ff7ef63$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>(0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl , item: item , key: key  })=>{
            $41b3099c4ff7ef63$var$detachRefs(ctrl, ref);
            $41b3099c4ff7ef63$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $41b3099c4ff7ef63$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave  } = propsFn ? propsFn() : props;
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $67a01f8f769a9ff0$export$91db9bc4f8ac944a)();
    const defaultProps = $41b3099c4ff7ef63$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $bh6RR.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $bh6RR.useRef)(false);
    (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $41b3099c4ff7ef63$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $41b3099c4ff7ef63$var$callProp(to2, t.item, i);
        to2 = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).obj(to2) ? $41b3099c4ff7ef63$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $41b3099c4ff7ef63$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $41b3099c4ff7ef63$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve  } = payload;
        payload.onResolve = (result)=>{
            $41b3099c4ff7ef63$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $41b3099c4ff7ef63$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $41b3099c4ff7ef63$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $bh6RR.useContext)($41b3099c4ff7ef63$export$f12a216ec50d2cf1);
    const prevContext = (0, $67a01f8f769a9ff0$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $41b3099c4ff7ef63$var$hasProps(context);
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase , payload: payload  }, t)=>{
            const { ctrl: ctrl  } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $41b3099c4ff7ef63$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs  } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $bh6RR.createElement(elem.type, {
                ...elem.props,
                key: (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).str(t.key) || (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $41b3099c4ff7ef63$var$nextKey = 1;
function $41b3099c4ff7ef63$var$getKeys(items, { key: key , keys: keys = key  }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $41b3099c4ff7ef63$var$nextKey++;
        });
    }
    return (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(keys) ? items : (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $67a01f8f769a9ff0$export$45b10814cc054894)(keys);
}
var $41b3099c4ff7ef63$export$d928051c8cd740b = ({ container: container , ...springOptions } = {})=>{
    const [scrollValues, api] = $41b3099c4ff7ef63$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $67a01f8f769a9ff0$export$d4d89fd61e5416ee)(({ x: x , y: y  })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $41b3099c4ff7ef63$export$e8b771555dc4a003 = ({ container: container , ...springOptions })=>{
    const [sizeValues, api] = $41b3099c4ff7ef63$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $67a01f8f769a9ff0$export$45b39e67d4ce4921)(({ width: width , height: height  })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $41b3099c4ff7ef63$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $41b3099c4ff7ef63$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $bh6RR.useState)(false);
    const ref = (0, $bh6RR.useRef)();
    const propsFn = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {} , from: from = {} , ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $41b3099c4ff7ef63$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $67a01f8f769a9ff0$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root , once: once , amount: amount = "any" , ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $41b3099c4ff7ef63$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $41b3099c4ff7ef63$export$a500e5b516cedfc({ children: children , ...props }) {
    return children($41b3099c4ff7ef63$export$c4af9125706c4d30(props));
}
function $41b3099c4ff7ef63$export$3b8b9d47fbf8fd2b({ items: items , children: children , ...props }) {
    const trails = $41b3099c4ff7ef63$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $41b3099c4ff7ef63$export$be58926105124dd4({ items: items , children: children , ...props }) {
    return $41b3099c4ff7ef63$export$7b286972b8d8ccbf(items, props)(children);
}
var $41b3099c4ff7ef63$export$b0cc4f9860136880 = class extends $41b3099c4ff7ef63$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $67a01f8f769a9ff0$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $17cf8f29d99824c1$export$e6b77ddbe47b132e)(value);
        (0, $17cf8f29d99824c1$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $67a01f8f769a9ff0$export$248d38f6296296c5)(value, oldValue)) {
            (0, $17cf8f29d99824c1$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $41b3099c4ff7ef63$var$checkIdle(this._active)) $41b3099c4ff7ef63$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $67a01f8f769a9ff0$export$e37b7520edd66839)) : (0, $67a01f8f769a9ff0$export$45b10814cc054894)((0, $67a01f8f769a9ff0$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$41b3099c4ff7ef63$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)((0, $17cf8f29d99824c1$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).skipAnimation) {
                (0, $67a01f8f769a9ff0$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $41b3099c4ff7ef63$var$becomeIdle(this);
            } else (0, $67a01f8f769a9ff0$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)((0, $67a01f8f769a9ff0$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(source)) (0, $67a01f8f769a9ff0$export$72d604e3f8d000a5)(source, this);
            if ($41b3099c4ff7ef63$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)((0, $67a01f8f769a9ff0$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(source)) (0, $67a01f8f769a9ff0$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $41b3099c4ff7ef63$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $67a01f8f769a9ff0$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($41b3099c4ff7ef63$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $41b3099c4ff7ef63$var$isIdle(source) {
    return source.idle !== false;
}
function $41b3099c4ff7ef63$var$checkIdle(active) {
    return !active.size || Array.from(active).every($41b3099c4ff7ef63$var$isIdle);
}
function $41b3099c4ff7ef63$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)((0, $17cf8f29d99824c1$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $67a01f8f769a9ff0$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $41b3099c4ff7ef63$export$2c618a4308a30424 = (source, ...args)=>new $41b3099c4ff7ef63$export$b0cc4f9860136880(source, args);
var $41b3099c4ff7ef63$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $67a01f8f769a9ff0$export$2abfcde8ae218ba8)(), new $41b3099c4ff7ef63$export$b0cc4f9860136880(source, args));
(0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $67a01f8f769a9ff0$export$4759a013d387347a,
    to: (source, args)=>new $41b3099c4ff7ef63$export$b0cc4f9860136880(source, args)
});
var $41b3099c4ff7ef63$export$722fbec263ad908a = (0, $67a01f8f769a9ff0$export$a57f5080a3bcc90a).advance;





// src/applyAnimatedValues.ts
var $e76b8f2030afb380$var$isCustomPropRE = /^--/;
function $e76b8f2030afb380$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$e76b8f2030afb380$var$isCustomPropRE.test(name) && !($e76b8f2030afb380$var$isUnitlessNumber.hasOwnProperty(name) && $e76b8f2030afb380$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $e76b8f2030afb380$var$attributeCache = {};
function $e76b8f2030afb380$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style: style , children: children , scrollTop: scrollTop , scrollLeft: scrollLeft , viewBox: viewBox , ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $e76b8f2030afb380$var$attributeCache[name] || ($e76b8f2030afb380$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $e76b8f2030afb380$var$dangerousStyleValue(name, style[name]);
        if ($e76b8f2030afb380$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $e76b8f2030afb380$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $e76b8f2030afb380$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $e76b8f2030afb380$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$e76b8f2030afb380$var$isUnitlessNumber = Object.keys($e76b8f2030afb380$var$isUnitlessNumber).reduce((acc, prop)=>{
    $e76b8f2030afb380$var$prefixes.forEach((prefix)=>acc[$e76b8f2030afb380$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $e76b8f2030afb380$var$isUnitlessNumber);
var $e76b8f2030afb380$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $e76b8f2030afb380$var$pxTransforms = /^(translate)/;
var $e76b8f2030afb380$var$degTransforms = /^(rotate|skew)/;
var $e76b8f2030afb380$var$addUnit = (value, unit)=>(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $e76b8f2030afb380$var$isValueIdentity = (value, id)=>(0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$e76b8f2030afb380$var$isValueIdentity(v, id)) : (0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $e76b8f2030afb380$var$AnimatedStyle = class extends (0, $17cf8f29d99824c1$export$f1b0b9e366a6e2d4) {
    constructor({ x: x , y: y , z: z , ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$e76b8f2030afb380$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $e76b8f2030afb380$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $67a01f8f769a9ff0$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($e76b8f2030afb380$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $e76b8f2030afb380$var$pxTransforms.test(key) ? "px" : $e76b8f2030afb380$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $67a01f8f769a9ff0$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$e76b8f2030afb380$var$addUnit(deg, unit)})`,
                        $e76b8f2030afb380$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$e76b8f2030afb380$var$addUnit(v, unit)).join(",")})`,
                        $e76b8f2030afb380$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $e76b8f2030afb380$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $e76b8f2030afb380$var$FluidTransform = class extends (0, $67a01f8f769a9ff0$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $67a01f8f769a9ff0$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $67a01f8f769a9ff0$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $67a01f8f769a9ff0$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(input, (value)=>(0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(value) && (0, $67a01f8f769a9ff0$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $67a01f8f769a9ff0$export$79b2f7037acddd43)(input, (value)=>(0, $67a01f8f769a9ff0$export$57ea7e3a7f6280c7)(value) && (0, $67a01f8f769a9ff0$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $67a01f8f769a9ff0$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $e76b8f2030afb380$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $67a01f8f769a9ff0$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $47cfd4084854a574$exports.unstable_batchedUpdates),
    createStringInterpolator: $67a01f8f769a9ff0$export$4759a013d387347a,
    colors: $67a01f8f769a9ff0$export$8f45430ccf837300
});
var $e76b8f2030afb380$var$host = (0, $17cf8f29d99824c1$export$4ee5c78f6dcbcef)($e76b8f2030afb380$var$primitives, {
    applyAnimatedValues: $e76b8f2030afb380$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $e76b8f2030afb380$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop , scrollLeft: scrollLeft , ...props })=>props
});
var $e76b8f2030afb380$export$407448d2b89b1813 = $e76b8f2030afb380$var$host.animated;





var $bh6RR = parcelRequire("bh6RR");
const $2ac33e5e4657f241$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $2ac33e5e4657f241$var$rotate = (v)=>{
    const angle = $2ac33e5e4657f241$var$radToDeg(Math.atan2(v[1], v[0]));
    return $2ac33e5e4657f241$var$rebaseAngle(angle);
};
const $2ac33e5e4657f241$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $2ac33e5e4657f241$var$rotate,
    rotateZ: $2ac33e5e4657f241$var$rotate,
    skewX: (v)=>$2ac33e5e4657f241$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$2ac33e5e4657f241$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $2ac33e5e4657f241$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $2ac33e5e4657f241$var$rotateZ = $2ac33e5e4657f241$var$rotate;
const $2ac33e5e4657f241$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $2ac33e5e4657f241$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $2ac33e5e4657f241$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $2ac33e5e4657f241$var$scaleX,
    scaleY: $2ac33e5e4657f241$var$scaleY,
    scale: (v)=>($2ac33e5e4657f241$var$scaleX(v) + $2ac33e5e4657f241$var$scaleY(v)) / 2,
    rotateX: (v)=>$2ac33e5e4657f241$var$rebaseAngle($2ac33e5e4657f241$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$2ac33e5e4657f241$var$rebaseAngle($2ac33e5e4657f241$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $2ac33e5e4657f241$var$rotateZ,
    rotate: $2ac33e5e4657f241$var$rotateZ,
    skewX: (v)=>$2ac33e5e4657f241$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$2ac33e5e4657f241$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $2ac33e5e4657f241$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $2ac33e5e4657f241$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $2ac33e5e4657f241$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $2ac33e5e4657f241$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $2ac33e5e4657f241$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $2ac33e5e4657f241$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($2ac33e5e4657f241$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $2ac33e5e4657f241$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none"  } = getComputedStyle(instance);
    return $2ac33e5e4657f241$export$f9111f9e16b73a26(transform, name);
};
function $2ac33e5e4657f241$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

const $49219324029fd57b$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $49219324029fd57b$export$9de1236619d9e756 = /*@__PURE__*/ $49219324029fd57b$var$checkStringStartsWith("--");
const $49219324029fd57b$var$startsAsVariableToken = /*@__PURE__*/ $49219324029fd57b$var$checkStringStartsWith("var(--");
const $49219324029fd57b$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $49219324029fd57b$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $49219324029fd57b$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $49219324029fd57b$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

/**
 * Generate a list of every possible transform key.
 */ const $0bbdb08d9f4ac4a7$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $0bbdb08d9f4ac4a7$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($0bbdb08d9f4ac4a7$export$280dc01950909d86))();


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $040c3e7ac51c9eb3$export$d3955c6a8f65a36b({ top: top , left: left , right: right , bottom: bottom  }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $040c3e7ac51c9eb3$export$b6b9cd4198191a47({ x: x , y: y  }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $040c3e7ac51c9eb3$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $5670722145d83593$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $fed21f2a9fad1fb9$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fed21f2a9fad1fb9$export$bdf30dca883ea463({ scale: scale , scaleX: scaleX , scaleY: scaleY  }) {
    return !$fed21f2a9fad1fb9$var$isIdentityScale(scale) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleX) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleY);
}
function $fed21f2a9fad1fb9$export$a545127cf1fbb600(values) {
    return $fed21f2a9fad1fb9$export$bdf30dca883ea463(values) || $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) {
    return $fed21f2a9fad1fb9$var$is2DTranslate(values.x) || $fed21f2a9fad1fb9$var$is2DTranslate(values.y);
}
function $fed21f2a9fad1fb9$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $4c951bbfa32a6f81$export$d80074982803af5c(box, { x: x , y: y  }) {
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $4c951bbfa32a6f81$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement  } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $4c951bbfa32a6f81$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $4c951bbfa32a6f81$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) $4c951bbfa32a6f81$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX && treeScale.x > $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX && treeScale.y > $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $4c951bbfa32a6f81$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $4c951bbfa32a6f81$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $4c951bbfa32a6f81$export$58b16271041fbfb(box, transform) {
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $0b2600dd2e3d7275$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $040c3e7ac51c9eb3$export$d3955c6a8f65a36b)((0, $040c3e7ac51c9eb3$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $0b2600dd2e3d7275$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $0b2600dd2e3d7275$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll  } = rootProjectionNode;
    if (scroll) {
        (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}



const $9a6eef991e30600f$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $0bbdb08d9f4ac4a7$export$280dc01950909d86)
]);


/**
 * ValueType for "auto"
 */ const $30bd7e55dbd3ee77$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


const $a484866b2daf521b$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $83fcba696e6be959$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $83fcba696e6be959$export$58f0f39f63f3cf42 = {
    ...$83fcba696e6be959$export$98e628dec113755e,
    transform: (v)=>(0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $83fcba696e6be959$export$dcdf75081b88279d = {
    ...$83fcba696e6be959$export$98e628dec113755e,
    default: 1
};


/*#__NO_SIDE_EFFECTS__*/ const $bf9cea26a42df991$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $bf9cea26a42df991$export$41fc368e1a942b97 = /*@__PURE__*/ $bf9cea26a42df991$var$createUnitType("deg");
const $bf9cea26a42df991$export$626336c2cd4b14de = /*@__PURE__*/ $bf9cea26a42df991$var$createUnitType("%");
const $bf9cea26a42df991$export$91c0eda1d06bf008 = /*@__PURE__*/ $bf9cea26a42df991$var$createUnitType("px");
const $bf9cea26a42df991$export$f91e8c45a95a32f2 = /*@__PURE__*/ $bf9cea26a42df991$var$createUnitType("vh");
const $bf9cea26a42df991$export$aed3d7b7d206c196 = /*@__PURE__*/ $bf9cea26a42df991$var$createUnitType("vw");
const $bf9cea26a42df991$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$bf9cea26a42df991$export$626336c2cd4b14de,
        parse: (v)=>$bf9cea26a42df991$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$bf9cea26a42df991$export$626336c2cd4b14de.transform(v * 100)
    }))();


/**
 * Tests a provided value against a ValueType
 */ const $022f524f82caf57c$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $4b753667a8aa16ea$export$d176691c1998a1f5 = [
    (0, $83fcba696e6be959$export$98e628dec113755e),
    (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    (0, $bf9cea26a42df991$export$626336c2cd4b14de),
    (0, $bf9cea26a42df991$export$41fc368e1a942b97),
    (0, $bf9cea26a42df991$export$aed3d7b7d206c196),
    (0, $bf9cea26a42df991$export$f91e8c45a95a32f2),
    (0, $30bd7e55dbd3ee77$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $4b753667a8aa16ea$export$eefdd52e3ccae428 = (v)=>$4b753667a8aa16ea$export$d176691c1998a1f5.find((0, $022f524f82caf57c$export$6eae4d0a6a7ca7cd)(v));



let $af7e1b70fef19820$export$491112666e282270 = ()=>{};
let $af7e1b70fef19820$export$f5708dca728d7177 = ()=>{};
var $af7e1b70fef19820$var$check, $af7e1b70fef19820$var$message, $af7e1b70fef19820$var$errorCode, $af7e1b70fef19820$var$check1, $af7e1b70fef19820$var$message1, $af7e1b70fef19820$var$errorCode1;

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $83e9eb5cd9110f92$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $db69d0eeafe2eb04$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $db69d0eeafe2eb04$export$b9f0c1f373aee2b0(current) {
    const match = $db69d0eeafe2eb04$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $db69d0eeafe2eb04$var$maxDepth = 4;
function $db69d0eeafe2eb04$export$289398774300c991(current, element, depth = 1) {
    (0, $af7e1b70fef19820$export$f5708dca728d7177)(depth <= $db69d0eeafe2eb04$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $db69d0eeafe2eb04$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $83e9eb5cd9110f92$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $49219324029fd57b$export$31f9caa2600b5723)(fallback) ? $db69d0eeafe2eb04$export$289398774300c991(fallback, element, depth + 1) : fallback;
}



function $5ec6e430efae8073$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}






const $0cf1f6c6fe745e51$export$8e5250d1aa9bf370 = (v)=>v === (0, $83fcba696e6be959$export$98e628dec113755e) || v === (0, $bf9cea26a42df991$export$91c0eda1d06bf008);
const $0cf1f6c6fe745e51$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $0cf1f6c6fe745e51$var$nonTranslationalTransformKeys = (0, $0bbdb08d9f4ac4a7$export$280dc01950909d86).filter((key)=>!$0cf1f6c6fe745e51$var$transformKeys.has(key));
function $0cf1f6c6fe745e51$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $0cf1f6c6fe745e51$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $0cf1f6c6fe745e51$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x  }, { paddingLeft: paddingLeft = "0" , paddingRight: paddingRight = "0"  })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y  }, { paddingTop: paddingTop = "0" , paddingBottom: paddingBottom = "0"  })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top  })=>parseFloat(top),
    left: (_bbox, { left: left  })=>parseFloat(left),
    bottom: ({ y: y  }, { top: top  })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x  }, { left: left  })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform  })=>(0, $2ac33e5e4657f241$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform  })=>(0, $2ac33e5e4657f241$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$0cf1f6c6fe745e51$export$781d46a8aa670d52.translateX = $0cf1f6c6fe745e51$export$781d46a8aa670d52.x;
$0cf1f6c6fe745e51$export$781d46a8aa670d52.translateY = $0cf1f6c6fe745e51$export$781d46a8aa670d52.y;


/*#__NO_SIDE_EFFECTS__*/ const $c13dd6518645747b$export$8793edee2d425525 = (any)=>any;


const $7339c1fd7dc301d8$export$dd826089e3c5e502 = {};


const $5e712550f6fcef4d$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $457a4fe615cf8ddf$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $c29c43b277004adb$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $457a4fe615cf8ddf$export$84ce9a476f53d110).value) (0, $457a4fe615cf8ddf$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $dcfc6094db6b337b$var$maxElapsed = 40;
function $dcfc6094db6b337b$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $5e712550f6fcef4d$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $c29c43b277004adb$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup , read: read , resolveKeyframes: resolveKeyframes , preUpdate: preUpdate , update: update , preRender: preRender , render: render , postRender: postRender  } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $7339c1fd7dc301d8$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $7339c1fd7dc301d8$export$dd826089e3c5e502).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $dcfc6094db6b337b$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $5e712550f6fcef4d$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $5e712550f6fcef4d$export$71ecace0a033b35a).length; i++)steps[(0, $5e712550f6fcef4d$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $5d53a624d838ced1$export$2cef06c20297c17d , cancel: $5d53a624d838ced1$export$ec99c0ef4978dccb , state: $5d53a624d838ced1$export$fff89137e9e818ce , steps: $5d53a624d838ced1$export$1811c3a7e3af92f0  } = /* @__PURE__ */ (0, $dcfc6094db6b337b$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $c13dd6518645747b$export$8793edee2d425525), true);


const $04b9bd6f381bbede$var$toResolve = new Set();
let $04b9bd6f381bbede$var$isScheduled = false;
let $04b9bd6f381bbede$var$anyNeedsMeasurement = false;
let $04b9bd6f381bbede$var$isForced = false;
function $04b9bd6f381bbede$var$measureAllKeyframes() {
    if ($04b9bd6f381bbede$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($04b9bd6f381bbede$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $0cf1f6c6fe745e51$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $04b9bd6f381bbede$var$anyNeedsMeasurement = false;
    $04b9bd6f381bbede$var$isScheduled = false;
    $04b9bd6f381bbede$var$toResolve.forEach((resolver)=>resolver.complete($04b9bd6f381bbede$var$isForced));
    $04b9bd6f381bbede$var$toResolve.clear();
}
function $04b9bd6f381bbede$var$readAllKeyframes() {
    $04b9bd6f381bbede$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $04b9bd6f381bbede$var$anyNeedsMeasurement = true;
    });
}
function $04b9bd6f381bbede$export$78b96d2a12593b05() {
    $04b9bd6f381bbede$var$isForced = true;
    $04b9bd6f381bbede$var$readAllKeyframes();
    $04b9bd6f381bbede$var$measureAllKeyframes();
    $04b9bd6f381bbede$var$isForced = false;
}
class $04b9bd6f381bbede$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $04b9bd6f381bbede$var$toResolve.add(this);
            if (!$04b9bd6f381bbede$var$isScheduled) {
                $04b9bd6f381bbede$var$isScheduled = true;
                (0, $5d53a624d838ced1$export$2cef06c20297c17d).read($04b9bd6f381bbede$var$readAllKeyframes);
                (0, $5d53a624d838ced1$export$2cef06c20297c17d).resolveKeyframes($04b9bd6f381bbede$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , name: name , element: element , motionValue: motionValue  } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $5ec6e430efae8073$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $04b9bd6f381bbede$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $04b9bd6f381bbede$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $ef7aa251191fb1e2$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $b9f33c7526eaa743$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $ef7aa251191fb1e2$export$ade84c85e44a6cb1)(value);
    else return true;
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $29c4a1f427e427ab$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $4996b8466115ac8b$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $26ddad70f5b72fee$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $4424162007459663$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $f93759b22f4bf9af$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $4424162007459663$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $26ddad70f5b72fee$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $f93759b22f4bf9af$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $4996b8466115ac8b$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $87160918533d96f2$var$clampRgbUnit = (v)=>(0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)(0, 255, v);
const $87160918533d96f2$export$7a99c86b5b1f4c9e = {
    ...(0, $83fcba696e6be959$export$98e628dec113755e),
    transform: (v)=>Math.round($87160918533d96f2$var$clampRgbUnit(v))
};
const $87160918533d96f2$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $f93759b22f4bf9af$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $f93759b22f4bf9af$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red , green: green , blue: blue , alpha: alpha$1 = 1  })=>"rgba(" + $87160918533d96f2$export$7a99c86b5b1f4c9e.transform(red) + ", " + $87160918533d96f2$export$7a99c86b5b1f4c9e.transform(green) + ", " + $87160918533d96f2$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $29c4a1f427e427ab$export$83d2e9e3e4ee39ed)((0, $83fcba696e6be959$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $69d03907c8eb4e64$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $69d03907c8eb4e64$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $f93759b22f4bf9af$export$2c8400d58aca05e)("#"),
    parse: $69d03907c8eb4e64$var$parseHex,
    transform: (0, $87160918533d96f2$export$4e46ac54fc82cf3b).transform
};






const $3910c6f8a2b7497d$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $f93759b22f4bf9af$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $f93759b22f4bf9af$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue , saturation: saturation , lightness: lightness , alpha: alpha$1 = 1  })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $bf9cea26a42df991$export$626336c2cd4b14de).transform((0, $29c4a1f427e427ab$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $bf9cea26a42df991$export$626336c2cd4b14de).transform((0, $29c4a1f427e427ab$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $29c4a1f427e427ab$export$83d2e9e3e4ee39ed)((0, $83fcba696e6be959$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $81f7d86e129b05ee$export$35e9368ef982300f = {
    test: (v)=>(0, $87160918533d96f2$export$4e46ac54fc82cf3b).test(v) || (0, $69d03907c8eb4e64$export$834dfc94dde4b3d8).test(v) || (0, $3910c6f8a2b7497d$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $87160918533d96f2$export$4e46ac54fc82cf3b).test(v)) return (0, $87160918533d96f2$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $3910c6f8a2b7497d$export$810b04175080204c).test(v)) return (0, $3910c6f8a2b7497d$export$810b04175080204c).parse(v);
        else return (0, $69d03907c8eb4e64$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $87160918533d96f2$export$4e46ac54fc82cf3b).transform(v) : (0, $3910c6f8a2b7497d$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $81f7d86e129b05ee$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $81f7d86e129b05ee$export$35e9368ef982300f.transform(parsed);
    }
};


const $68e40df21d875f7f$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $fba129027036429a$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $4996b8466115ac8b$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $68e40df21d875f7f$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $fba129027036429a$var$NUMBER_TOKEN = "number";
const $fba129027036429a$var$COLOR_TOKEN = "color";
const $fba129027036429a$var$VAR_TOKEN = "var";
const $fba129027036429a$var$VAR_FUNCTION_TOKEN = "var(";
const $fba129027036429a$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $fba129027036429a$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $fba129027036429a$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($fba129027036429a$var$complexRegex, (parsedValue)=>{
        if ((0, $81f7d86e129b05ee$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($fba129027036429a$var$COLOR_TOKEN);
            values.push((0, $81f7d86e129b05ee$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($fba129027036429a$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($fba129027036429a$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($fba129027036429a$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $fba129027036429a$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($fba129027036429a$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $fba129027036429a$var$parseComplexValue(v) {
    return $fba129027036429a$export$b61fc7c44bf646d5(v).values;
}
function $fba129027036429a$var$createTransformer(source) {
    const { split: split , types: types  } = $fba129027036429a$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $fba129027036429a$var$NUMBER_TOKEN) output += (0, $29c4a1f427e427ab$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $fba129027036429a$var$COLOR_TOKEN) output += (0, $81f7d86e129b05ee$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $fba129027036429a$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $81f7d86e129b05ee$export$35e9368ef982300f).test(v) ? (0, $81f7d86e129b05ee$export$35e9368ef982300f).getAnimatableNone(v) : v;
function $fba129027036429a$var$getAnimatableNone(v) {
    const parsed = $fba129027036429a$var$parseComplexValue(v);
    const transformer = $fba129027036429a$var$createTransformer(v);
    return transformer(parsed.map($fba129027036429a$var$convertNumbersToZero));
}
const $fba129027036429a$export$83a0e34f1302825b = {
    test: $fba129027036429a$var$test,
    parse: $fba129027036429a$var$parseComplexValue,
    createTransformer: $fba129027036429a$var$createTransformer,
    getAnimatableNone: $fba129027036429a$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $5acdf26813da2697$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $5acdf26813da2697$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $4996b8466115ac8b$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $5acdf26813da2697$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $5acdf26813da2697$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $5acdf26813da2697$export$3dea766d36a8935f = {
    ...(0, $fba129027036429a$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($5acdf26813da2697$var$functionRegex);
        return functions ? functions.map($5acdf26813da2697$var$applyDefaultFilter).join(" ") : v;
    }
};





const $f99f591390597816$export$7d260a2a5f8bc19e = {
    ...(0, $83fcba696e6be959$export$98e628dec113755e),
    transform: Math.round
};






const $abd29d7e1ae57a0b$export$f2e4285fee37e26 = {
    rotate: (0, $bf9cea26a42df991$export$41fc368e1a942b97),
    rotateX: (0, $bf9cea26a42df991$export$41fc368e1a942b97),
    rotateY: (0, $bf9cea26a42df991$export$41fc368e1a942b97),
    rotateZ: (0, $bf9cea26a42df991$export$41fc368e1a942b97),
    scale: $83fcba696e6be959$export$dcdf75081b88279d,
    scaleX: (0, $83fcba696e6be959$export$dcdf75081b88279d),
    scaleY: (0, $83fcba696e6be959$export$dcdf75081b88279d),
    scaleZ: (0, $83fcba696e6be959$export$dcdf75081b88279d),
    skew: (0, $bf9cea26a42df991$export$41fc368e1a942b97),
    skewX: (0, $bf9cea26a42df991$export$41fc368e1a942b97),
    skewY: (0, $bf9cea26a42df991$export$41fc368e1a942b97),
    distance: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    translateX: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    translateY: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    translateZ: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    x: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    y: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    z: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    perspective: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    transformPerspective: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    opacity: (0, $83fcba696e6be959$export$58f0f39f63f3cf42),
    originX: (0, $bf9cea26a42df991$export$44e2e1705876d7ed),
    originY: (0, $bf9cea26a42df991$export$44e2e1705876d7ed),
    originZ: (0, $bf9cea26a42df991$export$91c0eda1d06bf008)
};


const $d9fd516ad4375c7c$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderTopWidth: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderRightWidth: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderRadius: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    radius: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    maxWidth: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    height: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    maxHeight: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    top: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    right: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    bottom: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    left: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    paddingTop: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    paddingRight: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    paddingBottom: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    paddingLeft: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    margin: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    marginTop: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    marginRight: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    marginBottom: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    marginLeft: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $bf9cea26a42df991$export$91c0eda1d06bf008),
    ...(0, $abd29d7e1ae57a0b$export$f2e4285fee37e26),
    zIndex: (0, $f99f591390597816$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $83fcba696e6be959$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $83fcba696e6be959$export$58f0f39f63f3cf42),
    numOctaves: (0, $f99f591390597816$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $61f146ad2a90b4ed$export$98cd7c72c5a731fb = {
    ...(0, $d9fd516ad4375c7c$export$eec14432cd1cb67b),
    color: // Color props
    $81f7d86e129b05ee$export$35e9368ef982300f,
    backgroundColor: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    outlineColor: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    fill: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    stroke: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    borderTopColor: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    borderRightColor: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    borderBottomColor: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    borderLeftColor: (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    filter: $5acdf26813da2697$export$3dea766d36a8935f,
    WebkitFilter: (0, $5acdf26813da2697$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $61f146ad2a90b4ed$export$67d1babe0338d23b = (key)=>$61f146ad2a90b4ed$export$98cd7c72c5a731fb[key];


function $cce185499ab83941$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $61f146ad2a90b4ed$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $5acdf26813da2697$export$3dea766d36a8935f)) defaultValueType = (0, $fba129027036429a$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $8d6afc19f3156907$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $8d6afc19f3156907$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$8d6afc19f3156907$var$invalidTemplates.has(keyframe) && (0, $fba129027036429a$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $cce185499ab83941$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $3b2f4eac3c9d8b6b$export$4983792d11b61017 extends (0, $04b9bd6f381bbede$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , element: element , name: name  } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $49219324029fd57b$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $db69d0eeafe2eb04$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $9a6eef991e30600f$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $4b753667a8aa16ea$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $4b753667a8aa16ea$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $0cf1f6c6fe745e51$export$8e5250d1aa9bf370)(originType) && (0, $0cf1f6c6fe745e51$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $0cf1f6c6fe745e51$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , name: name  } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $b9f33c7526eaa743$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $8d6afc19f3156907$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element , unresolvedKeyframes: unresolvedKeyframes , name: name  } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $0cf1f6c6fe745e51$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element , name: name , unresolvedKeyframes: unresolvedKeyframes  } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $0cf1f6c6fe745e51$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

const $e9cb684de1415b1e$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);






/**
 * A list of all ValueTypes
 */ const $929a49b266faa443$var$valueTypes = [
    ...(0, $4b753667a8aa16ea$export$d176691c1998a1f5),
    (0, $81f7d86e129b05ee$export$35e9368ef982300f),
    (0, $fba129027036429a$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $929a49b266faa443$export$950e7e59ea1ffed7 = (v)=>$929a49b266faa443$var$valueTypes.find((0, $022f524f82caf57c$export$6eae4d0a6a7ca7cd)(v));


const { schedule: $8409471350b1e8a6$export$bb76eed83315504c , cancel: $8409471350b1e8a6$export$3252729004b8456e  } = /* @__PURE__ */ (0, $dcfc6094db6b337b$export$510b0596a933801a)(queueMicrotask, false);

function $a34ee2d11d990b2a$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $a34ee2d11d990b2a$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $a34ee2d11d990b2a$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $4cf799ef4cb4f7a9$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $a34ee2d11d990b2a$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $a34ee2d11d990b2a$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $549b0b6df941bbfe$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




let $49ed686fac20002d$var$now;
function $49ed686fac20002d$var$clearTime() {
    $49ed686fac20002d$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $49ed686fac20002d$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($49ed686fac20002d$var$now === undefined) $49ed686fac20002d$export$2da9be4cfdb689b1.set((0, $5d53a624d838ced1$export$fff89137e9e818ce).isProcessing || (0, $7339c1fd7dc301d8$export$dd826089e3c5e502).useManualTiming ? (0, $5d53a624d838ced1$export$fff89137e9e818ce).timestamp : performance.now());
        return $49ed686fac20002d$var$now;
    },
    set: (newTime)=>{
        $49ed686fac20002d$var$now = newTime;
        queueMicrotask($49ed686fac20002d$var$clearTime);
    }
};



/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $b7c16cc987b0f736$var$MAX_VELOCITY_DELTA = 30;
const $b7c16cc987b0f736$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $b7c16cc987b0f736$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $b7c16cc987b0f736$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $b7c16cc987b0f736$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $4cf799ef4cb4f7a9$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $5d53a624d838ced1$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($b7c16cc987b0f736$export$67fcd818a264039d.current) $b7c16cc987b0f736$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $b7c16cc987b0f736$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $b7c16cc987b0f736$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $549b0b6df941bbfe$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $b7c16cc987b0f736$export$ce8bdc721e76545f(init, options) {
    return new $b7c16cc987b0f736$export$8cea36d14ee64562(init, options);
}



const $145d8d26c6dc52b8$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $145d8d26c6dc52b8$export$65570e08d843624d = {};
for(const key in $145d8d26c6dc52b8$var$featureProps)$145d8d26c6dc52b8$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$145d8d26c6dc52b8$var$featureProps[key].some((name)=>!!props[name])
};


const $93b39ae61dedc877$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $93b39ae61dedc877$export$3d227df54007d73a = ()=>({
        x: $93b39ae61dedc877$export$ff25708b37f72782(),
        y: $93b39ae61dedc877$export$ff25708b37f72782()
    });
const $93b39ae61dedc877$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $93b39ae61dedc877$export$6459fc9e86be362e = ()=>({
        x: $93b39ae61dedc877$export$6db76765312617ac(),
        y: $93b39ae61dedc877$export$6db76765312617ac()
    });


const $0ec11121663cc82b$export$4e09c449d6c407f7 = typeof window !== "undefined";


// Does this device prefer reduced motion? Returns `null` server-side.
const $16faa30fcf534207$export$ff7706047246b98b = {
    current: null
};
const $16faa30fcf534207$export$6476d16e2fd2d0db = {
    current: false
};


function $8c52f85ab085b323$export$ca9f41fb23dded3d() {
    (0, $16faa30fcf534207$export$6476d16e2fd2d0db).current = true;
    if (!(0, $0ec11121663cc82b$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $16faa30fcf534207$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $16faa30fcf534207$export$ff7706047246b98b).current = false;
}



const $7680e86648d809f1$export$bc2a978a17abfdde = new WeakMap();


function $6c424f3bd35daf15$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $e4ec7857057a08b6$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $eb6a0a2a824114cd$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $eb6a0a2a824114cd$export$1405a65085f40b9 = [
    "initial",
    ...$eb6a0a2a824114cd$export$16e45afcc206d3a8
];


function $a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) {
    return (0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(props.animate) || (0, $eb6a0a2a824114cd$export$1405a65085f40b9).some((name)=>(0, $e4ec7857057a08b6$export$720b90e312cea233)(props[name]));
}
function $a01dc07902ba23d1$export$ce46fa4165cdec40(props) {
    return Boolean($a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) || props.variants);
}



function $c1ce9b34358097f3$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $e9cb684de1415b1e$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $e9cb684de1415b1e$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $b7c16cc987b0f736$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $b7c16cc987b0f736$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


function $960c679efe64d12b$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $960c679efe64d12b$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $960c679efe64d12b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $960c679efe64d12b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


const $59dc28bcfaa62e03$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $59dc28bcfaa62e03$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent , props: props , presenceContext: presenceContext , reducedMotionConfig: reducedMotionConfig , blockInitialAnimation: blockInitialAnimation , visualState: visualState  }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $04b9bd6f381bbede$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $5d53a624d838ced1$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues , renderState: renderState  } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $a01dc07902ba23d1$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange , ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $e9cb684de1415b1e$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $7680e86648d809f1$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $16faa30fcf534207$export$6476d16e2fd2d0db).current) (0, $8c52f85ab085b323$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $16faa30fcf534207$export$ff7706047246b98b).current;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $5d53a624d838ced1$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $5d53a624d838ced1$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $0bbdb08d9f4ac4a7$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $5d53a624d838ced1$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $145d8d26c6dc52b8$export$65570e08d843624d){
            const featureDefinition = (0, $145d8d26c6dc52b8$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled , Feature: FeatureConstructor  } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $59dc28bcfaa62e03$var$propEventHandlers.length; i++){
            const key = $59dc28bcfaa62e03$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $c1ce9b34358097f3$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $b7c16cc987b0f736$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $83e9eb5cd9110f92$export$65583ed5a868f2d9)(value) || (0, $ef7aa251191fb1e2$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $929a49b266faa443$export$950e7e59ea1ffed7)(value) && (0, $fba129027036429a$export$83a0e34f1302825b).test(target)) value = (0, $cce185499ab83941$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $e9cb684de1415b1e$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $e9cb684de1415b1e$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial  } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $e9cb684de1415b1e$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $4cf799ef4cb4f7a9$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $8409471350b1e8a6$export$bb76eed83315504c).render(this.render);
    }
}


class $f82c67e8782ea4e3$export$e49735c2a366bdc7 extends (0, $59dc28bcfaa62e03$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $3b2f4eac3c9d8b6b$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars , style: style  }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children  } = this.props;
        if ((0, $e9cb684de1415b1e$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $51bd922a63a98387$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $6330a89fb7e6648e$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $6330a89fb7e6648e$var$numTransforms = (0, $0bbdb08d9f4ac4a7$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $6330a89fb7e6648e$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $6330a89fb7e6648e$var$numTransforms; i++){
        const key = (0, $0bbdb08d9f4ac4a7$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $51bd922a63a98387$export$453ef540a9a1bd6b)(value, (0, $d9fd516ad4375c7c$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $6330a89fb7e6648e$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $5a314cc097974a58$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style , vars: vars , transformOrigin: transformOrigin  } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $0bbdb08d9f4ac4a7$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $49219324029fd57b$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $51bd922a63a98387$export$453ef540a9a1bd6b)(value, (0, $d9fd516ad4375c7c$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $6330a89fb7e6648e$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%" , originY: originY = "50%" , originZ: originZ = 0  } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $46b26a876b49a8ee$export$1a32bf6229c258c0(element, { style: style , vars: vars  }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}





const $93233d74f0d10a65$export$91ddd985b97788d1 = {};
function $93233d74f0d10a65$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $93233d74f0d10a65$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $49219324029fd57b$export$9de1236619d9e756)(key)) $93233d74f0d10a65$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf(key, { layout: layout , layoutId: layoutId  }) {
    return (0, $0bbdb08d9f4ac4a7$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $93233d74f0d10a65$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $c0a33d9fc770b07f$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style  } = props;
    const newValues = {};
    for(const key in style)if ((0, $e9cb684de1415b1e$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $e9cb684de1415b1e$export$605d60a2578142d3)(prevProps.style[key]) || (0, $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}


function $c22d56f4f698c1a8$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $c22d56f4f698c1a8$export$23fea75b03ac16b3 extends (0, $f82c67e8782ea4e3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $46b26a876b49a8ee$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $0bbdb08d9f4ac4a7$export$7b42a0094fb00b6e).has(key)) return this.projection?.isProjecting ? (0, $2ac33e5e4657f241$export$1f10c01143b9f089)(key) : (0, $2ac33e5e4657f241$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $c22d56f4f698c1a8$export$3735103072e4a80(instance);
            const value = ((0, $49219324029fd57b$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint  }) {
        return (0, $0b2600dd2e3d7275$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $c0a33d9fc770b07f$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}





/**
 * Convert camelCase to dash-case properties.
 */ const $002b84d235cc9e7f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();




const $3fd910e6a82125ad$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $3fd910e6a82125ad$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $3fd910e6a82125ad$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $3fd910e6a82125ad$var$dashKeys : $3fd910e6a82125ad$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $bf9cea26a42df991$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $bf9cea26a42df991$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $bf9cea26a42df991$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $6f8e2d5207755192$export$5475d24f125d7053(state, { attrX: attrX , attrY: attrY , attrScale: attrScale , pathLength: pathLength , pathSpacing: pathSpacing = 1 , pathOffset: pathOffset = 0 , // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs , style: style  } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $3fd910e6a82125ad$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $896574d8c8ac028d$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $5c8095c47c03f29b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $50c74351dd8901bc$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $46b26a876b49a8ee$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $896574d8c8ac028d$export$28931db5d57958e5).has(key) ? (0, $002b84d235cc9e7f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}




function $4c234d289d8baf9a$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $c0a33d9fc770b07f$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $e9cb684de1415b1e$export$605d60a2578142d3)(props[key]) || (0, $e9cb684de1415b1e$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $0bbdb08d9f4ac4a7$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $86a41d187babab09$export$86bcdffbaf733d84 extends (0, $f82c67e8782ea4e3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $93b39ae61dedc877$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $0bbdb08d9f4ac4a7$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $61f146ad2a90b4ed$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $896574d8c8ac028d$export$28931db5d57958e5).has(key) ? (0, $002b84d235cc9e7f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $4c234d289d8baf9a$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $6f8e2d5207755192$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $50c74351dd8901bc$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c47a60ce42aa9a7c$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $f9a5862a9160f78d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $c47a60ce42aa9a7c$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}


const $584c8429f63c1575$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? new (0, $86a41d187babab09$export$86bcdffbaf733d84)(options) : new (0, $c22d56f4f698c1a8$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $bh6RR.Fragment)
    });
};






var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $364741b44296b530$export$a3579ca508007a95 = (0, $bh6RR.createContext)({});



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $6a5cdc65c5393968$export$40f10139ecf1f171 = (0, $bh6RR.createContext)({
    strict: false
});



var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @public
 */ const $f69ceb430ae9345a$export$22a697fb29aac98d = (0, $bh6RR.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $38e1c7c15d587098$export$2285bbca2c666415 = /* @__PURE__ */ (0, $bh6RR.createContext)({});



var $bh6RR = parcelRequire("bh6RR");



function $be811e3f75d8f6fc$export$12fc32fc096a04a3(props, context) {
    if ((0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial , animate: animate  } = props;
        return {
            initial: initial === false || (0, $e4ec7857057a08b6$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $e4ec7857057a08b6$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


"use client";
function $a6e92297d8c984af$export$c5638d843b37a176(props) {
    const { initial: initial , animate: animate  } = (0, $be811e3f75d8f6fc$export$12fc32fc096a04a3)(props, (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415)));
    return (0, $bh6RR.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a6e92297d8c984af$var$variantLabelsAsDependency(initial),
        $a6e92297d8c984af$var$variantLabelsAsDependency(animate)
    ]);
}
function $a6e92297d8c984af$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");


const $44dd7fb05ec6c3e6$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


"use client";
function $1988bd02b7e1d29b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $e9cb684de1415b1e$export$605d60a2578142d3)(source[key]) && !(0, $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $1988bd02b7e1d29b$var$useInitialMotionValues({ transformTemplate: transformTemplate  }, visualState) {
    return (0, $bh6RR.useMemo)(()=>{
        const state = (0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)();
        (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $1988bd02b7e1d29b$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $1988bd02b7e1d29b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $1988bd02b7e1d29b$var$useInitialMotionValues(props, visualState));
    return style;
}
function $1988bd02b7e1d29b$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $1988bd02b7e1d29b$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}



var $bh6RR = parcelRequire("bh6RR");



const $a6f7f4461a184c55$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)(),
        attrs: {}
    });



"use client";
function $f708387b704893ba$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $bh6RR.useMemo)(()=>{
        const state = (0, $a6f7f4461a184c55$export$41be8b43e1c4d4f9)();
        (0, $6f8e2d5207755192$export$5475d24f125d7053)(state, visualState, (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $1988bd02b7e1d29b$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $a022688aad5e3d50$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $a022688aad5e3d50$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $a022688aad5e3d50$var$validMotionProps.has(key);
}


let $2d7757648940a601$var$shouldForward = (key)=>!(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key);
function $2d7757648940a601$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $2d7757648940a601$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $2d7757648940a601$export$59d6962c470509a5((parcelRequire("fjRTt")).default);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $2d7757648940a601$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($2d7757648940a601$var$shouldForward(key) || forwardMotionProps === true && (0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) || !isDom && !(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



"use client";
function $890426a95a69aae0$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues  }, isStatic, forwardMotionProps = false) {
    const useVisualProps = (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? (0, $f708387b704893ba$export$84309c4f53cb1bd5) : (0, $1988bd02b7e1d29b$export$57be0a314572d87d);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $2d7757648940a601$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $bh6RR.Fragment) ? {
        ...filteredProps,
        ...visualProps,
        ref: ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children  } = props;
    const renderedChildren = (0, $bh6RR.useMemo)(()=>(0, $e9cb684de1415b1e$export$605d60a2578142d3)(children) ? children.get() : children, [
        children
    ]);
    return (0, $bh6RR.createElement)(Component, {
        ...elementProps,
        children: renderedChildren
    });
}




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @public
 */ const $12e60920c2394b39$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $bh6RR.createContext)(null);





var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $9237e2773f81c3d0$export$fe4300aa8eebea86(init) {
    const ref = (0, $bh6RR.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $9e7923b7600c25b9$export$fcc2206ecb6d74b(value) {
    return (0, $e9cb684de1415b1e$export$605d60a2578142d3)(value) ? value.get() : value;
}


"use client";
function $e82a2bc47b563e2e$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps , createRenderState: createRenderState  }, props, context, presenceContext) {
    const state = {
        latestValues: $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial , animate: animate  } = props;
    const isControllingVariants$1 = (0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $a01dc07902ba23d1$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd , transition: transition , ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $e82a2bc47b563e2e$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415));
        const presenceContext = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
        const make = ()=>$e82a2bc47b563e2e$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(make);
    };




"use client";
const $7048c9d3cc99b433$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $e82a2bc47b563e2e$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: $c0a33d9fc770b07f$export$16da615486abaa45,
    createRenderState: (0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)
});





"use client";
const $e07732523000706a$export$9922240e40b88c48 = /*@__PURE__*/ (0, $e82a2bc47b563e2e$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $4c234d289d8baf9a$export$16da615486abaa45),
    createRenderState: (0, $a6f7f4461a184c55$export$41be8b43e1c4d4f9)
});





function $8223c64d87d3460d$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $145d8d26c6dc52b8$export$65570e08d843624d)[key] = {
        ...(0, $145d8d26c6dc52b8$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $92847778545e8ed0$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $bh6RR = parcelRequire("bh6RR");
function $0dc8dc297bc3aa83$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $29bcaad27b8bb245$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $bh6RR.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */ [
        visualElement
    ]);
}



var $bh6RR = parcelRequire("bh6RR");

const $6b140fcbcf20767d$export$ed7b8fa9dbf0105d = "framerAppearId";
const $6b140fcbcf20767d$export$8592e1c077c890a6 = "data-" + (0, $002b84d235cc9e7f$export$9fd24a634729c672)($6b140fcbcf20767d$export$ed7b8fa9dbf0105d);







var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $b8a0e6b50203ba18$export$da5f7b802957459a = (0, $bh6RR.createContext)({});




var $bh6RR = parcelRequire("bh6RR");

"use client";
const $56377e0c81527360$export$700979bc83e7db82 = (0, $0ec11121663cc82b$export$4e09c449d6c407f7) ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);


"use client";
function $05aa2ab8e054331c$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent  } = (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415));
    const lazyContext = (0, $bh6RR.useContext)((0, $6a5cdc65c5393968$export$40f10139ecf1f171));
    const presenceContext = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $bh6RR.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $bh6RR.useContext)((0, $b8a0e6b50203ba18$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $05aa2ab8e054331c$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $6b140fcbcf20767d$export$8592e1c077c890a6];
    const wantsHandoff = (0, $bh6RR.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $56377e0c81527360$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $05aa2ab8e054331c$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId , layout: layout , drag: drag , dragConstraints: dragConstraints , layoutScroll: layoutScroll , layoutRoot: layoutRoot , layoutCrossfade: layoutCrossfade  } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $0c5a031ea8dd3973$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false  } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $8223c64d87d3460d$export$449561ec5703cdc8)(preloadedFeatures);
    const useVisualState = (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? (0, $e07732523000706a$export$9922240e40b88c48) : (0, $7048c9d3cc99b433$export$851cf1f78cb3feac);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d)),
            ...props,
            layoutId: $0c5a031ea8dd3973$var$useLayoutId(props)
        };
        const { isStatic: isStatic  } = configAndProps;
        const context = (0, $a6e92297d8c984af$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $0ec11121663cc82b$export$4e09c449d6c407f7)) {
            $0c5a031ea8dd3973$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $0c5a031ea8dd3973$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $05aa2ab8e054331c$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $d4dab640dcbe486c$exports.jsxs)((0, $38e1c7c15d587098$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $d4dab640dcbe486c$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                (0, $890426a95a69aae0$export$e25bb1e5b53cbdff)(Component, props, (0, $29bcaad27b8bb245$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps)
            ]
        });
    }
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $bh6RR.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $92847778545e8ed0$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $0c5a031ea8dd3973$var$useLayoutId({ layoutId: layoutId  }) {
    const layoutGroupId = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $0c5a031ea8dd3973$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $bh6RR.useContext)((0, $6a5cdc65c5393968$export$40f10139ecf1f171)).strict;
}
function $0c5a031ea8dd3973$var$getProjectionFunctionality(props) {
    const { drag: drag , layout: layout  } = (0, $145d8d26c6dc52b8$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


function $118ccf88bcfc51b9$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $0c5a031ea8dd3973$export$46b7e4b9dc6110c3;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $0c5a031ea8dd3973$export$46b7e4b9dc6110c3)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $0c5a031ea8dd3973$export$46b7e4b9dc6110c3)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}




function $dfe6a10b7b91d234$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


function $7fa3dbba529c0c38$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}



const $96ae1bfc697c0155$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $b7c16cc987b0f736$export$ce8bdc721e76545f)(value));
}
function $4ddbbe2518feafa3$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $4ddbbe2518feafa3$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {} , transition: transition = {} , ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $4ddbbe2518feafa3$var$resolveFinalValueInKeyframes(target[key]);
        $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value);
    }
}




function $7b21dab475728d1e$export$98397f3adbf6259f(value) {
    return Boolean((0, $e9cb684de1415b1e$export$605d60a2578142d3)(value) && value.add);
}


function $bd95401810c788ae$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $7b21dab475728d1e$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $7339c1fd7dc301d8$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $7339c1fd7dc301d8$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}



function $e2f74713dde14d85$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $6b140fcbcf20767d$export$8592e1c077c890a6];
}




/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $3ae67a7aa0703caa$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $b319cee3e91187f8$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $b319cee3e91187f8$export$a4627e546088548d = (...transformers)=>transformers.reduce($b319cee3e91187f8$var$combineFunctions);



const $89c716b71568b4dc$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};









// Adapted from https://gist.github.com/mjackson/5311256
function $270fe66c504601bd$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $270fe66c504601bd$export$6ae64dbcd6bfc33e({ hue: hue , saturation: saturation , lightness: lightness , alpha: alpha  }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $270fe66c504601bd$var$hueToRgb(p, q, hue + 1 / 3);
        green = $270fe66c504601bd$var$hueToRgb(p, q, hue);
        blue = $270fe66c504601bd$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $7a97edbe73fc407e$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $cef6a81c38c5f504$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $cef6a81c38c5f504$var$colorTypes = [
    (0, $69d03907c8eb4e64$export$834dfc94dde4b3d8),
    (0, $87160918533d96f2$export$4e46ac54fc82cf3b),
    (0, $3910c6f8a2b7497d$export$810b04175080204c)
];
const $cef6a81c38c5f504$var$getColorType = (v)=>$cef6a81c38c5f504$var$colorTypes.find((type)=>type.test(v));
function $cef6a81c38c5f504$var$asRGBA(color) {
    const type = $cef6a81c38c5f504$var$getColorType(color);
    (0, $af7e1b70fef19820$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $3910c6f8a2b7497d$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $270fe66c504601bd$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $cef6a81c38c5f504$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $cef6a81c38c5f504$var$asRGBA(from);
    const toRGBA = $cef6a81c38c5f504$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $7a97edbe73fc407e$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $cef6a81c38c5f504$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $cef6a81c38c5f504$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $cef6a81c38c5f504$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $87160918533d96f2$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $2b8e405387ec1e93$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $2b8e405387ec1e93$export$fed62ccc3fb1a568(origin, target) {
    if ($2b8e405387ec1e93$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $b5f23508d26a0d21$var$mixNumber(a, b) {
    return (p)=>(0, $5670722145d83593$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $b5f23508d26a0d21$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $b5f23508d26a0d21$var$mixNumber;
    else if (typeof a === "string") return (0, $49219324029fd57b$export$31f9caa2600b5723)(a) ? (0, $7a97edbe73fc407e$export$a6f92d4bae65c0f1) : (0, $81f7d86e129b05ee$export$35e9368ef982300f).test(a) ? (0, $cef6a81c38c5f504$export$51e568cf5c039bac) : $b5f23508d26a0d21$export$65516310a87d8205;
    else if (Array.isArray(a)) return $b5f23508d26a0d21$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $81f7d86e129b05ee$export$35e9368ef982300f).test(a) ? (0, $cef6a81c38c5f504$export$51e568cf5c039bac) : $b5f23508d26a0d21$export$ebc23b6840c51ba1;
    return 0, $7a97edbe73fc407e$export$a6f92d4bae65c0f1;
}
function $b5f23508d26a0d21$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$b5f23508d26a0d21$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $b5f23508d26a0d21$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $b5f23508d26a0d21$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $b5f23508d26a0d21$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $b5f23508d26a0d21$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $fba129027036429a$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $fba129027036429a$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $fba129027036429a$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $2b8e405387ec1e93$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $2b8e405387ec1e93$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $2b8e405387ec1e93$export$fed62ccc3fb1a568)(origin, target);
        return (0, $b319cee3e91187f8$export$a4627e546088548d)($b5f23508d26a0d21$export$3bbefa2f402845c4($b5f23508d26a0d21$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $af7e1b70fef19820$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $7a97edbe73fc407e$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $75d6a07fc86c2267$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $b5f23508d26a0d21$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $62633593bb6e8f57$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp  })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $5d53a624d838ced1$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $5d53a624d838ced1$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $5d53a624d838ced1$export$fff89137e9e818ce).isProcessing ? (0, $5d53a624d838ced1$export$fff89137e9e818ce).timestamp : (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now()
    };
};



const $3345c58b9a5b9ea2$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $175defc6e5d60949$export$f4ff70a5b4808fd8 = 20000;
function $175defc6e5d60949$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $175defc6e5d60949$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $175defc6e5d60949$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $6a97c49c15a1f41b$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $175defc6e5d60949$export$cbdd6b3d40ea54e2)(generator), (0, $175defc6e5d60949$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(duration)
    };
}



const $d2cd49aeb29486cb$var$velocitySampleDuration = 5; // ms
function $d2cd49aeb29486cb$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $d2cd49aeb29486cb$var$velocitySampleDuration, 0);
    return (0, $549b0b6df941bbfe$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $52cd25aa9c311874$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};




const $30c78c0b441232c1$var$safeMin = 0.001;
function $30c78c0b441232c1$export$b15f158dc6d6f458({ duration: duration = (0, $52cd25aa9c311874$export$86436497e7b05d16).duration , bounce: bounce = (0, $52cd25aa9c311874$export$86436497e7b05d16).bounce , velocity: velocity = (0, $52cd25aa9c311874$export$86436497e7b05d16).velocity , mass: mass = (0, $52cd25aa9c311874$export$86436497e7b05d16).mass  }) {
    let envelope;
    let derivative;
    (0, $af7e1b70fef19820$export$491112666e282270)(duration <= (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)((0, $52cd25aa9c311874$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)((0, $52cd25aa9c311874$export$86436497e7b05d16).minDamping, (0, $52cd25aa9c311874$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)((0, $52cd25aa9c311874$export$86436497e7b05d16).minDuration, (0, $52cd25aa9c311874$export$86436497e7b05d16).maxDuration, (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $30c78c0b441232c1$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $30c78c0b441232c1$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $30c78c0b441232c1$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $30c78c0b441232c1$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$30c78c0b441232c1$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $30c78c0b441232c1$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $52cd25aa9c311874$export$86436497e7b05d16).stiffness,
        damping: (0, $52cd25aa9c311874$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $30c78c0b441232c1$var$rootIterations = 12;
function $30c78c0b441232c1$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $30c78c0b441232c1$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $30c78c0b441232c1$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $9d57f2e275bc13d2$var$durationKeys = [
    "duration",
    "bounce"
];
const $9d57f2e275bc13d2$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $9d57f2e275bc13d2$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $9d57f2e275bc13d2$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $52cd25aa9c311874$export$86436497e7b05d16).velocity,
        stiffness: (0, $52cd25aa9c311874$export$86436497e7b05d16).stiffness,
        damping: (0, $52cd25aa9c311874$export$86436497e7b05d16).damping,
        mass: (0, $52cd25aa9c311874$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$9d57f2e275bc13d2$var$isSpringType(options, $9d57f2e275bc13d2$var$physicsKeys) && $9d57f2e275bc13d2$var$isSpringType(options, $9d57f2e275bc13d2$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $52cd25aa9c311874$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $30c78c0b441232c1$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $52cd25aa9c311874$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $9d57f2e275bc13d2$export$b36281d89752ae66(optionsOrVisualDuration = (0, $52cd25aa9c311874$export$86436497e7b05d16).visualDuration, bounce = (0, $52cd25aa9c311874$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed , restDelta: restDelta  } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness , damping: damping , mass: mass , duration: duration , velocity: velocity , isResolvedFromDuration: isResolvedFromDuration  } = $9d57f2e275bc13d2$var$getSpringOptions({
        ...options,
        velocity: -(0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $52cd25aa9c311874$export$86436497e7b05d16).restSpeed.granular : (0, $52cd25aa9c311874$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $52cd25aa9c311874$export$86436497e7b05d16).restDelta.granular : (0, $52cd25aa9c311874$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $30c78c0b441232c1$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $d2cd49aeb29486cb$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $175defc6e5d60949$export$cbdd6b3d40ea54e2)(generator), (0, $175defc6e5d60949$export$f4ff70a5b4808fd8));
            const easing = (0, $3345c58b9a5b9ea2$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$9d57f2e275bc13d2$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $6a97c49c15a1f41b$export$7f1511d09ee75a99)(options, 100, $9d57f2e275bc13d2$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



function $6e4a7697bb03d8a3$export$ee3ff3a17106998({ keyframes: keyframes , velocity: velocity = 0.0 , power: power = 0.8 , timeConstant: timeConstant = 325 , bounceDamping: bounceDamping = 10 , bounceStiffness: bounceStiffness = 500 , modifyTarget: modifyTarget , min: min , max: max , restDelta: restDelta = 0.5 , restSpeed: restSpeed  }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $9d57f2e275bc13d2$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $d2cd49aeb29486cb$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $3b4416fbb4eb5f92$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $3b4416fbb4eb5f92$var$subdivisionPrecision = 0.0000001;
const $3b4416fbb4eb5f92$var$subdivisionMaxIterations = 12;
function $3b4416fbb4eb5f92$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $3b4416fbb4eb5f92$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $3b4416fbb4eb5f92$var$subdivisionPrecision && ++i < $3b4416fbb4eb5f92$var$subdivisionMaxIterations);
    return currentT;
}
function $3b4416fbb4eb5f92$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $c13dd6518645747b$export$8793edee2d425525;
    const getTForX = (aX)=>$3b4416fbb4eb5f92$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $3b4416fbb4eb5f92$var$calcBezier(getTForX(t), mY1, mY2);
}


const $89222ca60c512a6b$export$929e5a82286172a6 = /*@__PURE__*/ (0, $3b4416fbb4eb5f92$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $89222ca60c512a6b$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $3b4416fbb4eb5f92$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $89222ca60c512a6b$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $3b4416fbb4eb5f92$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $7014bdc307b9017f$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $effe809157040eb3$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $5976cf65520af851$export$77edfce482316a60 = /*@__PURE__*/ (0, $3b4416fbb4eb5f92$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $5976cf65520af851$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $effe809157040eb3$export$2c07eeff45156d4d)($5976cf65520af851$export$77edfce482316a60);
const $5976cf65520af851$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $7014bdc307b9017f$export$f946554fb8aeaf0d)($5976cf65520af851$export$b01116c84cdfe1a2);


const $2a3cde73c8e60821$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $5976cf65520af851$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $bb7f99d4c4026b1e$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $bb7f99d4c4026b1e$export$c8d67a19199d1a50 = (0, $effe809157040eb3$export$2c07eeff45156d4d)($bb7f99d4c4026b1e$export$e444123e42d03385);
const $bb7f99d4c4026b1e$export$30d3455eee55bed5 = (0, $7014bdc307b9017f$export$f946554fb8aeaf0d)($bb7f99d4c4026b1e$export$e444123e42d03385);




const $a19f632009f7348a$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $16bbf814f5de8e5a$var$easingLookup = {
    linear: (0, $c13dd6518645747b$export$8793edee2d425525),
    easeIn: $89222ca60c512a6b$export$929e5a82286172a6,
    easeInOut: $89222ca60c512a6b$export$c07234257a03d5e9,
    easeOut: $89222ca60c512a6b$export$57636bb43b1ccbb0,
    circIn: $bb7f99d4c4026b1e$export$e444123e42d03385,
    circInOut: $bb7f99d4c4026b1e$export$30d3455eee55bed5,
    circOut: $bb7f99d4c4026b1e$export$c8d67a19199d1a50,
    backIn: $5976cf65520af851$export$b01116c84cdfe1a2,
    backInOut: $5976cf65520af851$export$ddc5fd596f6c71b2,
    backOut: $5976cf65520af851$export$77edfce482316a60,
    anticipate: $2a3cde73c8e60821$export$6b0af63b873d419e
};
const $16bbf814f5de8e5a$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $16bbf814f5de8e5a$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $a19f632009f7348a$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $af7e1b70fef19820$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $3b4416fbb4eb5f92$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($16bbf814f5de8e5a$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $af7e1b70fef19820$export$f5708dca728d7177)($16bbf814f5de8e5a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $16bbf814f5de8e5a$var$easingLookup[definition];
    }
    return definition;
};

const $4061615368e775f5$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $ae2145642557546a$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



function $ec7e0e0f426b7377$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $7339c1fd7dc301d8$export$dd826089e3c5e502).mix || (0, $75d6a07fc86c2267$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $c13dd6518645747b$export$8793edee2d425525) : ease;
            mixer = (0, $b319cee3e91187f8$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec7e0e0f426b7377$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true , ease: ease , mixer: mixer  } = {}) {
    const inputLength = input.length;
    (0, $af7e1b70fef19820$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec7e0e0f426b7377$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $ae2145642557546a$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a41e0717e7165aa3$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $ae2145642557546a$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $5670722145d83593$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $af7f31f325d4e6aa$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a41e0717e7165aa3$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $0e1a33287d257124$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $81a33f1229cf3c44$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $89222ca60c512a6b$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $81a33f1229cf3c44$export$d25ddfdf17c3ad3e({ duration: duration = 300 , keyframes: keyframeValues , times: times , ease: ease = "easeInOut"  }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $4061615368e775f5$export$216948827bbdc797)(ease) ? ease.map((0, $16bbf814f5de8e5a$export$ef97fe084f156ca4)) : (0, $16bbf814f5de8e5a$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $0e1a33287d257124$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $af7f31f325d4e6aa$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $ec7e0e0f426b7377$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $81a33f1229cf3c44$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



const $e24c3cc87a3c85b1$var$isNotNull = (value)=>value !== null;
function $e24c3cc87a3c85b1$export$14de59408fad90b(keyframes, { repeat: repeat , repeatType: repeatType = "loop"  }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($e24c3cc87a3c85b1$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





const $83ace93c5ccf180b$var$transitionTypeMap = {
    decay: (0, $6e4a7697bb03d8a3$export$ee3ff3a17106998),
    inertia: $6e4a7697bb03d8a3$export$ee3ff3a17106998,
    tween: (0, $81a33f1229cf3c44$export$d25ddfdf17c3ad3e),
    keyframes: (0, $81a33f1229cf3c44$export$d25ddfdf17c3ad3e),
    spring: $9d57f2e275bc13d2$export$b36281d89752ae66
};
function $83ace93c5ccf180b$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $83ace93c5ccf180b$var$transitionTypeMap[transition.type];
}


class $8c3cb907ab5970b5$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}


const $23853422476b5ba7$var$percentToProgress = (percent)=>percent / 100;
class $23853422476b5ba7$export$3394f837405475c7 extends (0, $8c3cb907ab5970b5$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue  } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now()) this.tick((0, $49ed686fac20002d$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $89c716b71568b4dc$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options  } = this;
        (0, $83ace93c5ccf180b$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $81a33f1229cf3c44$export$d25ddfdf17c3ad3e) , repeat: repeat = 0 , repeatDelay: repeatDelay = 0 , repeatType: repeatType , velocity: velocity = 0  } = options;
        let { keyframes: keyframes$1  } = options;
        const generatorFactory = type || (0, $81a33f1229cf3c44$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $81a33f1229cf3c44$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $b319cee3e91187f8$export$a4627e546088548d)($23853422476b5ba7$var$percentToProgress, (0, $75d6a07fc86c2267$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $175defc6e5d60949$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration  } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator , totalDuration: totalDuration , mixKeyframes: mixKeyframes , mirroredGenerator: mirroredGenerator , resolvedDuration: resolvedDuration , calculatedDuration: calculatedDuration  } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0 , keyframes: keyframes , repeat: repeat , repeatType: repeatType , repeatDelay: repeatDelay , type: type , onUpdate: onUpdate , finalKeyframe: finalKeyframe  } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done  } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $6e4a7697bb03d8a3$export$ee3ff3a17106998)) state.value = (0, $e24c3cc87a3c85b1$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0  } = this.options || {};
        return this.duration + (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        this.driver?.start(false);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $49ed686fac20002d$export$2da9be4cfdb689b1).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $62633593bb6e8f57$export$c1033964b5ad7fef) , startTime: startTime  } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $49ed686fac20002d$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $89c716b71568b4dc$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $23853422476b5ba7$export$ee9b76de7353d815(options) {
    return new $23853422476b5ba7$export$3394f837405475c7(options);
}







const $2449c5644c085ed8$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $50f411d2dd47afcb$export$37a5fde709c1db82(element, name, value) {
    (0, $2449c5644c085ed8$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $43b56f3d6cf00122$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $ab6abce9b1295760$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $43b56f3d6cf00122$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);








/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $df7346e5ebc6717b$export$e3ad02c335474dee = {};


function $42785ca7c0cb63b9$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $43b56f3d6cf00122$export$7c73462e0d25e514)(callback);
    return ()=>(0, $df7346e5ebc6717b$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $9c7c93019429f6d6$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $42785ca7c0cb63b9$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $a48af88179894f0d$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $9f480c26936f6028$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $a48af88179894f0d$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $a48af88179894f0d$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $a48af88179894f0d$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $a48af88179894f0d$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $de95b1c9785e3efd$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $9c7c93019429f6d6$export$866c1d07a1ac2ab)() ? (0, $3345c58b9a5b9ea2$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $a19f632009f7348a$export$ff43f99925d7366b)(easing)) return (0, $a48af88179894f0d$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$de95b1c9785e3efd$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $9f480c26936f6028$export$2cf569f5e2221176).easeOut);
    else return (0, $9f480c26936f6028$export$2cf569f5e2221176)[easing];
}


function $7e8c6ca6a1c8441b$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0 , duration: duration = 300 , repeat: repeat = 0 , repeatType: repeatType = "loop" , ease: ease = "easeOut" , times: times  } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $de95b1c9785e3efd$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $457a4fe615cf8ddf$export$84ce9a476f53d110).value) (0, $89c716b71568b4dc$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $457a4fe615cf8ddf$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $89c716b71568b4dc$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}



function $da585aaca4fb3c01$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $8ac1d452fe03d583$export$a31269144d66b4a({ type: type , ...options }) {
    if ((0, $da585aaca4fb3c01$export$6ab7812f1bac68be)(type) && (0, $9c7c93019429f6d6$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $9f7058955b2a556e$export$6c0f9803d8aa7219 extends (0, $8c3cb907ab5970b5$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element , name: name , keyframes: keyframes , pseudoElement: pseudoElement , allowFlatten: allowFlatten = false , finalKeyframe: finalKeyframe , onComplete: onComplete  } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $af7e1b70fef19820$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $8ac1d452fe03d583$export$a31269144d66b4a)(options);
        this.animation = (0, $7e8c6ca6a1c8441b$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $e24c3cc87a3c85b1$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $50f411d2dd47afcb$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state  } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0  } = this.options || {};
        return this.duration + (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline , observe: observe  }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $ab6abce9b1295760$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            return 0, $c13dd6518645747b$export$8793edee2d425525;
        } else return observe(this);
    }
}




const $dd4fe749055bbe8e$var$unsupportedEasingFunctions = {
    anticipate: $2a3cde73c8e60821$export$6b0af63b873d419e,
    backInOut: $5976cf65520af851$export$ddc5fd596f6c71b2,
    circInOut: $bb7f99d4c4026b1e$export$30d3455eee55bed5
};
function $dd4fe749055bbe8e$var$isUnsupportedEase(key) {
    return key in $dd4fe749055bbe8e$var$unsupportedEasingFunctions;
}
function $dd4fe749055bbe8e$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $dd4fe749055bbe8e$var$isUnsupportedEase(transition.ease)) transition.ease = $dd4fe749055bbe8e$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $5c0e40a5be4c02d2$var$sampleDelta = 10; //ms
class $5c0e40a5be4c02d2$export$bd2cd6a048093d96 extends (0, $9f7058955b2a556e$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $dd4fe749055bbe8e$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $83ace93c5ccf180b$export$98db6ef1242dfa2)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue , onUpdate: onUpdate , onComplete: onComplete , element: element , ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $23853422476b5ba7$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $5c0e40a5be4c02d2$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $5c0e40a5be4c02d2$var$sampleDelta);
        sampleAnimation.stop();
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ac20f2cf574614b3$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $fba129027036429a$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $4189505d4bee246e$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $4189505d4bee246e$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $ac20f2cf574614b3$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $ac20f2cf574614b3$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $af7e1b70fef19820$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $4189505d4bee246e$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $da585aaca4fb3c01$export$6ab7812f1bac68be)(type)) && velocity;
}


function $f9e7c02e0474559f$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $66cb9b2e88ffe3f6$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $66cb9b2e88ffe3f6$var$supportsWaapi = /*@__PURE__*/ (0, $43b56f3d6cf00122$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $66cb9b2e88ffe3f6$export$ea92bde116fda821(options) {
    const { motionValue: motionValue , name: name , repeatDelay: repeatDelay , repeatType: repeatType , damping: damping , type: type  } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate , transformTemplate: transformTemplate  } = motionValue.owner.getProps();
    return $66cb9b2e88ffe3f6$var$supportsWaapi() && name && $66cb9b2e88ffe3f6$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $6ee25c2b86fd2e72$var$MAX_RESOLVE_DELAY = 40;
class $6ee25c2b86fd2e72$export$b9855e2a7dee3dd2 extends (0, $8c3cb907ab5970b5$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true , delay: delay = 0 , type: type = "keyframes" , repeat: repeat = 0 , repeatDelay: repeatDelay = 0 , repeatType: repeatType = "loop" , keyframes: keyframes , name: name , motionValue: motionValue , element: element , ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $04b9bd6f381bbede$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name , type: type , velocity: velocity , delay: delay , isHandoff: isHandoff , onUpdate: onUpdate  } = options;
        this.resolvedAt = (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $4189505d4bee246e$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            if ((0, $7339c1fd7dc301d8$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $e24c3cc87a3c85b1$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $f9e7c02e0474559f$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $6ee25c2b86fd2e72$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $66cb9b2e88ffe3f6$export$ea92bde116fda821)(resolvedOptions) ? new (0, $5c0e40a5be4c02d2$export$bd2cd6a048093d96)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $23853422476b5ba7$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>this.notifyFinished()).catch((0, $c13dd6518645747b$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $04b9bd6f381bbede$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}



const $cb21c6c57eea1e02$var$isNotNull = (value)=>value !== null;
function $cb21c6c57eea1e02$export$14de59408fad90b(keyframes, { repeat: repeat , repeatType: repeatType = "loop"  }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($cb21c6c57eea1e02$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}



const $943a3f0a32f59f42$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $943a3f0a32f59f42$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $943a3f0a32f59f42$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $943a3f0a32f59f42$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $943a3f0a32f59f42$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes  })=>{
    if (keyframes.length > 2) return $943a3f0a32f59f42$var$keyframesTransition;
    else if ((0, $0bbdb08d9f4ac4a7$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $943a3f0a32f59f42$var$criticallyDampedSpring(keyframes[1]) : $943a3f0a32f59f42$var$underDampedSpring;
    return $943a3f0a32f59f42$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $21fa6358c07b6e55$export$ca8e47dc8ed5a9d7({ when: when , delay: _delay , delayChildren: delayChildren , staggerChildren: staggerChildren , staggerDirection: staggerDirection , repeat: repeat , repeatType: repeatType , repeatDelay: repeatDelay , from: from , elapsed: elapsed , ...transition }) {
    return !!Object.keys(transition).length;
}


const $3431270835958863$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $7fa3dbba529c0c38$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0  } = transition;
        elapsed = elapsed - (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $21fa6358c07b6e55$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $943a3f0a32f59f42$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $f9e7c02e0474559f$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $7339c1fd7dc301d8$export$dd826089e3c5e502).instantAnimations || (0, $7339c1fd7dc301d8$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            (0, $f9e7c02e0474559f$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $cb21c6c57eea1e02$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $5d53a624d838ced1$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $23853422476b5ba7$export$3394f837405475c7)(options) : new (0, $6ee25c2b86fd2e72$export$b9855e2a7dee3dd2)(options);
    };


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cbfc21822c188a13$var$shouldBlockAnimation({ protectedKeys: protectedKeys , needsAnimating: needsAnimating  }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cbfc21822c188a13$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0 , transitionOverride: transitionOverride , type: type  } = {}) {
    let { transition: transition = visualElement.getDefaultTransition() , transitionEnd: transitionEnd , ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $cbfc21822c188a13$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $7fa3dbba529c0c38$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) continue;
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $e2f74713dde14d85$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $5d53a624d838ced1$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $bd95401810c788ae$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $3431270835958863$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $9a6eef991e30600f$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $5d53a624d838ced1$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $4ddbbe2518feafa3$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}



function $1ce777bd6825e88a$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}



function $8c445c76717d72c0$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {}  } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $cbfc21822c188a13$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0 , staggerChildren: staggerChildren , staggerDirection: staggerDirection  } = transition;
        return $8c445c76717d72c0$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when  } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $8c445c76717d72c0$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($8c445c76717d72c0$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $1ce777bd6825e88a$export$6e01cb2cb232d79b)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        }).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}


function $ca7433f5e9b78911$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $8c445c76717d72c0$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $8c445c76717d72c0$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $cbfc21822c188a13$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}





function $b3131a4296a9915c$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




const $51a01f65a0f496d4$var$numVariantProps = (0, $eb6a0a2a824114cd$export$1405a65085f40b9).length;
function $51a01f65a0f496d4$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $51a01f65a0f496d4$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $51a01f65a0f496d4$var$numVariantProps; i++){
        const name = (0, $eb6a0a2a824114cd$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $e4ec7857057a08b6$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}





const $e4063d3013cf053c$var$reversePriorityOrder = [
    ...(0, $eb6a0a2a824114cd$export$16e45afcc206d3a8)
].reverse();
const $e4063d3013cf053c$var$numAnimationTypes = (0, $eb6a0a2a824114cd$export$16e45afcc206d3a8).length;
function $e4063d3013cf053c$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation , options: options  })=>(0, $ca7433f5e9b78911$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $e4063d3013cf053c$export$bb53502b7a672aa8(visualElement) {
    let animate = $e4063d3013cf053c$var$animateList(visualElement);
    let state = $e4063d3013cf053c$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition , transitionEnd: transitionEnd , ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props  } = visualElement;
        const context = (0, $51a01f65a0f496d4$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $e4063d3013cf053c$var$numAnimationTypes; i++){
            const type = $e4063d3013cf053c$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $e4ec7857057a08b6$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $e4063d3013cf053c$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {}  } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(next) && (0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $b3131a4296a9915c$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && isInitialRender && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent  } = visualElement;
                    const parentVariant = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren  } = parentVariant.transition || {};
                        options.delay = (0, $1ce777bd6825e88a$export$6e01cb2cb232d79b)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $e4063d3013cf053c$var$createState();
            isInitialRender = true;
        }
    };
}
function $e4063d3013cf053c$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $b3131a4296a9915c$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $e4063d3013cf053c$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $e4063d3013cf053c$var$createState() {
    return {
        animate: $e4063d3013cf053c$var$createTypeState(true),
        whileInView: $e4063d3013cf053c$var$createTypeState(),
        whileHover: $e4063d3013cf053c$var$createTypeState(),
        whileTap: $e4063d3013cf053c$var$createTypeState(),
        whileDrag: $e4063d3013cf053c$var$createTypeState(),
        whileFocus: $e4063d3013cf053c$var$createTypeState(),
        exit: $e4063d3013cf053c$var$createTypeState()
    };
}


class $8c269db61902fb68$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $f32e32aeb432bca6$export$b45b3fe5caabdca extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $e4063d3013cf053c$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate  } = this.node.getProps();
        if ((0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate  } = this.node.getProps();
        const { animate: prevAnimate  } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}



let $a4f717d2e1520e94$var$id = 0;
class $a4f717d2e1520e94$export$4989d1eb6104cc6c extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $a4f717d2e1520e94$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent , onExitComplete: onExitComplete  } = this.node.presenceContext;
        const { isPresent: prevIsPresent  } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register , onExitComplete: onExitComplete  } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $61912b83da9ce72c$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f32e32aeb432bca6$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $a4f717d2e1520e94$export$4989d1eb6104cc6c)
    }
};




const $11aaa3516eb4fe3b$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $11aaa3516eb4fe3b$export$1b3dd616664938e4() {
    return $11aaa3516eb4fe3b$export$9e9bc3c487fccc00.x || $11aaa3516eb4fe3b$export$9e9bc3c487fccc00.y;
}


function $7a2dafd130edc18a$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x || (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x = (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x = (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




function $5727f053dc302d4d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



const $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $c20245f8d567b28b$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $c20245f8d567b28b$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event) && handler(event, $c20245f8d567b28b$export$12f84bb882d06e1a(event));
};


function $149813d40ccb6fe7$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(target, eventName, (0, $c20245f8d567b28b$export$c404e80f92c98d29)(handler), options);
}





const $d9901b0e7f584a90$var$SCALE_PRECISION = 0.0001;
const $d9901b0e7f584a90$var$SCALE_MIN = 1 - $d9901b0e7f584a90$var$SCALE_PRECISION;
const $d9901b0e7f584a90$var$SCALE_MAX = 1 + $d9901b0e7f584a90$var$SCALE_PRECISION;
const $d9901b0e7f584a90$var$TRANSLATE_PRECISION = 0.01;
const $d9901b0e7f584a90$var$TRANSLATE_MIN = 0 - $d9901b0e7f584a90$var$TRANSLATE_PRECISION;
const $d9901b0e7f584a90$var$TRANSLATE_MAX = 0 + $d9901b0e7f584a90$var$TRANSLATE_PRECISION;
function $d9901b0e7f584a90$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $d9901b0e7f584a90$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $d9901b0e7f584a90$export$c1c127004b72a37(target) / $d9901b0e7f584a90$export$c1c127004b72a37(source);
    delta.translate = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $d9901b0e7f584a90$var$SCALE_MIN && delta.scale <= $d9901b0e7f584a90$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $d9901b0e7f584a90$var$TRANSLATE_MIN && delta.translate <= $d9901b0e7f584a90$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $d9901b0e7f584a90$export$c0d25e96fc67d310(delta, source, target, origin) {
    $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $d9901b0e7f584a90$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $d9901b0e7f584a90$export$c1c127004b72a37(relative);
}
function $d9901b0e7f584a90$export$426154f9d100f99(target, relative, parent) {
    $d9901b0e7f584a90$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $d9901b0e7f584a90$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $d9901b0e7f584a90$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $d9901b0e7f584a90$export$c1c127004b72a37(layout);
}
function $d9901b0e7f584a90$export$2785bfcc929c5650(target, layout, parent) {
    $d9901b0e7f584a90$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $d9901b0e7f584a90$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}



function $c68037220032f1d8$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}



// Fixes https://github.com/motiondivision/motion/issues/2270
const $1a5cc9ddc6d87d3a$export$d533d84f9871c879 = ({ current: current  })=>{
    return current ? current.ownerDocument.defaultView : null;
};








const $d4f8ff7f023adf4a$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $d4f8ff7f023adf4a$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $d4f8ff7f023adf4a$export$9f17032d917177de(a.x, b.x);
    const yDelta = $d4f8ff7f023adf4a$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}


/**
 * @internal
 */ class $f05cb07b67532e20$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint , contextWindow: contextWindow = window , dragSnapToOrigin: dragSnapToOrigin = false , distanceThreshold: distanceThreshold = 3  } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $f05cb07b67532e20$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $d4f8ff7f023adf4a$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point  } = info;
            const { timestamp: timestamp  } = (0, $5d53a624d838ced1$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart , onMove: onMove  } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $5d53a624d838ced1$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd , onSessionEnd: onSessionEnd , resumeAnimation: resumeAnimation  } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $f05cb07b67532e20$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event);
        const initialInfo = $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint);
        const { point: point  } = initialInfo;
        const { timestamp: timestamp  } = (0, $5d53a624d838ced1$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart  } = handlers;
        onSessionStart && onSessionStart(event, $f05cb07b67532e20$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $b319cee3e91187f8$export$a4627e546088548d)((0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $5d53a624d838ced1$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $f05cb07b67532e20$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $f05cb07b67532e20$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $f05cb07b67532e20$var$getPanInfo({ point: point  }, history) {
    return {
        point: point,
        delta: $f05cb07b67532e20$var$subtractPoint(point, $f05cb07b67532e20$var$lastDevicePoint(history)),
        offset: $f05cb07b67532e20$var$subtractPoint(point, $f05cb07b67532e20$var$startDevicePoint(history)),
        velocity: $f05cb07b67532e20$var$getVelocity(history, 0.1)
    };
}
function $f05cb07b67532e20$var$startDevicePoint(history) {
    return history[0];
}
function $f05cb07b67532e20$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $f05cb07b67532e20$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $f05cb07b67532e20$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}





/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $e4bc4f9b398dfeb3$export$b3c764d3fca3ffe3(point, { min: min , max: max  }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $e4bc4f9b398dfeb3$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $e4bc4f9b398dfeb3$export$4e9195bf7793bc78(layoutBox, { top: top , left: left , bottom: bottom , right: right  }) {
    return {
        x: $e4bc4f9b398dfeb3$export$690c180aa5775042(layoutBox.x, left, right),
        y: $e4bc4f9b398dfeb3$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $e4bc4f9b398dfeb3$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $e4bc4f9b398dfeb3$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(source);
    const targetLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $ae2145642557546a$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $ae2145642557546a$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $e4bc4f9b398dfeb3$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $e4bc4f9b398dfeb3$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $e4bc4f9b398dfeb3$export$7c5eaef8f4723d22(dragElastic = $e4bc4f9b398dfeb3$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $e4bc4f9b398dfeb3$export$a3366d3bac43a742;
    return {
        x: $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $0ba13f75c89670e3$export$f0a15892c27dc07c = new WeakMap();
class $0ba13f75c89670e3$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false , distanceThreshold: distanceThreshold  } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext  } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin  } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag , dragPropagation: dragPropagation , onDragStart: onDragStart  } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $7a2dafd130edc18a$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $bf9cea26a42df991$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection  } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $5d53a624d838ced1$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $bd95401810c788ae$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState  } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation , dragDirectionLock: dragDirectionLock , onDirectionLock: onDirectionLock , onDrag: onDrag  } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset  } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $0ba13f75c89670e3$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>(0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>this.getAnimationState(axis) === "paused" && this.getAxisMotionValue(axis).animation?.play());
        const { dragSnapToOrigin: dragSnapToOrigin  } = this.getProps();
        this.panSession = new (0, $f05cb07b67532e20$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $1a5cc9ddc6d87d3a$export$d533d84f9871c879)(this.visualElement)
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity  } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd  } = this.getProps();
        if (onDragEnd) (0, $5d53a624d838ced1$export$2cef06c20297c17d).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection , animationState: animationState  } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation  } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag  } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $e4bc4f9b398dfeb3$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints , dragElastic: dragElastic  } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $e4bc4f9b398dfeb3$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $e4bc4f9b398dfeb3$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $e4bc4f9b398dfeb3$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints , onMeasureDragConstraints: onMeasureDragConstraints  } = this.getProps();
        if (!constraints || !(0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $af7e1b70fef19820$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection  } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $0b2600dd2e3d7275$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $e4bc4f9b398dfeb3$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $040c3e7ac51c9eb3$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $040c3e7ac51c9eb3$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag , dragMomentum: dragMomentum , dragElastic: dragElastic , dragTransition: dragTransition , dragSnapToOrigin: dragSnapToOrigin , onDragTransitionEnd: onDragTransitionEnd  } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $bd95401810c788ae$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $3431270835958863$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).animation?.pause());
    }
    getAnimationState(axis) {
        return this.getAxisMotionValue(axis).animation?.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const { drag: drag  } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection  } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min , max: max  } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag , dragConstraints: dragConstraints  } = this.getProps();
        const { projection: projection  } = this.visualElement;
        if (!(0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $e4bc4f9b398dfeb3$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate  } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min , max: max  } = this.constraints[axis];
            axisValue.set((0, $5670722145d83593$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $0ba13f75c89670e3$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag , dragListener: dragListener = true  } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints  } = this.getProps();
            if ((0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection  } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $5d53a624d838ced1$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta , hasLayoutChanged: hasLayoutChanged  })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false , dragDirectionLock: dragDirectionLock = false , dragPropagation: dragPropagation = false , dragConstraints: dragConstraints = false , dragElastic: dragElastic = (0, $e4bc4f9b398dfeb3$export$a3366d3bac43a742) , dragMomentum: dragMomentum = true  } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $0ba13f75c89670e3$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $0ba13f75c89670e3$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $012c82f716440bf2$export$5d97dc2872682820 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $c13dd6518645747b$export$8793edee2d425525);
        this.removeListeners = (0, $c13dd6518645747b$export$8793edee2d425525);
        this.controls = new (0, $0ba13f75c89670e3$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls  } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $c13dd6518645747b$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $a23e02b288283422$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $5d53a624d838ced1$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $a23e02b288283422$export$b4f8f1ee75ce5859 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $c13dd6518645747b$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $f05cb07b67532e20$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $1a5cc9ddc6d87d3a$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart , onPanStart: onPanStart , onPan: onPan , onPanEnd: onPanEnd  } = this.node.getProps();
        return {
            onSessionStart: $a23e02b288283422$var$asyncHandler(onPanSessionStart),
            onStart: $a23e02b288283422$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $5d53a624d838ced1$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}





var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $11db8f3094dfc6f1$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent , onExitComplete: onExitComplete , register: register  } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $bh6RR.useId)();
    (0, $bh6RR.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $bh6RR.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $11db8f3094dfc6f1$export$8249053f690ea39a() {
    return $11db8f3094dfc6f1$export$ee27c052bca048fb((0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2)));
}
function $11db8f3094dfc6f1$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $fb51e1392d812b31$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $e543877808356f59$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $e543877808356f59$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $bf9cea26a42df991$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $e543877808356f59$export$fafff692be55225d(latest, node.target.x);
        const y = $e543877808356f59$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};



const $2e837016dedbf14e$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale , projectionDelta: projectionDelta  })=>{
        const original = latest;
        const shadow = (0, $fba129027036429a$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $fba129027036429a$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};



"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $b6e93d5d187b3d6c$var$hasTakenAnySnapshot = false;
class $b6e93d5d187b3d6c$var$MeasureLayoutWithContext extends (0, $bh6RR.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement , layoutGroup: layoutGroup , switchLayoutGroup: switchLayoutGroup , layoutId: layoutId  } = this.props;
        const { projection: projection  } = visualElement;
        (0, $93233d74f0d10a65$export$de9e7791c71225fd)($b6e93d5d187b3d6c$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($b6e93d5d187b3d6c$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency , visualElement: visualElement , drag: drag , isPresent: isPresent  } = this.props;
        const { projection: projection  } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        $b6e93d5d187b3d6c$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $5d53a624d838ced1$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection  } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $8409471350b1e8a6$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement , layoutGroup: layoutGroup , switchLayoutGroup: promoteContext  } = this.props;
        const { projection: projection  } = visualElement;
        $b6e93d5d187b3d6c$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove  } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $b6e93d5d187b3d6c$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $11db8f3094dfc6f1$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95));
    return (0, $d4dab640dcbe486c$exports.jsx)($b6e93d5d187b3d6c$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $bh6RR.useContext)((0, $b8a0e6b50203ba18$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $b6e93d5d187b3d6c$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $e543877808356f59$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    boxShadow: (0, $2e837016dedbf14e$export$eb0bc629e74dcf8)
};


function $6bd59a5dc6ef8f97$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $47c9f2c62d157c66$export$17eda790a720ec57(element) {
    return (0, $6bd59a5dc6ef8f97$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $0b506ebbd47a954a$export$66957ea77182581d(element) {
    return (0, $47c9f2c62d157c66$export$17eda790a720ec57)(element) && element.tagName === "svg";
}





function $a676325df12b3ad9$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $e9cb684de1415b1e$export$605d60a2578142d3)(value) ? value : (0, $b7c16cc987b0f736$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $3431270835958863$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}




const $b2b47619cf5d2c84$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $1f12cfa00e0c731b$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $a34ee2d11d990b2a$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $a34ee2d11d990b2a$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $b2b47619cf5d2c84$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * Timeout defined in ms
 */ function $d62baf960e3e1cd2$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp  })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $5d53a624d838ced1$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $5d53a624d838ced1$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $5d53a624d838ced1$export$ec99c0ef4978dccb)(checkElapsed);
}
function $d62baf960e3e1cd2$export$fcd451ca460f8a2a(callback, timeout) {
    return $d62baf960e3e1cd2$export$1391212d75b2ee65(callback, (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(timeout));
}





const $210c6abc2ab907de$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $210c6abc2ab907de$var$numBorders = $210c6abc2ab907de$var$borders.length;
const $210c6abc2ab907de$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $210c6abc2ab907de$var$isPx = (value)=>typeof value === "number" || (0, $bf9cea26a42df991$export$91c0eda1d06bf008).test(value);
function $210c6abc2ab907de$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(0, lead.opacity ?? 1, $210c6abc2ab907de$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, 0, $210c6abc2ab907de$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $210c6abc2ab907de$var$numBorders; i++){
        const borderLabel = `border${$210c6abc2ab907de$var$borders[i]}Radius`;
        let followRadius = $210c6abc2ab907de$var$getRadius(follow, borderLabel);
        let leadRadius = $210c6abc2ab907de$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $210c6abc2ab907de$var$isPx(followRadius) === $210c6abc2ab907de$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $5670722145d83593$export$3bb0b4ff1037b8dd)($210c6abc2ab907de$var$asNumber(followRadius), $210c6abc2ab907de$var$asNumber(leadRadius), progress), 0);
            if ((0, $bf9cea26a42df991$export$626336c2cd4b14de).test(leadRadius) || (0, $bf9cea26a42df991$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $210c6abc2ab907de$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $210c6abc2ab907de$var$easeCrossfadeIn = /*@__PURE__*/ $210c6abc2ab907de$var$compress(0, 0.5, (0, $bb7f99d4c4026b1e$export$c8d67a19199d1a50));
const $210c6abc2ab907de$var$easeCrossfadeOut = /*@__PURE__*/ $210c6abc2ab907de$var$compress(0.5, 0.95, (0, $c13dd6518645747b$export$8793edee2d425525));
function $210c6abc2ab907de$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $ae2145642557546a$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$c53fd88f45d77e4b(box, originBox) {
    $44cebc6c5c69ba9d$export$a0230ae482601ae8(box.x, originBox.x);
    $44cebc6c5c69ba9d$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}






/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $749794150c53d8b2$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $4c951bbfa32a6f81$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $4c951bbfa32a6f81$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $749794150c53d8b2$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $bf9cea26a42df991$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $749794150c53d8b2$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $749794150c53d8b2$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $749794150c53d8b2$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $749794150c53d8b2$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $749794150c53d8b2$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $749794150c53d8b2$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $749794150c53d8b2$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $749794150c53d8b2$export$42b76f1d0d16d5b(box.x, transforms, $749794150c53d8b2$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $749794150c53d8b2$export$42b76f1d0d16d5b(box.y, transforms, $749794150c53d8b2$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $360ce5c67f749464$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $360ce5c67f749464$export$a7ec7642fe550fb6(delta) {
    return $360ce5c67f749464$var$isAxisDeltaZero(delta.x) && $360ce5c67f749464$var$isAxisDeltaZero(delta.y);
}
function $360ce5c67f749464$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $360ce5c67f749464$export$8d5cf76bb7daff09(a, b) {
    return $360ce5c67f749464$export$7a9a6f114ddd0fdb(a.x, b.x) && $360ce5c67f749464$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $360ce5c67f749464$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $360ce5c67f749464$export$ef641b782d85522(a, b) {
    return $360ce5c67f749464$export$22adf28bfca1c186(a.x, b.x) && $360ce5c67f749464$export$22adf28bfca1c186(a.y, b.y);
}
function $360ce5c67f749464$export$c5706146bc63213(box) {
    return (0, $d9901b0e7f584a90$export$c1c127004b72a37)(box.x) / (0, $d9901b0e7f584a90$export$c1c127004b72a37)(box.y);
}
function $360ce5c67f749464$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $183043a6fc74a7d6$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $a34ee2d11d990b2a$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $a34ee2d11d990b2a$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade  } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options , resumingFrom: resumingFrom  } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $bec23b122ca5d293$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective , rotate: rotate , rotateX: rotateX , rotateY: rotateY , skewX: skewX , skewY: skewY  } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $281d58aebf127403$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $281d58aebf127403$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $281d58aebf127403$var$animationTarget = 1000;
let $281d58aebf127403$var$id = 0;
function $281d58aebf127403$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues  } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement  } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $e2f74713dde14d85$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout , layoutId: layoutId  } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $5d53a624d838ced1$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent  } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $281d58aebf127403$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener , defaultParent: defaultParent , measureScroll: measureScroll , checkIsScrollRoot: checkIsScrollRoot , resetTransform: resetTransform  }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $281d58aebf127403$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $457a4fe615cf8ddf$export$84ce9a476f53d110).value) $281d58aebf127403$var$metrics.nodes = $281d58aebf127403$var$metrics.calculatedTargetDeltas = $281d58aebf127403$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($281d58aebf127403$export$131f2f0cc5fe9609);
                this.nodes.forEach($281d58aebf127403$var$resolveTargetDelta);
                this.nodes.forEach($281d58aebf127403$var$calcProjection);
                this.nodes.forEach($281d58aebf127403$export$c2664f37bc951031);
                if ((0, $457a4fe615cf8ddf$export$84ce9a476f53d110).addProjectionMetrics) (0, $457a4fe615cf8ddf$export$84ce9a476f53d110).addProjectionMetrics($281d58aebf127403$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $1f12cfa00e0c731b$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $4cf799ef4cb4f7a9$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $47c9f2c62d157c66$export$17eda790a720ec57)(instance) && !(0, $0b506ebbd47a954a$export$66957ea77182581d)(instance);
            this.instance = instance;
            const { layoutId: layoutId , layout: layout , visualElement: visualElement  } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $5d53a624d838ced1$export$2cef06c20297c17d).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $d62baf960e3e1cd2$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($281d58aebf127403$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta , hasLayoutChanged: hasLayoutChanged , hasRelativeLayoutChanged: hasRelativeLayoutChanged , layout: newLayout  })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $281d58aebf127403$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart , onLayoutAnimationComplete: onLayoutAnimationComplete  } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $360ce5c67f749464$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, $7fa3dbba529c0c38$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $281d58aebf127403$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $5d53a624d838ced1$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($281d58aebf127403$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement  } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId , layout: layout  } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($281d58aebf127403$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($281d58aebf127403$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($281d58aebf127403$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Write
                 */ this.nodes.forEach($281d58aebf127403$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($281d58aebf127403$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($281d58aebf127403$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $49ed686fac20002d$export$2da9be4cfdb689b1).now();
            (0, $5d53a624d838ced1$export$fff89137e9e818ce).delta = (0, $a484866b2daf521b$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $5d53a624d838ced1$export$fff89137e9e818ce).timestamp);
            (0, $5d53a624d838ced1$export$fff89137e9e818ce).timestamp = now;
            (0, $5d53a624d838ced1$export$fff89137e9e818ce).isProcessing = true;
            (0, $5d53a624d838ced1$export$1811c3a7e3af92f0).update.process((0, $5d53a624d838ced1$export$fff89137e9e818ce));
            (0, $5d53a624d838ced1$export$1811c3a7e3af92f0).preRender.process((0, $5d53a624d838ced1$export$fff89137e9e818ce));
            (0, $5d53a624d838ced1$export$1811c3a7e3af92f0).render.process((0, $5d53a624d838ced1$export$fff89137e9e818ce));
            (0, $5d53a624d838ced1$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $8409471350b1e8a6$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($281d58aebf127403$var$clearSnapshot);
            this.sharedNodes.forEach($281d58aebf127403$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $5d53a624d838ced1$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $5d53a624d838ced1$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement  } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $360ce5c67f749464$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $281d58aebf127403$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement  } = this.options;
            if (!visualElement) return (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($281d58aebf127403$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll  } = this.root;
                if (scroll) {
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll , options: options  } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fed21f2a9fad1fb9$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $749794150c53d8b2$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) (0, $749794150c53d8b2$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $5d53a624d838ced1$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout , layoutId: layoutId  } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $5d53a624d838ced1$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $d9901b0e7f584a90$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $4c951bbfa32a6f81$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $457a4fe615cf8ddf$export$84ce9a476f53d110).value) $281d58aebf127403$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fed21f2a9fad1fb9$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $5d53a624d838ced1$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout , layoutId: layoutId  } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $4c951bbfa32a6f81$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            }
            const { target: target  } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $44cebc6c5c69ba9d$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $44cebc6c5c69ba9d$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $360ce5c67f749464$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $360ce5c67f749464$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $457a4fe615cf8ddf$export$84ce9a476f53d110).value) $281d58aebf127403$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            this.projectionDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($281d58aebf127403$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $281d58aebf127403$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $281d58aebf127403$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $281d58aebf127403$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $360ce5c67f749464$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $210c6abc2ab907de$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, $5d53a624d838ced1$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $5d53a624d838ced1$export$2cef06c20297c17d).update(()=>{
                (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $89c716b71568b4dc$export$d921fb2475e2900c).layout++;
                this.motionValue || (this.motionValue = (0, $b7c16cc987b0f736$export$ce8bdc721e76545f)(0));
                this.currentAnimation = (0, $a676325df12b3ad9$export$335a17c977067b99)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $89c716b71568b4dc$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $89c716b71568b4dc$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($281d58aebf127403$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms , target: target , layout: layout , latestValues: latestValues  } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $281d58aebf127403$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                const xLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $183043a6fc74a7d6$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId  } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId  } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId  } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset , transition: transition , preserveFollowOpacity: preserveFollowOpacity  } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement  } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues  } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $281d58aebf127403$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $281d58aebf127403$var$transformAxes.length; i++){
                $281d58aebf127403$var$resetDistortingTransform(`rotate${$281d58aebf127403$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $281d58aebf127403$var$resetDistortingTransform(`skew${$281d58aebf127403$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $bec23b122ca5d293$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x , y: y  } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $93233d74f0d10a65$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct , applyTo: applyTo , isCSSVariable: isCSSVariable  } = (0, $93233d74f0d10a65$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($281d58aebf127403$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $281d58aebf127403$var$updateLayout(node) {
    node.updateLayout();
}
function $281d58aebf127403$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout , measuredBox: measuredLayout  } = node.layout;
        const { animationType: animationType  } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($281d58aebf127403$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        if (isShared) (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $360ce5c67f749464$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot , layout: parentLayout  } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $360ce5c67f749464$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete  } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $281d58aebf127403$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $457a4fe615cf8ddf$export$84ce9a476f53d110).value) $281d58aebf127403$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $281d58aebf127403$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $281d58aebf127403$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $281d58aebf127403$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $281d58aebf127403$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $281d58aebf127403$var$resetTransformStyle(node) {
    const { visualElement: visualElement  } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $281d58aebf127403$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $281d58aebf127403$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $281d58aebf127403$var$calcProjection(node) {
    node.calcProjection();
}
function $281d58aebf127403$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $281d58aebf127403$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $281d58aebf127403$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $281d58aebf127403$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $5670722145d83593$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $281d58aebf127403$export$6ffd3e6ae339a132(output, from, to, p) {
    $281d58aebf127403$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $281d58aebf127403$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $281d58aebf127403$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $281d58aebf127403$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $281d58aebf127403$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $281d58aebf127403$var$roundPoint = $281d58aebf127403$var$userAgentContains("applewebkit/") && !$281d58aebf127403$var$userAgentContains("chrome/") ? Math.round : (0, $c13dd6518645747b$export$8793edee2d425525);
function $281d58aebf127403$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $281d58aebf127403$var$roundPoint(axis.min);
    axis.max = $281d58aebf127403$var$roundPoint(axis.max);
}
function $281d58aebf127403$var$roundBox(box) {
    $281d58aebf127403$var$roundAxis(box.x);
    $281d58aebf127403$var$roundAxis(box.y);
}
function $281d58aebf127403$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $d9901b0e7f584a90$export$28d0384c4b79bde2)((0, $360ce5c67f749464$export$c5706146bc63213)(snapshot), (0, $360ce5c67f749464$export$c5706146bc63213)(layout), 0.2);
}
function $281d58aebf127403$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}




const $b2724fa5a1f79278$export$2d029a49a09b6177 = (0, $281d58aebf127403$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $5727f053dc302d4d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $e8dff807472b9243$export$b91509fcf893b648 = {
    current: undefined
};
const $e8dff807472b9243$export$b61a9eb3dbde8858 = (0, $281d58aebf127403$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$e8dff807472b9243$export$b91509fcf893b648.current) {
            const documentNode = new (0, $b2724fa5a1f79278$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $e8dff807472b9243$export$b91509fcf893b648.current = documentNode;
        }
        return $e8dff807472b9243$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $5e0aeefdd70dc82e$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $a23e02b288283422$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $012c82f716440bf2$export$5d97dc2872682820),
        ProjectionNode: (0, $e8dff807472b9243$export$b61a9eb3dbde8858),
        MeasureLayout: $b6e93d5d187b3d6c$export$779f5fb01ad751cd
    }
};



function $5c6341e39395a445$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $c98cdcb0020672a8$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $5c6341e39395a445$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $62aebe68f5a3cc52$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $11aaa3516eb4fe3b$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $62aebe68f5a3cc52$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $c98cdcb0020672a8$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$62aebe68f5a3cc52$var$isValidHover(enterEvent)) return;
        const { target: target  } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$62aebe68f5a3cc52$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}




function $d74f51ccafbc2725$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props  } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $5d53a624d838ced1$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event)));
}
class $d74f51ccafbc2725$export$93a81ea037eac456 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    mount() {
        const { current: current  } = this.node;
        if (!current) return;
        this.unmount = (0, $62aebe68f5a3cc52$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $d74f51ccafbc2725$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$d74f51ccafbc2725$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $194e5f2fba7dd91c$export$d4826db40d47595b extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $b319cee3e91187f8$export$a4627e546088548d)((0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}



/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $331a310c8191b255$export$1b3bfaa9684536aa(element) {
    return (0, $6bd59a5dc6ef8f97$export$a6cdc56e425d0d0a)(element) && "offsetHeight" in element;
}



/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $e3dc885e9b4ce990$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $e3dc885e9b4ce990$export$e841ada32ff745b(parent, child.parentElement);
};




const $9e66ba36736ca475$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $9e66ba36736ca475$export$5f6976e2f961e8b7(element) {
    return $9e66ba36736ca475$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $38fc35b2f99bbeec$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $ec2e5a2e73f36afc$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $ec2e5a2e73f36afc$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $ec2e5a2e73f36afc$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $ec2e5a2e73f36afc$var$filterEvents(()=>{
        if ((0, $38fc35b2f99bbeec$export$7987404a4e35b84b).has(element)) return;
        $ec2e5a2e73f36afc$var$firePointerEvent(element, "down");
        const handleKeyup = $ec2e5a2e73f36afc$var$filterEvents(()=>{
            $ec2e5a2e73f36afc$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$ec2e5a2e73f36afc$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $1fb501146082d657$var$isValidPressEvent(event) {
    return (0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event) && !(0, $11aaa3516eb4fe3b$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $1fb501146082d657$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $c98cdcb0020672a8$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$1fb501146082d657$var$isValidPressEvent(startEvent)) return;
        (0, $38fc35b2f99bbeec$export$7987404a4e35b84b).add(target);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $38fc35b2f99bbeec$export$7987404a4e35b84b).has(target)) (0, $38fc35b2f99bbeec$export$7987404a4e35b84b).delete(target);
            if (!$1fb501146082d657$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $e3dc885e9b4ce990$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $331a310c8191b255$export$1b3bfaa9684536aa)(target)) {
            target.addEventListener("focus", (event)=>(0, $ec2e5a2e73f36afc$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $9e66ba36736ca475$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}




function $7978956cdecaf1df$var$handlePressEvent(node, event, lifecycle) {
    const { props: props  } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $5d53a624d838ced1$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event)));
}
class $7978956cdecaf1df$export$f026abdbba7f0c9e extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    mount() {
        const { current: current  } = this.node;
        if (!current) return;
        this.unmount = (0, $1fb501146082d657$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $7978956cdecaf1df$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success  })=>$7978956cdecaf1df$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $a7da81711d7ddff5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $a7da81711d7ddff5$var$observers = new WeakMap();
const $a7da81711d7ddff5$var$fireObserverCallback = (entry)=>{
    const callback = $a7da81711d7ddff5$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $a7da81711d7ddff5$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($a7da81711d7ddff5$var$fireObserverCallback);
};
function $a7da81711d7ddff5$var$initIntersectionObserver({ root: root , ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$a7da81711d7ddff5$var$observers.has(lookupRoot)) $a7da81711d7ddff5$var$observers.set(lookupRoot, {});
    const rootObservers = $a7da81711d7ddff5$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($a7da81711d7ddff5$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $a7da81711d7ddff5$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $a7da81711d7ddff5$var$initIntersectionObserver(options);
    $a7da81711d7ddff5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $a7da81711d7ddff5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $62d26f27ee79826d$var$thresholdNames = {
    some: 0,
    all: 1
};
class $62d26f27ee79826d$export$150851c8cc2f0c72 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {}  } = this.node.getProps();
        const { root: root , margin: rootMargin , amount: amount = "some" , once: once  } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $62d26f27ee79826d$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting  } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter , onViewportLeave: onViewportLeave  } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $a7da81711d7ddff5$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props , prevProps: prevProps  } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($62d26f27ee79826d$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $62d26f27ee79826d$var$hasViewportOptionChanged({ viewport: viewport = {}  }, { viewport: prevViewport = {}  } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $aadd72d7ca06bd3a$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $62d26f27ee79826d$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $7978956cdecaf1df$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $194e5f2fba7dd91c$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $d74f51ccafbc2725$export$93a81ea037eac456)
    }
};




const $17a320fc4896a503$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $e8dff807472b9243$export$b61a9eb3dbde8858),
        MeasureLayout: $b6e93d5d187b3d6c$export$779f5fb01ad751cd
    }
};


const $ab4f9b04650b6b88$export$d596cd8841d25433 = {
    ...(0, $61912b83da9ce72c$export$7f9953c70dacfd7f),
    ...(0, $aadd72d7ca06bd3a$export$e5b72898e5a201f1),
    ...(0, $5e0aeefdd70dc82e$export$d7d5d435647ed5a0),
    ...(0, $17a320fc4896a503$export$b3219800bda33a1f)
};


const $08c9f1bffbd2aec7$export$e25e478948902b8b = /*@__PURE__*/ (0, $118ccf88bcfc51b9$export$a28d6df673050e18)((0, $ab4f9b04650b6b88$export$d596cd8841d25433), (0, $584c8429f63c1575$export$56ba0183203348f5));






var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");









var $bh6RR = parcelRequire("bh6RR");
const $168a40e325c04e1b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $168a40e325c04e1b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $168a40e325c04e1b$export$803cd8101b6c182b = /*#__PURE__*/ $168a40e325c04e1b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[0], side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[1]), []);
const $168a40e325c04e1b$export$96ec731ed4dcb222 = Math.min;
const $168a40e325c04e1b$export$8960430cfd85939f = Math.max;
const $168a40e325c04e1b$export$2077e0241d6afd3c = Math.round;
const $168a40e325c04e1b$export$a3fe094919f356fd = Math.floor;
const $168a40e325c04e1b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $168a40e325c04e1b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $168a40e325c04e1b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $168a40e325c04e1b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $168a40e325c04e1b$export$8960430cfd85939f(start, $168a40e325c04e1b$export$96ec731ed4dcb222(value, end));
}
function $168a40e325c04e1b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $168a40e325c04e1b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $168a40e325c04e1b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $168a40e325c04e1b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $168a40e325c04e1b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $168a40e325c04e1b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($168a40e325c04e1b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement) {
    return $168a40e325c04e1b$export$8a000a963141ac32($168a40e325c04e1b$export$f28e8f882010718a(placement));
}
function $168a40e325c04e1b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement);
    const length = $168a40e325c04e1b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $168a40e325c04e1b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $168a40e325c04e1b$export$9c5e28bad23365fa(placement);
    return [
        $168a40e325c04e1b$export$2b182c584985588b(placement),
        oppositePlacement,
        $168a40e325c04e1b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $168a40e325c04e1b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$168a40e325c04e1b$var$oppositeAlignmentMap[alignment]);
}
function $168a40e325c04e1b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $168a40e325c04e1b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    let list = $168a40e325c04e1b$var$getSideList($168a40e325c04e1b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($168a40e325c04e1b$export$2b182c584985588b));
    }
    return list;
}
function $168a40e325c04e1b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$168a40e325c04e1b$var$oppositeSideMap[side]);
}
function $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $168a40e325c04e1b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $168a40e325c04e1b$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $926256944d3cd62f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference , floating: floating  } = _ref;
    const sideAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $926256944d3cd62f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform  } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x , y: y  } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name , fn: fn  } = validMiddleware[i];
        const { x: nextX , y: nextY , data: data , reset: reset  } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x , y: y  } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $926256944d3cd62f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x , y: y , platform: platform , rects: rects , elements: elements , strategy: strategy  } = state;
    const { boundary: boundary = "clippingAncestors" , rootBoundary: rootBoundary = "viewport" , elementContext: elementContext = "floating" , altBoundary: altBoundary = false , padding: padding = 0  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $926256944d3cd62f$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , platform: platform , elements: elements , middlewareData: middlewareData  } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element , padding: padding = 0  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $926256944d3cd62f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $168a40e325c04e1b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $926256944d3cd62f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects , middlewareData: middlewareData , placement: placement , platform: platform , elements: elements  } = state;
            const { crossAxis: crossAxis = false , alignment: alignment , allowedPlacements: allowedPlacements = (0, $168a40e325c04e1b$export$803cd8101b6c182b) , autoAlignment: autoAlignment = true , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $168a40e325c04e1b$export$803cd8101b6c182b) ? $926256944d3cd62f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $168a40e325c04e1b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $926256944d3cd62f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement , middlewareData: middlewareData , rects: rects , initialPlacement: initialPlacement , platform: platform , elements: elements  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true , fallbackPlacements: specifiedFallbackPlacements , fallbackStrategy: fallbackStrategy = "bestFit" , fallbackAxisSideDirection: fallbackAxisSideDirection = "none" , flipAlignment: flipAlignment = true , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $168a40e325c04e1b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $168a40e325c04e1b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $168a40e325c04e1b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $168a40e325c04e1b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $926256944d3cd62f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $926256944d3cd62f$var$isAnySideFullyClipped(overflow) {
    return (0, $168a40e325c04e1b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $926256944d3cd62f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects  } = state;
            const { strategy: strategy = "referenceHidden" , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $926256944d3cd62f$var$getBoundingRect(rects) {
    const minX = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $926256944d3cd62f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($926256944d3cd62f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $926256944d3cd62f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement , elements: elements , rects: rects , platform: platform , strategy: strategy  } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2 , x: x , y: y  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $926256944d3cd62f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($926256944d3cd62f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $926256944d3cd62f$var$convertValueToCoords(state, options) {
    const { placement: placement , platform: platform , elements: elements  } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis , crossAxis: crossAxis , alignmentAxis: alignmentAxis  } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $926256944d3cd62f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x , y: y  } = state;
            const diffCoords = await $926256944d3cd62f$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $926256944d3cd62f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = false , limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x , y: y  } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $926256944d3cd62f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , middlewareData: middlewareData  } = state;
            const { offset: offset = 0 , mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $926256944d3cd62f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            const { apply: apply = ()=>{} , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
            const { width: width , height: height  } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $e2c1d25bdd91a12d$export$651544f548703224(node) {
    if ($e2c1d25bdd91a12d$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $e2c1d25bdd91a12d$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $e2c1d25bdd91a12d$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($e2c1d25bdd91a12d$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $e2c1d25bdd91a12d$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $e2c1d25bdd91a12d$export$38b2d434cce3ea22(value).Node;
}
function $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $e2c1d25bdd91a12d$export$38b2d434cce3ea22(value).Element;
}
function $e2c1d25bdd91a12d$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $e2c1d25bdd91a12d$export$38b2d434cce3ea22(value).HTMLElement;
}
function $e2c1d25bdd91a12d$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $e2c1d25bdd91a12d$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $e2c1d25bdd91a12d$export$989e911fa9af580a(element) {
    const { overflow: overflow , overflowX: overflowX , overflowY: overflowY , display: display  } = $e2c1d25bdd91a12d$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $e2c1d25bdd91a12d$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($e2c1d25bdd91a12d$export$651544f548703224(element));
}
function $e2c1d25bdd91a12d$export$d6c4e8150c35fed1(element) {
    const webkit = $e2c1d25bdd91a12d$export$78551043582a6a98();
    const css = $e2c1d25bdd91a12d$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $e2c1d25bdd91a12d$export$940d8225183e1404(element) {
    let currentNode = $e2c1d25bdd91a12d$export$4e12058fc4d51d56(element);
    while($e2c1d25bdd91a12d$export$1b3bfaa9684536aa(currentNode) && !$e2c1d25bdd91a12d$export$d1162fb0b6d4cd51(currentNode)){
        if ($e2c1d25bdd91a12d$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $e2c1d25bdd91a12d$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $e2c1d25bdd91a12d$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $e2c1d25bdd91a12d$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($e2c1d25bdd91a12d$export$651544f548703224(node));
}
function $e2c1d25bdd91a12d$export$3735103072e4a80(element) {
    return $e2c1d25bdd91a12d$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $e2c1d25bdd91a12d$export$dc8fc79fa2800137(element) {
    if ($e2c1d25bdd91a12d$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $e2c1d25bdd91a12d$export$4e12058fc4d51d56(node) {
    if ($e2c1d25bdd91a12d$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $e2c1d25bdd91a12d$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $e2c1d25bdd91a12d$export$e495491855dc5418(node);
    return $e2c1d25bdd91a12d$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $e2c1d25bdd91a12d$export$7cd01a57c8ca906c(node) {
    const parentNode = $e2c1d25bdd91a12d$export$4e12058fc4d51d56(node);
    if ($e2c1d25bdd91a12d$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($e2c1d25bdd91a12d$export$1b3bfaa9684536aa(parentNode) && $e2c1d25bdd91a12d$export$989e911fa9af580a(parentNode)) return parentNode;
    return $e2c1d25bdd91a12d$export$7cd01a57c8ca906c(parentNode);
}
function $e2c1d25bdd91a12d$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $e2c1d25bdd91a12d$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $e2c1d25bdd91a12d$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $e2c1d25bdd91a12d$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $e2c1d25bdd91a12d$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $e2c1d25bdd91a12d$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $985fd6054d85832a$var$getCssDimensions(element) {
    const css = (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $985fd6054d85832a$var$unwrapElement(element) {
    return !(0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $985fd6054d85832a$var$getScale(element) {
    const domElement = $985fd6054d85832a$var$unwrapElement(element);
    if (!(0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(domElement)) return (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width , height: height , $: $  } = $985fd6054d85832a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $985fd6054d85832a$var$noOffsets = /*#__PURE__*/ (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
function $985fd6054d85832a$var$getVisualOffsets(element) {
    const win = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(element);
    if (!(0, $e2c1d25bdd91a12d$export$78551043582a6a98)() || !win.visualViewport) return $985fd6054d85832a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $985fd6054d85832a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $985fd6054d85832a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $985fd6054d85832a$var$unwrapElement(element);
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(offsetParent)) scale = $985fd6054d85832a$var$getScale(offsetParent);
        } else scale = $985fd6054d85832a$var$getScale(element);
    }
    const visualOffsets = $985fd6054d85832a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $985fd6054d85832a$var$getVisualOffsets(domElement) : (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $985fd6054d85832a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect , offsetParent: offsetParent , strategy: strategy  } = _ref;
    const isOffsetParentAnElement = (0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $e2c1d25bdd91a12d$export$651544f548703224)(offsetParent) !== "body" || (0, $e2c1d25bdd91a12d$export$989e911fa9af580a)(documentElement)) scroll = (0, $e2c1d25bdd91a12d$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent);
            scale = $985fd6054d85832a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $985fd6054d85832a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $985fd6054d85832a$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $985fd6054d85832a$var$getBoundingClientRect((0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element)).left + (0, $e2c1d25bdd91a12d$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $985fd6054d85832a$var$getDocumentRect(element) {
    const html = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element);
    const scroll = (0, $e2c1d25bdd91a12d$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $985fd6054d85832a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $e2c1d25bdd91a12d$export$3735103072e4a80)(body).direction === "rtl") x += (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getViewportRect(element, strategy) {
    const win = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(element);
    const html = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $e2c1d25bdd91a12d$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $985fd6054d85832a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $985fd6054d85832a$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(element) ? $985fd6054d85832a$var$getScale(element) : (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $985fd6054d85832a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $985fd6054d85832a$var$getDocumentRect((0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element));
    else if ((0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $985fd6054d85832a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $985fd6054d85832a$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(rect);
}
function $985fd6054d85832a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $e2c1d25bdd91a12d$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(parentNode) || (0, $e2c1d25bdd91a12d$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(parentNode).position === "fixed" || $985fd6054d85832a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $985fd6054d85832a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $e2c1d25bdd91a12d$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(el) && (0, $e2c1d25bdd91a12d$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $e2c1d25bdd91a12d$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(currentNode) && !(0, $e2c1d25bdd91a12d$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $e2c1d25bdd91a12d$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $e2c1d25bdd91a12d$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $985fd6054d85832a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $e2c1d25bdd91a12d$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $985fd6054d85832a$var$getClippingRect(_ref) {
    let { element: element , boundary: boundary , rootBoundary: rootBoundary , strategy: strategy  } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $985fd6054d85832a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $985fd6054d85832a$var$getDimensions(element) {
    return $985fd6054d85832a$var$getCssDimensions(element);
}
function $985fd6054d85832a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $985fd6054d85832a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e2c1d25bdd91a12d$export$651544f548703224)(offsetParent) !== "body" || (0, $e2c1d25bdd91a12d$export$989e911fa9af580a)(documentElement)) scroll = (0, $e2c1d25bdd91a12d$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $985fd6054d85832a$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $985fd6054d85832a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(element) || (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $985fd6054d85832a$var$getOffsetParent(element, polyfill) {
    const window = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(element);
    if (!(0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $e2c1d25bdd91a12d$export$71535ffaa902797f)(offsetParent) && (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $e2c1d25bdd91a12d$export$651544f548703224)(offsetParent) === "html" || (0, $e2c1d25bdd91a12d$export$651544f548703224)(offsetParent) === "body" && (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $e2c1d25bdd91a12d$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $e2c1d25bdd91a12d$export$940d8225183e1404)(element) || window;
}
const $985fd6054d85832a$var$getElementRects = async function(_ref) {
    let { reference: reference , floating: floating , strategy: strategy  } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $985fd6054d85832a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $985fd6054d85832a$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $985fd6054d85832a$var$isRTL(element) {
    return (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(element).direction === "rtl";
}
const $985fd6054d85832a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $e2c1d25bdd91a12d$export$e495491855dc5418,
    getClippingRect: $985fd6054d85832a$var$getClippingRect,
    getOffsetParent: $985fd6054d85832a$var$getOffsetParent,
    getElementRects: $985fd6054d85832a$var$getElementRects,
    getClientRects: $985fd6054d85832a$var$getClientRects,
    getDimensions: $985fd6054d85832a$var$getDimensions,
    getScale: $985fd6054d85832a$var$getScale,
    isElement: $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d,
    isRTL: $985fd6054d85832a$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $985fd6054d85832a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left , top: top , width: width , height: height  } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $168a40e325c04e1b$export$8960430cfd85939f)(0, (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $985fd6054d85832a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true , ancestorResize: ancestorResize = true , elementResize: elementResize = typeof ResizeObserver === "function" , layoutShift: layoutShift = typeof IntersectionObserver === "function" , animationFrame: animationFrame = false  } = options;
    const referenceEl = $985fd6054d85832a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $e2c1d25bdd91a12d$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $e2c1d25bdd91a12d$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $985fd6054d85832a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $985fd6054d85832a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $985fd6054d85832a$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $985fd6054d85832a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $985fd6054d85832a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $926256944d3cd62f$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $bh6RR = parcelRequire("bh6RR");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f0eb2bc09271deae$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element , padding: padding  } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $926256944d3cd62f$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            } else if (element) return (0, $926256944d3cd62f$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $f0eb2bc09271deae$var$index = typeof document !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $f0eb2bc09271deae$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$f0eb2bc09271deae$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$f0eb2bc09271deae$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $f0eb2bc09271deae$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $f0eb2bc09271deae$var$roundByDPR(element, value) {
    const dpr = $f0eb2bc09271deae$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $f0eb2bc09271deae$var$useLatestRef(value) {
    const ref = $bh6RR.useRef(value);
    $f0eb2bc09271deae$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */ function $f0eb2bc09271deae$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform , elements: { reference: externalReference , floating: externalFloating  } = {} , transform: transform = true , whileElementsMounted: whileElementsMounted , open: open  } = options;
    const [data, setData] = $bh6RR.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $bh6RR.useState(middleware);
    if (!$f0eb2bc09271deae$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $bh6RR.useState(null);
    const [_floating, _setFloating] = $bh6RR.useState(null);
    const setReference = $bh6RR.useCallback((node)=>{
        if (node != referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [
        _setReference
    ]);
    const setFloating = $bh6RR.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, [
        _setFloating
    ]);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $bh6RR.useRef(null);
    const floatingRef = $bh6RR.useRef(null);
    const dataRef = $bh6RR.useRef(data);
    const whileElementsMountedRef = $f0eb2bc09271deae$var$useLatestRef(whileElementsMounted);
    const platformRef = $f0eb2bc09271deae$var$useLatestRef(platform);
    const update = $bh6RR.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $985fd6054d85832a$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$f0eb2bc09271deae$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $47cfd4084854a574$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $f0eb2bc09271deae$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $bh6RR.useRef(false);
    $f0eb2bc09271deae$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $f0eb2bc09271deae$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            else update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef
    ]);
    const refs = $bh6RR.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $bh6RR.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $bh6RR.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $f0eb2bc09271deae$var$roundByDPR(elements.floating, data.x);
        const y = $f0eb2bc09271deae$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$f0eb2bc09271deae$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $bh6RR.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}




var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $0cab61c36b921768$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $0cab61c36b921768$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).svg, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $bh6RR.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($0cab61c36b921768$export$21b07c8f274aebd5, {
    displayName: $0cab61c36b921768$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0cab61c36b921768$export$be92b6f5f03c0fe9 = $0cab61c36b921768$export$21b07c8f274aebd5;








var $bh6RR = parcelRequire("bh6RR");

function $3193bf9be93d584d$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $bh6RR.useState)(undefined);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $b539e51fb424541d$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $b539e51fb424541d$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext, $b539e51fb424541d$export$722aac194ae923] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperProvider, $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $b539e51fb424541d$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = (0, $bh6RR.useState)(null);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$badac9ada3a0bdf9, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $b539e51fb424541d$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$ecd4e1ccab6ed6d, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$useContentContext] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $b539e51fb424541d$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper , side: side = "bottom" , sideOffset: sideOffset = 0 , align: align = "center" , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , avoidCollisions: avoidCollisions = true , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = "partial" , hideWhenDetached: hideWhenDetached = false , updatePositionStrategy: updatePositionStrategy = "optimized" , onPlaced: onPlaced , ...contentProps } = props;
    const context = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $bh6RR.useState)(null);
    const arrowSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs , floatingStyles: floatingStyles , placement: placement , isPositioned: isPositioned , middlewareData: middlewareData  } = (0, $f0eb2bc09271deae$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $985fd6054d85832a$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $926256944d3cd62f$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $926256944d3cd62f$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $926256944d3cd62f$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $926256944d3cd62f$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $926256944d3cd62f$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements , rects: rects , availableWidth: availableWidth , availableHeight: availableHeight  })=>{
                    const { width: anchorWidth , height: anchorHeight  } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $f0eb2bc09271deae$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $926256944d3cd62f$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPlaced);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $bh6RR.useState)();
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$bc4ae5855d3c4fc, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $b539e51fb424541d$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$useContentContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $bh6RR.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0cab61c36b921768$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$79d62cd4e10a3fd0, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $b539e51fb424541d$export$be92b6f5f03c0fe9 = $b539e51fb424541d$export$badac9ada3a0bdf9;
const $b539e51fb424541d$export$b688253958b8dfe7 = $b539e51fb424541d$export$ecd4e1ccab6ed6d;
const $b539e51fb424541d$export$7c6e2c02157bb7d2 = $b539e51fb424541d$export$bc4ae5855d3c4fc;
const $b539e51fb424541d$export$21b07c8f274aebd5 = $b539e51fb424541d$export$79d62cd4e10a3fd0;









/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$createPopoverContext, $a21b5dec320f3ef0$export$c8393c9e73286932] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $b539e51fb424541d$export$722aac194ae923)
]);
const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $b539e51fb424541d$export$722aac194ae923)();
const [$a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverProvider, $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext] = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$createPopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$POPOVER_NAME);
const $a21b5dec320f3ef0$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = false  } = props;
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0, $bh6RR.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0, $bh6RR.useState)(false);
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $bh6RR.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $bh6RR.useCallback)(()=>setHasCustomAnchor(true), []),
        onCustomAnchorRemove: (0, $bh6RR.useCallback)(()=>setHasCustomAnchor(false), []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$5b6b19405a83ff9d, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $a21b5dec320f3ef0$export$96e5381f42521a79 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...anchorProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd , onCustomAnchorRemove: onCustomAnchorRemove  } = context;
    (0, $bh6RR.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$96e5381f42521a79, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $a21b5dec320f3ef0$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...triggerProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$7dacb05d26466c3, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PortalProvider, $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePortalContext] = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$createPopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $a21b5dec320f3ef0$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover , forceMount: forceMount , children: children , container: container  } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$dd679ffb4362d2d4, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $a21b5dec320f3ef0$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePortalContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$d7e1f420b25549ff, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0, $bh6RR.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $bh6RR.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $2a904e957609af53$export$2e2bcd8739ae039), {
        as: (0, $18fd289ffa468154$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        })
    })));
});
const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0, $bh6RR.useRef)(false);
    const hasPointerDownOutsideRef = (0, $bh6RR.useRef)(false);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , disableOutsidePointerEvents: disableOutsidePointerEvents , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , ...contentProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $39ae7ab2790868b6$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0757534448b5e4bf$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
            "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
            "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $a21b5dec320f3ef0$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...closeProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$d6ac43ebaa40d53e, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
const $a21b5dec320f3ef0$export$3152841115e061b2 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...arrowProps } = props;
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$3152841115e061b2, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
const $a21b5dec320f3ef0$export$be92b6f5f03c0fe9 = $a21b5dec320f3ef0$export$5b6b19405a83ff9d;
const $a21b5dec320f3ef0$export$b688253958b8dfe7 = $a21b5dec320f3ef0$export$96e5381f42521a79;
const $a21b5dec320f3ef0$export$41fb9f06171c75f4 = $a21b5dec320f3ef0$export$7dacb05d26466c3;
const $a21b5dec320f3ef0$export$602eac185826482c = $a21b5dec320f3ef0$export$dd679ffb4362d2d4;
const $a21b5dec320f3ef0$export$7c6e2c02157bb7d2 = $a21b5dec320f3ef0$export$d7e1f420b25549ff;
const $a21b5dec320f3ef0$export$f39c2d165cd861fe = $a21b5dec320f3ef0$export$d6ac43ebaa40d53e;
const $a21b5dec320f3ef0$export$21b07c8f274aebd5 = $a21b5dec320f3ef0$export$3152841115e061b2;



const $f4f2feb6906486e3$export$5b6b19405a83ff9d = $a21b5dec320f3ef0$export$be92b6f5f03c0fe9;
const $f4f2feb6906486e3$export$7dacb05d26466c3 = $a21b5dec320f3ef0$export$41fb9f06171c75f4;
const $f4f2feb6906486e3$export$d7e1f420b25549ff = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , align: align = "center" , sideOffset: sideOffset = 4 , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($a21b5dec320f3ef0$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($a21b5dec320f3ef0$export$7c6e2c02157bb7d2, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
            ...props
        })
    }));
$f4f2feb6906486e3$export$d7e1f420b25549ff.displayName = $a21b5dec320f3ef0$export$7c6e2c02157bb7d2.displayName;



parcelRequire("bh6RR");


const $a3a14057cf57930c$export$48443d129636634d = (0, $3e91b320546fc9fb$export$87dc52566e90b739)("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
    variants: {
        variant: {
            default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
            secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
            destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
            outline: "text-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function $a3a14057cf57930c$export$37acb3580601e69a({ className: className , variant: variant , ...props }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)($a3a14057cf57930c$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    });
}


function $39399887a43190b2$export$a73a93adb33205b0({ shouldAnimate: shouldAnimate = false , ...props }) {
    const DIFFICULTY_COLOR_MAP = {
        1: "rgb(250 224 66)",
        2: "rgb(160 195 90)",
        3: "rgb(176 196 239)",
        4: "rgb(186 129 197)"
    };
    const color = `${DIFFICULTY_COLOR_MAP[props.difficulty]}`;
    const [hasBeenClicked, setHasBeenClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const springProps = (0, $41b3099c4ff7ef63$export$c4af9125706c4d30)({
        from: {
            opacity: 0,
            transform: "scale(0.6)",
            height: 0,
            overflow: "hidden"
        },
        to: {
            opacity: 1,
            transform: "scale(1)",
            height: "auto",
            overflow: "visible"
        },
        config: {
            tension: 280,
            friction: 22
        },
        delay: shouldAnimate ? 800 : 0
    });
    const isImageAvailable = props.imageSrc != null;
    const content = !isImageAvailable ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        style: {
            backgroundColor: color,
            borderRadius: 8
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "font-semibold pt-2 pl-4 text-gray-900",
                children: props.category
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "font-normal pb-2 pl-4 text-gray-800",
                children: props.words.join(", ")
            })
        ]
    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $f4f2feb6906486e3$export$5b6b19405a83ff9d), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f4f2feb6906486e3$export$7dacb05d26466c3), {
                asChild: true,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "cursor-pointer hover:animate-pulse shadow-md",
                    style: {
                        backgroundColor: color,
                        borderRadius: 8
                    },
                    onClick: ()=>setHasBeenClicked(true),
                    children: [
                        !hasBeenClicked && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a3a14057cf57930c$export$37acb3580601e69a), {
                            className: "animate-pulse absolute top-0 right-0 mr-2 mt-2",
                            children: "View More"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            className: "font-semibold pt-2 pl-4 text-gray-900",
                            children: props.category
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            className: "font-normal pb-2 pl-4 text-gray-800",
                            children: props.words.join(", ")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f4f2feb6906486e3$export$d7e1f420b25549ff), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: props.imageSrc
                    })
                })
            })
        ]
    });
    if (!shouldAnimate) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: content
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e76b8f2030afb380$export$407448d2b89b1813).div, {
        style: springProps,
        children: content
    });
}
function $39399887a43190b2$var$GameGrid({ flatWordsList: flatWordsList , shouldGridShake: shouldGridShake , setShouldGridShake: setShouldGridShake , animatingWords: animatingWords = [] , mergingWords: mergingWords = []  }) {
    const { submittedGuesses: submittedGuesses , isGameOver: isGameOver , isGameWon: isGameWon , solvedGameData: solvedGameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $005b445a28133b13$export$3f49015a6304186f));
    const { gameData: gameData , categorySize: categorySize  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ae43375334d8e130$export$e8331451049320c2));
    const initialSolvedCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(solvedGameData.length);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const shakeEffect = window.setTimeout(()=>{
            setShouldGridShake(false);
        }, 2000);
        return ()=>window.clearTimeout(shakeEffect);
    }, [
        submittedGuesses
    ]);
    const isGameOverAndLost = isGameOver && !isGameWon;
    const isGameOverAndWon = isGameOver && isGameWon;
    const isGameActive = !isGameOver;
    const isGameActiveWithAnySolvedRows = isGameActive && solvedGameData.length > 0;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "w-full",
        children: [
            (isGameOverAndWon || isGameActiveWithAnySolvedRows) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "grid gap-y-2 pb-2",
                children: solvedGameData.map((solvedRowObj, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($39399887a43190b2$export$a73a93adb33205b0, {
                        shouldAnimate: index >= initialSolvedCountRef.current && isGameActive,
                        ...solvedRowObj
                    }, solvedRowObj.category))
            }),
            isGameActive && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: `grid grid-cols-4 gap-2 md:gap-4 w-full ${shouldGridShake ? $715d2096b51a0c15$export$267b06a7460aa7d3 : ""}`,
                children: flatWordsList.map((word)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).div, {
                        layout: true,
                        transition: {
                            layout: {
                                duration: 0.6,
                                ease: [
                                    0.4,
                                    0.0,
                                    0.2,
                                    1
                                ]
                            }
                        },
                        className: "aspect-square w-full",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a8473a6fb8133656$export$2e2bcd8739ae039), {
                            word: word,
                            fullCandidateSize: categorySize,
                            isAnimating: animatingWords.includes(word),
                            isMerging: mergingWords.includes(word)
                        })
                    }, word))
            })
        ]
    });
}
var $39399887a43190b2$export$2e2bcd8739ae039 = $39399887a43190b2$var$GameGrid;






var $bh6RR = parcelRequire("bh6RR");



function $72681eacbfe72cc0$var$NumberOfMistakesDisplay() {
    const { numMistakesUsed: numMistakesUsed  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $005b445a28133b13$export$3f49015a6304186f));
    // array size of number of guess. [1, 2, 3, 4]
    const mistakeRange = (0, $92dc8dbec6af1b1e$export$d02631cccf789723)((0, $5763721b9fa71fc2$export$7ea57ed97bda1046));
    const mistakesRemaining = (0, $5763721b9fa71fc2$export$7ea57ed97bda1046) - numMistakesUsed;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "flex items-center justify-center gap-2",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: "text-[#6B7F5E] tracking-wide",
                children: "Mistakes remaining:"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "flex gap-2",
                children: mistakeRange.map((el)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: `w-2.5 h-2.5 rounded-full transition-all duration-300 ${el < mistakesRemaining ? "bg-gradient-to-br from-[#9CA986] to-[#6B7F5E] shadow-md" : "bg-[#D4D9CE]/50"}`
                    }, el))
            })
        ]
    });
}
var $72681eacbfe72cc0$export$2e2bcd8739ae039 = $72681eacbfe72cc0$var$NumberOfMistakesDisplay;





parcelRequire("bh6RR");


/**
 * lucide-react v0.288.0 - ISC
 */ 
const $02e02564a7127b84$export$2e2bcd8739ae039 = (0, $dc38aceacd32c739$export$2e2bcd8739ae039)("RotateCcw", [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
]);


function $e61d4104e0131cca$var$GameLostModal({ open: open , onPlayAgain: onPlayAgain  }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1afdc1be3ae11346$export$2e2bcd8739ae039), {
        title: "You lost.",
        initiallyOpen: open,
        footerElements: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $96fae3fa1f07fd29$export$353f5b6fc5456de1), {
            variant: "secondary",
            onClick: onPlayAgain,
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02e02564a7127b84$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 mr-2",
                    strokeWidth: 1
                }),
                "Play Again"
            ]
        }),
        showActionButton: false,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "grid gap-y-2",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "text-base font-medium text-center",
                children: "Better luck next time!"
            })
        })
    });
}
var $e61d4104e0131cca$export$2e2bcd8739ae039 = $e61d4104e0131cca$var$GameLostModal;






var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");

// https://www.joshwcomeau.com/react/animated-sparkles-in-react/


var $bh6RR = parcelRequire("bh6RR");

function $2b1c4ea9a24f2dc7$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $6af46881e84be06d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $6af46881e84be06d$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $2b1c4ea9a24f2dc7$export$2e2bcd8739ae039)(function(prop) {
    return $6af46881e84be06d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $bh6RR = parcelRequire("bh6RR");
var $53a106364dbd0a1b$exports = {};
//
$53a106364dbd0a1b$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $783faa7ec18221fc$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$783faa7ec18221fc$export$4659b591c19bdf3d(e, r);
    });
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$590e8b2c435046d9(e) {
    while(e.root)e = $783faa7ec18221fc$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $783faa7ec18221fc$export$10d8903dec122b9d(e, e.siblings);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var m = c;
    var x = s;
    var y = n;
    var j = k;
    while(w)switch(h = g, g = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(j += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $783faa7ec18221fc$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(j) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(j + ";", n, a, l - 1, i) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(y = $783faa7ec18221fc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, k, m = [], x = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, y, y, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, k, c, m = [], l, x), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = j = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $783faa7ec18221fc$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) j += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(k = j += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $783faa7ec18221fc$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $783faa7ec18221fc$export$2f35ab04d2335697(e, p + 1, p = $783faa7ec18221fc$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $783faa7ec18221fc$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span") ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch") ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            if (!$783faa7ec18221fc$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


var $e484c752f3f06549$var$f = ("undefined" != typeof $391299e0893a3dfa$exports && void 0 !== $391299e0893a3dfa$exports.env && undefined, "data-styled"), $e484c752f3f06549$export$83d89fbfd8236492 = "6.1.0", $e484c752f3f06549$var$y = "undefined" != typeof window && "HTMLElement" in window, $e484c752f3f06549$var$v = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, "undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, false)), $e484c752f3f06549$var$g = {}, $e484c752f3f06549$var$S = /invalid hook call/i, $e484c752f3f06549$var$w = new Set, $e484c752f3f06549$var$b = function(t, n) {
    var o, s, i, a, e;
}, $e484c752f3f06549$var$E = Object.freeze([]), $e484c752f3f06549$var$N = Object.freeze({});
function $e484c752f3f06549$var$P(e, t, n) {
    return void 0 === n && (n = $e484c752f3f06549$var$N), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e484c752f3f06549$var$_ = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e484c752f3f06549$var$C = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e484c752f3f06549$var$I = /(^-|-$)/g;
function $e484c752f3f06549$var$A(e) {
    return e.replace($e484c752f3f06549$var$C, "-").replace($e484c752f3f06549$var$I, "");
}
var $e484c752f3f06549$var$O = /(a)(d)/gi, $e484c752f3f06549$var$D = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e484c752f3f06549$var$R(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $e484c752f3f06549$var$D(t % 52) + n;
    return ($e484c752f3f06549$var$D(t % 52) + n).replace($e484c752f3f06549$var$O, "$1-$2");
}
var $e484c752f3f06549$var$T, $e484c752f3f06549$var$k = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e484c752f3f06549$var$j = function(e) {
    return $e484c752f3f06549$var$k(5381, e);
};
function $e484c752f3f06549$var$x(e) {
    return $e484c752f3f06549$var$R($e484c752f3f06549$var$j(e) >>> 0);
}
function $e484c752f3f06549$var$V(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e484c752f3f06549$var$F(e) {
    return "string" == typeof e && true;
}
var $e484c752f3f06549$var$M = "function" == typeof Symbol && Symbol.for, $e484c752f3f06549$var$$ = $e484c752f3f06549$var$M ? Symbol.for("react.memo") : 60115, $e484c752f3f06549$var$z = $e484c752f3f06549$var$M ? Symbol.for("react.forward_ref") : 60112, $e484c752f3f06549$var$B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$L = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e484c752f3f06549$var$G = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$Y = (($e484c752f3f06549$var$T = {})[$e484c752f3f06549$var$z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e484c752f3f06549$var$T[$e484c752f3f06549$var$$] = $e484c752f3f06549$var$G, $e484c752f3f06549$var$T);
function $e484c752f3f06549$var$W(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e484c752f3f06549$var$$ ? $e484c752f3f06549$var$G : "$$typeof" in e ? $e484c752f3f06549$var$Y[e.$$typeof] : $e484c752f3f06549$var$B;
}
var $e484c752f3f06549$var$q = Object.defineProperty, $e484c752f3f06549$var$H = Object.getOwnPropertyNames, $e484c752f3f06549$var$U = Object.getOwnPropertySymbols, $e484c752f3f06549$var$J = Object.getOwnPropertyDescriptor, $e484c752f3f06549$var$X = Object.getPrototypeOf, $e484c752f3f06549$var$Z = Object.prototype;
function $e484c752f3f06549$var$K(e, t, n) {
    if ("string" != typeof t) {
        if ($e484c752f3f06549$var$Z) {
            var o = $e484c752f3f06549$var$X(t);
            o && o !== $e484c752f3f06549$var$Z && $e484c752f3f06549$var$K(e, o, n);
        }
        var r = $e484c752f3f06549$var$H(t);
        $e484c752f3f06549$var$U && (r = r.concat($e484c752f3f06549$var$U(t)));
        for(var s = $e484c752f3f06549$var$W(e), i = $e484c752f3f06549$var$W(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e484c752f3f06549$var$L || n && n[c] || i && c in i || s && c in s)) {
                var l = $e484c752f3f06549$var$J(t, c);
                try {
                    $e484c752f3f06549$var$q(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e484c752f3f06549$var$Q(e) {
    return "function" == typeof e;
}
function $e484c752f3f06549$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e484c752f3f06549$var$te(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e484c752f3f06549$var$ne(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e484c752f3f06549$var$oe(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e484c752f3f06549$var$re(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e484c752f3f06549$var$oe(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e484c752f3f06549$var$re(e[o], t[o]);
    else if ($e484c752f3f06549$var$oe(t)) for(var o in t)e[o] = $e484c752f3f06549$var$re(e[o], t[o]);
    return e;
}
function $e484c752f3f06549$var$se(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e484c752f3f06549$var$ie = {};
function $e484c752f3f06549$var$ae() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e484c752f3f06549$var$ce(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e484c752f3f06549$var$le = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e484c752f3f06549$var$ce(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
        return t;
    }, e;
}(), $e484c752f3f06549$var$ue = new Map, $e484c752f3f06549$var$pe = new Map, $e484c752f3f06549$var$de = 1, $e484c752f3f06549$var$he = function(e) {
    if ($e484c752f3f06549$var$ue.has(e)) return $e484c752f3f06549$var$ue.get(e);
    for(; $e484c752f3f06549$var$pe.has($e484c752f3f06549$var$de);)$e484c752f3f06549$var$de++;
    var t = $e484c752f3f06549$var$de++;
    return $e484c752f3f06549$var$ue.set(e, t), $e484c752f3f06549$var$pe.set(t, e), t;
}, $e484c752f3f06549$var$fe = function(e, t) {
    $e484c752f3f06549$var$ue.set(e, t), $e484c752f3f06549$var$pe.set(t, e);
}, $e484c752f3f06549$var$me = "style[".concat($e484c752f3f06549$var$f, "][").concat("data-styled-version", '="').concat("6.1.0", '"]'), $e484c752f3f06549$var$ye = new RegExp("^".concat($e484c752f3f06549$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e484c752f3f06549$var$ve = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e484c752f3f06549$var$ge = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e484c752f3f06549$var$ye);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e484c752f3f06549$var$fe(u, l), $e484c752f3f06549$var$ve(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $e484c752f3f06549$var$Se() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e484c752f3f06549$var$we = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e484c752f3f06549$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e484c752f3f06549$var$f, "active"), o.setAttribute("data-styled-version", "6.1.0");
    var i = $e484c752f3f06549$var$Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e484c752f3f06549$var$be = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e484c752f3f06549$var$ce(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e484c752f3f06549$var$Ee = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e484c752f3f06549$var$Ne = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e484c752f3f06549$var$Pe = $e484c752f3f06549$var$y, $e484c752f3f06549$var$_e = {
    isServer: !$e484c752f3f06549$var$y,
    useCSSOMInjection: !$e484c752f3f06549$var$v
}, $e484c752f3f06549$var$Ce = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e484c752f3f06549$var$N), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, $e484c752f3f06549$var$_e), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e484c752f3f06549$var$y && $e484c752f3f06549$var$Pe && ($e484c752f3f06549$var$Pe = !1, function(e) {
            for(var t = document.querySelectorAll($e484c752f3f06549$var$me), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && "active" !== r.getAttribute($e484c752f3f06549$var$f) && ($e484c752f3f06549$var$ge(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $e484c752f3f06549$var$se(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e484c752f3f06549$var$pe.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($e484c752f3f06549$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e484c752f3f06549$var$he(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e484c752f3f06549$var$Ne(n) : t ? new $e484c752f3f06549$var$be(n) : new $e484c752f3f06549$var$Ee(n);
        }(this.options), new $e484c752f3f06549$var$le(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e484c752f3f06549$var$he(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e484c752f3f06549$var$he(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e484c752f3f06549$var$he(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e484c752f3f06549$var$Ie = /&/g, $e484c752f3f06549$var$Ae = /^\s*\/\/.*$/gm;
function $e484c752f3f06549$var$Oe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e484c752f3f06549$var$Oe(e.children, t)), e;
    });
}
function $e484c752f3f06549$var$De(e) {
    var t, n, o, r = void 0 === e ? $e484c752f3f06549$var$N : e, s = r.options, i = void 0 === s ? $e484c752f3f06549$var$N : s, a = r.plugins, c = void 0 === a ? $e484c752f3f06549$var$E : a, l = function(e, o, r) {
        return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $783faa7ec18221fc$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e484c752f3f06549$var$Ie, n).replace(o, l));
    }), i.prefix && u.push($783faa7ec18221fc$export$e08c7d021b829b7a), u.push($783faa7ec18221fc$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e484c752f3f06549$var$Ae, ""), l = $783faa7ec18221fc$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e484c752f3f06549$var$Oe(l, i.namespace));
        var p = [];
        return $783faa7ec18221fc$export$dfdc1655ccc5b9cb(l, $783faa7ec18221fc$export$5a7767152ae0305f(u.concat($783faa7ec18221fc$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e484c752f3f06549$var$ce(15), $e484c752f3f06549$var$k(e, t.name);
    }, 5381).toString() : "", p;
}
var $e484c752f3f06549$var$Re = new $e484c752f3f06549$var$Ce, $e484c752f3f06549$var$Te = $e484c752f3f06549$var$De(), $e484c752f3f06549$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e484c752f3f06549$var$Re,
    stylis: $e484c752f3f06549$var$Te
}), $e484c752f3f06549$export$91317688fc694efa = $e484c752f3f06549$export$8c190ef828af4c86.Consumer, $e484c752f3f06549$var$xe = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
function $e484c752f3f06549$var$Ve() {
    return (0, $bh6RR.useContext)($e484c752f3f06549$export$8c190ef828af4c86);
}
function $e484c752f3f06549$export$a473771da2f0ff7c(e) {
    var t = (0, $bh6RR.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e484c752f3f06549$var$Ve().styleSheet, l = (0, $bh6RR.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $bh6RR.useMemo)(function() {
        return $e484c752f3f06549$var$De({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $bh6RR.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($53a106364dbd0a1b$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $bh6RR.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$var$xe.Provider, {
        value: u
    }, e.children));
}
var $e484c752f3f06549$var$Me = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e484c752f3f06549$var$Te);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e484c752f3f06549$var$se(this, function() {
            throw $e484c752f3f06549$var$ce(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e484c752f3f06549$var$Te), this.name + e.hash;
    }, e;
}(), $e484c752f3f06549$var$$e = function(e) {
    return e >= "A" && e <= "Z";
};
function $e484c752f3f06549$var$ze(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e484c752f3f06549$var$$e(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e484c752f3f06549$var$Be = function(e) {
    return null == e || !1 === e || "" === e;
}, $e484c752f3f06549$var$Le = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e484c752f3f06549$var$Be(i) && (Array.isArray(i) && i.isCss || $e484c752f3f06549$var$Q(i) ? r.push("".concat($e484c752f3f06549$var$ze(s), ":"), i, ";") : $e484c752f3f06549$var$oe(i) ? r.push.apply(r, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)((0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e484c752f3f06549$var$Le(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e484c752f3f06549$var$ze(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $78b52bced097bc64$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e484c752f3f06549$var$Ge(e, t, n, o) {
    if ($e484c752f3f06549$var$Be(e)) return [];
    if ($e484c752f3f06549$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e484c752f3f06549$var$Q(e)) {
        if (!$e484c752f3f06549$var$Q(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e484c752f3f06549$var$Ge(r, t, n, o);
    }
    var s;
    return e instanceof $e484c752f3f06549$var$Me ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e484c752f3f06549$var$oe(e) ? $e484c752f3f06549$var$Le(e) : Array.isArray(e) ? Array.prototype.concat.apply($e484c752f3f06549$var$E, e.map(function(e) {
        return $e484c752f3f06549$var$Ge(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e484c752f3f06549$var$Ye(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e484c752f3f06549$var$Q(n) && !$e484c752f3f06549$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e484c752f3f06549$var$We = $e484c752f3f06549$var$j("6.1.0"), $e484c752f3f06549$var$qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e484c752f3f06549$var$Ye(e), this.componentId = t, this.baseHash = $e484c752f3f06549$var$k($e484c752f3f06549$var$We, t), this.baseStyle = n, $e484c752f3f06549$var$Ce.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e484c752f3f06549$var$te(o, this.staticRulesId);
            else {
                var r = $e484c752f3f06549$var$ne($e484c752f3f06549$var$Ge(this.rules, e, t, n)), s = $e484c752f3f06549$var$R($e484c752f3f06549$var$k(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e484c752f3f06549$var$te(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e484c752f3f06549$var$k(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e484c752f3f06549$var$ne($e484c752f3f06549$var$Ge(u, e, t, n));
                    a = $e484c752f3f06549$var$k(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e484c752f3f06549$var$R(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e484c752f3f06549$var$te(o, d);
            }
        }
        return o;
    }, e;
}(), $e484c752f3f06549$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0), $e484c752f3f06549$export$b631efc24e9d5e2f = $e484c752f3f06549$export$2c657da244d00bd6.Consumer;
function $e484c752f3f06549$export$93d4e7f90805808f() {
    var e = (0, $bh6RR.useContext)($e484c752f3f06549$export$2c657da244d00bd6);
    if (!e) throw $e484c752f3f06549$var$ce(18);
    return e;
}
function $e484c752f3f06549$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, $bh6RR.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e484c752f3f06549$var$ce(14);
            if ($e484c752f3f06549$var$Q(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e484c752f3f06549$var$ce(8);
            return n ? (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e484c752f3f06549$var$Ze = {}, $e484c752f3f06549$var$Ke = new Set;
function $e484c752f3f06549$var$Qe(e, r, s) {
    var i = $e484c752f3f06549$export$7ba318d8d2f06c76(e), a = e, c = !$e484c752f3f06549$var$F(e), p = r.attrs, d = void 0 === p ? $e484c752f3f06549$var$E : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e484c752f3f06549$var$A(e);
        $e484c752f3f06549$var$Ze[n] = ($e484c752f3f06549$var$Ze[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e484c752f3f06549$var$x("6.1.0" + n + $e484c752f3f06549$var$Ze[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e484c752f3f06549$var$F(e) ? "styled.".concat(e) : "Styled(".concat($e484c752f3f06549$var$V(e), ")");
    }(e) : m, v = r.displayName && r.componentId ? "".concat($e484c752f3f06549$var$A(r.displayName), "-").concat(r.componentId) : r.componentId || f, g = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, S = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var w = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var C = r.shouldForwardProp;
            S = function(e, t) {
                return w(e, t) && C(e, t);
            };
        } else S = w;
    }
    var I = new $e484c752f3f06549$var$qe(s, v, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), m = $e484c752f3f06549$var$Ve(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = function(e, n, o) {
                for(var r, s = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e484c752f3f06549$var$Q(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e484c752f3f06549$var$te(s[c], a[c]) : "style" === c ? (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e484c752f3f06549$var$te(s.className, n.className)), s;
            }(i, r, $e484c752f3f06549$var$P(r, f, c) || $e484c752f3f06549$var$N), g = v.as || h, S = {};
            for(var w in v)void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w || ("forwardedAs" === w ? S.as = v.forwardedAs : y && !y(w, g) || (S[w] = v[w], y));
            var b = function(e, t) {
                var n = $e484c752f3f06549$var$Ve(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, v);
            var E = $e484c752f3f06549$var$te(p, d);
            return b && (E += " " + b), v.className && (E += " " + v.className), S[$e484c752f3f06549$var$F(g) && !$e484c752f3f06549$var$_.has(g) ? "class" : "className"] = E, S.ref = s, (0, $bh6RR.createElement)(g, S);
        }(D, e, r);
    }
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(O);
    return D.attrs = g, D.componentStyle = I, D.shouldForwardProp = S, D.foldedComponentIds = i ? $e484c752f3f06549$var$te(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = v, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e484c752f3f06549$var$re(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e484c752f3f06549$var$se(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e484c752f3f06549$var$K(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e484c752f3f06549$var$et(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e484c752f3f06549$var$tt = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e484c752f3f06549$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e484c752f3f06549$var$Q(t) || $e484c752f3f06549$var$oe(t)) {
        var r = t;
        return $e484c752f3f06549$var$tt($e484c752f3f06549$var$Ge($e484c752f3f06549$var$et($e484c752f3f06549$var$E, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            r
        ], n, !0))));
    }
    var s = t;
    return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? $e484c752f3f06549$var$Ge(s) : $e484c752f3f06549$var$tt($e484c752f3f06549$var$Ge($e484c752f3f06549$var$et(s, n)));
}
function $e484c752f3f06549$var$ot(n, o, r) {
    if (void 0 === r && (r = $e484c752f3f06549$var$N), !o) throw $e484c752f3f06549$var$ce(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e484c752f3f06549$var$ot(n, o, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e484c752f3f06549$var$ot(n, o, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e484c752f3f06549$var$rt = function(e) {
    return $e484c752f3f06549$var$ot($e484c752f3f06549$var$Qe, e);
}, $e484c752f3f06549$export$2e2bcd8739ae039 = $e484c752f3f06549$var$rt;
$e484c752f3f06549$var$_.forEach(function(e) {
    $e484c752f3f06549$export$2e2bcd8739ae039[e] = $e484c752f3f06549$var$rt(e);
});
var $e484c752f3f06549$var$it = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e484c752f3f06549$var$Ye(e), $e484c752f3f06549$var$Ce.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e484c752f3f06549$var$ne($e484c752f3f06549$var$Ge(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e484c752f3f06549$var$Ce.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e484c752f3f06549$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e484c752f3f06549$var$x(JSON.stringify(i))), c = new $e484c752f3f06549$var$it(i, a);
    var l = function(e) {
        var t = $e484c752f3f06549$var$Ve(), n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e484c752f3f06549$var$g, o, s);
        else {
            var i = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), {
                theme: $e484c752f3f06549$var$P(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(l);
}
function $e484c752f3f06549$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e484c752f3f06549$var$ne($e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e484c752f3f06549$var$x(r);
    return new $e484c752f3f06549$var$Me(s, r);
}
function $e484c752f3f06549$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(n, r) {
        var s = $e484c752f3f06549$var$P(n, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(e, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return $e484c752f3f06549$var$K(n, e);
}
var $e484c752f3f06549$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $e484c752f3f06549$var$Se(), o = $e484c752f3f06549$var$ne([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e484c752f3f06549$var$f, '="true"'),
                "".concat("data-styled-version", '="').concat("6.1.0", '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e484c752f3f06549$var$ce(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e484c752f3f06549$var$ce(2);
            var r = ((n = {})[$e484c752f3f06549$var$f] = "", n["data-styled-version"] = "6.1.0", n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $e484c752f3f06549$var$Se();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e484c752f3f06549$var$Ce({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e484c752f3f06549$var$ce(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e484c752f3f06549$var$ce(3);
    }, e;
}(), $e484c752f3f06549$export$5c87cfe6c475f500 = {
    StyleSheet: $e484c752f3f06549$var$Ce,
    mainSheet: $e484c752f3f06549$var$Re
};
var $e484c752f3f06549$var$dt = "__sc-".concat($e484c752f3f06549$var$f, "__");



// https://www.joshwcomeau.com/snippets/react-hooks/use-prefers-reduced-motion/

var $bh6RR = parcelRequire("bh6RR");
const $722b582ec0971f60$var$QUERY = "(prefers-reduced-motion: no-preference)";
const $722b582ec0971f60$var$isRenderingOnServer = typeof window === "undefined";
const $722b582ec0971f60$var$getInitialState = ()=>{
    // For our initial server render, we won't know if the user
    // prefers reduced motion, but it doesn't matter. This value
    // will be overwritten on the client, before any animations
    // occur.
    return $722b582ec0971f60$var$isRenderingOnServer ? true : !window.matchMedia($722b582ec0971f60$var$QUERY).matches;
};
function $722b582ec0971f60$var$usePrefersReducedMotion() {
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState($722b582ec0971f60$var$getInitialState);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const mediaQueryList = window.matchMedia($722b582ec0971f60$var$QUERY);
        const listener = (event)=>{
            setPrefersReducedMotion(!event.matches);
        };
        if (mediaQueryList.addEventListener) mediaQueryList.addEventListener("change", listener);
        else mediaQueryList.addListener(listener);
        return ()=>{
            if (mediaQueryList.removeEventListener) mediaQueryList.removeEventListener("change", listener);
            else mediaQueryList.removeListener(listener);
        };
    }, []);
    return prefersReducedMotion;
}
var $722b582ec0971f60$export$2e2bcd8739ae039 = $722b582ec0971f60$var$usePrefersReducedMotion;


// Utility helper for random number generation
// https://www.joshwcomeau.com/snippets/react-hooks/use-random-interval/

var $bh6RR = parcelRequire("bh6RR");
const $24e31ac04d7bae66$var$random = (min, max)=>Math.floor(Math.random() * (max - min)) + min;
const $24e31ac04d7bae66$var$useRandomInterval = (callback, minDelay, maxDelay)=>{
    const timeoutId = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const savedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        let isEnabled = typeof minDelay === "number" && typeof maxDelay === "number";
        if (isEnabled) {
            const handleTick = ()=>{
                const nextTickAt = $24e31ac04d7bae66$var$random(minDelay, maxDelay);
                timeoutId.current = window.setTimeout(()=>{
                    savedCallback.current();
                    handleTick();
                }, nextTickAt);
            };
            handleTick();
        }
        return ()=>window.clearTimeout(timeoutId.current);
    }, [
        minDelay,
        maxDelay
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function() {
        window.clearTimeout(timeoutId.current);
    }, []);
    return cancel;
};
var $24e31ac04d7bae66$export$2e2bcd8739ae039 = $24e31ac04d7bae66$var$useRandomInterval;


const $5783fab4c4309ce7$var$DEFAULT_COLOR = "#FFC700";
const $5783fab4c4309ce7$var$generateSparkle = (color)=>{
    const sparkle = {
        id: String((0, $92dc8dbec6af1b1e$export$4385e60b38654f68)(10000, 99999)),
        createdAt: Date.now(),
        color: color,
        size: (0, $92dc8dbec6af1b1e$export$4385e60b38654f68)(10, 20),
        style: {
            top: (0, $92dc8dbec6af1b1e$export$4385e60b38654f68)(0, 100) + "%",
            left: (0, $92dc8dbec6af1b1e$export$4385e60b38654f68)(0, 100) + "%",
            zIndex: 3
        }
    };
    return sparkle;
};
const $5783fab4c4309ce7$var$Sparkles = ({ color: color = $5783fab4c4309ce7$var$DEFAULT_COLOR , children: children , ...delegated })=>{
    const [sparkles, setSparkles] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(()=>{
        return (0, $92dc8dbec6af1b1e$export$d02631cccf789723)(3).map(()=>$5783fab4c4309ce7$var$generateSparkle(color));
    });
    const prefersReducedMotion = (0, $722b582ec0971f60$export$2e2bcd8739ae039)();
    (0, $24e31ac04d7bae66$export$2e2bcd8739ae039)(()=>{
        const sparkle = $5783fab4c4309ce7$var$generateSparkle(color);
        const now = Date.now();
        const nextSparkles = sparkles.filter((sp)=>{
            const delta = now - sp.createdAt;
            return delta < 750;
        });
        nextSparkles.push(sparkle);
        setSparkles(nextSparkles);
    }, prefersReducedMotion ? null : 50, prefersReducedMotion ? null : 450);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($5783fab4c4309ce7$var$Wrapper, {
        ...delegated,
        children: [
            sparkles.map((sparkle)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5783fab4c4309ce7$var$Sparkle, {
                    color: sparkle.color,
                    size: sparkle.size,
                    style: sparkle.style
                }, sparkle.id)),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5783fab4c4309ce7$var$ChildWrapper, {
                children: children
            })
        ]
    });
};
const $5783fab4c4309ce7$var$Sparkle = ({ size: size , color: color , style: style  })=>{
    const path = "M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5783fab4c4309ce7$var$SparkleWrapper, {
        style: style,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5783fab4c4309ce7$var$SparkleSvg, {
            width: size,
            height: size,
            viewBox: "0 0 68 68",
            fill: "none",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: path,
                fill: color
            })
        })
    });
};
const $5783fab4c4309ce7$var$comeInOut = (0, $e484c752f3f06549$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`;
const $5783fab4c4309ce7$var$spin = (0, $e484c752f3f06549$export$d25ddfdf17c3ad3e)`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
`;
const $5783fab4c4309ce7$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  display: inline-block;
  position: relative;
`;
const $5783fab4c4309ce7$var$SparkleWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  position: absolute;
  display: block;
  pointer-events: none;
  @media (prefers-reduced-motion: no-preference) {
    animation: ${$5783fab4c4309ce7$var$comeInOut} 700ms forwards;
  }
`;
const $5783fab4c4309ce7$var$SparkleSvg = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  display: block;
  @media (prefers-reduced-motion: no-preference) {
    animation: ${$5783fab4c4309ce7$var$spin} 1000ms linear;
  }
`;
const $5783fab4c4309ce7$var$ChildWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).strong`
  position: relative;
  z-index: 1;
  font-weight: bold;
`;
var $5783fab4c4309ce7$export$2e2bcd8739ae039 = $5783fab4c4309ce7$var$Sparkles;





// Inspired by react-hot-toast library

var $bh6RR = parcelRequire("bh6RR");
const $c3f30381ef8228c0$var$TOAST_LIMIT = 1;
const $c3f30381ef8228c0$var$TOAST_REMOVE_DELAY = 1000000;
const $c3f30381ef8228c0$var$actionTypes = {
    ADD_TOAST: "ADD_TOAST",
    UPDATE_TOAST: "UPDATE_TOAST",
    DISMISS_TOAST: "DISMISS_TOAST",
    REMOVE_TOAST: "REMOVE_TOAST"
};
let $c3f30381ef8228c0$var$count = 0;
function $c3f30381ef8228c0$var$genId() {
    $c3f30381ef8228c0$var$count = ($c3f30381ef8228c0$var$count + 1) % Number.MAX_VALUE;
    return $c3f30381ef8228c0$var$count.toString();
}
const $c3f30381ef8228c0$var$toastTimeouts = new Map();
const $c3f30381ef8228c0$var$addToRemoveQueue = (toastId)=>{
    if ($c3f30381ef8228c0$var$toastTimeouts.has(toastId)) return;
    const timeout = setTimeout(()=>{
        $c3f30381ef8228c0$var$toastTimeouts.delete(toastId);
        $c3f30381ef8228c0$var$dispatch({
            type: "REMOVE_TOAST",
            toastId: toastId
        });
    }, $c3f30381ef8228c0$var$TOAST_REMOVE_DELAY);
    $c3f30381ef8228c0$var$toastTimeouts.set(toastId, timeout);
};
const $c3f30381ef8228c0$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case "ADD_TOAST":
            return {
                ...state,
                toasts: [
                    action.toast,
                    ...state.toasts
                ].slice(0, $c3f30381ef8228c0$var$TOAST_LIMIT)
            };
        case "UPDATE_TOAST":
            return {
                ...state,
                toasts: state.toasts.map((t)=>t.id === action.toast.id ? {
                        ...t,
                        ...action.toast
                    } : t)
            };
        case "DISMISS_TOAST":
            {
                const { toastId: toastId  } = action;
                // ! Side effects ! - This could be extracted into a dismissToast() action,
                // but I'll keep it here for simplicity
                if (toastId) $c3f30381ef8228c0$var$addToRemoveQueue(toastId);
                else state.toasts.forEach((toast)=>{
                    $c3f30381ef8228c0$var$addToRemoveQueue(toast.id);
                });
                return {
                    ...state,
                    toasts: state.toasts.map((t)=>t.id === toastId || toastId === undefined ? {
                            ...t,
                            open: false
                        } : t)
                };
            }
        case "REMOVE_TOAST":
            if (action.toastId === undefined) return {
                ...state,
                toasts: []
            };
            return {
                ...state,
                toasts: state.toasts.filter((t)=>t.id !== action.toastId)
            };
    }
};
const $c3f30381ef8228c0$var$listeners = [];
let $c3f30381ef8228c0$var$memoryState = {
    toasts: []
};
function $c3f30381ef8228c0$var$dispatch(action) {
    $c3f30381ef8228c0$var$memoryState = $c3f30381ef8228c0$export$1650419e431d3ba3($c3f30381ef8228c0$var$memoryState, action);
    $c3f30381ef8228c0$var$listeners.forEach((listener)=>{
        listener($c3f30381ef8228c0$var$memoryState);
    });
}
function $c3f30381ef8228c0$export$b410431fab84fa58({ ...props }) {
    const id = $c3f30381ef8228c0$var$genId();
    const update = (props)=>$c3f30381ef8228c0$var$dispatch({
            type: "UPDATE_TOAST",
            toast: {
                ...props,
                id: id
            }
        });
    const dismiss = ()=>$c3f30381ef8228c0$var$dispatch({
            type: "DISMISS_TOAST",
            toastId: id
        });
    $c3f30381ef8228c0$var$dispatch({
        type: "ADD_TOAST",
        toast: {
            ...props,
            id: id,
            open: true,
            onOpenChange: (open)=>{
                if (!open) dismiss();
            }
        }
    });
    return {
        id: id,
        dismiss: dismiss,
        update: update
    };
}
function $c3f30381ef8228c0$export$a407b657d3044108() {
    const [state, setState] = $bh6RR.useState($c3f30381ef8228c0$var$memoryState);
    $bh6RR.useEffect(()=>{
        $c3f30381ef8228c0$var$listeners.push(setState);
        return ()=>{
            const index = $c3f30381ef8228c0$var$listeners.indexOf(setState);
            if (index > -1) $c3f30381ef8228c0$var$listeners.splice(index, 1);
        };
    }, [
        state
    ]);
    return {
        ...state,
        toast: $c3f30381ef8228c0$export$b410431fab84fa58,
        dismiss: (toastId)=>$c3f30381ef8228c0$var$dispatch({
                type: "DISMISS_TOAST",
                toastId: toastId
            })
    };
}



var $7ORd6 = parcelRequire("7ORd6");



// Share logic from here: https://github.com/cwackerfuss/react-wordle/blob/main/src/lib/share.ts
const $54de83ab5ea878ea$var$webShareApiDeviceTypes = [
    "mobile",
    "smarttv",
    "wearable"
];
const $54de83ab5ea878ea$var$parser = new (0, $7ORd6.UAParser)();
const $54de83ab5ea878ea$var$browser = $54de83ab5ea878ea$var$parser.getBrowser();
const $54de83ab5ea878ea$var$device = $54de83ab5ea878ea$var$parser.getDevice();
const $54de83ab5ea878ea$export$45a7387fb8fe733b = (gameData, submittedGuesses, handleShareToClipboard, handleShareFailure, includeGameLink = true)=>{
    const GAME_URL = window.location.href;
    const textToShare = `${(0, $5763721b9fa71fc2$export$3f68a6c8e931da17)} #${(0, $b50a230eab57da32$export$3014f1d0d6bd394f)}\n\n` + (0, $b9fa76065069edb9$export$a63577e223e2a6c9)(gameData, submittedGuesses, true) + `${includeGameLink ? "\n\n" + GAME_URL : ""}`;
    const shareData = {
        text: textToShare
    };
    let shareSuccess = false;
    try {
        if ($54de83ab5ea878ea$var$attemptShare(shareData)) {
            navigator.share(shareData);
            shareSuccess = true;
        }
    } catch (error) {
        shareSuccess = false;
    }
    try {
        if (!shareSuccess) {
            if (navigator.clipboard) navigator.clipboard.writeText(textToShare).then(handleShareToClipboard).catch(handleShareFailure);
            else handleShareFailure();
        }
    } catch (error) {
        handleShareFailure();
    }
};
const $54de83ab5ea878ea$var$attemptShare = (shareData)=>{
    return(// Deliberately exclude Firefox Mobile, because its Web Share API isn't working correctly
    $54de83ab5ea878ea$var$browser.name?.toUpperCase().indexOf("FIREFOX") === -1 && $54de83ab5ea878ea$var$webShareApiDeviceTypes.indexOf($54de83ab5ea878ea$var$device.type ?? "") !== -1 && navigator.canShare && navigator.canShare(shareData) && navigator.share);
};





function $edebedacdc02cdb3$var$ShareScoreButton({ buttonText: buttonText = "Share" , className: className = ""  }) {
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ae43375334d8e130$export$e8331451049320c2));
    const { submittedGuesses: submittedGuesses , isGameWon: isGameWon  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $005b445a28133b13$export$3f49015a6304186f));
    const { toast: toast  } = (0, $c3f30381ef8228c0$export$a407b657d3044108)();
    function handleShareToClipboard() {
        (0, $61b270a9c2ec9ef5$export$691802c93373a60f)(submittedGuesses.length, isGameWon);
        toast({
            label: "Notification",
            title: "",
            description: "Copied to clipboard!"
        });
    }
    function handleShareFailure() {
        toast({
            label: "Notification",
            title: "",
            description: "Was unable to copy to clipboard / share."
        });
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5783fab4c4309ce7$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $96fae3fa1f07fd29$export$353f5b6fc5456de1), {
            className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)(className, "w-full"),
            variant: "share",
            onClick: ()=>(0, $54de83ab5ea878ea$export$45a7387fb8fe733b)(gameData, submittedGuesses, handleShareToClipboard, handleShareFailure, true),
            children: buttonText
        })
    });
}
var $edebedacdc02cdb3$export$2e2bcd8739ae039 = $edebedacdc02cdb3$var$ShareScoreButton;





function $8e952cf10097a2ff$var$GameWonModal({ open: open , submittedGuesses: submittedGuesses  }) {
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ae43375334d8e130$export$e8331451049320c2));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $1afdc1be3ae11346$export$2e2bcd8739ae039), {
        title: "You won the game!",
        initiallyOpen: open,
        footerElements: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $edebedacdc02cdb3$export$2e2bcd8739ae039), {}),
        showActionButton: false,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "Great job, share your results!"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "justify-center",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: "text-center whitespace-pre",
                    children: [
                        "\n",
                        (0, $b9fa76065069edb9$export$a63577e223e2a6c9)(gameData, submittedGuesses)
                    ]
                })
            })
        ]
    });
}
var $8e952cf10097a2ff$export$2e2bcd8739ae039 = $8e952cf10097a2ff$var$GameWonModal;







var $bh6RR = parcelRequire("bh6RR");
var $972b234689e1deef$exports = {};
var $8dae0da9e78ee487$exports = {};
var $21d95395709da5fd$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $21d95395709da5fd$var$nativeCeil = Math.ceil, $21d95395709da5fd$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $21d95395709da5fd$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $21d95395709da5fd$var$nativeMax($21d95395709da5fd$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$21d95395709da5fd$exports = $21d95395709da5fd$var$baseRange;


var $0fa22948390b654e$exports = {};
var $d3b5784bbbc55641$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d3b5784bbbc55641$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$d3b5784bbbc55641$exports = $d3b5784bbbc55641$var$eq;


var $681032a0f414881e$exports = {};
var $3c413d87f292fe2c$exports = {};
var $396b15940342a7f1$exports = {};
var $2388da93fa592950$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $2388da93fa592950$var$Symbol = $dnnhb.Symbol;
$2388da93fa592950$exports = $2388da93fa592950$var$Symbol;


var $8005b8efeeb9f4e7$exports = {};

/** Used for built-in method references. */ var $8005b8efeeb9f4e7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8005b8efeeb9f4e7$var$hasOwnProperty = $8005b8efeeb9f4e7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8005b8efeeb9f4e7$var$nativeObjectToString = $8005b8efeeb9f4e7$var$objectProto.toString;
/** Built-in value references. */ var $8005b8efeeb9f4e7$var$symToStringTag = $2388da93fa592950$exports ? $2388da93fa592950$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8005b8efeeb9f4e7$var$getRawTag(value) {
    var isOwn = $8005b8efeeb9f4e7$var$hasOwnProperty.call(value, $8005b8efeeb9f4e7$var$symToStringTag), tag = value[$8005b8efeeb9f4e7$var$symToStringTag];
    try {
        value[$8005b8efeeb9f4e7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $8005b8efeeb9f4e7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$8005b8efeeb9f4e7$var$symToStringTag] = tag;
        else delete value[$8005b8efeeb9f4e7$var$symToStringTag];
    }
    return result;
}
$8005b8efeeb9f4e7$exports = $8005b8efeeb9f4e7$var$getRawTag;


var $8777fc9d1b1902f9$exports = {};
/** Used for built-in method references. */ var $8777fc9d1b1902f9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8777fc9d1b1902f9$var$nativeObjectToString = $8777fc9d1b1902f9$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8777fc9d1b1902f9$var$objectToString(value) {
    return $8777fc9d1b1902f9$var$nativeObjectToString.call(value);
}
$8777fc9d1b1902f9$exports = $8777fc9d1b1902f9$var$objectToString;


/** `Object#toString` result references. */ var $396b15940342a7f1$var$nullTag = "[object Null]", $396b15940342a7f1$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $396b15940342a7f1$var$symToStringTag = $2388da93fa592950$exports ? $2388da93fa592950$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $396b15940342a7f1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $396b15940342a7f1$var$undefinedTag : $396b15940342a7f1$var$nullTag;
    return $396b15940342a7f1$var$symToStringTag && $396b15940342a7f1$var$symToStringTag in Object(value) ? $8005b8efeeb9f4e7$exports(value) : $8777fc9d1b1902f9$exports(value);
}
$396b15940342a7f1$exports = $396b15940342a7f1$var$baseGetTag;


var $e4bea0192758232a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e4bea0192758232a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$e4bea0192758232a$exports = $e4bea0192758232a$var$isObject;


/** `Object#toString` result references. */ var $3c413d87f292fe2c$var$asyncTag = "[object AsyncFunction]", $3c413d87f292fe2c$var$funcTag = "[object Function]", $3c413d87f292fe2c$var$genTag = "[object GeneratorFunction]", $3c413d87f292fe2c$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3c413d87f292fe2c$var$isFunction(value) {
    if (!$e4bea0192758232a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $396b15940342a7f1$exports(value);
    return tag == $3c413d87f292fe2c$var$funcTag || tag == $3c413d87f292fe2c$var$genTag || tag == $3c413d87f292fe2c$var$asyncTag || tag == $3c413d87f292fe2c$var$proxyTag;
}
$3c413d87f292fe2c$exports = $3c413d87f292fe2c$var$isFunction;


var $cb5309a5575a37b9$exports = {};
/** Used as references for various `Number` constants. */ var $cb5309a5575a37b9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $cb5309a5575a37b9$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $cb5309a5575a37b9$var$MAX_SAFE_INTEGER;
}
$cb5309a5575a37b9$exports = $cb5309a5575a37b9$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $681032a0f414881e$var$isArrayLike(value) {
    return value != null && $cb5309a5575a37b9$exports(value.length) && !$3c413d87f292fe2c$exports(value);
}
$681032a0f414881e$exports = $681032a0f414881e$var$isArrayLike;


var $ec0ca5ffb2ff14ec$exports = {};
/** Used as references for various `Number` constants. */ var $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ec0ca5ffb2ff14ec$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec0ca5ffb2ff14ec$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $ec0ca5ffb2ff14ec$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ec0ca5ffb2ff14ec$exports = $ec0ca5ffb2ff14ec$var$isIndex;



/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $0fa22948390b654e$var$isIterateeCall(value, index, object) {
    if (!$e4bea0192758232a$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $681032a0f414881e$exports(object) && $ec0ca5ffb2ff14ec$exports(index, object.length) : type == "string" && index in object) return $d3b5784bbbc55641$exports(object[index], value);
    return false;
}
$0fa22948390b654e$exports = $0fa22948390b654e$var$isIterateeCall;


var $8da36a9ee743aed0$exports = {};
var $94b27a3e78e3c823$exports = {};
var $c67bd29bac11ba49$exports = {};
var $1751409297565aa8$exports = {};
/** Used to match a single whitespace character. */ var $1751409297565aa8$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $1751409297565aa8$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $1751409297565aa8$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$1751409297565aa8$exports = $1751409297565aa8$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $c67bd29bac11ba49$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $c67bd29bac11ba49$var$baseTrim(string) {
    return string ? string.slice(0, $1751409297565aa8$exports(string) + 1).replace($c67bd29bac11ba49$var$reTrimStart, "") : string;
}
$c67bd29bac11ba49$exports = $c67bd29bac11ba49$var$baseTrim;



var $42e9ee7d3311848a$exports = {};

var $4a94b44c4940d5a5$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4a94b44c4940d5a5$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$4a94b44c4940d5a5$exports = $4a94b44c4940d5a5$var$isObjectLike;


/** `Object#toString` result references. */ var $42e9ee7d3311848a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $42e9ee7d3311848a$var$isSymbol(value) {
    return typeof value == "symbol" || $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $42e9ee7d3311848a$var$symbolTag;
}
$42e9ee7d3311848a$exports = $42e9ee7d3311848a$var$isSymbol;


/** Used as references for various `Number` constants. */ var $94b27a3e78e3c823$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $94b27a3e78e3c823$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $94b27a3e78e3c823$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $94b27a3e78e3c823$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $94b27a3e78e3c823$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $94b27a3e78e3c823$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($42e9ee7d3311848a$exports(value)) return $94b27a3e78e3c823$var$NAN;
    if ($e4bea0192758232a$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $e4bea0192758232a$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $c67bd29bac11ba49$exports(value);
    var isBinary = $94b27a3e78e3c823$var$reIsBinary.test(value);
    return isBinary || $94b27a3e78e3c823$var$reIsOctal.test(value) ? $94b27a3e78e3c823$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $94b27a3e78e3c823$var$reIsBadHex.test(value) ? $94b27a3e78e3c823$var$NAN : +value;
}
$94b27a3e78e3c823$exports = $94b27a3e78e3c823$var$toNumber;


/** Used as references for various `Number` constants. */ var $8da36a9ee743aed0$var$INFINITY = 1 / 0, $8da36a9ee743aed0$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $8da36a9ee743aed0$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $94b27a3e78e3c823$exports(value);
    if (value === $8da36a9ee743aed0$var$INFINITY || value === -$8da36a9ee743aed0$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $8da36a9ee743aed0$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$8da36a9ee743aed0$exports = $8da36a9ee743aed0$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $8dae0da9e78ee487$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $0fa22948390b654e$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $8da36a9ee743aed0$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $8da36a9ee743aed0$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $8da36a9ee743aed0$exports(step);
        return $21d95395709da5fd$exports(start, end, step, fromRight);
    };
}
$8dae0da9e78ee487$exports = $8dae0da9e78ee487$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $972b234689e1deef$var$range = $8dae0da9e78ee487$exports();
$972b234689e1deef$exports = $972b234689e1deef$var$range;




function $cd488cd9c287f883$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $bh6RR = parcelRequire("bh6RR");
var $770bbfe5492d7fd4$exports = {};
"use strict";
var $f7eb0b72c50199f8$exports = {};
"use strict";

$f7eb0b72c50199f8$exports = (parcelRequire("g4WQO"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$f7eb0b72c50199f8$exports.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$f7eb0b72c50199f8$exports.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($f7eb0b72c50199f8$exports.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component["$$typeof"]] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$770bbfe5492d7fd4$exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;



var $bh6RR = parcelRequire("bh6RR");



var $530ccb0f846f6b91$exports = {};
"use strict";
Object.defineProperty($530ccb0f846f6b91$exports, "__esModule", {
    value: true
});
$530ccb0f846f6b91$exports.default = $530ccb0f846f6b91$var$getDisplayName;
function $530ccb0f846f6b91$var$getDisplayName(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


function $b00a230e66cc9d68$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b00a230e66cc9d68$var$_extends() {
    $b00a230e66cc9d68$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b00a230e66cc9d68$var$_extends.apply(this, arguments);
}
function $b00a230e66cc9d68$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $b00a230e66cc9d68$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b00a230e66cc9d68$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && !Array.isArray(obj);
}
function $b00a230e66cc9d68$var$createThemeProvider(context) {
    var ThemeProvider = /*#__PURE__*/ function(_React$Component) {
        $b00a230e66cc9d68$var$_inheritsLoose(ThemeProvider, _React$Component);
        function ThemeProvider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            $b00a230e66cc9d68$var$_defineProperty($b00a230e66cc9d68$var$_assertThisInitialized($b00a230e66cc9d68$var$_assertThisInitialized(_this)), "cachedTheme", void 0);
            $b00a230e66cc9d68$var$_defineProperty($b00a230e66cc9d68$var$_assertThisInitialized($b00a230e66cc9d68$var$_assertThisInitialized(_this)), "lastOuterTheme", void 0);
            $b00a230e66cc9d68$var$_defineProperty($b00a230e66cc9d68$var$_assertThisInitialized($b00a230e66cc9d68$var$_assertThisInitialized(_this)), "lastTheme", void 0);
            $b00a230e66cc9d68$var$_defineProperty($b00a230e66cc9d68$var$_assertThisInitialized($b00a230e66cc9d68$var$_assertThisInitialized(_this)), "renderProvider", function(outerTheme) {
                var children = _this.props.children;
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(context.Provider, {
                    value: _this.getTheme(outerTheme)
                }, children);
            });
            return _this;
        }
        var _proto = ThemeProvider.prototype;
        // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
        _proto.getTheme = function getTheme(outerTheme) {
            if (this.props.theme !== this.lastTheme || outerTheme !== this.lastOuterTheme || !this.cachedTheme) {
                this.lastOuterTheme = outerTheme;
                this.lastTheme = this.props.theme;
                if (typeof this.lastTheme === "function") {
                    var theme = this.props.theme;
                    this.cachedTheme = theme(outerTheme);
                } else {
                    var _theme = this.props.theme;
                    this.cachedTheme = outerTheme ? $b00a230e66cc9d68$var$_extends({}, outerTheme, _theme) : _theme;
                }
            }
            return this.cachedTheme;
        };
        _proto.render = function render() {
            var children = this.props.children;
            if (!children) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(context.Consumer, null, this.renderProvider);
        };
        return ThemeProvider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
    return ThemeProvider;
}
function $b00a230e66cc9d68$var$createWithTheme(context) {
    return function hoc(Component) {
        var withTheme = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(context.Consumer, null, function(theme) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, $b00a230e66cc9d68$var$_extends({
                    theme: theme,
                    ref: ref
                }, props));
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($770bbfe5492d7fd4$exports)))(withTheme, Component);
        return withTheme;
    };
}
function $b00a230e66cc9d68$var$createUseTheme(context) {
    var useTheme = function useTheme() {
        var theme = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext(context);
        return theme;
    };
    return useTheme;
}
function $b00a230e66cc9d68$export$c0de29a8ef9dbf92(context) {
    return {
        context: context,
        withTheme: $b00a230e66cc9d68$var$createWithTheme(context),
        useTheme: $b00a230e66cc9d68$var$createUseTheme(context),
        ThemeProvider: $b00a230e66cc9d68$var$createThemeProvider(context)
    };
}
var $b00a230e66cc9d68$export$2c657da244d00bd6 = (0, $bh6RR.createContext)();
var $b00a230e66cc9d68$var$_createTheming = $b00a230e66cc9d68$export$c0de29a8ef9dbf92($b00a230e66cc9d68$export$2c657da244d00bd6), $b00a230e66cc9d68$export$e8748c6a27b910dc = $b00a230e66cc9d68$var$_createTheming.withTheme, $b00a230e66cc9d68$export$d8964aec282183a3 = $b00a230e66cc9d68$var$_createTheming.ThemeProvider, $b00a230e66cc9d68$export$93d4e7f90805808f = $b00a230e66cc9d68$var$_createTheming.useTheme;


var $90505e58c00ce0c9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $90505e58c00ce0c9$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $90505e58c00ce0c9$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $90505e58c00ce0c9$var$_typeof(document)) === "object" && document.nodeType === 9;
var $90505e58c00ce0c9$export$2e2bcd8739ae039 = $90505e58c00ce0c9$export$4e09c449d6c407f7;





var $88d6b79dcec0cfd7$var$isProduction = true;
function $88d6b79dcec0cfd7$var$warning(condition, message) {
    if (!$88d6b79dcec0cfd7$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $88d6b79dcec0cfd7$export$2e2bcd8739ae039 = $88d6b79dcec0cfd7$var$warning;




function $94d637ce061dd3ca$export$2e2bcd8739ae039(input, hint) {
    if ((0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $d0643fe154cb74c1$export$2e2bcd8739ae039(arg) {
    var key = (0, $94d637ce061dd3ca$export$2e2bcd8739ae039)(arg, "string");
    return (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $eebcda4657ff09bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $d0643fe154cb74c1$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $eebcda4657ff09bb$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $eebcda4657ff09bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eebcda4657ff09bb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $ca073d81f2a471af$export$2e2bcd8739ae039(o, p) {
    $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ca073d81f2a471af$export$2e2bcd8739ae039(o, p);
}


function $c375c92967c25393$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(subClass, superClass);
}


function $cb0e0834598ff6d6$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $f9c08e91c2468f05$var$plainObjectConstrurctor = {}.constructor;
function $f9c08e91c2468f05$var$cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map($f9c08e91c2468f05$var$cloneStyle);
    if (style.constructor !== $f9c08e91c2468f05$var$plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = $f9c08e91c2468f05$var$cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function $f9c08e91c2468f05$export$56e87122f905fac0(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = $f9c08e91c2468f05$var$cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var $f9c08e91c2468f05$var$join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var $f9c08e91c2468f05$export$5ac341d5e3cf9273 = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += $f9c08e91c2468f05$var$join(value[i], " ");
    }
    else cssValue = $f9c08e91c2468f05$var$join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function $f9c08e91c2468f05$var$getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function $f9c08e91c2468f05$var$indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function $f9c08e91c2468f05$var$toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = $f9c08e91c2468f05$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += $f9c08e91c2468f05$var$indentStr(prop + ":" + space + $f9c08e91c2468f05$export$5ac341d5e3cf9273(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += $f9c08e91c2468f05$var$indentStr(_prop + ":" + space + $f9c08e91c2468f05$export$5ac341d5e3cf9273(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += $f9c08e91c2468f05$var$indentStr(_prop2 + ":" + space + $f9c08e91c2468f05$export$5ac341d5e3cf9273(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return $f9c08e91c2468f05$var$indentStr("" + selector + space + "{" + result, indent) + $f9c08e91c2468f05$var$indentStr("}", indent);
}
var $f9c08e91c2468f05$var$escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var $f9c08e91c2468f05$var$nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var $f9c08e91c2468f05$var$escape = function(str) {
    return $f9c08e91c2468f05$var$nativeEscape ? $f9c08e91c2468f05$var$nativeEscape(str) : str.replace($f9c08e91c2468f05$var$escapeRegex, "\\$1");
};
var $f9c08e91c2468f05$var$BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var $f9c08e91c2468f05$var$StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), sheet);
            _this.selectorText = "." + $f9c08e91c2468f05$var$escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = $f9c08e91c2468f05$export$5ac341d5e3cf9273(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            allowEmpty: true
        }) : options;
        return $f9c08e91c2468f05$var$toCss(this.selectorText, this.style, opts);
    };
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}($f9c08e91c2468f05$var$BaseStyleRule);
var $f9c08e91c2468f05$var$pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new $f9c08e91c2468f05$var$StyleRule(key, style, options);
    }
};
var $f9c08e91c2468f05$var$defaultToStringOptions = {
    indent: 1,
    children: true
};
var $f9c08e91c2468f05$var$atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var $f9c08e91c2468f05$var$ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match($f9c08e91c2468f05$var$atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new $f9c08e91c2468f05$export$d9da2a13178d3d68((0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $f9c08e91c2468f05$var$defaultToStringOptions;
        var _getWhitespaceSymbols = $f9c08e91c2468f05$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $f9c08e91c2468f05$var$defaultToStringOptions.indent;
        if (options.children == null) options.children = $f9c08e91c2468f05$var$defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var $f9c08e91c2468f05$var$keyRegExp = /@container|@media|@supports\s+/;
var $f9c08e91c2468f05$var$pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return $f9c08e91c2468f05$var$keyRegExp.test(key) ? new $f9c08e91c2468f05$var$ConditionalRule(key, styles, options) : null;
    }
};
var $f9c08e91c2468f05$var$defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var $f9c08e91c2468f05$var$nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var $f9c08e91c2468f05$var$KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match($f9c08e91c2468f05$var$nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : $f9c08e91c2468f05$var$escape(generateId(this, sheet));
        this.rules = new $f9c08e91c2468f05$export$d9da2a13178d3d68((0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $f9c08e91c2468f05$var$defaultToStringOptions$1;
        var _getWhitespaceSymbols = $f9c08e91c2468f05$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $f9c08e91c2468f05$var$defaultToStringOptions$1.indent;
        if (options.children == null) options.children = $f9c08e91c2468f05$var$defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var $f9c08e91c2468f05$var$keyRegExp$1 = /@keyframes\s+/;
var $f9c08e91c2468f05$var$refRegExp = /\$([\w-]+)/g;
var $f9c08e91c2468f05$var$findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace($f9c08e91c2468f05$var$refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var $f9c08e91c2468f05$var$replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = $f9c08e91c2468f05$var$findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var $f9c08e91c2468f05$var$pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && $f9c08e91c2468f05$var$keyRegExp$1.test(key) ? new $f9c08e91c2468f05$var$KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) $f9c08e91c2468f05$var$replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) $f9c08e91c2468f05$var$replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return $f9c08e91c2468f05$var$findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return $f9c08e91c2468f05$var$findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var $f9c08e91c2468f05$var$KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            allowEmpty: true
        }) : options;
        return $f9c08e91c2468f05$var$toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}($f9c08e91c2468f05$var$BaseStyleRule);
var $f9c08e91c2468f05$var$pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new $f9c08e91c2468f05$var$KeyframeRule(key, style, options);
        return null;
    }
};
var $f9c08e91c2468f05$var$FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = $f9c08e91c2468f05$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += $f9c08e91c2468f05$var$toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return $f9c08e91c2468f05$var$toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var $f9c08e91c2468f05$var$keyRegExp$2 = /@font-face/;
var $f9c08e91c2468f05$var$pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return $f9c08e91c2468f05$var$keyRegExp$2.test(key) ? new $f9c08e91c2468f05$var$FontFaceRule(key, style, options) : null;
    }
};
var $f9c08e91c2468f05$var$ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return $f9c08e91c2468f05$var$toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var $f9c08e91c2468f05$var$pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new $f9c08e91c2468f05$var$ViewportRule(key, style, options) : null;
    }
};
var $f9c08e91c2468f05$var$SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var $f9c08e91c2468f05$var$keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var $f9c08e91c2468f05$var$pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in $f9c08e91c2468f05$var$keysMap ? new $f9c08e91c2468f05$var$SimpleRule(key, value, options) : null;
    }
};
var $f9c08e91c2468f05$var$plugins = [
    $f9c08e91c2468f05$var$pluginStyleRule,
    $f9c08e91c2468f05$var$pluginConditionalRule,
    $f9c08e91c2468f05$var$pluginKeyframesRule,
    $f9c08e91c2468f05$var$pluginKeyframeRule,
    $f9c08e91c2468f05$var$pluginFontFaceRule,
    $f9c08e91c2468f05$var$pluginViewportRule,
    $f9c08e91c2468f05$var$pluginSimpleRule
];
var $f9c08e91c2468f05$var$defaultUpdateOptions = {
    process: true
};
var $f9c08e91c2468f05$var$forceUpdateOptions = {
    force: true,
    process: true
};
var $f9c08e91c2468f05$export$d9da2a13178d3d68 = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + $f9c08e91c2468f05$var$escape(this.classes[key]);
        var rule = $f9c08e91c2468f05$export$56e87122f905fac0(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof $f9c08e91c2468f05$var$StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof $f9c08e91c2468f05$var$KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof $f9c08e91c2468f05$var$StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof $f9c08e91c2468f05$var$KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = $f9c08e91c2468f05$var$defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, $f9c08e91c2468f05$var$forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, $f9c08e91c2468f05$var$forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = $f9c08e91c2468f05$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var $f9c08e91c2468f05$var$StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new $f9c08e91c2468f05$export$d9da2a13178d3d68(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var $f9c08e91c2468f05$var$PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var $f9c08e91c2468f05$export$bcb2f1d96ff51db3 = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = $f9c08e91c2468f05$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var $f9c08e91c2468f05$export$d1f2fc3a3d47c5af = new $f9c08e91c2468f05$export$bcb2f1d96ff51db3();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var $f9c08e91c2468f05$var$globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var $f9c08e91c2468f05$var$ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if ($f9c08e91c2468f05$var$globalThis$1[$f9c08e91c2468f05$var$ns] == null) $f9c08e91c2468f05$var$globalThis$1[$f9c08e91c2468f05$var$ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var $f9c08e91c2468f05$var$moduleId = $f9c08e91c2468f05$var$globalThis$1[$f9c08e91c2468f05$var$ns]++;
var $f9c08e91c2468f05$var$maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var $f9c08e91c2468f05$export$ddff9cce7c732c82 = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + $f9c08e91c2468f05$var$moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + $f9c08e91c2468f05$var$moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var $f9c08e91c2468f05$var$memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var $f9c08e91c2468f05$var$getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var $f9c08e91c2468f05$var$setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = $f9c08e91c2468f05$export$5ac341d5e3cf9273(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var $f9c08e91c2468f05$var$removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var $f9c08e91c2468f05$var$setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var $f9c08e91c2468f05$var$getHead = $f9c08e91c2468f05$var$memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function $f9c08e91c2468f05$var$findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function $f9c08e91c2468f05$var$findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function $f9c08e91c2468f05$var$findCommentNode(text) {
    var head = $f9c08e91c2468f05$var$getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function $f9c08e91c2468f05$var$findPrevNode(options) {
    var registry = $f9c08e91c2468f05$export$d1f2fc3a3d47c5af.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = $f9c08e91c2468f05$var$findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = $f9c08e91c2468f05$var$findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = $f9c08e91c2468f05$var$findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function $f9c08e91c2468f05$var$insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = $f9c08e91c2468f05$var$findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    $f9c08e91c2468f05$var$getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var $f9c08e91c2468f05$var$getNonce = $f9c08e91c2468f05$var$memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var $f9c08e91c2468f05$var$_insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var $f9c08e91c2468f05$var$getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var $f9c08e91c2468f05$var$createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var $f9c08e91c2468f05$var$DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = $f9c08e91c2468f05$var$getPropertyValue;
        this.setProperty = $f9c08e91c2468f05$var$setProperty;
        this.removeProperty = $f9c08e91c2468f05$var$removeProperty;
        this.setSelector = $f9c08e91c2468f05$var$setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) $f9c08e91c2468f05$export$d1f2fc3a3d47c5af.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || $f9c08e91c2468f05$var$createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = $f9c08e91c2468f05$var$getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        $f9c08e91c2468f05$var$insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = $f9c08e91c2468f05$var$getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = $f9c08e91c2468f05$var$_insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = $f9c08e91c2468f05$var$getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = $f9c08e91c2468f05$var$_insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof $f9c08e91c2468f05$var$StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var $f9c08e91c2468f05$var$instanceCounter = 0;
var $f9c08e91c2468f05$var$Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = $f9c08e91c2468f05$var$instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new $f9c08e91c2468f05$var$PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: $f9c08e91c2468f05$export$ddff9cce7c732c82,
            Renderer: (0, $90505e58c00ce0c9$export$2e2bcd8739ae039) ? $f9c08e91c2468f05$var$DomRenderer : null,
            plugins: []
        };
        this.generateId = $f9c08e91c2468f05$export$ddff9cce7c732c82({
            minify: false
        });
        for(var i = 0; i < $f9c08e91c2468f05$var$plugins.length; i++)this.plugins.use($f9c08e91c2468f05$var$plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = $f9c08e91c2468f05$export$d1f2fc3a3d47c5af.index === 0 ? 0 : $f9c08e91c2468f05$export$d1f2fc3a3d47c5af.index + 1;
        var sheet = new $f9c08e91c2468f05$var$StyleSheet(styles, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        $f9c08e91c2468f05$export$d1f2fc3a3d47c5af.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = $f9c08e91c2468f05$export$56e87122f905fac0(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var $f9c08e91c2468f05$export$185802fd694ee1f5 = function createJss(options) {
    return new $f9c08e91c2468f05$var$Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var $f9c08e91c2468f05$export$c72bb5031d779271 = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $88d6b79dcec0cfd7$export$2e2bcd8739ae039)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $88d6b79dcec0cfd7$export$2e2bcd8739ae039)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var $f9c08e91c2468f05$export$2305122a7d881dec = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function $f9c08e91c2468f05$export$8558f2aefa046992(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = $f9c08e91c2468f05$export$8558f2aefa046992(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var $f9c08e91c2468f05$var$index = $f9c08e91c2468f05$export$185802fd694ee1f5();
var $f9c08e91c2468f05$export$2e2bcd8739ae039 = $f9c08e91c2468f05$var$index;




var $fc8f730b382434f1$var$now = Date.now();
var $fc8f730b382434f1$var$fnValuesNs = "fnValues" + $fc8f730b382434f1$var$now;
var $fc8f730b382434f1$var$fnRuleNs = "fnStyle" + ++$fc8f730b382434f1$var$now;
var $fc8f730b382434f1$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $f9c08e91c2468f05$export$56e87122f905fac0)(name, {}, options);
            rule[$fc8f730b382434f1$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($fc8f730b382434f1$var$fnValuesNs in rule || $fc8f730b382434f1$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$fc8f730b382434f1$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$fc8f730b382434f1$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$fc8f730b382434f1$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $fc8f730b382434f1$export$2e2bcd8739ae039 = $fc8f730b382434f1$var$functionPlugin;



var $frWs0 = parcelRequire("frWs0");

var $6e7a4a64d784029e$var$isObservable = function isObservable(value) {
    return value && value[0, $frWs0.default] && value === value[0, $frWs0.default]();
};
var $6e7a4a64d784029e$var$observablePlugin = function observablePlugin(updateOptions) {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (!$6e7a4a64d784029e$var$isObservable(decl)) return null;
            var style$ = decl;
            var rule = (0, $f9c08e91c2468f05$export$56e87122f905fac0)(name, {}, options); // TODO
            // Call `stream.subscribe()` returns a subscription, which should be explicitly
            // unsubscribed from when we know this sheet is no longer needed.
            style$.subscribe(function(style) {
                for(var prop in style)rule.prop(prop, style[prop], updateOptions);
            });
            return rule;
        },
        onProcessRule: function onProcessRule(rule) {
            if (rule && rule.type !== "style") return;
            var styleRule = rule;
            var style = styleRule.style;
            var _loop = function _loop(prop) {
                var value = style[prop];
                if (!$6e7a4a64d784029e$var$isObservable(value)) return "continue";
                delete style[prop];
                value.subscribe({
                    next: function next(nextValue) {
                        styleRule.prop(prop, nextValue, updateOptions);
                    }
                });
            };
            for(var prop in style){
                var _ret = _loop(prop);
                if (_ret === "continue") continue;
            }
        }
    };
};
var $6e7a4a64d784029e$export$2e2bcd8739ae039 = $6e7a4a64d784029e$var$observablePlugin;



var $42f95bf6e0d55fce$var$semiWithNl = /;\n/;
/**
 * Naive CSS parser.
 * - Supports only rule body (no selectors)
 * - Requires semicolon and new line after the value (except of last line)
 * - No nested rules support
 */ var $42f95bf6e0d55fce$var$parse = function parse(cssText) {
    var style = {};
    var split = cssText.split($42f95bf6e0d55fce$var$semiWithNl);
    for(var i = 0; i < split.length; i++){
        var decl = (split[i] || "").trim();
        if (!decl) continue;
        var colonIndex = decl.indexOf(":");
        if (colonIndex === -1) continue;
        var prop = decl.substr(0, colonIndex).trim();
        var value = decl.substr(colonIndex + 1).trim();
        style[prop] = value;
    }
    return style;
};
var $42f95bf6e0d55fce$var$onProcessRule = function onProcessRule(rule) {
    if (typeof rule.style === "string") rule.style = $42f95bf6e0d55fce$var$parse(rule.style);
};
function $42f95bf6e0d55fce$var$templatePlugin() {
    return {
        onProcessRule: $42f95bf6e0d55fce$var$onProcessRule
    };
}
var $42f95bf6e0d55fce$export$2e2bcd8739ae039 = $42f95bf6e0d55fce$var$templatePlugin;




var $9a0b09d8df48aadc$var$at = "@global";
var $9a0b09d8df48aadc$var$atPrefix = "@global ";
var $9a0b09d8df48aadc$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $9a0b09d8df48aadc$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $f9c08e91c2468f05$export$d9da2a13178d3d68)((0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $9a0b09d8df48aadc$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $9a0b09d8df48aadc$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($9a0b09d8df48aadc$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $9a0b09d8df48aadc$var$separatorRegExp = /\s*,\s*/g;
function $9a0b09d8df48aadc$var$addScope(selector, scope) {
    var parts = selector.split($9a0b09d8df48aadc$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $9a0b09d8df48aadc$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$9a0b09d8df48aadc$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
        selector: $9a0b09d8df48aadc$var$addScope(name, rule.selector)
    }));
    delete style[$9a0b09d8df48aadc$var$at];
}
function $9a0b09d8df48aadc$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $9a0b09d8df48aadc$var$at.length) !== $9a0b09d8df48aadc$var$at) continue;
        var selector = $9a0b09d8df48aadc$var$addScope(prop.substr($9a0b09d8df48aadc$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $9a0b09d8df48aadc$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $9a0b09d8df48aadc$var$at) return new $9a0b09d8df48aadc$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $9a0b09d8df48aadc$var$atPrefix.length) === $9a0b09d8df48aadc$var$atPrefix) return new $9a0b09d8df48aadc$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $9a0b09d8df48aadc$var$handleNestedGlobalContainerRule(rule, sheet);
        $9a0b09d8df48aadc$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $9a0b09d8df48aadc$export$2e2bcd8739ae039 = $9a0b09d8df48aadc$var$jssGlobal;




var $5bf5891680f95795$var$isObject = function isObject(obj) {
    return obj && typeof obj === "object" && !Array.isArray(obj);
};
var $5bf5891680f95795$var$valueNs = "extendCurrValue" + Date.now();
function $5bf5891680f95795$var$mergeExtend(style, rule, sheet, newStyle) {
    var extendType = typeof style.extend; // Extend using a rule name.
    if (extendType === "string") {
        if (!sheet) return;
        var refRule = sheet.getRule(style.extend);
        if (!refRule) return;
        if (refRule === rule) return;
        var parent = refRule.options.parent;
        if (parent) {
            var originalStyle = parent.rules.raw[style.extend];
            $5bf5891680f95795$var$extend(originalStyle, rule, sheet, newStyle);
        }
        return;
    } // Extend using an array.
    if (Array.isArray(style.extend)) {
        for(var index = 0; index < style.extend.length; index++){
            var singleExtend = style.extend[index];
            var singleStyle = typeof singleExtend === "string" ? (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, style, {
                extend: singleExtend
            }) : style.extend[index];
            $5bf5891680f95795$var$extend(singleStyle, rule, sheet, newStyle);
        }
        return;
    } // Extend is a style object.
    for(var prop in style.extend){
        if (prop === "extend") {
            $5bf5891680f95795$var$extend(style.extend.extend, rule, sheet, newStyle);
            continue;
        }
        if ($5bf5891680f95795$var$isObject(style.extend[prop])) {
            if (!(prop in newStyle)) newStyle[prop] = {};
            $5bf5891680f95795$var$extend(style.extend[prop], rule, sheet, newStyle[prop]);
            continue;
        }
        newStyle[prop] = style.extend[prop];
    }
}
function $5bf5891680f95795$var$mergeRest(style, rule, sheet, newStyle) {
    // Copy base style.
    for(var prop in style){
        if (prop === "extend") continue;
        if ($5bf5891680f95795$var$isObject(newStyle[prop]) && $5bf5891680f95795$var$isObject(style[prop])) {
            $5bf5891680f95795$var$extend(style[prop], rule, sheet, newStyle[prop]);
            continue;
        }
        if ($5bf5891680f95795$var$isObject(style[prop])) {
            newStyle[prop] = $5bf5891680f95795$var$extend(style[prop], rule, sheet);
            continue;
        }
        newStyle[prop] = style[prop];
    }
}
/**
 * Recursively extend styles.
 */ function $5bf5891680f95795$var$extend(style, rule, sheet, newStyle) {
    if (newStyle === void 0) newStyle = {};
    $5bf5891680f95795$var$mergeExtend(style, rule, sheet, newStyle);
    $5bf5891680f95795$var$mergeRest(style, rule, sheet, newStyle);
    return newStyle;
}
/**
 * Handle `extend` property.
 */ function $5bf5891680f95795$var$jssExtend() {
    function onProcessStyle(style, rule, sheet) {
        if ("extend" in style) return $5bf5891680f95795$var$extend(style, rule, sheet);
        return style;
    }
    function onChangeValue(value, prop, rule) {
        if (prop !== "extend") return value; // Value is empty, remove properties set previously.
        if (value == null || value === false) {
            for(var key in rule[$5bf5891680f95795$var$valueNs])rule.prop(key, null);
            rule[$5bf5891680f95795$var$valueNs] = null;
            return null;
        }
        if (typeof value === "object") {
            for(var _key in value)rule.prop(_key, value[_key]);
            rule[$5bf5891680f95795$var$valueNs] = value;
        } // Make sure we don't set the value in the core.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5bf5891680f95795$export$2e2bcd8739ae039 = $5bf5891680f95795$var$jssExtend;




var $01f99ad62fc1fd6d$var$separatorRegExp = /\s*,\s*/g;
var $01f99ad62fc1fd6d$var$parentRegExp = /&/g;
var $01f99ad62fc1fd6d$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $01f99ad62fc1fd6d$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($01f99ad62fc1fd6d$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($01f99ad62fc1fd6d$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($01f99ad62fc1fd6d$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($01f99ad62fc1fd6d$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $01f99ad62fc1fd6d$export$2e2bcd8739ae039 = $01f99ad62fc1fd6d$var$jssNested;



/**
 * Set selector.
 *
 * @param original rule
 * @param className class string
 * @return flag indicating function was successfull or not
 */ function $5d4b96abaa7b78e9$var$registerClass(rule, className) {
    // Skip falsy values
    if (!className) return true; // Support array of class names `{composes: ['foo', 'bar']}`
    if (Array.isArray(className)) {
        for(var index = 0; index < className.length; index++){
            var isSetted = $5d4b96abaa7b78e9$var$registerClass(rule, className[index]);
            if (!isSetted) return false;
        }
        return true;
    } // Support space separated class names `{composes: 'foo bar'}`
    if (className.indexOf(" ") > -1) return $5d4b96abaa7b78e9$var$registerClass(rule, className.split(" "));
    var parent = rule.options.parent; // It is a ref to a local rule.
    if (className[0] === "$") {
        var refRule = parent.getRule(className.substr(1));
        if (!refRule) return false;
        if (refRule === rule) return false;
        parent.classes[rule.key] += " " + parent.classes[refRule.key];
        return true;
    }
    parent.classes[rule.key] += " " + className;
    return true;
}
/**
 * Convert compose property to additional class, remove property from original styles.
 */ function $5d4b96abaa7b78e9$var$jssCompose() {
    function onProcessStyle(style, rule) {
        if (!("composes" in style)) return style;
        $5d4b96abaa7b78e9$var$registerClass(rule, style.composes); // Remove composes property to prevent infinite loop.
        delete style.composes;
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $5d4b96abaa7b78e9$export$2e2bcd8739ae039 = $5d4b96abaa7b78e9$var$jssCompose;


/* eslint-disable no-var, prefer-template */ var $0ff0bfc26ba44f29$var$uppercasePattern = /[A-Z]/g;
var $0ff0bfc26ba44f29$var$msPattern = /^ms-/;
var $0ff0bfc26ba44f29$var$cache = {};
function $0ff0bfc26ba44f29$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $0ff0bfc26ba44f29$var$hyphenateStyleName(name) {
    if ($0ff0bfc26ba44f29$var$cache.hasOwnProperty(name)) return $0ff0bfc26ba44f29$var$cache[name];
    var hName = name.replace($0ff0bfc26ba44f29$var$uppercasePattern, $0ff0bfc26ba44f29$var$toHyphenLower);
    return $0ff0bfc26ba44f29$var$cache[name] = $0ff0bfc26ba44f29$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $0ff0bfc26ba44f29$export$2e2bcd8739ae039 = $0ff0bfc26ba44f29$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $4d57a7ec76f96997$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $0ff0bfc26ba44f29$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($4d57a7ec76f96997$var$convertCase);
        else converted.fallbacks = $4d57a7ec76f96997$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $4d57a7ec76f96997$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $4d57a7ec76f96997$var$convertCase(style[index]);
            return style;
        }
        return $4d57a7ec76f96997$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $0ff0bfc26ba44f29$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $4d57a7ec76f96997$export$2e2bcd8739ae039 = $4d57a7ec76f96997$var$camelCase;



var $702382a92195133c$var$px = (0, $f9c08e91c2468f05$export$2305122a7d881dec) && CSS ? CSS.px : "px";
var $702382a92195133c$var$ms = (0, $f9c08e91c2468f05$export$2305122a7d881dec) && CSS ? CSS.ms : "ms";
var $702382a92195133c$var$percent = (0, $f9c08e91c2468f05$export$2305122a7d881dec) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $702382a92195133c$var$defaultUnits = {
    // Animation properties
    "animation-delay": $702382a92195133c$var$ms,
    "animation-duration": $702382a92195133c$var$ms,
    // Background properties
    "background-position": $702382a92195133c$var$px,
    "background-position-x": $702382a92195133c$var$px,
    "background-position-y": $702382a92195133c$var$px,
    "background-size": $702382a92195133c$var$px,
    // Border Properties
    border: $702382a92195133c$var$px,
    "border-bottom": $702382a92195133c$var$px,
    "border-bottom-left-radius": $702382a92195133c$var$px,
    "border-bottom-right-radius": $702382a92195133c$var$px,
    "border-bottom-width": $702382a92195133c$var$px,
    "border-left": $702382a92195133c$var$px,
    "border-left-width": $702382a92195133c$var$px,
    "border-radius": $702382a92195133c$var$px,
    "border-right": $702382a92195133c$var$px,
    "border-right-width": $702382a92195133c$var$px,
    "border-top": $702382a92195133c$var$px,
    "border-top-left-radius": $702382a92195133c$var$px,
    "border-top-right-radius": $702382a92195133c$var$px,
    "border-top-width": $702382a92195133c$var$px,
    "border-width": $702382a92195133c$var$px,
    "border-block": $702382a92195133c$var$px,
    "border-block-end": $702382a92195133c$var$px,
    "border-block-end-width": $702382a92195133c$var$px,
    "border-block-start": $702382a92195133c$var$px,
    "border-block-start-width": $702382a92195133c$var$px,
    "border-block-width": $702382a92195133c$var$px,
    "border-inline": $702382a92195133c$var$px,
    "border-inline-end": $702382a92195133c$var$px,
    "border-inline-end-width": $702382a92195133c$var$px,
    "border-inline-start": $702382a92195133c$var$px,
    "border-inline-start-width": $702382a92195133c$var$px,
    "border-inline-width": $702382a92195133c$var$px,
    "border-start-start-radius": $702382a92195133c$var$px,
    "border-start-end-radius": $702382a92195133c$var$px,
    "border-end-start-radius": $702382a92195133c$var$px,
    "border-end-end-radius": $702382a92195133c$var$px,
    // Margin properties
    margin: $702382a92195133c$var$px,
    "margin-bottom": $702382a92195133c$var$px,
    "margin-left": $702382a92195133c$var$px,
    "margin-right": $702382a92195133c$var$px,
    "margin-top": $702382a92195133c$var$px,
    "margin-block": $702382a92195133c$var$px,
    "margin-block-end": $702382a92195133c$var$px,
    "margin-block-start": $702382a92195133c$var$px,
    "margin-inline": $702382a92195133c$var$px,
    "margin-inline-end": $702382a92195133c$var$px,
    "margin-inline-start": $702382a92195133c$var$px,
    // Padding properties
    padding: $702382a92195133c$var$px,
    "padding-bottom": $702382a92195133c$var$px,
    "padding-left": $702382a92195133c$var$px,
    "padding-right": $702382a92195133c$var$px,
    "padding-top": $702382a92195133c$var$px,
    "padding-block": $702382a92195133c$var$px,
    "padding-block-end": $702382a92195133c$var$px,
    "padding-block-start": $702382a92195133c$var$px,
    "padding-inline": $702382a92195133c$var$px,
    "padding-inline-end": $702382a92195133c$var$px,
    "padding-inline-start": $702382a92195133c$var$px,
    // Mask properties
    "mask-position-x": $702382a92195133c$var$px,
    "mask-position-y": $702382a92195133c$var$px,
    "mask-size": $702382a92195133c$var$px,
    // Width and height properties
    height: $702382a92195133c$var$px,
    width: $702382a92195133c$var$px,
    "min-height": $702382a92195133c$var$px,
    "max-height": $702382a92195133c$var$px,
    "min-width": $702382a92195133c$var$px,
    "max-width": $702382a92195133c$var$px,
    // Position properties
    bottom: $702382a92195133c$var$px,
    left: $702382a92195133c$var$px,
    top: $702382a92195133c$var$px,
    right: $702382a92195133c$var$px,
    inset: $702382a92195133c$var$px,
    "inset-block": $702382a92195133c$var$px,
    "inset-block-end": $702382a92195133c$var$px,
    "inset-block-start": $702382a92195133c$var$px,
    "inset-inline": $702382a92195133c$var$px,
    "inset-inline-end": $702382a92195133c$var$px,
    "inset-inline-start": $702382a92195133c$var$px,
    // Shadow properties
    "box-shadow": $702382a92195133c$var$px,
    "text-shadow": $702382a92195133c$var$px,
    // Column properties
    "column-gap": $702382a92195133c$var$px,
    "column-rule": $702382a92195133c$var$px,
    "column-rule-width": $702382a92195133c$var$px,
    "column-width": $702382a92195133c$var$px,
    // Font and text properties
    "font-size": $702382a92195133c$var$px,
    "font-size-delta": $702382a92195133c$var$px,
    "letter-spacing": $702382a92195133c$var$px,
    "text-decoration-thickness": $702382a92195133c$var$px,
    "text-indent": $702382a92195133c$var$px,
    "text-stroke": $702382a92195133c$var$px,
    "text-stroke-width": $702382a92195133c$var$px,
    "word-spacing": $702382a92195133c$var$px,
    // Motion properties
    motion: $702382a92195133c$var$px,
    "motion-offset": $702382a92195133c$var$px,
    // Outline properties
    outline: $702382a92195133c$var$px,
    "outline-offset": $702382a92195133c$var$px,
    "outline-width": $702382a92195133c$var$px,
    // Perspective properties
    perspective: $702382a92195133c$var$px,
    "perspective-origin-x": $702382a92195133c$var$percent,
    "perspective-origin-y": $702382a92195133c$var$percent,
    // Transform properties
    "transform-origin": $702382a92195133c$var$percent,
    "transform-origin-x": $702382a92195133c$var$percent,
    "transform-origin-y": $702382a92195133c$var$percent,
    "transform-origin-z": $702382a92195133c$var$percent,
    // Transition properties
    "transition-delay": $702382a92195133c$var$ms,
    "transition-duration": $702382a92195133c$var$ms,
    // Alignment properties
    "vertical-align": $702382a92195133c$var$px,
    "flex-basis": $702382a92195133c$var$px,
    // Some random properties
    "shape-margin": $702382a92195133c$var$px,
    size: $702382a92195133c$var$px,
    gap: $702382a92195133c$var$px,
    // Grid properties
    grid: $702382a92195133c$var$px,
    "grid-gap": $702382a92195133c$var$px,
    "row-gap": $702382a92195133c$var$px,
    "grid-row-gap": $702382a92195133c$var$px,
    "grid-column-gap": $702382a92195133c$var$px,
    "grid-template-rows": $702382a92195133c$var$px,
    "grid-template-columns": $702382a92195133c$var$px,
    "grid-auto-rows": $702382a92195133c$var$px,
    "grid-auto-columns": $702382a92195133c$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $702382a92195133c$var$px,
    "box-shadow-y": $702382a92195133c$var$px,
    "box-shadow-blur": $702382a92195133c$var$px,
    "box-shadow-spread": $702382a92195133c$var$px,
    "font-line-height": $702382a92195133c$var$px,
    "text-shadow-x": $702382a92195133c$var$px,
    "text-shadow-y": $702382a92195133c$var$px,
    "text-shadow-blur": $702382a92195133c$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $702382a92195133c$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $702382a92195133c$var$units = $702382a92195133c$var$addCamelCasedVersion($702382a92195133c$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $702382a92195133c$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $702382a92195133c$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $702382a92195133c$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $702382a92195133c$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $702382a92195133c$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $702382a92195133c$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $702382a92195133c$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $702382a92195133c$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $702382a92195133c$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $702382a92195133c$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $702382a92195133c$export$2e2bcd8739ae039 = $702382a92195133c$var$defaultUnit;


/**
 * A scheme for converting properties from array to regular style.
 * All properties listed below will be transformed to a string separated by space.
 */ var $c9812094e0c1722f$var$propArray = {
    "background-size": true,
    "background-position": true,
    border: true,
    "border-bottom": true,
    "border-left": true,
    "border-top": true,
    "border-right": true,
    "border-radius": true,
    "border-image": true,
    "border-width": true,
    "border-style": true,
    "border-color": true,
    "box-shadow": true,
    flex: true,
    margin: true,
    padding: true,
    outline: true,
    "transform-origin": true,
    transform: true,
    transition: true
};
var $c9812094e0c1722f$var$propArrayInObj = {
    position: true,
    // background-position
    size: true // background-size
};
var $c9812094e0c1722f$var$propObj = {
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    background: {
        attachment: null,
        color: null,
        image: null,
        position: null,
        repeat: null
    },
    border: {
        width: null,
        style: null,
        color: null
    },
    "border-top": {
        width: null,
        style: null,
        color: null
    },
    "border-right": {
        width: null,
        style: null,
        color: null
    },
    "border-bottom": {
        width: null,
        style: null,
        color: null
    },
    "border-left": {
        width: null,
        style: null,
        color: null
    },
    outline: {
        width: null,
        style: null,
        color: null
    },
    "list-style": {
        type: null,
        position: null,
        image: null
    },
    transition: {
        property: null,
        duration: null,
        "timing-function": null,
        timingFunction: null,
        // Needed for avoiding comilation issues with jss-plugin-camel-case
        delay: null
    },
    animation: {
        name: null,
        duration: null,
        "timing-function": null,
        timingFunction: null,
        // Needed to avoid compilation issues with jss-plugin-camel-case
        delay: null,
        "iteration-count": null,
        iterationCount: null,
        // Needed to avoid compilation issues with jss-plugin-camel-case
        direction: null,
        "fill-mode": null,
        fillMode: null,
        // Needed to avoid compilation issues with jss-plugin-camel-case
        "play-state": null,
        playState: null // Needed to avoid compilation issues with jss-plugin-camel-case
    },
    "box-shadow": {
        x: 0,
        y: 0,
        blur: 0,
        spread: 0,
        color: null,
        inset: null
    },
    "text-shadow": {
        x: 0,
        y: 0,
        blur: null,
        color: null
    }
};
var $c9812094e0c1722f$var$customPropObj = {
    border: {
        radius: "border-radius",
        image: "border-image",
        width: "border-width",
        style: "border-style",
        color: "border-color"
    },
    "border-bottom": {
        width: "border-bottom-width",
        style: "border-bottom-style",
        color: "border-bottom-color"
    },
    "border-top": {
        width: "border-top-width",
        style: "border-top-style",
        color: "border-top-color"
    },
    "border-left": {
        width: "border-left-width",
        style: "border-left-style",
        color: "border-left-color"
    },
    "border-right": {
        width: "border-right-width",
        style: "border-right-style",
        color: "border-right-color"
    },
    background: {
        size: "background-size",
        image: "background-image"
    },
    font: {
        style: "font-style",
        variant: "font-variant",
        weight: "font-weight",
        stretch: "font-stretch",
        size: "font-size",
        family: "font-family",
        lineHeight: "line-height",
        // Needed to avoid compilation issues with jss-plugin-camel-case
        "line-height": "line-height"
    },
    flex: {
        grow: "flex-grow",
        basis: "flex-basis",
        direction: "flex-direction",
        wrap: "flex-wrap",
        flow: "flex-flow",
        shrink: "flex-shrink"
    },
    align: {
        self: "align-self",
        items: "align-items",
        content: "align-content"
    },
    grid: {
        "template-columns": "grid-template-columns",
        templateColumns: "grid-template-columns",
        "template-rows": "grid-template-rows",
        templateRows: "grid-template-rows",
        "template-areas": "grid-template-areas",
        templateAreas: "grid-template-areas",
        template: "grid-template",
        "auto-columns": "grid-auto-columns",
        autoColumns: "grid-auto-columns",
        "auto-rows": "grid-auto-rows",
        autoRows: "grid-auto-rows",
        "auto-flow": "grid-auto-flow",
        autoFlow: "grid-auto-flow",
        row: "grid-row",
        column: "grid-column",
        "row-start": "grid-row-start",
        rowStart: "grid-row-start",
        "row-end": "grid-row-end",
        rowEnd: "grid-row-end",
        "column-start": "grid-column-start",
        columnStart: "grid-column-start",
        "column-end": "grid-column-end",
        columnEnd: "grid-column-end",
        area: "grid-area",
        gap: "grid-gap",
        "row-gap": "grid-row-gap",
        rowGap: "grid-row-gap",
        "column-gap": "grid-column-gap",
        columnGap: "grid-column-gap"
    }
};
/* eslint-disable no-use-before-define */ /**
 * Map values by given prop.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {String} original rule
 * @return {String} mapped values
 */ function $c9812094e0c1722f$var$mapValuesByProp(value, prop, rule) {
    return value.map(function(item) {
        return $c9812094e0c1722f$var$objectToArray(item, prop, rule, false, true);
    });
}
/**
 * Convert array to nested array, if needed
 */ function $c9812094e0c1722f$var$processArray(value, prop, scheme, rule) {
    if (scheme[prop] == null) return value;
    if (value.length === 0) return [];
    if (Array.isArray(value[0])) return $c9812094e0c1722f$var$processArray(value[0], prop, scheme, rule);
    if (typeof value[0] === "object") return $c9812094e0c1722f$var$mapValuesByProp(value, prop, rule);
    return [
        value
    ];
}
/**
 * Convert object to array.
 */ function $c9812094e0c1722f$var$objectToArray(value, prop, rule, isFallback, isInArray) {
    if (!($c9812094e0c1722f$var$propObj[prop] || $c9812094e0c1722f$var$customPropObj[prop])) return [];
    var result = []; // Check if exists any non-standard property
    if ($c9812094e0c1722f$var$customPropObj[prop]) // eslint-disable-next-line no-param-reassign
    value = $c9812094e0c1722f$var$customPropsToStyle(value, rule, $c9812094e0c1722f$var$customPropObj[prop], isFallback);
     // Pass throught all standart props
    if (Object.keys(value).length) for(var baseProp in $c9812094e0c1722f$var$propObj[prop]){
        if (value[baseProp]) {
            if (Array.isArray(value[baseProp])) result.push($c9812094e0c1722f$var$propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(" "));
            else result.push(value[baseProp]);
            continue;
        } // Add default value from props config.
        if ($c9812094e0c1722f$var$propObj[prop][baseProp] != null) result.push($c9812094e0c1722f$var$propObj[prop][baseProp]);
    }
    if (!result.length || isInArray) return result;
    return [
        result
    ];
}
/**
 * Convert custom properties values to styles adding them to rule directly
 */ function $c9812094e0c1722f$var$customPropsToStyle(value, rule, customProps, isFallback) {
    for(var prop in customProps){
        var propName = customProps[prop]; // If current property doesn't exist already in rule - add new one
        if (typeof value[prop] !== "undefined" && (isFallback || !rule.prop(propName))) {
            var _styleDetector;
            var appendedValue = $c9812094e0c1722f$var$styleDetector((_styleDetector = {}, _styleDetector[propName] = value[prop], _styleDetector), rule)[propName]; // Add style directly in rule
            if (isFallback) rule.style.fallbacks[propName] = appendedValue;
            else rule.style[propName] = appendedValue;
        } // Delete converted property to avoid double converting
        delete value[prop];
    }
    return value;
}
/**
 * Detect if a style needs to be converted.
 */ function $c9812094e0c1722f$var$styleDetector(style, rule, isFallback) {
    for(var prop in style){
        var value = style[prop];
        if (Array.isArray(value)) // Check double arrays to avoid recursion.
        {
            if (!Array.isArray(value[0])) {
                if (prop === "fallbacks") {
                    for(var index = 0; index < style.fallbacks.length; index++)style.fallbacks[index] = $c9812094e0c1722f$var$styleDetector(style.fallbacks[index], rule, true);
                    continue;
                }
                style[prop] = $c9812094e0c1722f$var$processArray(value, prop, $c9812094e0c1722f$var$propArray, rule); // Avoid creating properties with empty values
                if (!style[prop].length) delete style[prop];
            }
        } else if (typeof value === "object") {
            if (prop === "fallbacks") {
                style.fallbacks = $c9812094e0c1722f$var$styleDetector(style.fallbacks, rule, true);
                continue;
            }
            style[prop] = $c9812094e0c1722f$var$objectToArray(value, prop, rule, isFallback); // Avoid creating properties with empty values
            if (!style[prop].length) delete style[prop];
        } else if (style[prop] === "") delete style[prop];
    }
    return style;
}
/**
 * Adds possibility to write expanded styles.
 */ function $c9812094e0c1722f$var$jssExpand() {
    function onProcessStyle(style, rule) {
        if (!style || rule.type !== "style") return style;
        if (Array.isArray(style)) {
            // Pass rules one by one and reformat them
            for(var index = 0; index < style.length; index++)style[index] = $c9812094e0c1722f$var$styleDetector(style[index], rule);
            return style;
        }
        return $c9812094e0c1722f$var$styleDetector(style, rule);
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $c9812094e0c1722f$export$2e2bcd8739ae039 = $c9812094e0c1722f$var$jssExpand;



function $9031f7f2924753e9$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $63b81041f3d12ee7$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(arr);
}


function $90a8d1a06a2704aa$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $708ce1d4f20bd938$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(o, minLen);
}


function $1ceafd62b5589195$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e8694aff92b422dc$export$2e2bcd8739ae039(arr) {
    return (0, $63b81041f3d12ee7$export$2e2bcd8739ae039)(arr) || (0, $90a8d1a06a2704aa$export$2e2bcd8739ae039)(arr) || (0, $708ce1d4f20bd938$export$2e2bcd8739ae039)(arr) || (0, $1ceafd62b5589195$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $b26a91ccc30c45c7$var$js = "";
var $b26a91ccc30c45c7$var$css = "";
var $b26a91ccc30c45c7$var$vendor = "";
var $b26a91ccc30c45c7$var$browser = "";
var $b26a91ccc30c45c7$var$isTouch = (0, $90505e58c00ce0c9$export$2e2bcd8739ae039) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $90505e58c00ce0c9$export$2e2bcd8739ae039) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $b26a91ccc30c45c7$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $b26a91ccc30c45c7$var$_document$createEleme = document.createElement("p"), $b26a91ccc30c45c7$var$style = $b26a91ccc30c45c7$var$_document$createEleme.style;
    var $b26a91ccc30c45c7$var$testProp = "Transform";
    for(var $b26a91ccc30c45c7$var$key in $b26a91ccc30c45c7$var$jsCssMap)if ($b26a91ccc30c45c7$var$key + $b26a91ccc30c45c7$var$testProp in $b26a91ccc30c45c7$var$style) {
        $b26a91ccc30c45c7$var$js = $b26a91ccc30c45c7$var$key;
        $b26a91ccc30c45c7$var$css = $b26a91ccc30c45c7$var$jsCssMap[$b26a91ccc30c45c7$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($b26a91ccc30c45c7$var$js === "Webkit" && "msHyphens" in $b26a91ccc30c45c7$var$style) {
        $b26a91ccc30c45c7$var$js = "ms";
        $b26a91ccc30c45c7$var$css = $b26a91ccc30c45c7$var$jsCssMap.ms;
        $b26a91ccc30c45c7$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($b26a91ccc30c45c7$var$js === "Webkit" && "-apple-trailing-word" in $b26a91ccc30c45c7$var$style) $b26a91ccc30c45c7$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $b26a91ccc30c45c7$export$82e9f45cca5ba907 = {
    js: $b26a91ccc30c45c7$var$js,
    css: $b26a91ccc30c45c7$var$css,
    vendor: $b26a91ccc30c45c7$var$vendor,
    browser: $b26a91ccc30c45c7$var$browser,
    isTouch: $b26a91ccc30c45c7$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $b26a91ccc30c45c7$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $b26a91ccc30c45c7$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $b26a91ccc30c45c7$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Webkit") return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $b26a91ccc30c45c7$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $b26a91ccc30c45c7$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $b26a91ccc30c45c7$var$camelize(str) {
    return str.replace($b26a91ccc30c45c7$var$regExp, $b26a91ccc30c45c7$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $b26a91ccc30c45c7$var$pascalize(str) {
    return $b26a91ccc30c45c7$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $b26a91ccc30c45c7$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($b26a91ccc30c45c7$var$camelize(longhand) in style) return prop;
            if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(longhand) in style) return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $b26a91ccc30c45c7$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.vendor === "apple" && !$b26a91ccc30c45c7$export$82e9f45cca5ba907.isTouch) return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $b26a91ccc30c45c7$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $b26a91ccc30c45c7$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $b26a91ccc30c45c7$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Webkit" || $b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms" && $b26a91ccc30c45c7$export$82e9f45cca5ba907.browser !== "edge") return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $b26a91ccc30c45c7$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Moz" || $b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms" || $b26a91ccc30c45c7$export$82e9f45cca5ba907.vendor === "apple") return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $b26a91ccc30c45c7$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $b26a91ccc30c45c7$var$pascalize(prop);
            return jsProp in style ? $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $b26a91ccc30c45c7$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $b26a91ccc30c45c7$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(newProp) in style ? $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $b26a91ccc30c45c7$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $b26a91ccc30c45c7$var$camelize(prop) in style ? prop : false;
    }
};
var $b26a91ccc30c45c7$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $b26a91ccc30c45c7$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js + pascalized in style) return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $b26a91ccc30c45c7$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms") return "" + $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $b26a91ccc30c45c7$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms") return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $b26a91ccc30c45c7$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $b26a91ccc30c45c7$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $b26a91ccc30c45c7$var$propMap[prop];
        if (!newProp) return false;
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(newProp) in style ? $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $b26a91ccc30c45c7$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $b26a91ccc30c45c7$var$propKeys = Object.keys($b26a91ccc30c45c7$var$propMap$1);
var $b26a91ccc30c45c7$var$prefixCss = function prefixCss(p) {
    return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $b26a91ccc30c45c7$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($b26a91ccc30c45c7$var$propKeys.indexOf(prop) > -1) {
            var newProp = $b26a91ccc30c45c7$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(newProp) in style ? $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($b26a91ccc30c45c7$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $b26a91ccc30c45c7$var$plugins = [
    $b26a91ccc30c45c7$var$appearence,
    $b26a91ccc30c45c7$var$colorAdjust,
    $b26a91ccc30c45c7$var$mask,
    $b26a91ccc30c45c7$var$textOrientation,
    $b26a91ccc30c45c7$var$transform,
    $b26a91ccc30c45c7$var$transition,
    $b26a91ccc30c45c7$var$writingMode,
    $b26a91ccc30c45c7$var$userSelect,
    $b26a91ccc30c45c7$var$breakPropsOld,
    $b26a91ccc30c45c7$var$inlineLogicalOld,
    $b26a91ccc30c45c7$var$unprefixed,
    $b26a91ccc30c45c7$var$prefixed,
    $b26a91ccc30c45c7$var$scrollSnap,
    $b26a91ccc30c45c7$var$overscrollBehavior,
    $b26a91ccc30c45c7$var$flex2012,
    $b26a91ccc30c45c7$var$flex2009
];
var $b26a91ccc30c45c7$var$propertyDetectors = $b26a91ccc30c45c7$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $b26a91ccc30c45c7$var$noPrefill = $b26a91ccc30c45c7$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $e8694aff92b422dc$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $b26a91ccc30c45c7$var$el;
var $b26a91ccc30c45c7$var$cache = {};
if (0, $90505e58c00ce0c9$export$2e2bcd8739ae039) {
    $b26a91ccc30c45c7$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $b26a91ccc30c45c7$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $b26a91ccc30c45c7$var$key$1 in $b26a91ccc30c45c7$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($b26a91ccc30c45c7$var$key$1)) $b26a91ccc30c45c7$var$cache[$b26a91ccc30c45c7$var$computed[$b26a91ccc30c45c7$var$key$1]] = $b26a91ccc30c45c7$var$computed[$b26a91ccc30c45c7$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $b26a91ccc30c45c7$var$noPrefill.forEach(function(x) {
        return delete $b26a91ccc30c45c7$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $b26a91ccc30c45c7$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$b26a91ccc30c45c7$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($b26a91ccc30c45c7$var$cache[prop] != null) return $b26a91ccc30c45c7$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $b26a91ccc30c45c7$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $b26a91ccc30c45c7$var$propertyDetectors.length; i++){
        $b26a91ccc30c45c7$var$cache[prop] = $b26a91ccc30c45c7$var$propertyDetectors[i](prop, $b26a91ccc30c45c7$var$el.style, options); // Break loop, if value found.
        if ($b26a91ccc30c45c7$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $b26a91ccc30c45c7$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $b26a91ccc30c45c7$var$cache[prop];
}
var $b26a91ccc30c45c7$var$cache$1 = {};
var $b26a91ccc30c45c7$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $b26a91ccc30c45c7$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $b26a91ccc30c45c7$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $b26a91ccc30c45c7$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $b26a91ccc30c45c7$export$ce097f82c2e4551a(p1) : ", " + $b26a91ccc30c45c7$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $90505e58c00ce0c9$export$2e2bcd8739ae039) $b26a91ccc30c45c7$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $b26a91ccc30c45c7$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$b26a91ccc30c45c7$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($b26a91ccc30c45c7$var$cache$1[cacheKey] != null) return $b26a91ccc30c45c7$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $b26a91ccc30c45c7$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $b26a91ccc30c45c7$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($b26a91ccc30c45c7$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($b26a91ccc30c45c7$var$transPropsRegExp, $b26a91ccc30c45c7$var$prefixTransitionCallback);
    else if ($b26a91ccc30c45c7$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $b26a91ccc30c45c7$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $b26a91ccc30c45c7$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($b26a91ccc30c45c7$var$el$1.style[property] === "") {
            $b26a91ccc30c45c7$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $b26a91ccc30c45c7$var$el$1.style[property] = ""; // Write current value to cache.
    $b26a91ccc30c45c7$var$cache$1[cacheKey] = prefixedValue;
    return $b26a91ccc30c45c7$var$cache$1[cacheKey];
}



/**
 * Add vendor prefix to a property name when needed.
 */ function $c13f6150388ba631$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $b26a91ccc30c45c7$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $b26a91ccc30c45c7$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $b26a91ccc30c45c7$export$511766124059c277)(supportedProp, (0, $f9c08e91c2468f05$export$5ac341d5e3cf9273)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $b26a91ccc30c45c7$export$511766124059c277)(prop, (0, $f9c08e91c2468f05$export$5ac341d5e3cf9273)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $c13f6150388ba631$export$2e2bcd8739ae039 = $c13f6150388ba631$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $5d47eb7841bd32ac$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $5d47eb7841bd32ac$export$2e2bcd8739ae039 = $5d47eb7841bd32ac$var$jssPropsSort;


var $8351833f7e7605ba$var$create = function create(options) {
    if (options === void 0) options = {};
    return {
        plugins: [
            (0, $fc8f730b382434f1$export$2e2bcd8739ae039)(),
            (0, $6e7a4a64d784029e$export$2e2bcd8739ae039)(options.observable),
            (0, $42f95bf6e0d55fce$export$2e2bcd8739ae039)(),
            (0, $9a0b09d8df48aadc$export$2e2bcd8739ae039)(),
            (0, $5bf5891680f95795$export$2e2bcd8739ae039)(),
            (0, $01f99ad62fc1fd6d$export$2e2bcd8739ae039)(),
            (0, $5d4b96abaa7b78e9$export$2e2bcd8739ae039)(),
            (0, $4d57a7ec76f96997$export$2e2bcd8739ae039)(),
            (0, $702382a92195133c$export$2e2bcd8739ae039)(options.defaultUnit),
            (0, $c9812094e0c1722f$export$2e2bcd8739ae039)(),
            (0, $c13f6150388ba631$export$2e2bcd8739ae039)(),
            (0, $5d47eb7841bd32ac$export$2e2bcd8739ae039)()
        ]
    };
};
var $8351833f7e7605ba$export$2e2bcd8739ae039 = $8351833f7e7605ba$var$create;


function $60736e760047e4b2$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $60736e760047e4b2$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    var len = arrA.length;
    if (arrB.length !== len) return false;
    for(var i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}



var $fjRTt = parcelRequire("fjRTt");


// Since we are in a single sheet mode, user shouldn't care about this.
var $deac06e643c1fc55$var$MAX_RULES_PER_SHEET = 10000;
var $deac06e643c1fc55$var$defaultJss = (0, $f9c08e91c2468f05$export$185802fd694ee1f5)((0, $8351833f7e7605ba$export$2e2bcd8739ae039)());
var $deac06e643c1fc55$export$185802fd694ee1f5 = function createCss(jss) {
    if (jss === void 0) jss = $deac06e643c1fc55$var$defaultJss;
    var cache = new Map();
    var ruleIndex = 0;
    var sheet;
    var getSheet = function getSheet() {
        if (!sheet || sheet.rules.index.length > $deac06e643c1fc55$var$MAX_RULES_PER_SHEET) sheet = jss.createStyleSheet().attach();
        return sheet;
    };
    function css() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments; // We can avoid the need for stringification with a babel plugin,
        // which could generate a hash at build time and add it to the object.
        var argsStr = JSON.stringify(args);
        var cached = cache.get(argsStr);
        if (cached) return cached.className;
        var flatArgs = []; // Flatten arguments which can be
        // - style objects
        // - array of style objects
        // - arrays of style objects
        for(var argIndex in args){
            var arg = args[argIndex];
            if (!Array.isArray(arg)) {
                flatArgs.push(arg);
                continue;
            }
            for(var innerArgIndex = 0; innerArgIndex < arg.length; innerArgIndex++)flatArgs.push(arg[innerArgIndex]);
        }
        var mergedStyle = {};
        var labels = [];
        for(var i = 0; i < flatArgs.length; i++){
            var style = flatArgs[i];
            if (!style) continue;
            var styleObject = style; // It can be a class name that css() has previously generated.
            if (typeof style === "string") {
                // eslint-disable-next-line no-shadow
                var _cached = cache.get(style);
                if (_cached) {
                    // eslint-disable-next-line prefer-spread
                    if (_cached.labels.length) labels.push.apply(labels, _cached.labels);
                    styleObject = _cached.style;
                }
            }
            if (styleObject.label && labels.indexOf(styleObject.label) === -1) labels.push(styleObject.label);
            Object.assign(mergedStyle, styleObject);
        }
        delete mergedStyle.label;
        var label = labels.length === 0 ? "css" : labels.join("-");
        var key = label + "-" + ruleIndex++;
        getSheet().addRule(key, mergedStyle);
        var className = getSheet().classes[key];
        var cacheValue = {
            style: mergedStyle,
            labels: labels,
            className: className
        };
        cache.set(argsStr, cacheValue);
        cache.set(className, cacheValue);
        return className;
    } // For testing only.
    css.getSheet = getSheet;
    return css;
};
var $deac06e643c1fc55$var$css = $deac06e643c1fc55$export$185802fd694ee1f5();
var $deac06e643c1fc55$export$2e2bcd8739ae039 = $deac06e643c1fc55$var$css;


var $e1604d12639183a7$var$getDisplayName = function getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
};
var $e1604d12639183a7$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (Array.isArray(lastArgs) && args.length === lastArgs.length) {
            var isSame = true;
            for(var i = 0; i < args.length; i++)if (args[i] !== lastArgs[i]) isSame = false;
            if (isSame) return lastResult;
        }
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};
var $e1604d12639183a7$var$mergeClasses = function mergeClasses(baseClasses, additionalClasses) {
    var combinedClasses = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, baseClasses);
    for(var name in additionalClasses)combinedClasses[name] = name in combinedClasses ? combinedClasses[name] + " " + additionalClasses[name] : additionalClasses[name];
    return combinedClasses;
};
/**
 * Global index counter to preserve source order.
 * As we create the style sheet during componentWillMount lifecycle,
 * children are handled after the parents, so the order of style elements would
 * be parent->child. It is a problem though when a parent passes a className
 * which needs to override any childs styles. StyleSheet of the child has a higher
 * specificity, because of the source order.
 * So our solution is to render sheets them in the reverse order child->sheet, so
 * that parent has a higher specificity.
 *
 * We start at [Number.MIN_SAFE_INTEGER] to always insert sheets from react-jss first before any
 * sheet which might be inserted manually by the user.
 */ var $e1604d12639183a7$var$index = Number.MIN_SAFE_INTEGER || -1000000000;
var $e1604d12639183a7$var$getSheetIndex = function getSheetIndex() {
    return $e1604d12639183a7$var$index++;
};
var $e1604d12639183a7$export$193e6193848b8f2a = (0, $bh6RR.createContext)({
    classNamePrefix: "",
    disableStylesGeneration: false,
    isSSR: !(0, $90505e58c00ce0c9$export$2e2bcd8739ae039)
});
var $e1604d12639183a7$var$defaultManagers = new Map();
var $e1604d12639183a7$var$getManager = function getManager(context, managerId) {
    // If `managers` map is present in the context, we use it in order to
    // let JssProvider reset them when new response has to render server-side.
    var managers = context.managers;
    if (managers) {
        if (!managers[managerId]) managers[managerId] = new (0, $f9c08e91c2468f05$export$c72bb5031d779271)();
        return managers[managerId];
    }
    var manager = $e1604d12639183a7$var$defaultManagers.get(managerId);
    if (!manager) {
        manager = new (0, $f9c08e91c2468f05$export$c72bb5031d779271)();
        $e1604d12639183a7$var$defaultManagers.set(managerId, manager);
    }
    return manager;
};
var $e1604d12639183a7$var$manageSheet = function manageSheet(options) {
    var sheet = options.sheet, context = options.context, index = options.index, theme = options.theme;
    if (!sheet) return;
    var manager = $e1604d12639183a7$var$getManager(context, index);
    manager.manage(theme);
    if (context.registry) context.registry.add(sheet);
};
var $e1604d12639183a7$var$unmanageSheet = function unmanageSheet(options) {
    if (!options.sheet) return;
    var manager = $e1604d12639183a7$var$getManager(options.context, options.index);
    manager.unmanage(options.theme);
};
var $e1604d12639183a7$export$da211f3899f3fa9c = (0, $f9c08e91c2468f05$export$185802fd694ee1f5)((0, $8351833f7e7605ba$export$2e2bcd8739ae039)());
var $e1604d12639183a7$var$sheetsMeta = new WeakMap();
var $e1604d12639183a7$var$getMeta = function getMeta(sheet) {
    return $e1604d12639183a7$var$sheetsMeta.get(sheet);
};
var $e1604d12639183a7$var$addMeta = function addMeta(sheet, meta) {
    $e1604d12639183a7$var$sheetsMeta.set(sheet, meta);
};
var $e1604d12639183a7$var$getStyles = function getStyles(options) {
    var styles = options.styles;
    if (typeof styles !== "function") return styles;
    return styles(options.theme);
};
function $e1604d12639183a7$var$getSheetOptions(options, link) {
    var minify;
    if (options.context.id && options.context.id.minify != null) minify = options.context.id.minify;
    var classNamePrefix = options.context.classNamePrefix || "";
    if (options.name && !minify) classNamePrefix += options.name.replace(/\s/g, "-") + "-";
    var meta = "";
    if (options.name) meta = options.name + ", ";
    meta += typeof options.styles === "function" ? "Themed" : "Unthemed";
    return (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, options.sheetOptions, {
        index: options.index,
        meta: meta,
        classNamePrefix: classNamePrefix,
        link: link,
        generateId: options.sheetOptions && options.sheetOptions.generateId ? options.sheetOptions.generateId : options.context.generateId
    });
}
var $e1604d12639183a7$var$createStyleSheet = function createStyleSheet(options) {
    if (options.context.disableStylesGeneration) return undefined;
    var manager = $e1604d12639183a7$var$getManager(options.context, options.index);
    var existingSheet = manager.get(options.theme);
    if (existingSheet) return existingSheet;
    var jss = options.context.jss || $e1604d12639183a7$export$da211f3899f3fa9c;
    var styles = $e1604d12639183a7$var$getStyles(options);
    var dynamicStyles = (0, $f9c08e91c2468f05$export$8558f2aefa046992)(styles);
    var sheet = jss.createStyleSheet(styles, $e1604d12639183a7$var$getSheetOptions(options, dynamicStyles !== null));
    $e1604d12639183a7$var$addMeta(sheet, {
        dynamicStyles: dynamicStyles,
        styles: styles
    });
    manager.add(options.theme, sheet);
    return sheet;
};
var $e1604d12639183a7$var$removeDynamicRules = function removeDynamicRules(sheet, rules) {
    // Loop over each dynamic rule and remove the dynamic rule
    // We can't just remove the whole sheet as this has all of the rules for every component instance
    for(var key in rules)sheet.deleteRule(rules[key]);
};
var $e1604d12639183a7$var$updateDynamicRules = function updateDynamicRules(data, sheet, rules) {
    // Loop over each dynamic rule and update it
    // We can't just update the whole sheet as this has all of the rules for every component instance
    for(var key in rules)sheet.updateOne(rules[key], data);
};
var $e1604d12639183a7$var$addDynamicRules = function addDynamicRules(sheet, data) {
    var meta = $e1604d12639183a7$var$getMeta(sheet);
    if (!meta) return undefined;
    var rules = {}; // Loop over each dynamic rule and add it to the stylesheet
    for(var key in meta.dynamicStyles){
        var initialRuleCount = sheet.rules.index.length;
        var originalRule = sheet.addRule(key, meta.dynamicStyles[key]); // Loop through all created rules, fixes updating dynamic rules
        for(var i = initialRuleCount; i < sheet.rules.index.length; i++){
            var rule = sheet.rules.index[i];
            sheet.updateOne(rule, data); // If it's the original rule, we need to add it by the correct key so the hook and hoc
            // can correctly concat the dynamic class with the static one
            rules[originalRule === rule ? key : rule.key] = rule;
        }
    }
    return rules;
};
var $e1604d12639183a7$var$getSheetClasses = function getSheetClasses(sheet, dynamicRules) {
    if (!dynamicRules) return sheet.classes;
    var meta = $e1604d12639183a7$var$getMeta(sheet);
    if (!meta) return sheet.classes;
    var classes = {};
    for(var key in meta.styles){
        classes[key] = sheet.classes[key];
        if (key in dynamicRules) classes[key] += " " + sheet.classes[dynamicRules[key].key];
    }
    return classes;
};
function $e1604d12639183a7$var$getUseInsertionEffect(isSSR) {
    return isSSR ? (0, $bh6RR.useEffect) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useInsertionEffect || // React 18+ (https://github.com/reactwg/react-18/discussions/110)
    (0, $bh6RR.useLayoutEffect);
}
var $e1604d12639183a7$var$noTheme = {};
var $e1604d12639183a7$export$644d15e5a9a5f175 = function createUseStyles(styles, options) {
    if (options === void 0) options = {};
    var _options = options, _options$index = _options.index, index = _options$index === void 0 ? $e1604d12639183a7$var$getSheetIndex() : _options$index, theming = _options.theming, name = _options.name, sheetOptions = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_options, [
        "index",
        "theming",
        "name"
    ]);
    var ThemeContext$1 = theming && theming.context || (0, $b00a230e66cc9d68$export$2c657da244d00bd6);
    var useTheme = function useTheme(theme) {
        if (typeof styles === "function") return theme || (0, $bh6RR.useContext)(ThemeContext$1) || $e1604d12639183a7$var$noTheme;
        return $e1604d12639183a7$var$noTheme;
    };
    var emptyObject = {};
    return function useStyles(data) {
        var isFirstMount = (0, $bh6RR.useRef)(true);
        var context = (0, $bh6RR.useContext)($e1604d12639183a7$export$193e6193848b8f2a);
        var theme = useTheme(data && data.theme);
        var _useMemo = (0, $bh6RR.useMemo)(function() {
            var newSheet = $e1604d12639183a7$var$createStyleSheet({
                context: context,
                styles: styles,
                name: name,
                theme: theme,
                index: index,
                sheetOptions: sheetOptions
            });
            if (newSheet && context.isSSR) // manage immediately during SSRs. browsers will manage the sheet through useInsertionEffect below
            $e1604d12639183a7$var$manageSheet({
                index: index,
                context: context,
                sheet: newSheet,
                theme: theme
            });
            return [
                newSheet,
                newSheet ? $e1604d12639183a7$var$addDynamicRules(newSheet, data) : null
            ];
        }, [
            context,
            theme
        ]), sheet = _useMemo[0], dynamicRules = _useMemo[1];
        $e1604d12639183a7$var$getUseInsertionEffect(context.isSSR)(function() {
            // We only need to update the rules on a subsequent update and not in the first mount
            if (sheet && dynamicRules && !isFirstMount.current) $e1604d12639183a7$var$updateDynamicRules(data, sheet, dynamicRules);
        }, [
            data
        ]);
        $e1604d12639183a7$var$getUseInsertionEffect(context.isSSR)(function() {
            if (sheet) $e1604d12639183a7$var$manageSheet({
                index: index,
                context: context,
                sheet: sheet,
                theme: theme
            });
            return function() {
                if (sheet) {
                    $e1604d12639183a7$var$unmanageSheet({
                        index: index,
                        context: context,
                        sheet: sheet,
                        theme: theme
                    }); // when sheet changes, remove related dynamic rules
                    if (dynamicRules) $e1604d12639183a7$var$removeDynamicRules(sheet, dynamicRules);
                }
            };
        }, [
            sheet
        ]);
        var classes = (0, $bh6RR.useMemo)(function() {
            return sheet && dynamicRules ? $e1604d12639183a7$var$getSheetClasses(sheet, dynamicRules) : emptyObject;
        }, [
            sheet,
            dynamicRules
        ]);
        (0, $bh6RR.useDebugValue)(classes);
        (0, $bh6RR.useDebugValue)(theme === $e1604d12639183a7$var$noTheme ? "No theme" : theme);
        (0, $bh6RR.useEffect)(function() {
            isFirstMount.current = false;
        });
        return classes;
    };
};
var $e1604d12639183a7$var$NoRenderer = function NoRenderer(props) {
    return props.children || null;
};
/**
 * HOC creator function that wrapps the user component.
 *
 * `withStyles(styles, [options])(Component)`
 */ var $e1604d12639183a7$export$99b4b78fb79d96b3 = function createWithStyles(styles, options) {
    if (options === void 0) options = {};
    var _options = options, _options$index = _options.index, index = _options$index === void 0 ? $e1604d12639183a7$var$getSheetIndex() : _options$index, theming = _options.theming, injectTheme = _options.injectTheme, sheetOptions = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_options, [
        "index",
        "theming",
        "injectTheme"
    ]);
    var ThemeContext$1 = theming ? theming.context : (0, $b00a230e66cc9d68$export$2c657da244d00bd6);
    return function(InnerComponent) {
        if (InnerComponent === void 0) InnerComponent = $e1604d12639183a7$var$NoRenderer;
        var displayName = $e1604d12639183a7$var$getDisplayName(InnerComponent);
        var mergeClassesProp = $e1604d12639183a7$var$memoize(function(sheetClasses, classesProp) {
            return classesProp ? $e1604d12639183a7$var$mergeClasses(sheetClasses, classesProp) : sheetClasses;
        });
        var hookOptions = Object.assign(sheetOptions, {
            theming: theming,
            index: index,
            name: displayName
        });
        var useStyles = $e1604d12639183a7$export$644d15e5a9a5f175(styles, hookOptions);
        var WithStyles = (0, $bh6RR.forwardRef)(function(props, ref) {
            var theme = (0, $bh6RR.useContext)(ThemeContext$1);
            var newProps = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props);
            if (injectTheme && newProps.theme == null) newProps.theme = theme;
            var sheetClasses = useStyles(newProps);
            var classes = mergeClassesProp(sheetClasses, props.classes);
            return (0, $bh6RR.createElement)(InnerComponent, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, newProps, {
                classes: classes,
                ref: ref
            }));
        });
        WithStyles.displayName = "WithStyles(" + displayName + ")";
        WithStyles.defaultProps = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, InnerComponent.defaultProps);
        WithStyles.InnerComponent = InnerComponent;
        return (0, (/*@__PURE__*/$parcel$interopDefault($770bbfe5492d7fd4$exports)))(WithStyles, InnerComponent);
    };
};
var $e1604d12639183a7$var$initialContext = {};
function $e1604d12639183a7$export$5c4291a09aa0f577(props) {
    var managersRef = (0, $bh6RR.useRef)({});
    var prevContextRef = (0, $bh6RR.useRef)();
    var registryRef = (0, $bh6RR.useRef)(null);
    var createContext = function createContext(parentContext, prevContext) {
        if (prevContext === void 0) prevContext = $e1604d12639183a7$var$initialContext;
        var registry = props.registry, classNamePrefix = props.classNamePrefix, jss = props.jss, generateId = props.generateId, disableStylesGeneration = props.disableStylesGeneration, media = props.media, id = props.id, isSSR = props.isSSR;
        var context = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, parentContext);
        if (registry) {
            context.registry = registry; // This way we identify a new request on the server, because user will create
            // a new Registry instance for each.
            if (registry !== registryRef.current) {
                // We reset managers because we have to regenerate all sheets for the new request.
                managersRef.current = {};
                registryRef.current = registry;
            }
        }
        context.managers = managersRef.current;
        if (id !== undefined) context.id = id;
        if (generateId !== undefined) context.generateId = generateId;
        else if (!context.generateId || !prevContext || context.id !== prevContext.id) context.generateId = (0, $f9c08e91c2468f05$export$ddff9cce7c732c82)(context.id);
        if (classNamePrefix) context.classNamePrefix = (context.classNamePrefix || "") + classNamePrefix;
        if (media !== undefined) context.media = media;
        if (jss) context.jss = jss;
        if (disableStylesGeneration !== undefined) context.disableStylesGeneration = disableStylesGeneration;
        if (isSSR !== undefined) context.isSSR = isSSR;
        if (prevContext && (0, $60736e760047e4b2$export$3e67810a3f0e9f1c)(prevContext, context)) return prevContext;
        return context;
    };
    var renderProvider = function renderProvider(parentContext) {
        var children = props.children;
        var context = createContext(parentContext, prevContextRef.current);
        prevContextRef.current = context;
        return (0, $bh6RR.createElement)($e1604d12639183a7$export$193e6193848b8f2a.Provider, {
            value: context
        }, children);
    };
    return (0, $bh6RR.createElement)($e1604d12639183a7$export$193e6193848b8f2a.Consumer, null, renderProvider);
}
var $e1604d12639183a7$var$parseStyles = function parseStyles(args) {
    var dynamicStyles = [];
    var staticStyle;
    var labels = []; // Not using ...rest to optimize perf.
    for(var key in args){
        var style = args[key];
        if (!style) continue;
        if (typeof style === "function") dynamicStyles.push(style);
        else {
            if (!staticStyle) staticStyle = {};
            Object.assign(staticStyle, style);
            var _staticStyle = staticStyle, _label = _staticStyle.label;
            if (_label) {
                if (labels.indexOf(_label) === -1) labels.push(_label);
            }
        }
    }
    var styles = {};
    var label = labels.length === 0 ? "sc" : labels.join("-");
    if (staticStyle) {
        // Label should not leak to the core.
        if ("label" in staticStyle) delete staticStyle.label;
        styles[label] = staticStyle;
    } // When there is only one function rule, we don't need to wrap it.
    if (dynamicStyles.length === 1) styles.scd = dynamicStyles[0];
     // We create a new function rule which will call all other function rules
    // and merge the styles they return.
    if (dynamicStyles.length > 1) styles.scd = function(props) {
        var merged = {};
        for(var i = 0; i < dynamicStyles.length; i++){
            var dynamicStyle = dynamicStyles[i](props);
            if (dynamicStyle) Object.assign(merged, dynamicStyle);
        }
        return merged;
    };
    return {
        styles: styles,
        label: label
    };
};
var $e1604d12639183a7$var$shouldForwardPropSymbol = Symbol("react-jss-styled");
var $e1604d12639183a7$var$getShouldForwardProp = function getShouldForwardProp(tagOrComponent, options) {
    var shouldForwardProp = options.shouldForwardProp;
    var childShouldForwardProp = tagOrComponent[$e1604d12639183a7$var$shouldForwardPropSymbol];
    var finalShouldForwardProp = shouldForwardProp || childShouldForwardProp;
    if (shouldForwardProp && childShouldForwardProp) finalShouldForwardProp = function finalShouldForwardProp(prop) {
        return childShouldForwardProp(prop) && shouldForwardProp(prop);
    };
    return finalShouldForwardProp;
};
var $e1604d12639183a7$var$getChildProps = function getChildProps(props, shouldForwardProp, isTag) {
    var childProps = {};
    for(var prop in props){
        if (shouldForwardProp) {
            if (shouldForwardProp(prop) === true) childProps[prop] = props[prop];
            continue;
        } // We don't want to pass non-dom props to the DOM.
        if (isTag) {
            if ((0, $fjRTt.default)(prop)) childProps[prop] = props[prop];
            continue;
        }
        childProps[prop] = props[prop];
    }
    return childProps;
}; // eslint-disable-next-line no-unused-vars
var $e1604d12639183a7$export$3817b7a54a07cec7 = function configureStyled(tagOrComponent, options) {
    if (options === void 0) options = {};
    var _options = options, theming = _options.theming;
    var isTag = typeof tagOrComponent === "string";
    var ThemeContext$1 = theming ? theming.context : (0, $b00a230e66cc9d68$export$2c657da244d00bd6);
    var shouldForwardProp = $e1604d12639183a7$var$getShouldForwardProp(tagOrComponent, options);
    var _options2 = options, _ = _options2.shouldForwardProp, hookOptions = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_options2, [
        "shouldForwardProp"
    ]);
    return function createStyledComponent() {
        // eslint-disable-next-line prefer-rest-params
        var _parseStyles = $e1604d12639183a7$var$parseStyles(arguments), styles = _parseStyles.styles, label = _parseStyles.label;
        var useStyles = $e1604d12639183a7$export$644d15e5a9a5f175(styles, hookOptions);
        var Styled = function Styled(props) {
            var as = props.as, className = props.className;
            var theme = (0, $bh6RR.useContext)(ThemeContext$1);
            var propsWithTheme = Object.assign({
                theme: theme
            }, props);
            var classes = useStyles(propsWithTheme);
            var childProps = $e1604d12639183a7$var$getChildProps(props, shouldForwardProp, isTag);
            var classNames = ((classes[label] || classes.sc || "") + " " + (classes.scd || "")).trim();
            childProps.className = className ? className + " " + classNames : classNames;
            if (!isTag && shouldForwardProp) tagOrComponent[$e1604d12639183a7$var$shouldForwardPropSymbol] = shouldForwardProp;
            if (isTag && as) return (0, $bh6RR.createElement)(as, childProps);
            return (0, $bh6RR.createElement)(tagOrComponent, childProps);
        };
        return Styled;
    };
};
/* eslint-disable prefer-rest-params, prefer-spread */ var $e1604d12639183a7$export$e961a3d853e7ed35 = function create(css) {
    if (css === void 0) css = (0, $deac06e643c1fc55$export$2e2bcd8739ae039);
    return function createElement$1(type, props) {
        var args = arguments;
        if (props && props.css) {
            var className = css(props.css);
            var newProps = Object.assign({}, props);
            newProps.className = props.className ? props.className + " " + className : className;
            delete newProps.css;
            args[1] = newProps;
        }
        return (0, $bh6RR.createElement).apply(undefined, args);
    };
};
var $e1604d12639183a7$export$34b9dba7ce09269b = $e1604d12639183a7$export$e961a3d853e7ed35();
var $e1604d12639183a7$export$2e2bcd8739ae039 = $e1604d12639183a7$export$99b4b78fb79d96b3;


var $b750b42bd943e1b3$exports = {};
var $a8926e8acfc4412a$exports = {};

var $dnnhb = parcelRequire("dnnhb");
var $d048dec454357051$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $d048dec454357051$var$toInteger(value) {
    var result = $8da36a9ee743aed0$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$d048dec454357051$exports = $d048dec454357051$var$toInteger;



var $a863ad98b2851f02$exports = {};
var $2859adc7c6ec1638$exports = {};

var $2984cf9c242fe53a$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2984cf9c242fe53a$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$2984cf9c242fe53a$exports = $2984cf9c242fe53a$var$arrayMap;


var $730d1b366662da48$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $730d1b366662da48$var$isArray = Array.isArray;
$730d1b366662da48$exports = $730d1b366662da48$var$isArray;



/** Used as references for various `Number` constants. */ var $2859adc7c6ec1638$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2859adc7c6ec1638$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $2859adc7c6ec1638$var$symbolToString = $2859adc7c6ec1638$var$symbolProto ? $2859adc7c6ec1638$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2859adc7c6ec1638$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($730d1b366662da48$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $2984cf9c242fe53a$exports(value, $2859adc7c6ec1638$var$baseToString) + "";
    if ($42e9ee7d3311848a$exports(value)) return $2859adc7c6ec1638$var$symbolToString ? $2859adc7c6ec1638$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$2859adc7c6ec1638$var$INFINITY ? "-0" : result;
}
$2859adc7c6ec1638$exports = $2859adc7c6ec1638$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a863ad98b2851f02$var$toString(value) {
    return value == null ? "" : $2859adc7c6ec1638$exports(value);
}
$a863ad98b2851f02$exports = $a863ad98b2851f02$var$toString;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $a8926e8acfc4412a$var$nativeIsFinite = $dnnhb.isFinite, $a8926e8acfc4412a$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $a8926e8acfc4412a$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $94b27a3e78e3c823$exports(number);
        precision = precision == null ? 0 : $a8926e8acfc4412a$var$nativeMin($d048dec454357051$exports(precision), 292);
        if (precision && $a8926e8acfc4412a$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($a863ad98b2851f02$exports(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = ($a863ad98b2851f02$exports(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
        }
        return func(number);
    };
}
$a8926e8acfc4412a$exports = $a8926e8acfc4412a$var$createRound;


/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */ var $b750b42bd943e1b3$var$round = $a8926e8acfc4412a$exports("round");
$b750b42bd943e1b3$exports = $b750b42bd943e1b3$var$round;


var $36cc539b4e4fca94$exports = {};
var $f62f68a862120e6f$exports = {};
var $c81129c59aef2ccf$exports = {};
var $419ba895b4ae45e6$exports = {};
var $6600d6a94bbfda55$exports = {};
var $88f8a458a1ebfb99$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $88f8a458a1ebfb99$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$88f8a458a1ebfb99$exports = $88f8a458a1ebfb99$var$listCacheClear;


var $ed3d1b1aa1c6eb21$exports = {};
var $f0b9af7eb68dc1e4$exports = {};

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f0b9af7eb68dc1e4$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($d3b5784bbbc55641$exports(array[length][0], key)) return length;
    }
    return -1;
}
$f0b9af7eb68dc1e4$exports = $f0b9af7eb68dc1e4$var$assocIndexOf;


/** Used for built-in method references. */ var $ed3d1b1aa1c6eb21$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ed3d1b1aa1c6eb21$var$splice = $ed3d1b1aa1c6eb21$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ed3d1b1aa1c6eb21$var$listCacheDelete(key) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ed3d1b1aa1c6eb21$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$ed3d1b1aa1c6eb21$exports = $ed3d1b1aa1c6eb21$var$listCacheDelete;


var $22784f0ffcbfc03d$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $22784f0ffcbfc03d$var$listCacheGet(key) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$22784f0ffcbfc03d$exports = $22784f0ffcbfc03d$var$listCacheGet;


var $4d131af2d890865b$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4d131af2d890865b$var$listCacheHas(key) {
    return $f0b9af7eb68dc1e4$exports(this.__data__, key) > -1;
}
$4d131af2d890865b$exports = $4d131af2d890865b$var$listCacheHas;


var $0a2d0ac185e5d2a7$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0a2d0ac185e5d2a7$var$listCacheSet(key, value) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$0a2d0ac185e5d2a7$exports = $0a2d0ac185e5d2a7$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6600d6a94bbfda55$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$6600d6a94bbfda55$var$ListCache.prototype.clear = $88f8a458a1ebfb99$exports;
$6600d6a94bbfda55$var$ListCache.prototype["delete"] = $ed3d1b1aa1c6eb21$exports;
$6600d6a94bbfda55$var$ListCache.prototype.get = $22784f0ffcbfc03d$exports;
$6600d6a94bbfda55$var$ListCache.prototype.has = $4d131af2d890865b$exports;
$6600d6a94bbfda55$var$ListCache.prototype.set = $0a2d0ac185e5d2a7$exports;
$6600d6a94bbfda55$exports = $6600d6a94bbfda55$var$ListCache;


var $9d1ea3c08850b010$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $9d1ea3c08850b010$var$stackClear() {
    this.__data__ = new $6600d6a94bbfda55$exports;
    this.size = 0;
}
$9d1ea3c08850b010$exports = $9d1ea3c08850b010$var$stackClear;


var $0ff58e43e318c414$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0ff58e43e318c414$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$0ff58e43e318c414$exports = $0ff58e43e318c414$var$stackDelete;


var $81d58a22530578d0$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $81d58a22530578d0$var$stackGet(key) {
    return this.__data__.get(key);
}
$81d58a22530578d0$exports = $81d58a22530578d0$var$stackGet;


var $48cf88273b00b4ea$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $48cf88273b00b4ea$var$stackHas(key) {
    return this.__data__.has(key);
}
$48cf88273b00b4ea$exports = $48cf88273b00b4ea$var$stackHas;


var $37ff411d932fb6f2$exports = {};

var $ab52caa45642ed43$exports = {};
var $507cda0e3d4397c2$exports = {};
var $8d02eb250319088c$exports = {};

var $53e75170d73e0e3c$exports = {};
var $558079b1ab119fea$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Used to detect overreaching core-js shims. */ var $558079b1ab119fea$var$coreJsData = $dnnhb["__core-js_shared__"];
$558079b1ab119fea$exports = $558079b1ab119fea$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $53e75170d73e0e3c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($558079b1ab119fea$exports && $558079b1ab119fea$exports.keys && $558079b1ab119fea$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $53e75170d73e0e3c$var$isMasked(func) {
    return !!$53e75170d73e0e3c$var$maskSrcKey && $53e75170d73e0e3c$var$maskSrcKey in func;
}
$53e75170d73e0e3c$exports = $53e75170d73e0e3c$var$isMasked;



var $5d4c9208b54c16cf$exports = {};
/** Used for built-in method references. */ var $5d4c9208b54c16cf$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5d4c9208b54c16cf$var$funcToString = $5d4c9208b54c16cf$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5d4c9208b54c16cf$var$toSource(func) {
    if (func != null) {
        try {
            return $5d4c9208b54c16cf$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$5d4c9208b54c16cf$exports = $5d4c9208b54c16cf$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8d02eb250319088c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8d02eb250319088c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8d02eb250319088c$var$funcProto = Function.prototype, $8d02eb250319088c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8d02eb250319088c$var$funcToString = $8d02eb250319088c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8d02eb250319088c$var$hasOwnProperty = $8d02eb250319088c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8d02eb250319088c$var$reIsNative = RegExp("^" + $8d02eb250319088c$var$funcToString.call($8d02eb250319088c$var$hasOwnProperty).replace($8d02eb250319088c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8d02eb250319088c$var$baseIsNative(value) {
    if (!$e4bea0192758232a$exports(value) || $53e75170d73e0e3c$exports(value)) return false;
    var pattern = $3c413d87f292fe2c$exports(value) ? $8d02eb250319088c$var$reIsNative : $8d02eb250319088c$var$reIsHostCtor;
    return pattern.test($5d4c9208b54c16cf$exports(value));
}
$8d02eb250319088c$exports = $8d02eb250319088c$var$baseIsNative;


var $d117e89f87247905$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d117e89f87247905$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d117e89f87247905$exports = $d117e89f87247905$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $507cda0e3d4397c2$var$getNative(object, key) {
    var value = $d117e89f87247905$exports(object, key);
    return $8d02eb250319088c$exports(value) ? value : undefined;
}
$507cda0e3d4397c2$exports = $507cda0e3d4397c2$var$getNative;



var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $ab52caa45642ed43$var$Map = $507cda0e3d4397c2$exports($dnnhb, "Map");
$ab52caa45642ed43$exports = $ab52caa45642ed43$var$Map;


var $eb2847cf8b43e448$exports = {};
var $0ef93b41d443d840$exports = {};
var $096b6e8d9d98217d$exports = {};
var $a41c4150a4a0597c$exports = {};
var $3775533b2ea97104$exports = {};

/* Built-in method references that are verified to be native. */ var $3775533b2ea97104$var$nativeCreate = $507cda0e3d4397c2$exports(Object, "create");
$3775533b2ea97104$exports = $3775533b2ea97104$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a41c4150a4a0597c$var$hashClear() {
    this.__data__ = $3775533b2ea97104$exports ? $3775533b2ea97104$exports(null) : {};
    this.size = 0;
}
$a41c4150a4a0597c$exports = $a41c4150a4a0597c$var$hashClear;


var $512e538f8ec06abe$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $512e538f8ec06abe$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$512e538f8ec06abe$exports = $512e538f8ec06abe$var$hashDelete;


var $305befcd54445446$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $305befcd54445446$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $305befcd54445446$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $305befcd54445446$var$hasOwnProperty = $305befcd54445446$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $305befcd54445446$var$hashGet(key) {
    var data = this.__data__;
    if ($3775533b2ea97104$exports) {
        var result = data[key];
        return result === $305befcd54445446$var$HASH_UNDEFINED ? undefined : result;
    }
    return $305befcd54445446$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$305befcd54445446$exports = $305befcd54445446$var$hashGet;


var $e98c409e6c78ac8d$exports = {};

/** Used for built-in method references. */ var $e98c409e6c78ac8d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e98c409e6c78ac8d$var$hasOwnProperty = $e98c409e6c78ac8d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e98c409e6c78ac8d$var$hashHas(key) {
    var data = this.__data__;
    return $3775533b2ea97104$exports ? data[key] !== undefined : $e98c409e6c78ac8d$var$hasOwnProperty.call(data, key);
}
$e98c409e6c78ac8d$exports = $e98c409e6c78ac8d$var$hashHas;


var $5aa4d120853b2dad$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $5aa4d120853b2dad$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $5aa4d120853b2dad$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $3775533b2ea97104$exports && value === undefined ? $5aa4d120853b2dad$var$HASH_UNDEFINED : value;
    return this;
}
$5aa4d120853b2dad$exports = $5aa4d120853b2dad$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $096b6e8d9d98217d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$096b6e8d9d98217d$var$Hash.prototype.clear = $a41c4150a4a0597c$exports;
$096b6e8d9d98217d$var$Hash.prototype["delete"] = $512e538f8ec06abe$exports;
$096b6e8d9d98217d$var$Hash.prototype.get = $305befcd54445446$exports;
$096b6e8d9d98217d$var$Hash.prototype.has = $e98c409e6c78ac8d$exports;
$096b6e8d9d98217d$var$Hash.prototype.set = $5aa4d120853b2dad$exports;
$096b6e8d9d98217d$exports = $096b6e8d9d98217d$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0ef93b41d443d840$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $096b6e8d9d98217d$exports,
        "map": new ($ab52caa45642ed43$exports || $6600d6a94bbfda55$exports),
        "string": new $096b6e8d9d98217d$exports
    };
}
$0ef93b41d443d840$exports = $0ef93b41d443d840$var$mapCacheClear;


var $d766380f20569b4b$exports = {};
var $134523692be3fdae$exports = {};
var $674a762a247d0e5a$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $674a762a247d0e5a$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$674a762a247d0e5a$exports = $674a762a247d0e5a$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $134523692be3fdae$var$getMapData(map, key) {
    var data = map.__data__;
    return $674a762a247d0e5a$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$134523692be3fdae$exports = $134523692be3fdae$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d766380f20569b4b$var$mapCacheDelete(key) {
    var result = $134523692be3fdae$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$d766380f20569b4b$exports = $d766380f20569b4b$var$mapCacheDelete;


var $31567d8d775c5c8a$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $31567d8d775c5c8a$var$mapCacheGet(key) {
    return $134523692be3fdae$exports(this, key).get(key);
}
$31567d8d775c5c8a$exports = $31567d8d775c5c8a$var$mapCacheGet;


var $3d8e18ae61a2fd42$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d8e18ae61a2fd42$var$mapCacheHas(key) {
    return $134523692be3fdae$exports(this, key).has(key);
}
$3d8e18ae61a2fd42$exports = $3d8e18ae61a2fd42$var$mapCacheHas;


var $908883b24173d38c$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $908883b24173d38c$var$mapCacheSet(key, value) {
    var data = $134523692be3fdae$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$908883b24173d38c$exports = $908883b24173d38c$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $eb2847cf8b43e448$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$eb2847cf8b43e448$var$MapCache.prototype.clear = $0ef93b41d443d840$exports;
$eb2847cf8b43e448$var$MapCache.prototype["delete"] = $d766380f20569b4b$exports;
$eb2847cf8b43e448$var$MapCache.prototype.get = $31567d8d775c5c8a$exports;
$eb2847cf8b43e448$var$MapCache.prototype.has = $3d8e18ae61a2fd42$exports;
$eb2847cf8b43e448$var$MapCache.prototype.set = $908883b24173d38c$exports;
$eb2847cf8b43e448$exports = $eb2847cf8b43e448$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $37ff411d932fb6f2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $37ff411d932fb6f2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $6600d6a94bbfda55$exports) {
        var pairs = data.__data__;
        if (!$ab52caa45642ed43$exports || pairs.length < $37ff411d932fb6f2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $eb2847cf8b43e448$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$37ff411d932fb6f2$exports = $37ff411d932fb6f2$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $419ba895b4ae45e6$var$Stack(entries) {
    var data = this.__data__ = new $6600d6a94bbfda55$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$419ba895b4ae45e6$var$Stack.prototype.clear = $9d1ea3c08850b010$exports;
$419ba895b4ae45e6$var$Stack.prototype["delete"] = $0ff58e43e318c414$exports;
$419ba895b4ae45e6$var$Stack.prototype.get = $81d58a22530578d0$exports;
$419ba895b4ae45e6$var$Stack.prototype.has = $48cf88273b00b4ea$exports;
$419ba895b4ae45e6$var$Stack.prototype.set = $37ff411d932fb6f2$exports;
$419ba895b4ae45e6$exports = $419ba895b4ae45e6$var$Stack;


var $0f039f12cd2ac022$exports = {};
var $cb3d1d2f030b3948$exports = {};

var $975c698101e172f2$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $975c698101e172f2$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $975c698101e172f2$var$setCacheAdd(value) {
    this.__data__.set(value, $975c698101e172f2$var$HASH_UNDEFINED);
    return this;
}
$975c698101e172f2$exports = $975c698101e172f2$var$setCacheAdd;


var $2b07a45d13b540cb$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2b07a45d13b540cb$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$2b07a45d13b540cb$exports = $2b07a45d13b540cb$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $cb3d1d2f030b3948$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $eb2847cf8b43e448$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$cb3d1d2f030b3948$var$SetCache.prototype.add = $cb3d1d2f030b3948$var$SetCache.prototype.push = $975c698101e172f2$exports;
$cb3d1d2f030b3948$var$SetCache.prototype.has = $2b07a45d13b540cb$exports;
$cb3d1d2f030b3948$exports = $cb3d1d2f030b3948$var$SetCache;


var $c0ac884d1efe56ee$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c0ac884d1efe56ee$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$c0ac884d1efe56ee$exports = $c0ac884d1efe56ee$var$arraySome;


var $058827dcb6837216$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $058827dcb6837216$var$cacheHas(cache, key) {
    return cache.has(key);
}
$058827dcb6837216$exports = $058827dcb6837216$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $0f039f12cd2ac022$var$COMPARE_PARTIAL_FLAG = 1, $0f039f12cd2ac022$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $0f039f12cd2ac022$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0f039f12cd2ac022$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $0f039f12cd2ac022$var$COMPARE_UNORDERED_FLAG ? new $cb3d1d2f030b3948$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$c0ac884d1efe56ee$exports(other, function(othValue, othIndex) {
                if (!$058827dcb6837216$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$0f039f12cd2ac022$exports = $0f039f12cd2ac022$var$equalArrays;


var $e7b4f0da30108603$exports = {};

var $f3f1e8c287dc271d$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $f3f1e8c287dc271d$var$Uint8Array = $dnnhb.Uint8Array;
$f3f1e8c287dc271d$exports = $f3f1e8c287dc271d$var$Uint8Array;




var $aa101734006c8cb4$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $aa101734006c8cb4$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$aa101734006c8cb4$exports = $aa101734006c8cb4$var$mapToArray;


var $3fc617daaa01c913$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $3fc617daaa01c913$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$3fc617daaa01c913$exports = $3fc617daaa01c913$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $e7b4f0da30108603$var$COMPARE_PARTIAL_FLAG = 1, $e7b4f0da30108603$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $e7b4f0da30108603$var$boolTag = "[object Boolean]", $e7b4f0da30108603$var$dateTag = "[object Date]", $e7b4f0da30108603$var$errorTag = "[object Error]", $e7b4f0da30108603$var$mapTag = "[object Map]", $e7b4f0da30108603$var$numberTag = "[object Number]", $e7b4f0da30108603$var$regexpTag = "[object RegExp]", $e7b4f0da30108603$var$setTag = "[object Set]", $e7b4f0da30108603$var$stringTag = "[object String]", $e7b4f0da30108603$var$symbolTag = "[object Symbol]";
var $e7b4f0da30108603$var$arrayBufferTag = "[object ArrayBuffer]", $e7b4f0da30108603$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $e7b4f0da30108603$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $e7b4f0da30108603$var$symbolValueOf = $e7b4f0da30108603$var$symbolProto ? $e7b4f0da30108603$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e7b4f0da30108603$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $e7b4f0da30108603$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $e7b4f0da30108603$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $f3f1e8c287dc271d$exports(object), new $f3f1e8c287dc271d$exports(other))) return false;
            return true;
        case $e7b4f0da30108603$var$boolTag:
        case $e7b4f0da30108603$var$dateTag:
        case $e7b4f0da30108603$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $d3b5784bbbc55641$exports(+object, +other);
        case $e7b4f0da30108603$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $e7b4f0da30108603$var$regexpTag:
        case $e7b4f0da30108603$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $e7b4f0da30108603$var$mapTag:
            var convert = $aa101734006c8cb4$exports;
        case $e7b4f0da30108603$var$setTag:
            var isPartial = bitmask & $e7b4f0da30108603$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $3fc617daaa01c913$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $e7b4f0da30108603$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $0f039f12cd2ac022$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $e7b4f0da30108603$var$symbolTag:
            if ($e7b4f0da30108603$var$symbolValueOf) return $e7b4f0da30108603$var$symbolValueOf.call(object) == $e7b4f0da30108603$var$symbolValueOf.call(other);
    }
    return false;
}
$e7b4f0da30108603$exports = $e7b4f0da30108603$var$equalByTag;


var $a7b235c007594e3f$exports = {};
var $3087323db8ebdb4a$exports = {};
var $8ff55e87051475e3$exports = {};
var $ce3fbf26bf92081d$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ce3fbf26bf92081d$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$ce3fbf26bf92081d$exports = $ce3fbf26bf92081d$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8ff55e87051475e3$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $730d1b366662da48$exports(object) ? result : $ce3fbf26bf92081d$exports(result, symbolsFunc(object));
}
$8ff55e87051475e3$exports = $8ff55e87051475e3$var$baseGetAllKeys;


var $6f0ffdf0419abb03$exports = {};
var $4f67014188a0aed7$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $4f67014188a0aed7$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$4f67014188a0aed7$exports = $4f67014188a0aed7$var$arrayFilter;


var $be064eff5dc241cd$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $be064eff5dc241cd$var$stubArray() {
    return [];
}
$be064eff5dc241cd$exports = $be064eff5dc241cd$var$stubArray;


/** Used for built-in method references. */ var $6f0ffdf0419abb03$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6f0ffdf0419abb03$var$propertyIsEnumerable = $6f0ffdf0419abb03$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6f0ffdf0419abb03$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6f0ffdf0419abb03$var$getSymbols = !$6f0ffdf0419abb03$var$nativeGetSymbols ? $be064eff5dc241cd$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $4f67014188a0aed7$exports($6f0ffdf0419abb03$var$nativeGetSymbols(object), function(symbol) {
        return $6f0ffdf0419abb03$var$propertyIsEnumerable.call(object, symbol);
    });
};
$6f0ffdf0419abb03$exports = $6f0ffdf0419abb03$var$getSymbols;


var $cf65da43818f725f$exports = {};
var $39a283488d173d50$exports = {};
var $7f7a679ab009c8e0$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $7f7a679ab009c8e0$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$7f7a679ab009c8e0$exports = $7f7a679ab009c8e0$var$baseTimes;


var $dd94877d05f10850$exports = {};
var $8f38f8261e818ef2$exports = {};


/** `Object#toString` result references. */ var $8f38f8261e818ef2$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8f38f8261e818ef2$var$baseIsArguments(value) {
    return $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $8f38f8261e818ef2$var$argsTag;
}
$8f38f8261e818ef2$exports = $8f38f8261e818ef2$var$baseIsArguments;



/** Used for built-in method references. */ var $dd94877d05f10850$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dd94877d05f10850$var$hasOwnProperty = $dd94877d05f10850$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $dd94877d05f10850$var$propertyIsEnumerable = $dd94877d05f10850$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $dd94877d05f10850$var$isArguments = $8f38f8261e818ef2$exports(function() {
    return arguments;
}()) ? $8f38f8261e818ef2$exports : function(value) {
    return $4a94b44c4940d5a5$exports(value) && $dd94877d05f10850$var$hasOwnProperty.call(value, "callee") && !$dd94877d05f10850$var$propertyIsEnumerable.call(value, "callee");
};
$dd94877d05f10850$exports = $dd94877d05f10850$var$isArguments;




var $8TKuU = parcelRequire("8TKuU");

var $54ae0102d9b8cfdf$exports = {};
var $f4e10a0fb2366352$exports = {};



/** `Object#toString` result references. */ var $f4e10a0fb2366352$var$argsTag = "[object Arguments]", $f4e10a0fb2366352$var$arrayTag = "[object Array]", $f4e10a0fb2366352$var$boolTag = "[object Boolean]", $f4e10a0fb2366352$var$dateTag = "[object Date]", $f4e10a0fb2366352$var$errorTag = "[object Error]", $f4e10a0fb2366352$var$funcTag = "[object Function]", $f4e10a0fb2366352$var$mapTag = "[object Map]", $f4e10a0fb2366352$var$numberTag = "[object Number]", $f4e10a0fb2366352$var$objectTag = "[object Object]", $f4e10a0fb2366352$var$regexpTag = "[object RegExp]", $f4e10a0fb2366352$var$setTag = "[object Set]", $f4e10a0fb2366352$var$stringTag = "[object String]", $f4e10a0fb2366352$var$weakMapTag = "[object WeakMap]";
var $f4e10a0fb2366352$var$arrayBufferTag = "[object ArrayBuffer]", $f4e10a0fb2366352$var$dataViewTag = "[object DataView]", $f4e10a0fb2366352$var$float32Tag = "[object Float32Array]", $f4e10a0fb2366352$var$float64Tag = "[object Float64Array]", $f4e10a0fb2366352$var$int8Tag = "[object Int8Array]", $f4e10a0fb2366352$var$int16Tag = "[object Int16Array]", $f4e10a0fb2366352$var$int32Tag = "[object Int32Array]", $f4e10a0fb2366352$var$uint8Tag = "[object Uint8Array]", $f4e10a0fb2366352$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f4e10a0fb2366352$var$uint16Tag = "[object Uint16Array]", $f4e10a0fb2366352$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $f4e10a0fb2366352$var$typedArrayTags = {};
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float64Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8ClampedTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint32Tag] = true;
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$argsTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayBufferTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$boolTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dataViewTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dateTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$errorTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$funcTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$mapTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$numberTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$objectTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$regexpTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$setTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$stringTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f4e10a0fb2366352$var$baseIsTypedArray(value) {
    return $4a94b44c4940d5a5$exports(value) && $cb5309a5575a37b9$exports(value.length) && !!$f4e10a0fb2366352$var$typedArrayTags[$396b15940342a7f1$exports(value)];
}
$f4e10a0fb2366352$exports = $f4e10a0fb2366352$var$baseIsTypedArray;


var $82313b399bb9d3fb$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $82313b399bb9d3fb$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$82313b399bb9d3fb$exports = $82313b399bb9d3fb$var$baseUnary;



var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $54ae0102d9b8cfdf$var$nodeIsTypedArray = $1mm29 && $1mm29.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $54ae0102d9b8cfdf$var$isTypedArray = $54ae0102d9b8cfdf$var$nodeIsTypedArray ? $82313b399bb9d3fb$exports($54ae0102d9b8cfdf$var$nodeIsTypedArray) : $f4e10a0fb2366352$exports;
$54ae0102d9b8cfdf$exports = $54ae0102d9b8cfdf$var$isTypedArray;


/** Used for built-in method references. */ var $39a283488d173d50$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $39a283488d173d50$var$hasOwnProperty = $39a283488d173d50$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $39a283488d173d50$var$arrayLikeKeys(value, inherited) {
    var isArr = $730d1b366662da48$exports(value), isArg = !isArr && $dd94877d05f10850$exports(value), isBuff = !isArr && !isArg && $8TKuU(value), isType = !isArr && !isArg && !isBuff && $54ae0102d9b8cfdf$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $7f7a679ab009c8e0$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $39a283488d173d50$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $ec0ca5ffb2ff14ec$exports(key, length)))) result.push(key);
    return result;
}
$39a283488d173d50$exports = $39a283488d173d50$var$arrayLikeKeys;


var $409962ffb97dfa14$exports = {};
var $966736caab723063$exports = {};
/** Used for built-in method references. */ var $966736caab723063$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $966736caab723063$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $966736caab723063$var$objectProto;
    return value === proto;
}
$966736caab723063$exports = $966736caab723063$var$isPrototype;


var $6a42e4b2642f3889$exports = {};
var $fd668335d1985147$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fd668335d1985147$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$fd668335d1985147$exports = $fd668335d1985147$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a42e4b2642f3889$var$nativeKeys = $fd668335d1985147$exports(Object.keys, Object);
$6a42e4b2642f3889$exports = $6a42e4b2642f3889$var$nativeKeys;


/** Used for built-in method references. */ var $409962ffb97dfa14$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $409962ffb97dfa14$var$hasOwnProperty = $409962ffb97dfa14$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $409962ffb97dfa14$var$baseKeys(object) {
    if (!$966736caab723063$exports(object)) return $6a42e4b2642f3889$exports(object);
    var result = [];
    for(var key in Object(object))if ($409962ffb97dfa14$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$409962ffb97dfa14$exports = $409962ffb97dfa14$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $cf65da43818f725f$var$keys(object) {
    return $681032a0f414881e$exports(object) ? $39a283488d173d50$exports(object) : $409962ffb97dfa14$exports(object);
}
$cf65da43818f725f$exports = $cf65da43818f725f$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3087323db8ebdb4a$var$getAllKeys(object) {
    return $8ff55e87051475e3$exports(object, $cf65da43818f725f$exports, $6f0ffdf0419abb03$exports);
}
$3087323db8ebdb4a$exports = $3087323db8ebdb4a$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $a7b235c007594e3f$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $a7b235c007594e3f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a7b235c007594e3f$var$hasOwnProperty = $a7b235c007594e3f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a7b235c007594e3f$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a7b235c007594e3f$var$COMPARE_PARTIAL_FLAG, objProps = $3087323db8ebdb4a$exports(object), objLength = objProps.length, othProps = $3087323db8ebdb4a$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $a7b235c007594e3f$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$a7b235c007594e3f$exports = $a7b235c007594e3f$var$equalObjects;


var $79d963e32ece07b6$exports = {};
var $bc0c33c3265e5ae1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $bc0c33c3265e5ae1$var$DataView = $507cda0e3d4397c2$exports($dnnhb, "DataView");
$bc0c33c3265e5ae1$exports = $bc0c33c3265e5ae1$var$DataView;



var $692fc18a853ab7b1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $692fc18a853ab7b1$var$Promise = $507cda0e3d4397c2$exports($dnnhb, "Promise");
$692fc18a853ab7b1$exports = $692fc18a853ab7b1$var$Promise;


var $2f7af927ce68d1f1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $2f7af927ce68d1f1$var$Set = $507cda0e3d4397c2$exports($dnnhb, "Set");
$2f7af927ce68d1f1$exports = $2f7af927ce68d1f1$var$Set;


var $47cc78defb163815$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $47cc78defb163815$var$WeakMap = $507cda0e3d4397c2$exports($dnnhb, "WeakMap");
$47cc78defb163815$exports = $47cc78defb163815$var$WeakMap;




/** `Object#toString` result references. */ var $79d963e32ece07b6$var$mapTag = "[object Map]", $79d963e32ece07b6$var$objectTag = "[object Object]", $79d963e32ece07b6$var$promiseTag = "[object Promise]", $79d963e32ece07b6$var$setTag = "[object Set]", $79d963e32ece07b6$var$weakMapTag = "[object WeakMap]";
var $79d963e32ece07b6$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $79d963e32ece07b6$var$dataViewCtorString = $5d4c9208b54c16cf$exports($bc0c33c3265e5ae1$exports), $79d963e32ece07b6$var$mapCtorString = $5d4c9208b54c16cf$exports($ab52caa45642ed43$exports), $79d963e32ece07b6$var$promiseCtorString = $5d4c9208b54c16cf$exports($692fc18a853ab7b1$exports), $79d963e32ece07b6$var$setCtorString = $5d4c9208b54c16cf$exports($2f7af927ce68d1f1$exports), $79d963e32ece07b6$var$weakMapCtorString = $5d4c9208b54c16cf$exports($47cc78defb163815$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $79d963e32ece07b6$var$getTag = $396b15940342a7f1$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($bc0c33c3265e5ae1$exports && $79d963e32ece07b6$var$getTag(new $bc0c33c3265e5ae1$exports(new ArrayBuffer(1))) != $79d963e32ece07b6$var$dataViewTag || $ab52caa45642ed43$exports && $79d963e32ece07b6$var$getTag(new $ab52caa45642ed43$exports) != $79d963e32ece07b6$var$mapTag || $692fc18a853ab7b1$exports && $79d963e32ece07b6$var$getTag($692fc18a853ab7b1$exports.resolve()) != $79d963e32ece07b6$var$promiseTag || $2f7af927ce68d1f1$exports && $79d963e32ece07b6$var$getTag(new $2f7af927ce68d1f1$exports) != $79d963e32ece07b6$var$setTag || $47cc78defb163815$exports && $79d963e32ece07b6$var$getTag(new $47cc78defb163815$exports) != $79d963e32ece07b6$var$weakMapTag) $79d963e32ece07b6$var$getTag = function(value) {
    var result = $396b15940342a7f1$exports(value), Ctor = result == $79d963e32ece07b6$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $5d4c9208b54c16cf$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $79d963e32ece07b6$var$dataViewCtorString:
            return $79d963e32ece07b6$var$dataViewTag;
        case $79d963e32ece07b6$var$mapCtorString:
            return $79d963e32ece07b6$var$mapTag;
        case $79d963e32ece07b6$var$promiseCtorString:
            return $79d963e32ece07b6$var$promiseTag;
        case $79d963e32ece07b6$var$setCtorString:
            return $79d963e32ece07b6$var$setTag;
        case $79d963e32ece07b6$var$weakMapCtorString:
            return $79d963e32ece07b6$var$weakMapTag;
    }
    return result;
};
$79d963e32ece07b6$exports = $79d963e32ece07b6$var$getTag;




var $8TKuU = parcelRequire("8TKuU");

/** Used to compose bitmasks for value comparisons. */ var $c81129c59aef2ccf$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c81129c59aef2ccf$var$argsTag = "[object Arguments]", $c81129c59aef2ccf$var$arrayTag = "[object Array]", $c81129c59aef2ccf$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c81129c59aef2ccf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c81129c59aef2ccf$var$hasOwnProperty = $c81129c59aef2ccf$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c81129c59aef2ccf$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $730d1b366662da48$exports(object), othIsArr = $730d1b366662da48$exports(other), objTag = objIsArr ? $c81129c59aef2ccf$var$arrayTag : $79d963e32ece07b6$exports(object), othTag = othIsArr ? $c81129c59aef2ccf$var$arrayTag : $79d963e32ece07b6$exports(other);
    objTag = objTag == $c81129c59aef2ccf$var$argsTag ? $c81129c59aef2ccf$var$objectTag : objTag;
    othTag = othTag == $c81129c59aef2ccf$var$argsTag ? $c81129c59aef2ccf$var$objectTag : othTag;
    var objIsObj = objTag == $c81129c59aef2ccf$var$objectTag, othIsObj = othTag == $c81129c59aef2ccf$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $8TKuU(object)) {
        if (!$8TKuU(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $419ba895b4ae45e6$exports);
        return objIsArr || $54ae0102d9b8cfdf$exports(object) ? $0f039f12cd2ac022$exports(object, other, bitmask, customizer, equalFunc, stack) : $e7b4f0da30108603$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c81129c59aef2ccf$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c81129c59aef2ccf$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $c81129c59aef2ccf$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $419ba895b4ae45e6$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $419ba895b4ae45e6$exports);
    return $a7b235c007594e3f$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$c81129c59aef2ccf$exports = $c81129c59aef2ccf$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f62f68a862120e6f$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$4a94b44c4940d5a5$exports(value) && !$4a94b44c4940d5a5$exports(other)) return value !== value && other !== other;
    return $c81129c59aef2ccf$exports(value, other, bitmask, customizer, $f62f68a862120e6f$var$baseIsEqual, stack);
}
$f62f68a862120e6f$exports = $f62f68a862120e6f$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $36cc539b4e4fca94$var$isEqual(value, other) {
    return $f62f68a862120e6f$exports(value, other);
}
$36cc539b4e4fca94$exports = $36cc539b4e4fca94$var$isEqual;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $2ec4332cbbb15f4e$var$__assign = function() {
    $2ec4332cbbb15f4e$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2ec4332cbbb15f4e$var$__assign.apply(this, arguments);
};
function $2ec4332cbbb15f4e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $2ec4332cbbb15f4e$var$mapRange = function(value, x1, y1, x2, y2) {
    return (value - x1) * (y2 - x2) / (y1 - x1) + x2;
};
var $2ec4332cbbb15f4e$var$rotate = function(degree, amount) {
    var result = degree + amount;
    return result > 360 ? result - 360 : result;
};
var $2ec4332cbbb15f4e$var$coinFlip = function() {
    return Math.random() > 0.5;
};
// avoid this for circles, as it will have no visual effect
var $2ec4332cbbb15f4e$var$zAxisRotation = [
    0,
    0,
    1
];
var $2ec4332cbbb15f4e$var$rotationTransforms = [
    // dual axis rotations (a bit more realistic)
    [
        1,
        1,
        0
    ],
    [
        1,
        0,
        1
    ],
    [
        0,
        1,
        1
    ],
    // single axis rotations (a bit dumber)
    [
        1,
        0,
        0
    ],
    [
        0,
        1,
        0
    ],
    $2ec4332cbbb15f4e$var$zAxisRotation
];
var $2ec4332cbbb15f4e$var$shouldBeCircle = function(rotationIndex) {
    return !(0, (/*@__PURE__*/$parcel$interopDefault($36cc539b4e4fca94$exports)))($2ec4332cbbb15f4e$var$rotationTransforms[rotationIndex], $2ec4332cbbb15f4e$var$zAxisRotation) && $2ec4332cbbb15f4e$var$coinFlip();
};
var $2ec4332cbbb15f4e$var$ROTATION_SPEED_MIN = 200; // minimum possible duration of single particle full rotation
var $2ec4332cbbb15f4e$var$ROTATION_SPEED_MAX = 800; // maximum possible duration of single particle full rotation
var $2ec4332cbbb15f4e$var$CRAZY_PARTICLES_FREQUENCY = 0.1; // 0-1 frequency of crazy curvy unpredictable particles
var $2ec4332cbbb15f4e$var$CRAZY_PARTICLE_CRAZINESS = 0.25; // 0-1 how crazy these crazy particles are
var $2ec4332cbbb15f4e$var$BEZIER_MEDIAN = 0.5; // utility for mid-point bezier curves, to ensure smooth motion paths
var $2ec4332cbbb15f4e$var$rotationKeyframes = $2ec4332cbbb15f4e$var$rotationTransforms.reduce(function(acc, xyz, i) {
    var _a;
    return $2ec4332cbbb15f4e$var$__assign($2ec4332cbbb15f4e$var$__assign({}, acc), (_a = {}, _a["@keyframes rotation-".concat(i)] = {
        "50%": {
            transform: "rotate3d(".concat(xyz.map(function(v) {
                return v / 2;
            }).join(), ", 180deg)")
        },
        "100%": {
            transform: "rotate3d(".concat(xyz.join(), ", 360deg)")
        }
    }, _a));
}, {});
var $2ec4332cbbb15f4e$var$confettiKeyframes = function(degrees, height, width) {
    var y = typeof height === "string" ? height : "".concat(height, "px");
    var xLandingPoints = degrees.reduce(function(acc, degree, i) {
        var _a;
        var landingPoint = $2ec4332cbbb15f4e$var$mapRange(Math.abs($2ec4332cbbb15f4e$var$rotate(degree, 90) - 180), 0, 180, -width / 2, width / 2);
        return $2ec4332cbbb15f4e$var$__assign($2ec4332cbbb15f4e$var$__assign({}, acc), (_a = {}, _a["@keyframes x-axis-".concat(i)] = {
            to: {
                transform: "translateX(".concat(landingPoint, "px)")
            }
        }, _a));
    }, {});
    return $2ec4332cbbb15f4e$var$__assign({
        "@keyframes y-axis": {
            to: {
                transform: "translateY(".concat(y, ")")
            }
        }
    }, xLandingPoints);
};
var $2ec4332cbbb15f4e$var$confettoStyle = function(particle, duration, force, size, i) {
    var _a;
    var rotation = Math.round(Math.random() * ($2ec4332cbbb15f4e$var$ROTATION_SPEED_MAX - $2ec4332cbbb15f4e$var$ROTATION_SPEED_MIN) + $2ec4332cbbb15f4e$var$ROTATION_SPEED_MIN);
    var rotationIndex = Math.round(Math.random() * ($2ec4332cbbb15f4e$var$rotationTransforms.length - 1));
    var durationChaos = duration - Math.round(Math.random() * 1000);
    var shouldBeCrazy = Math.random() < $2ec4332cbbb15f4e$var$CRAZY_PARTICLES_FREQUENCY;
    var isCircle = $2ec4332cbbb15f4e$var$shouldBeCircle(rotationIndex);
    // x-axis disturbance, roughly the distance the particle will initially deviate from its target
    var x1 = shouldBeCrazy ? (0, (/*@__PURE__*/$parcel$interopDefault($b750b42bd943e1b3$exports)))(Math.random() * $2ec4332cbbb15f4e$var$CRAZY_PARTICLE_CRAZINESS, 2) : 0;
    var x2 = x1 * -1;
    var x3 = x1;
    // x-axis arc of explosion, so 90deg and 270deg particles have curve of 1, 0deg and 180deg have 0
    var x4 = (0, (/*@__PURE__*/$parcel$interopDefault($b750b42bd943e1b3$exports)))(Math.abs($2ec4332cbbb15f4e$var$mapRange(Math.abs($2ec4332cbbb15f4e$var$rotate(particle.degree, 90) - 180), 0, 180, -1, 1)), 4);
    // roughly how fast particle reaches end of its explosion curve
    var y1 = (0, (/*@__PURE__*/$parcel$interopDefault($b750b42bd943e1b3$exports)))(Math.random() * $2ec4332cbbb15f4e$var$BEZIER_MEDIAN, 4);
    // roughly maps to the distance particle goes before reaching free-fall
    var y2 = (0, (/*@__PURE__*/$parcel$interopDefault($b750b42bd943e1b3$exports)))(Math.random() * force * ($2ec4332cbbb15f4e$var$coinFlip() ? 1 : -1), 4);
    // roughly how soon the particle transitions from explosion to free-fall
    var y3 = $2ec4332cbbb15f4e$var$BEZIER_MEDIAN;
    // roughly the ease of free-fall
    var y4 = (0, (/*@__PURE__*/$parcel$interopDefault($b750b42bd943e1b3$exports)))(Math.max($2ec4332cbbb15f4e$var$mapRange(Math.abs(particle.degree - 180), 0, 180, force, -force), 0), 4);
    return _a = {}, _a["&#confetti-particle-".concat(i)] = {
        animation: "$x-axis-".concat(i, " ").concat(durationChaos, "ms forwards cubic-bezier(").concat(x1, ", ").concat(x2, ", ").concat(x3, ", ").concat(x4, ")"),
        "& > div": {
            width: isCircle ? size : Math.round(Math.random() * 4) + size / 2,
            height: isCircle ? size : Math.round(Math.random() * 2) + size,
            animation: "$y-axis ".concat(durationChaos, "ms forwards cubic-bezier(").concat(y1, ", ").concat(y2, ", ").concat(y3, ", ").concat(y4, ")"),
            "&:after": $2ec4332cbbb15f4e$var$__assign({
                backgroundColor: particle.color,
                animation: "$rotation-".concat(rotationIndex, " ").concat(rotation, "ms infinite linear")
            }, isCircle ? {
                borderRadius: "50%"
            } : {})
        }
    }, _a;
};
var $2ec4332cbbb15f4e$var$useStyles = function(_a) {
    var particles = _a.particles, duration = _a.duration, height = _a.height, width = _a.width, force = _a.force, particleSize = _a.particleSize;
    var confettiStyles = particles.reduce(function(acc, particle, i) {
        return $2ec4332cbbb15f4e$var$__assign($2ec4332cbbb15f4e$var$__assign({}, acc), $2ec4332cbbb15f4e$var$confettoStyle(particle, duration, force, particleSize, i));
    }, {});
    return (0, $e1604d12639183a7$export$644d15e5a9a5f175)($2ec4332cbbb15f4e$var$__assign($2ec4332cbbb15f4e$var$__assign($2ec4332cbbb15f4e$var$__assign({}, $2ec4332cbbb15f4e$var$rotationKeyframes), $2ec4332cbbb15f4e$var$confettiKeyframes(particles.map(function(particle) {
        return particle.degree;
    }), height, width)), {
        container: {
            width: 0,
            height: 0,
            position: "relative"
        },
        screen: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: "hidden",
            pointerEvents: "none"
        },
        particle: $2ec4332cbbb15f4e$var$__assign($2ec4332cbbb15f4e$var$__assign({}, confettiStyles), {
            "& > div": {
                position: "absolute",
                left: 0,
                top: 0,
                "&:after": {
                    content: "''",
                    display: "block",
                    width: "100%",
                    height: "100%"
                }
            }
        })
    }), {
        name: "confetti-explosion"
    });
};
var $2ec4332cbbb15f4e$var$FORCE = 0.5; // 0-1 roughly the vertical force at which particles initially explode
var $2ec4332cbbb15f4e$var$SIZE = 12; // max height for particle rectangles, diameter for particle circles
var $2ec4332cbbb15f4e$var$HEIGHT = "120vh"; // distance particles will fall from initial explosion point
var $2ec4332cbbb15f4e$var$WIDTH = 1000; // horizontal spread of particles in pixels
var $2ec4332cbbb15f4e$var$PARTICLE_COUNT = 100;
var $2ec4332cbbb15f4e$var$DURATION = 2200;
var $2ec4332cbbb15f4e$var$COLORS = [
    "#FFC700",
    "#FF0000",
    "#2E3191",
    "#41BBC7"
];
var $2ec4332cbbb15f4e$var$createParticles = function(count, colors) {
    var increment = 360 / count;
    return (0, (/*@__PURE__*/$parcel$interopDefault($972b234689e1deef$exports)))(count).map(function(index) {
        return {
            color: colors[index % colors.length],
            degree: increment * index
        };
    });
};
function $2ec4332cbbb15f4e$export$2e2bcd8739ae039(_a) {
    var _b = _a.particleCount, particleCount = _b === void 0 ? $2ec4332cbbb15f4e$var$PARTICLE_COUNT : _b, _c = _a.duration, duration = _c === void 0 ? $2ec4332cbbb15f4e$var$DURATION : _c, _d = _a.colors, colors = _d === void 0 ? $2ec4332cbbb15f4e$var$COLORS : _d, _e = _a.particleSize, particleSize = _e === void 0 ? $2ec4332cbbb15f4e$var$SIZE : _e, _f = _a.force, force = _f === void 0 ? $2ec4332cbbb15f4e$var$FORCE : _f, _g = _a.height, height = _g === void 0 ? $2ec4332cbbb15f4e$var$HEIGHT : _g, _h = _a.width, width = _h === void 0 ? $2ec4332cbbb15f4e$var$WIDTH : _h, zIndex = _a.zIndex, onComplete = _a.onComplete, props = $2ec4332cbbb15f4e$var$__rest(_a, [
        "particleCount",
        "duration",
        "colors",
        "particleSize",
        "force",
        "height",
        "width",
        "zIndex",
        "onComplete"
    ]);
    var _j = $bh6RR.useState(), origin = _j[0], setOrigin = _j[1];
    var particles = $2ec4332cbbb15f4e$var$createParticles(particleCount, colors);
    var classes = $2ec4332cbbb15f4e$var$useStyles({
        particles: particles,
        duration: duration,
        particleSize: particleSize,
        force: force,
        width: width,
        height: height
    })();
    var originRef = $bh6RR.useCallback(function(node) {
        if (node) {
            var _a = node.getBoundingClientRect(), top_1 = _a.top, left = _a.left;
            setOrigin({
                top: top_1,
                left: left
            });
        }
    }, []);
    $bh6RR.useEffect(function() {
        if (typeof onComplete === "function") {
            var timeout_1 = setTimeout(onComplete, duration);
            return function() {
                return clearTimeout(timeout_1);
            };
        }
    }, [
        duration,
        onComplete
    ]);
    return (0, $d4dab640dcbe486c$exports.jsx)("div", $2ec4332cbbb15f4e$var$__assign({
        ref: originRef,
        className: classes.container
    }, props, {
        children: origin && (0, $47cfd4084854a574$exports.createPortal)((0, $d4dab640dcbe486c$exports.jsx)("div", $2ec4332cbbb15f4e$var$__assign({
            className: classes.screen
        }, zIndex ? {
            style: {
                zIndex: zIndex
            }
        } : null, {
            children: (0, $d4dab640dcbe486c$exports.jsx)("div", $2ec4332cbbb15f4e$var$__assign({
                style: {
                    position: "absolute",
                    top: origin.top,
                    left: origin.left
                }
            }, {
                children: particles.map(function(particle, i) {
                    return (0, $d4dab640dcbe486c$exports.jsx)("div", $2ec4332cbbb15f4e$var$__assign({
                        id: "confetti-particle-".concat(i),
                        className: classes.particle
                    }, {
                        children: (0, $d4dab640dcbe486c$exports.jsx)("div", {})
                    }), particle.degree);
                })
            }))
        })), document.body)
    }));
}







var $bh6RR = parcelRequire("bh6RR");


/**
 * lucide-react v0.288.0 - ISC
 */ 
const $66b74df6c0e88bf5$export$2e2bcd8739ae039 = (0, $dc38aceacd32c739$export$2e2bcd8739ae039)("Shuffle", [
    [
        "path",
        {
            d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22",
            key: "1wmou1"
        }
    ],
    [
        "path",
        {
            d: "m18 2 4 4-4 4",
            key: "pucp1d"
        }
    ],
    [
        "path",
        {
            d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2",
            key: "10bdb2"
        }
    ],
    [
        "path",
        {
            d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8",
            key: "vgxac0"
        }
    ],
    [
        "path",
        {
            d: "m18 14 4 4-4 4",
            key: "10pe0f"
        }
    ]
]);






function $d0e5e4046c4e4353$var$GameControlButtonsPanel({ flatWordsList: flatWordsList , setFlatWordsList: setFlatWordsList , setGridShake: setGridShake  }) {
    const { isGameOver: isGameOver , guessCandidate: guessCandidate , setGuessCandidate: setGuessCandidate , submittedGuesses: submittedGuesses , setSubmittedGuesses: setSubmittedGuesses , solvedGameData: solvedGameData , setSolvedGameData: setSolvedGameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $005b445a28133b13$export$3f49015a6304186f));
    const { gameData: gameData , categorySize: categorySize  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ae43375334d8e130$export$e8331451049320c2));
    const { toast: toast  } = (0, $c3f30381ef8228c0$export$a407b657d3044108)();
    function deselectAll() {
        (0, $61b270a9c2ec9ef5$export$64c83896ccb893ac)();
        setGuessCandidate([]);
    }
    function submitCandidateGuess() {
        // check that its a valid guess by size
        if (guessCandidate.length !== categorySize) return;
        // check that the guess hasnt already been submitted previously
        if ((0, $b9fa76065069edb9$export$a7c89472cbd6a2db)({
            submittedGuesses: submittedGuesses,
            guessCandidate: guessCandidate
        })) {
            (0, $61b270a9c2ec9ef5$export$9d170c11c6dddd1b)();
            toast({
                label: "Notification",
                title: "Repeated Guess",
                description: "You previously made this guess!"
            });
            return;
        }
        // add guess to state
        setSubmittedGuesses([
            ...submittedGuesses,
            guessCandidate
        ]);
        // check if the guess is correct
        const { isCorrect: isCorrect , correctWords: correctWords , correctCategory: correctCategory , isGuessOneAway: isGuessOneAway , correctDifficulty: correctDifficulty , correctImageSrc: correctImageSrc  } = (0, $b9fa76065069edb9$export$872584ef35ecfeaa)({
            guessCandidate: guessCandidate,
            gameData: gameData
        });
        // Track the guess submission
        (0, $61b270a9c2ec9ef5$export$74ddb128c139d5ca)(isCorrect, isGuessOneAway, submittedGuesses.length + 1);
        // if the guess is correct:
        // set it as solved in game data
        if (isCorrect) {
            setSolvedGameData([
                ...solvedGameData,
                {
                    category: correctCategory,
                    words: correctWords,
                    difficulty: correctDifficulty,
                    imageSrc: correctImageSrc
                }
            ]);
            setGuessCandidate([]);
        } else {
            // Shake the grid to give feedback that they were wrong
            setGridShake(true);
            if (isGuessOneAway) toast({
                label: "Notification",
                title: "Close Guess",
                description: "You were one guess away from correctly guessing a category!"
            });
        }
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "w-full flex gap-2",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $96fae3fa1f07fd29$export$353f5b6fc5456de1), {
                disabled: isGameOver,
                variant: "outline",
                onClick: ()=>{
                    (0, $61b270a9c2ec9ef5$export$25376a6166516c67)();
                    // Shuffle the flat list
                    const shuffled = [
                        ...flatWordsList
                    ].sort(()=>Math.random() - 0.5);
                    setFlatWordsList(shuffled);
                },
                className: "flex-grow border-[#B8A17F]/40 text-[#4A5D3F] hover:bg-[#B8A17F]/10 hover:border-[#B8A17F] backdrop-blur-sm bg-white/40 font-[525] transition-all duration-300",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $66b74df6c0e88bf5$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 mr-2"
                    }),
                    "Shuffle"
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $96fae3fa1f07fd29$export$353f5b6fc5456de1), {
                disabled: isGameOver || guessCandidate.length === 0,
                variant: "outline",
                onClick: deselectAll,
                className: "flex-grow border-[#B8A17F]/40 text-[#4A5D3F] hover:bg-[#B8A17F]/10 hover:border-[#B8A17F] backdrop-blur-sm bg-white/40 font-[525] disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-300",
                children: "Deselect All"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $96fae3fa1f07fd29$export$353f5b6fc5456de1), {
                onClick: submitCandidateGuess,
                disabled: isGameOver || guessCandidate.length !== categorySize,
                className: "flex-grow bg-gradient-to-br from-[#6B7F5E] to-[#4A5D3F] hover:from-[#4A5D3F] hover:to-[#2C3A28] text-white font-[525] disabled:opacity-40 disabled:cursor-not-allowed shadow-lg hover:shadow-xl transition-all duration-300",
                children: "Submit"
            })
        ]
    });
}
var $d0e5e4046c4e4353$export$2e2bcd8739ae039 = $d0e5e4046c4e4353$var$GameControlButtonsPanel;







var $bh6RR = parcelRequire("bh6RR");







function $ee26cab2e5fc3446$var$ViewResultsModal() {
    const { submittedGuesses: submittedGuesses  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $005b445a28133b13$export$3f49015a6304186f));
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ae43375334d8e130$export$e8331451049320c2));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1afdc1be3ae11346$export$2e2bcd8739ae039), {
        title: "",
        trigger: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $96fae3fa1f07fd29$export$353f5b6fc5456de1), {
            variant: "submit",
            className: "w-full",
            onClick: ()=>(0, $61b270a9c2ec9ef5$export$ffae68720d19fc39)(),
            children: "View Results"
        }),
        initiallyOpen: false,
        showActionButton: false,
        footerElements: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $edebedacdc02cdb3$export$2e2bcd8739ae039), {
            buttonText: "Share Your Score!"
        }),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "flex flex-col place-content-center",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    className: "text-center font-semibold",
                    children: "Your Guesses Are Represented Below"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: "text-center whitespace-pre mb-2",
                    children: [
                        "\n",
                        (0, $b9fa76065069edb9$export$a63577e223e2a6c9)(gameData, submittedGuesses)
                    ]
                })
            ]
        })
    });
}
var $ee26cab2e5fc3446$export$2e2bcd8739ae039 = $ee26cab2e5fc3446$var$ViewResultsModal;




function $64dda4da0336267f$var$Game() {
    const { gameData: gameData , categorySize: categorySize , numCategories: numCategories  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ae43375334d8e130$export$e8331451049320c2));
    const { submittedGuesses: submittedGuesses , solvedGameData: solvedGameData , isGameOver: isGameOver , isGameWon: isGameWon , setGuessCandidate: setGuessCandidate , setSubmittedGuesses: setSubmittedGuesses , setSolvedGameData: setSolvedGameData , setIsGameOver: setIsGameOver , setIsGameWon: setIsGameWon  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $005b445a28133b13$export$3f49015a6304186f));
    // Filter out already-solved categories on initial load
    const getUnsolvedGameData = ()=>{
        const solvedCategories = solvedGameData.map((data)=>data.category);
        return gameData.filter((data)=>!solvedCategories.includes(data.category));
    };
    const unsolvedData = getUnsolvedGameData();
    const initialShuffled = unsolvedData.length > 0 ? (0, $b9fa76065069edb9$export$d1246a55b993f861)({
        gameData: unsolvedData
    }) : [];
    const [shuffledRows, setShuffledRows] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(initialShuffled);
    const [flatWordsList, setFlatWordsList] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(initialShuffled.flat());
    const [isEndGameModalOpen, setisEndGameModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [gridShake, setGridShake] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showConfetti, setShowConfetti] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [animatingWords, setAnimatingWords] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [mergingWords, setMergingWords] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const isInitialMount = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(true);
    function resetGame() {
        (0, $61b270a9c2ec9ef5$export$69daaca24e7d39b8)();
        const newShuffledRows = (0, $b9fa76065069edb9$export$d1246a55b993f861)({
            gameData: gameData
        });
        setGuessCandidate([]);
        setSubmittedGuesses([]);
        setSolvedGameData([]);
        setAnimatingWords([]);
        setMergingWords([]);
        setShuffledRows(newShuffledRows);
        setFlatWordsList(newShuffledRows.flat());
        setIsGameOver(false);
        setIsGameWon(false);
        setisEndGameModalOpen(false);
        isInitialMount.current = true; // Reset to initial mount state
    }
    // use effect to update Game Grid after a row has been correctly solved
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        // Skip on initial mount to avoid animating already-solved data
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        if (solvedGameData.length === 0) return;
        // Get the most recently solved words
        const latestSolved = solvedGameData[solvedGameData.length - 1];
        // Reorder the flat list: put solved words at the front (positions 0-3)
        const solvedWords = latestSolved.words;
        const remainingWords = flatWordsList.filter((word)=>!solvedWords.includes(word));
        const reorderedList = [
            ...solvedWords,
            ...remainingWords
        ];
        // Update the list - framer-motion will animate the reordering
        setFlatWordsList(reorderedList);
        setAnimatingWords(solvedWords);
        // After grid reorders, start merge animation and remove words simultaneously
        const mergeDelay = window.setTimeout(()=>{
            setMergingWords(solvedWords);
            // Remove at the same time so success row doesn't push anything down
            setFlatWordsList(remainingWords);
            setAnimatingWords([]);
            setMergingWords([]);
        }, 800);
        return ()=>{
            window.clearTimeout(mergeDelay);
        };
    }, [
        solvedGameData
    ]);
    // Handle End Game!
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (!isGameOver) return;
        // Track game completion
        const numMistakes = submittedGuesses.length - solvedGameData.length;
        if (isGameWon) (0, $61b270a9c2ec9ef5$export$5d5a7387b247147e)(submittedGuesses.length, numMistakes);
        else (0, $61b270a9c2ec9ef5$export$74b3310c834b946e)(submittedGuesses.length, numMistakes);
        let confettiDelay;
        if (isGameWon) // Delay confetti to match success row appearance
        confettiDelay = window.setTimeout(()=>{
            setShowConfetti(true);
        }, 800);
        // extra delay for game won to allow confetti to show
        const modalDelay = isGameWon ? 2800 : 250;
        const delayModalOpen = window.setTimeout(()=>{
            setisEndGameModalOpen(true);
            //unmount confetti after modal opens
            setShowConfetti(false);
        }, modalDelay);
        return ()=>{
            window.clearTimeout(delayModalOpen);
            if (confettiDelay) window.clearTimeout(confettiDelay);
        };
    }, [
        isGameOver,
        isGameWon
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: `game-wrapper`,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    className: "text-center text-[#6B7F5E] mb-2 tracking-wide font-medium",
                    children: "Create four groups of four!"
                }),
                isGameOver && isGameWon ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8e952cf10097a2ff$export$2e2bcd8739ae039), {
                    open: isEndGameModalOpen,
                    submittedGuesses: submittedGuesses
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e61d4104e0131cca$export$2e2bcd8739ae039), {
                    open: isEndGameModalOpen,
                    submittedGuesses: submittedGuesses,
                    onPlayAgain: resetGame
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $39399887a43190b2$export$2e2bcd8739ae039), {
                    flatWordsList: flatWordsList,
                    shouldGridShake: gridShake,
                    setShouldGridShake: setGridShake,
                    animatingWords: animatingWords,
                    mergingWords: mergingWords
                }),
                showConfetti && isGameOver && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-50",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ec4332cbbb15f4e$export$2e2bcd8739ae039), {
                        particleCount: 100,
                        force: 0.8,
                        duration: 2500
                    })
                }),
                !isGameOver ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $72681eacbfe72cc0$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d0e5e4046c4e4353$export$2e2bcd8739ae039), {
                            flatWordsList: flatWordsList,
                            setFlatWordsList: setFlatWordsList,
                            setGridShake: setGridShake
                        })
                    ]
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ee26cab2e5fc3446$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $96fae3fa1f07fd29$export$353f5b6fc5456de1), {
                            variant: "secondary",
                            onClick: resetGame,
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02e02564a7127b84$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4 mr-2",
                                    strokeWidth: 1
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                                    className: "select-none font-medium",
                                    children: "Play Again"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $64dda4da0336267f$export$2e2bcd8739ae039 = $64dda4da0336267f$var$Game;







var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");














var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $91436baa4104b247$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $91436baa4104b247$export$439d29a4e110a164 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($91436baa4104b247$export$439d29a4e110a164, {
    displayName: $91436baa4104b247$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $91436baa4104b247$export$be92b6f5f03c0fe9 = $91436baa4104b247$export$439d29a4e110a164;


/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
const [$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$Collection, $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useCollection, $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$createCollectionScope] = (0, $c43a6ccc42422c95$export$c74125a8e3af6bb2)("Toast");
const [$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$createToastContext, $4fab4f7b5e5094a0$export$8a359da18fbc9073] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)("Toast", [
    $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$createCollectionScope
]);
const [$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastProviderProvider, $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useToastProviderContext] = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$createToastContext($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$PROVIDER_NAME);
const $4fab4f7b5e5094a0$export$f5d03d415824e0e = (props)=>{
    const { __scopeToast: __scopeToast , label: label = "Notification" , duration: duration = 5000 , swipeDirection: swipeDirection = "right" , swipeThreshold: swipeThreshold = 50 , children: children  } = props;
    const [viewport, setViewport] = (0, $bh6RR.useState)(null);
    const [toastCount, setToastCount] = (0, $bh6RR.useState)(0);
    const isFocusedToastEscapeKeyDownRef = (0, $bh6RR.useRef)(false);
    const isClosePausedRef = (0, $bh6RR.useRef)(false);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0, $bh6RR.useCallback)(()=>setToastCount((prevCount)=>prevCount + 1), []),
        onToastRemove: (0, $bh6RR.useCallback)(()=>setToastCount((prevCount)=>prevCount - 1), []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$4fab4f7b5e5094a0$export$f5d03d415824e0e.propTypes = {
    label (props) {
        if (props.label && typeof props.label === "string" && !props.label.trim()) {
            const error = `Invalid prop \`label\` supplied to \`${$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($4fab4f7b5e5094a0$export$f5d03d415824e0e, {
    displayName: $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    "F8"
];
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
const $4fab4f7b5e5094a0$export$6192c2425ecfd989 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , hotkey: hotkey = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY , label: label = "Notifications ({hotkey})" , ...viewportProps } = props;
    const context = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useToastProviderContext($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    const getItems = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useCollection(__scopeToast);
    const wrapperRef = (0, $bh6RR.useRef)(null);
    const headFocusProxyRef = (0, $bh6RR.useRef)(null);
    const tailFocusProxyRef = (0, $bh6RR.useRef)(null);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    const hasToasts = context.toastCount > 0;
    (0, $bh6RR.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key);
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        hotkey
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        const viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            const handlePause = ()=>{
                if (!context.isClosePausedRef.current) {
                    const pauseEvent = new CustomEvent($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            const handleResume = ()=>{
                if (context.isClosePausedRef.current) {
                    const resumeEvent = new CustomEvent($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            const handleFocusOutResume = (event)=>{
                const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            const handlePointerLeaveResume = ()=>{
                const isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener("focusin", handlePause);
            wrapper.addEventListener("focusout", handleFocusOutResume);
            wrapper.addEventListener("pointermove", handlePause);
            wrapper.addEventListener("pointerleave", handlePointerLeaveResume);
            window.addEventListener("blur", handlePause);
            window.addEventListener("focus", handleResume);
            return ()=>{
                wrapper.removeEventListener("focusin", handlePause);
                wrapper.removeEventListener("focusout", handleFocusOutResume);
                wrapper.removeEventListener("pointermove", handlePause);
                wrapper.removeEventListener("pointerleave", handlePointerLeaveResume);
                window.removeEventListener("blur", handlePause);
                window.removeEventListener("focus", handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    const getSortedTabbableCandidates = (0, $bh6RR.useCallback)(({ tabbingDirection: tabbingDirection  })=>{
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem)=>{
            const toastNode = toastItem.ref.current;
            const toastTabbableCandidates = [
                toastNode,
                ...$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
            ];
            return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            const handleKeyDown = (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === "Tab" && !isMetaKey;
                if (isTabKey) {
                    const focusedElement = document.activeElement;
                    const isTabbingBackwards = event.shiftKey;
                    const targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
                    const sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    const index = sortedCandidates.findIndex((candidate)=>candidate === focusedElement);
                    if ($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener("keydown", handleKeyDown);
            return ()=>viewport.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$aecb2ddcb55c95be), {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace("{hotkey}", hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : "none"
        }
    }, hasToasts && /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "forwards"
            });
            $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).ol, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "backwards"
            });
            $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($4fab4f7b5e5094a0$export$6192c2425ecfd989, {
    displayName: $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , onFocusFromOutsideViewport: onFocusFromOutsideViewport , ...proxyProps } = props;
    const context = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useToastProviderContext($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $91436baa4104b247$export$439d29a4e110a164), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: "fixed"
        },
        onFocus: (event)=>{
            var _context$viewport;
            const prevFocusedElement = event.relatedTarget;
            const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$FocusProxy, {
    displayName: $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_NAME = "Toast";
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
const $4fab4f7b5e5094a0$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , ...toastProps } = props;
    const [open = true, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: ()=>setOpen(false),
        onPause: (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(props.onPause),
        onResume: (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(props.onResume),
        onSwipeStart: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onSwipeStart, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onSwipeMove, (event)=>{
            const { x: x , y: y  } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "move");
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y}px`);
        }),
        onSwipeCancel: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onSwipeCancel, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "cancel");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onSwipeEnd, (event)=>{
            const { x: x , y: y  } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "end");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y}px`);
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($4fab4f7b5e5094a0$export$8d8dc7d5f743331b, {
    displayName: $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastInteractiveProvider, $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useToastInteractiveContext] = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$createToastContext($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_NAME, {
    onClose () {}
});
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , type: type = "foreground" , duration: durationProp , open: open , onClose: onClose , onEscapeKeyDown: onEscapeKeyDown , onPause: onPause , onResume: onResume , onSwipeStart: onSwipeStart , onSwipeMove: onSwipeMove , onSwipeCancel: onSwipeCancel , onSwipeEnd: onSwipeEnd , ...toastProps } = props;
    const context = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useToastProviderContext($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [node1, setNode] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const pointerStartRef = (0, $bh6RR.useRef)(null);
    const swipeDeltaRef = (0, $bh6RR.useRef)(null);
    const duration1 = durationProp || context.duration;
    const closeTimerStartTimeRef = (0, $bh6RR.useRef)(0);
    const closeTimerRemainingTimeRef = (0, $bh6RR.useRef)(duration1);
    const closeTimerRef = (0, $bh6RR.useRef)(0);
    const { onToastAdd: onToastAdd , onToastRemove: onToastRemove  } = context;
    const handleClose = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(()=>{
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    const startTimer = (0, $bh6RR.useCallback)((duration)=>{
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const viewport = context.viewport;
        if (viewport) {
            const handleResume = ()=>{
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            const handlePause = ()=>{
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return ()=>{
                viewport.removeEventListener($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0, $bh6RR.useEffect)(()=>{
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0, $bh6RR.useEffect)(()=>{
        onToastAdd();
        return ()=>onToastRemove();
    }, [
        onToastAdd,
        onToastRemove
    ]);
    const announceTextContent = (0, $bh6RR.useMemo)(()=>{
        return node1 ? $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, announceTextContent && /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0, $47cfd4084854a574$exports.createPortal)(/*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$be92b6f5f03c0fe9), {
        asChild: true,
        onEscapeKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(onEscapeKeyDown, ()=>{
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).li, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? "open" : "closed",
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: {
            userSelect: "none",
            touchAction: "none",
            ...props.style
        },
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key !== "Escape") return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (!pointerStartRef.current) return;
            const x = event.clientX - pointerStartRef.current.x;
            const y = event.clientY - pointerStartRef.current.y;
            const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            const isHorizontalSwipe = [
                "left",
                "right"
            ].includes(context.swipeDirection);
            const clamp = [
                "left",
                "up"
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            const clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            const clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
            const delta = {
                x: clampedX,
                y: clampedY
            };
            const eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerUp, (event1)=>{
            const delta = swipeDeltaRef.current;
            const target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                const toast = event1.currentTarget;
                const eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener("click", (event)=>event.preventDefault(), {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type (props) {
        if (props.type && ![
            "foreground",
            "background"
        ].includes(props.type)) {
            const error = `Invalid prop \`type\` supplied to \`${$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastAnnounce = (props)=>{
    const { __scopeToast: __scopeToast , children: children , ...announceProps } = props;
    const context = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useToastProviderContext($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [renderAnnounceText, setRenderAnnounceText] = (0, $bh6RR.useState)(false);
    const [isAnnounced, setIsAnnounced] = (0, $bh6RR.useState)(false); // render text content in the next frame to ensure toast is announced in NVDA
    $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useNextFrame(()=>setRenderAnnounceText(true)); // cleanup after announcing
    (0, $bh6RR.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsAnnounced(true), 1000);
        return ()=>window.clearTimeout(timer);
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), {
        asChild: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $91436baa4104b247$export$439d29a4e110a164), announceProps, renderAnnounceText && /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TITLE_NAME = "ToastTitle";
const $4fab4f7b5e5094a0$export$16d42d7c29b95a4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...titleProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($4fab4f7b5e5094a0$export$16d42d7c29b95a4, {
    displayName: $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$DESCRIPTION_NAME = "ToastDescription";
const $4fab4f7b5e5094a0$export$ecddd96c53621d9a = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...descriptionProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($4fab4f7b5e5094a0$export$ecddd96c53621d9a, {
    displayName: $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
const $4fab4f7b5e5094a0$export$3019feecfda683d2 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { altText: altText , ...actionProps } = props;
    if (!altText) return null;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$export$811e70f61c205839, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, actionProps, {
        ref: forwardedRef
    })));
});
$4fab4f7b5e5094a0$export$3019feecfda683d2.propTypes = {
    altText (props) {
        if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ACTION_NAME}\``);
        return null;
    }
};
/*#__PURE__*/ Object.assign($4fab4f7b5e5094a0$export$3019feecfda683d2, {
    displayName: $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
const $4fab4f7b5e5094a0$export$811e70f61c205839 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...closeProps } = props;
    const interactiveContext = $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useToastInteractiveContext($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($4fab4f7b5e5094a0$export$811e70f61c205839, {
    displayName: $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , altText: altText , ...announceExcludeProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$getAnnounceTextContent(container) {
    const textContent = [];
    const childNodes = Array.from(container.childNodes);
    childNodes.forEach((node)=>{
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$isHTMLElement(node)) {
            const isHidden = node.ariaHidden || node.hidden || node.style.display === "none";
            const isExcluded = node.dataset.radixToastAnnounceExclude === "";
            if (!isHidden) {
                if (isExcluded) {
                    const altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else textContent.push(...$4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$getAnnounceTextContent(node));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const currentTarget = detail.originalEvent.currentTarget;
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $793b1a0f4d9647b1$export$6d1a0317bde7de7f)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
const $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0)=>{
    const deltaX = Math.abs(delta.x);
    const deltaY = Math.abs(delta.y);
    const isDeltaX = deltaX > deltaY;
    if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$useNextFrame(callback = ()=>{}) {
    const fn = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(callback);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        let raf1 = 0;
        let raf2 = 0;
        raf1 = window.requestAnimationFrame(()=>raf2 = window.requestAnimationFrame(fn));
        return ()=>{
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $4fab4f7b5e5094a0$var$$054eb8030ebde76e$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
const $4fab4f7b5e5094a0$export$2881499e37b75b9a = $4fab4f7b5e5094a0$export$f5d03d415824e0e;
const $4fab4f7b5e5094a0$export$d5c6c08dc2d3ca7 = $4fab4f7b5e5094a0$export$6192c2425ecfd989;
const $4fab4f7b5e5094a0$export$be92b6f5f03c0fe9 = $4fab4f7b5e5094a0$export$8d8dc7d5f743331b;
const $4fab4f7b5e5094a0$export$f99233281efd08a0 = $4fab4f7b5e5094a0$export$16d42d7c29b95a4;
const $4fab4f7b5e5094a0$export$393edc798c47379d = $4fab4f7b5e5094a0$export$ecddd96c53621d9a;
const $4fab4f7b5e5094a0$export$e19cd5f9376f8cee = $4fab4f7b5e5094a0$export$3019feecfda683d2;
const $4fab4f7b5e5094a0$export$f39c2d165cd861fe = $4fab4f7b5e5094a0$export$811e70f61c205839;




/**
 * lucide-react v0.288.0 - ISC
 */ 
const $e810c41ef33b64dc$export$2e2bcd8739ae039 = (0, $dc38aceacd32c739$export$2e2bcd8739ae039)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);



const $b872aa3e5ee58880$export$f5d03d415824e0e = $4fab4f7b5e5094a0$export$2881499e37b75b9a;
const $b872aa3e5ee58880$export$6192c2425ecfd989 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($252b3d40eb00b07a$export$be92b6f5f03c0fe9, {
        className: "fixed z-[200]",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4fab4f7b5e5094a0$export$d5c6c08dc2d3ca7, {
            ref: ref,
            className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]", className),
            ...props
        })
    }));
$b872aa3e5ee58880$export$6192c2425ecfd989.displayName = $4fab4f7b5e5094a0$export$d5c6c08dc2d3ca7.displayName;
const $b872aa3e5ee58880$var$toastVariants = (0, $3e91b320546fc9fb$export$87dc52566e90b739)("group pointer-events-auto z-160 relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full", {
    variants: {
        variant: {
            default: "border bg-white text-foreground",
            destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
const $b872aa3e5ee58880$export$8d8dc7d5f743331b = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , variant: variant , ...props }, ref)=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4fab4f7b5e5094a0$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)($b872aa3e5ee58880$var$toastVariants({
            variant: variant
        }), className),
        ...props
    });
});
$b872aa3e5ee58880$export$8d8dc7d5f743331b.displayName = $4fab4f7b5e5094a0$export$be92b6f5f03c0fe9.displayName;
const $b872aa3e5ee58880$export$3019feecfda683d2 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4fab4f7b5e5094a0$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive", className),
        ...props
    }));
$b872aa3e5ee58880$export$3019feecfda683d2.displayName = $4fab4f7b5e5094a0$export$e19cd5f9376f8cee.displayName;
const $b872aa3e5ee58880$export$811e70f61c205839 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4fab4f7b5e5094a0$export$f39c2d165cd861fe, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600", className),
        "toast-close": "",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e810c41ef33b64dc$export$2e2bcd8739ae039), {
            className: "h-4 w-4"
        })
    }));
$b872aa3e5ee58880$export$811e70f61c205839.displayName = $4fab4f7b5e5094a0$export$f39c2d165cd861fe.displayName;
const $b872aa3e5ee58880$export$16d42d7c29b95a4 = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4fab4f7b5e5094a0$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("text-sm font-semibold", className),
        ...props
    }));
$b872aa3e5ee58880$export$16d42d7c29b95a4.displayName = $4fab4f7b5e5094a0$export$f99233281efd08a0.displayName;
const $b872aa3e5ee58880$export$ecddd96c53621d9a = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4fab4f7b5e5094a0$export$393edc798c47379d, {
        ref: ref,
        className: (0, $92dc8dbec6af1b1e$export$1343a74baacb0543)("text-sm opacity-90", className),
        ...props
    }));
$b872aa3e5ee58880$export$ecddd96c53621d9a.displayName = $4fab4f7b5e5094a0$export$393edc798c47379d.displayName;



function $12e11564ddba1f23$export$fb98e3a2a4cd92d7() {
    const { toasts: toasts  } = (0, $c3f30381ef8228c0$export$a407b657d3044108)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $b872aa3e5ee58880$export$f5d03d415824e0e), {
        children: [
            toasts.map(function({ id: id , title: title , description: description , action: action , ...props }) {
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $b872aa3e5ee58880$export$8d8dc7d5f743331b), {
                    ...props,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "grid gap-1",
                            children: [
                                title && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b872aa3e5ee58880$export$16d42d7c29b95a4), {
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b872aa3e5ee58880$export$ecddd96c53621d9a), {
                                    children: description
                                })
                            ]
                        }),
                        action,
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b872aa3e5ee58880$export$811e70f61c205839), {})
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b872aa3e5ee58880$export$6192c2425ecfd989), {})
        ]
    });
}




function $5c4c715ef872aa13$var$App() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ae43375334d8e130$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $005b445a28133b13$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $12e11564ddba1f23$export$fb98e3a2a4cd92d7), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02ce57c81a0104d3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $64dda4da0336267f$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}
var $5c4c715ef872aa13$export$2e2bcd8739ae039 = $5c4c715ef872aa13$var$App;






const $1f0dc3b9307be026$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.querySelector("#root"));
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c4c715ef872aa13$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.2426293b.js.map
